/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type Email = string;
export type InviteCode = string;
export type WithNotification = boolean;
export type RecipeUuid = string | null;
export type Source = string | null;
export type Platform = "web" | "ios" | "android";
export type Timezone = string | null;
export type RpcCheckEmailInput = string;
export type Email1 = string;
export type Password = string;
export type Uidb64 = string;
export type Token = string;
export type NewPassword1 = string;
export type NewPassword2 = string;
export type Askedforrating = boolean;
export type AppleHealth = Postponed | Never | Enabled | ShouldRequest;
export type Status = "LATER";
export type PostponedUntil = string;
export type Postponements = number;
export type EntriesCreated = number;
export type WorkoutsCompleted = number;
export type Status1 = "NEVER";
export type Status2 = "ENABLED";
export type Status3 = "SHOULD_REQUEST";
export type PushNotifications = Postponed | Never | Enabled;
export type TrackingAuthorization = "authorized" | "denied" | "notDetermined" | "restricted";
export type Myfitnesspal = (Postponed | Never | Enabled) | null;
export type Onboarding = (Postponed | Never | Enabled) | null;
export type Meals = ("MANUAL" | "AUTO_CREATED") | null;
export type RatingRequest = (Postponed | Enabled) | null;
export type FollowOnInstagram = (Postponed | Never | Enabled) | null;
export type DeviceId = string;
export type Type = string;
export type JoyTag = string | null;
export type JsonValue = unknown;
export type EmailUuid = string;
export type DeviceId1 = string;
export type RegistrationId = string;
export type ApplicationId = string;
export type Subject = string;
export type Body = string;
export type Id = number;
export type Type1 = string;
export type Recordtype = "Bounce";
export type Typecode = number;
export type Tag = string;
export type Messageid = string;
export type Details = string;
export type Email2 = string;
export type From = string;
export type Bouncedat = string;
export type Inactive = boolean;
export type Dumpavailable = boolean;
export type Canactivate = boolean;
export type Subject1 = string;
export type Serverid = number;
export type Messagestream = string;
export type Content = string;
export type Name = string;
export type Description = string;
export type Uuid = string;
export type MfpAccountUuid = string;
export type Type2 = "mfp";
export type DateOfBirth = string;
export type Gender = "MALE" | "FEMALE";
export type Units = "METRIC" | "IMPERIAL";
export type Feet = ("2" | "3" | "4" | "5" | "6" | "7" | "8") | null;
export type Inches = ("0" | "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | "10" | "11") | null;
export type Heightcm = string | null;
export type Weightlb = string | null;
export type Weightkg = string | null;
export type Goal = "lose" | "maintain" | "gain";
export type Cookingfrequency = "never" | "occasionally" | "often";
export type Assemblywilling = "yes" | "no";
export type Repetitiontolerance = "none" | "few" | "week";
export type Nightsout = "0" | "1" | "2" | "3+";
export type Ignored = string;
export type RpcRequestLoginLinkInput = string;
export type Token1 = string;
export type Email3 = string;
export type Email4 = string;
export type Message = string;
export type MessageType = "SUPPORT" | "MANAGER" | "FEEDBACK";
export type Announcement =
  | "HIDDEN_MACROS"
  | "SWIPE_TO_GO_BACK"
  | "MEAL_PLANS_BETA"
  | "CLIENT_MEASUREMENTS"
  | "COPY_MEAL_PLANS"
  | "MIGRATE_FROM_MYFITNESSPAL"
  | "SHOW_MIGRATE_FROM_MYFITNESS_PAL"
  | "FITNESS_BETA"
  | "MANAGER_FITNESS_BETA"
  | "WORKOUT_TEMPLATES"
  | "APPLE_HEALTH"
  | "NUTRITIONAL_AI"
  | "AI_COHORT"
  | "MODAL_ENTRY"
  | "CHALLENGE"
  | "HAS_USED_MYFITNESSPAL"
  | "NUTRITIONAL_VISION_INSTRUCTIONS"
  | "METHOD"
  | "NUTRITIONAL_AUDIO_INSTRUCTIONS"
  | "FIXED_SYNC_BUTTON"
  | "IAP_TRIAL"
  | "ENTRY_INSTRUCTIONS"
  | "SHARED_RECIPES"
  | "SHOW_INSTAGRAM_PROMPT"
  | "SHOW_REQUEST_TRACKING_AUTHORIZATION"
  | "SHOW_RECIPE_REGISTRATION"
  | "HIDE_RECIPE_REGISTRATION"
  | "DEBUG_HEALTHKIT"
  | "HAS_VIDEO_ACCESS"
  | "DEMO_MODE"
  | "PREDICTIONS"
  | "HOTJAR"
  | "PREDICTIONS_V2"
  | "LEARNING_WEEK"
  | "LEARNING_WEEK_TOUR"
  | "PLAN_WAITLIST"
  | "CAMERA_SEARCH_TUTORIAL"
  | "NEEDS_APPLE_HEALTH_RESYNC"
  | "RESYNCED_APPLE_HEALTH"
  | "WALKING_CLUB";
export type Email5 = string | null;
export type Name1 = string;
export type DateOfBirth1 = string | null;
export type IsImperial = boolean;
export type UseKilojoules = boolean;
export type Weight = string | null;
export type Height = string | null;
export type Waist = string | null;
export type Gender1 = string | null;
export type BodyFat = string | null;
export type Activity = string | null;
export type Goal1 = string | null;
export type Email6 = string;
export type AttributionType = "share";
export type Referrer = string | null;
export type ShareUuid = string;
export type ShareType = string;
export type AttributionType1 = "utm";
export type Referrer1 = string | null;
export type UtmSource = string | null;
export type UtmMedium = string | null;
export type UtmCampaign = string | null;
export type UtmTerm = string | null;
export type UtmContent = string | null;
export type ApiKey = string;
export type Url = string;
export type Subreddit = string;
export type ReceiptData = string;
export type Token2 = string;
export type PaymentId = string;
export type PayerId = string;
export type Name2 = string;
export type Metric__Type = "WEIGHT" | "STEPS" | "SLEEP" | "WATER" | "ACTIVE_CALORIES" | "BASE_CALORIES" | "WORKOUT";
export type StartDate = string;
export type EndDate = string;
export type Value = string | null;
export type Timezone1 = string;
export type AppleHealthUuid = UUID | null;
export type Uuid1 = UUID;
export type AppleHealthData = string | null;
export type RpcUpdateMetricsInput = ServerJournalDay_MetricInput[];
export type StartDate1 = string;
export type EndDate1 = string;
export type Timezone2 = string;
export type IsManual = boolean;
export type Value1 = number | null;
export type AppleHealthUuids = string[];
export type Human = string | null;
export type AppleHealthUuid1 = UUID;
export type Timezone3 = string;
export type StartTime = string;
export type EndTime = string;
export type WorkoutActivityType = string;
export type WorkoutActivityId = number;
export type DurationSeconds = number;
export type Calories = string | null;
export type DistanceMeters = string | null;
export type Source1 = string;
export type SourceBundleId = string;
export type UserId = number;
export type Type3 = string;
export type Date = string;
export type Timezone4 = string;
export type Buckets = number[];
export type Key = string | number;
export type UserId1 = number | null;
export type Weight1 = string | null;
export type Waist1 = string | null;
export type Navel = string | null;
export type BodyFat1 = string | null;
export type Hips = string | null;
export type Neck = string | null;
export type Thigh = string | null;
export type Bicep = string | null;
export type Chest = string | null;
export type Key1 = string;
export type UserId2 = number;
export type Pk = number;
export type Id1 = number;
export type UserId3 = number;
export type Name3 = string;
export type TargetLike__Type = "LOG" | "BASIC" | "ADVANCED";
export type Name4 = string;
export type CaloriesTarget = string | null;
export type TargetLike__Mode = "AT_LEAST" | "AT_MOST" | "EQUAL";
export type ProteinTarget = string | null;
export type FatTarget = string | null;
export type CarbsTarget = string | null;
export type FiberTarget = string | null;
export type NetCarbsTarget = string | null;
export type SodiumTarget = string | null;
export type SaturatedFatTarget = string | null;
export type MonounsaturatedFatTarget = string | null;
export type PolyunsaturatedFatTarget = string | null;
export type TransFatTarget = string | null;
export type CholesterolTarget = string | null;
export type SugarsTarget = string | null;
export type AddedSugarsTarget = string | null;
export type PotassiumTarget = string | null;
export type MagnesiumTarget = string | null;
export type VitaminADvTarget = string | null;
export type VitaminCDvTarget = string | null;
export type CalciumDvTarget = string | null;
export type IronDvTarget = string | null;
export type Gratitude = string;
export type IncludeInReports = boolean;
export type Notes = string;
export type Uuid2 = UUID;
export type Name5 = string;
export type Hour = number | null;
export type Meal__Type = "MANUAL" | "AUTO_CREATED";
export type Uuid3 = UUID;
export type Name6 = string;
export type Unit = string;
export type Quantity = string;
export type CaloriesPg = string | null;
export type ProteinPg = string | null;
export type FatPg = string | null;
export type CarbsPg = string | null;
export type NetCarbsPg = string | null;
export type FiberPg = string | null;
export type SodiumPg = string | null;
export type SaturatedFatPg = string | null;
export type MonounsaturatedFatPg = string | null;
export type PolyunsaturatedFatPg = string | null;
export type TransFatPg = string | null;
export type CholesterolPg = string | null;
export type SugarsPg = string | null;
export type AddedSugarsPg = string | null;
export type PotassiumPg = string | null;
export type MagnesiumPg = string | null;
export type VitaminADvPg = string | null;
export type VitaminCDvPg = string | null;
export type CalciumDvPg = string | null;
export type IronDvPg = string | null;
export type BaseUnit = ("" | "g" | "oz" | "ml" | "fl oz" | "mg" | "mcg" | "iu") | "grams";
export type BaseQuantity = string | null;
export type ServingSizeUnit = string;
export type ServingSizeNumerator = string;
export type ServingSizeDenominator = string;
export type ContainerUnit = string;
export type ContainerQuantity = string | null;
export type ContainerServings = string;
export type UsdaFoodId = number | null;
export type Notes1 = string;
export type Amount = string;
export type GramWeight = string;
export type Modifier = string;
export type AdditionalUnits = USDARawUnit[];
export type Uuid4 = UUID;
export type ImageUid = UUID | null;
export type NutritionalVisionPrompt__Status = "PROCESSING" | "IDENTIFIED" | "ERROR" | "INVALID" | "SUCCESS";
export type NutritionalVisionPrompt__Type = "VISION" | "AUDIO" | "PROSE" | "URL" | "BARCODE";
export type Name7 = string;
export type Backend =
  | ""
  | "factual"
  | "recipes"
  | "foods"
  | "recent"
  | "nutritionix"
  | "nutritionix_v2"
  | "inline"
  | "usda"
  | "mfp"
  | "mfp_recipes";
export type BackendId = string;
export type Uuid5 = UUID;
export type Name8 = string;
export type Unit1 = string;
export type Quantity1 = string;
export type CaloriesPg1 = string | null;
export type ProteinPg1 = string | null;
export type FatPg1 = string | null;
export type CarbsPg1 = string | null;
export type NetCarbsPg1 = string | null;
export type FiberPg1 = string | null;
export type SodiumPg1 = string | null;
export type SaturatedFatPg1 = string | null;
export type MonounsaturatedFatPg1 = string | null;
export type PolyunsaturatedFatPg1 = string | null;
export type TransFatPg1 = string | null;
export type CholesterolPg1 = string | null;
export type SugarsPg1 = string | null;
export type AddedSugarsPg1 = string | null;
export type PotassiumPg1 = string | null;
export type MagnesiumPg1 = string | null;
export type VitaminADvPg1 = string | null;
export type VitaminCDvPg1 = string | null;
export type CalciumDvPg1 = string | null;
export type IronDvPg1 = string | null;
export type BaseUnit1 = ("" | "g" | "oz" | "ml" | "fl oz" | "mg" | "mcg" | "iu") | "grams";
export type BaseQuantity1 = string | null;
export type ServingSizeUnit1 = string;
export type ServingSizeNumerator1 = string;
export type ServingSizeDenominator1 = string;
export type ContainerUnit1 = string;
export type ContainerQuantity1 = string | null;
export type ContainerServings1 = string;
export type UsdaFoodId1 = number | null;
export type Notes2 = string;
export type AdditionalUnits1 = USDARawUnit[];
export type Backend1 =
  | ""
  | "factual"
  | "recipes"
  | "foods"
  | "recent"
  | "nutritionix"
  | "nutritionix_v2"
  | "inline"
  | "usda"
  | "mfp"
  | "mfp_recipes";
export type BackendId1 = string;
export type ExpandedRecipe = ServerJournalNutrition_EntryInput[];
export type Entries = ServerJournalNutrition_ExpandedEntryInput[];
export type Meals1 = ServerJournalNutrition_MealInput[];
export type DeletedMealUuids = string[];
export type Gratitude1 = string;
export type IncludeInReports1 = boolean;
export type Notes3 = string;
export type Meals2 = ServerJournalNutrition_MealInput[];
export type ClientVersion = string;
export type ClientAppVersion = string;
export type Date1 = string;
export type Timezone5 = string | null;
export type DayOfWeek = number;
export type UserId4 = number;
export type CheckIn = "DISABLED" | "ENABLED";
export type Sleep = number | null;
export type CheckIn1 = null;
export type Steps = number | null;
export type Target = number;
export type Unit2 = ("cups" | "oz" | "liters" | "gallons") | null;
export type Macros = null;
export type Meals3 = null;
export type Weight2 = null;
export type Workout = null;
export type Prompt = string;
export type Uuid6 = string;
export type Backend2 =
  | ""
  | "factual"
  | "recipes"
  | "foods"
  | "recent"
  | "nutritionix"
  | "nutritionix_v2"
  | "inline"
  | "usda"
  | "mfp"
  | "mfp_recipes";
export type BackendId2 = string;
export type Name9 = string;
export type Target1 = string;
export type Frequency = string;
export type Unit3 = string;
export type Supplements = Supplement[];
export type Entries1 = ServerJournalNutrition_ExpandedEntryInput[];
export type Assignments = ServerJournalDay_AssignmentInput[];
export type UserId5 = number | "REQUEST_USER";
export type Uuid7 = UUID;
export type Name10 = string;
export type CaloriesTarget1 = string | null;
export type ProteinTarget1 = string | null;
export type FatTarget1 = string | null;
export type CarbsTarget1 = string | null;
export type FiberTarget1 = string | null;
export type NetCarbsTarget1 = string | null;
export type Targets = ServerJournalDay_ConsumerTargetInput[];
export type Name11 = string;
export type DateOfBirth2 = string | null;
export type Gender2 = string | null;
export type IsImperial1 = boolean;
export type Weight3 = string | null;
export type Height1 = string | null;
export type BodyFat2 = string | null;
export type Activity1 = string | null;
export type Uuid8 = UUID;
export type Uuid9 = UUID;
export type Uuid10 = UUID;
export type UserId6 = number;
export type IsActive = boolean;
export type Uuid11 = UUID;
export type Name12 = string;
export type Description1 = string;
export type Uuid12 = UUID;
export type Name13 = string | null;
export type Instructions = string;
export type Maxes = "EXISTING_MAXES" | "UPDATE_MAXES" | "AUTOMATIC";
export type Workout__Mode = "NORMAL" | "GUIDED";
export type Uuid13 = UUID;
export type WorkoutSection__Type = "BASIC" | "ROUNDS" | "DURATION";
export type Name14 = string | null;
export type Instructions1 = string;
export type Uuid14 = UUID;
export type Duration = number | null;
export type Rounds = number | null;
export type Uuid15 = UUID;
export type Uuid16 = UUID;
export type Instructions2 = string;
export type VideoUid = string | null;
export type RestDuration = number | null;
export type Uuid17 = UUID;
export type Uuid18 = UUID;
export type Name15 = string | null;
export type Weight4 = string | null;
export type ExerciseProgression__Type = "LINEAR" | "DOUBLE_LINEAR";
export type Exercise__Mode = "NORMAL" | "GUIDED";
export type Structure = "STRAIGHT" | "INTERVALS";
export type Uuid19 = UUID;
export type ExerciseSet__Type = "WARM_UP" | "WORKING" | "FAILURE" | "MAX" | "AMRAP" | "RPE" | "REST" | "COOL_DOWN";
export type DurationType = "SECONDS" | "MINUTES" | "HOURS";
export type DistanceType = "INCHES" | "METERS" | "YARDS" | "FEET" | "KILOMETERS" | "MILES";
export type SpeedType = "MPH" | "KPH";
export type Instructions3 = string;
export type Reps = number | null;
export type Weight5 = string | null;
export type Rpe = string | null;
export type ExerciseSet__Status = "INCOMPLETE" | "COMPLETE" | "SKIPPED";
export type Duration1 = number | null;
export type Distance = string | null;
export type Speed = string | null;
export type Incline = string | null;
export type Resistance = number | null;
export type WeightType = "VALUE" | "PERCENTAGE" | "RPE";
export type WeightPercentage = string | null;
export type Attribute = "BELT" | "STRAPS" | "CHALK" | "MIXED_GRIP" | "HOOK_GRIP";
export type Attributes = Attribute[];
export type Sets = ServerJournalWorkouts_ExerciseSetInput[];
export type Exercises = ServerJournalWorkouts_ExerciseInput[];
export type Groups = ServerJournalWorkouts_ExerciseGroupInput[];
export type Sections = ServerJournalWorkouts_WorkoutSectionInput[];
export type Uuid20 = UUID;
export type Uuid21 = UUID;
export type Name16 = string;
export type QuestionType__Type = "TEXT" | "RPE";
export type Answer = string;
export type Questions = ServerJournalWorkouts_QuestionInput[];
export type Workouts1 = ServerJournalWorkouts_WorkoutGroupWorkoutInput[];
export type WorkoutGroups = ServerJournalWorkouts_WorkoutGroupInput[];
export type ExerciseMax__Type = "TRAINING" | "MAX" | "AMRAP";
export type Reps1 = number;
export type Weight6 = string;
export type ExerciseMaxes = Class_5827A8Dbcef8Beb664F2241Fa48B91Ee[];
export type Name17 = string;
export type Description2 = string;
export type Visibility = "PRIVATE" | "PUBLIC" | "CLIENTS";
export type WorkoutProgram__Type =
  | "FIVE_THREE_ONE"
  | "FIVE_BY_FIVE"
  | "DUMBBELL_PROGRESSION_V1"
  | "BARBELL_PROGRESSION_V1"
  | "CUSTOM";
export type Mode = "TEMPLATE" | "PROGRAM";
export type Data1 = string | null;
export type DateOfBirth3 = string;
export type Gender3 = "MALE" | "FEMALE";
export type Height2 = string;
export type WorkoutExperience = "NONE" | "DUMBBELL" | "BARBELL" | "SKIP";
export type Mfp = "YES" | "NO";
export type Units1 = "METRIC" | "IMPERIAL";
export type Goal2 = "WEIGHT_LOSS" | "AGGRESSIVE_WEIGHT_LOSS" | "HEALTH" | "BULK" | "MASS";
export type Activity2 = "SEDENTARY" | "ACTIVE" | "VERY_ACTIVE";
export type IapMethod = "iap" | "trial";
export type Weightlb1 = string | null;
export type Weightkg1 = string | null;
export type Targets1 = ServerJournalDay_ConsumerTargetInput[];
export type Today = string;
export type DateOfBirth4 = string;
export type Gender4 = "MALE" | "FEMALE";
export type Height3 = string;
export type WorkoutExperience1 = "NONE" | "DUMBBELL" | "BARBELL" | "SKIP";
export type Mfp1 = "YES" | "NO";
export type Units2 = "METRIC" | "IMPERIAL";
export type Goal3 = "WEIGHT_LOSS" | "AGGRESSIVE_WEIGHT_LOSS" | "HEALTH" | "BULK" | "MASS";
export type Activity3 = "SEDENTARY" | "ACTIVE" | "VERY_ACTIVE";
export type IapMethod1 = "iap" | "trial";
export type Weightlb2 = string | null;
export type Weightkg2 = string | null;
export type Targets2 = ServerJournalDay_ConsumerTargetInput[];
export type Id2 = number;
export type Email7 = string;
export type ContactEmail = string | null;
export type Name18 = string | null;
export type OrderNumber = number | null;
export type FinancialStatus = string | null;
export type FulfillmentStatus = string | null;
export type TotalPrice = string | null;
export type SubtotalPrice = string | null;
export type TotalTax = string | null;
export type Currency = string | null;
export type Id3 = number;
export type Email8 = string;
export type FirstName = string | null;
export type LastName = string | null;
export type State = string | null;
export type VerifiedEmail = boolean | null;
export type Phone = string | null;
export type Tags = string | null;
export type Currency1 = string | null;
export type Id4 = number;
export type Sku = string | null;
export type Name19 = string;
export type Title = string;
export type Quantity2 = number;
export type Price = string;
export type Vendor = string | null;
export type ProductId = number | null;
export type VariantId = number | null;
export type VariantTitle = string | null;
export type LineItems = ShopifyLineItem[];
export type TargetEntryUuid = string;
export type UserId7 = number;
export type Key2 = string;
export type SourceUserId = number | null;
export type SourceDayKey = string;
export type UserId8 = number;
export type Key3 = string;
export type SourceUserId1 = number | null;
export type SourceDayKey1 = string;
export type UserId9 = number;
export type Key4 = string;
export type UserId10 = number;
export type Key5 = string;
export type UserId11 = number;
export type Key6 = string;
export type Notes4 = string;
export type Question = number;
export type Response = "VERY_NEGATIVE" | "NEGATIVE" | "NEUTRAL" | "POSITIVE" | "VERY_POSITIVE";
export type Responses = CheckInResponseInput[];
export type Id5 = number | null;
export type Name20 = string;
export type CaloriesTarget2 = string | null;
export type ProteinTarget2 = string | null;
export type FatTarget2 = string | null;
export type CarbsTarget2 = string | null;
export type NetCarbsTarget2 = string | null;
export type Targets3 = TargetInput[];
export type Reference = number | null;
export type Assignments2 = AssignmentInput[];
export type SourceWorkout = string;
export type Name21 = string;
export type SourceWorkout1 = string;
export type SourceGroup = string;
export type Uuid22 = UUID;
export type Sections1 = ServerJournalWorkouts_WorkoutSectionInput[];
export type Questions1 = ServerJournalWorkouts_QuestionInput[];
export type Name22 = string;
export type Instructions4 = string;
export type SourceProgram = string;
export type Name23 = string;
export type SourceProgram1 = string;
export type SourceTemplate = string | "BLANK";
export type UserId12 = number;
export type ShouldSync = boolean;
export type Weight7 = string;
export type Reps2 = number;
export type ExerciseMaxes1 = ServerJournalWorkouts_ExerciseMaxInput[];
export type Uuid23 = string;
export type Name24 = string;
export type Category =
  | "WEIGHT"
  | "BODYWEIGHT"
  | "CARDIO"
  | "DURATION"
  | "DURATION_DISTANCE"
  | "REPS_DISTANCE"
  | "MEDLEY"
  | "WEIGHT_DISTANCE"
  | "WEIGHT_DURATION_DISTANCE";
export type RpcCreateExerciseTypesInput = CreateExerciseType[];
export type RpcSetExerciseMaxesInput = ServerJournalWorkouts_ExerciseMaxInput[];
export type SourceExerciseGroup = string;
export type SourceWorkout2 = string | "BLANK";
export type UserId13 = number;
export type Date2 = string;
export type SourceProgram2 = string;
export type SourceProgram3 = string;
export type Offset = number;
export type ExcludeWorkout = string;
export type Query = string;
export type Uuid24 = UUID;
export type Side = "LEFT" | "RIGHT";
export type GymVisualCode = string;
export type GymVisualVideoPath = string;
export type GymVisualImagePath = string;
export type GymVisualGifPath = string;
export type GymVisualGreenVideoPath = string;
export type Uuid25 = string;
export type Name25 = string;
export type VideoUrl = string;
export type VideoUid1 = string;
export type Description3 = string;
export type ExerciseSetUuid = string;
export type ExerciseUuid = string;
export type ExerciseUuid1 = string;
export type ExerciseTypeUuid = string;
export type WorkoutUuid = string;
export type UserId14 = number | null;
export type Date3 = string;
export type UserId15 = number;
export type SourceWorkoutUuid = string;
export type WorkoutUuid1 = string;
export type WorkoutUuid2 = string;
export type Name26 = string;
export type Instructions5 = string;
export type Uuid26 = string;
export type Name27 = string;
export type Entries2 = ServerJournalNutrition_ExpandedEntryInput[];
export type RecipeUuid1 = string;
export type Entries3 = ServerJournalNutrition_ExpandedEntryInput[];
export type Upc = string;
export type Keywords = string;
export type Source2 = "ALL" | "USDA";
export type SourcePrompt = string;
export type Date4 = string;
export type UserId16 = number;
export type ShareUuid1 = string;
export type RecipeUuid2 = string;
export type Name28 = string;
export type Upc1 = string;
export type FromMissingUpc = boolean;
export type CaloriesPg2 = string | null;
export type ProteinPg2 = string | null;
export type FatPg2 = string | null;
export type CarbsPg2 = string | null;
export type NetCarbsPg2 = string | null;
export type FiberPg2 = string | null;
export type SodiumPg2 = string | null;
export type SaturatedFatPg2 = string | null;
export type MonounsaturatedFatPg2 = string | null;
export type PolyunsaturatedFatPg2 = string | null;
export type TransFatPg2 = string | null;
export type CholesterolPg2 = string | null;
export type SugarsPg2 = string | null;
export type AddedSugarsPg2 = string | null;
export type PotassiumPg2 = string | null;
export type MagnesiumPg2 = string | null;
export type VitaminADvPg2 = string | null;
export type VitaminCDvPg2 = string | null;
export type CalciumDvPg2 = string | null;
export type IronDvPg2 = string | null;
export type BaseUnit2 = string;
export type BaseQuantity2 = string | null;
export type ServingSizeUnit2 = string;
export type ServingSizeNumerator2 = string | null;
export type ContainerServings2 = string | null;
export type Name29 = string;
export type Upc2 = string;
export type FromMissingUpc1 = boolean;
export type CaloriesPg3 = string | null;
export type ProteinPg3 = string | null;
export type FatPg3 = string | null;
export type CarbsPg3 = string | null;
export type NetCarbsPg3 = string | null;
export type FiberPg3 = string | null;
export type SodiumPg3 = string | null;
export type SaturatedFatPg3 = string | null;
export type MonounsaturatedFatPg3 = string | null;
export type PolyunsaturatedFatPg3 = string | null;
export type TransFatPg3 = string | null;
export type CholesterolPg3 = string | null;
export type SugarsPg3 = string | null;
export type AddedSugarsPg3 = string | null;
export type PotassiumPg3 = string | null;
export type MagnesiumPg3 = string | null;
export type VitaminADvPg3 = string | null;
export type VitaminCDvPg3 = string | null;
export type CalciumDvPg3 = string | null;
export type IronDvPg3 = string | null;
export type BaseUnit3 = string;
export type BaseQuantity3 = string | null;
export type ServingSizeUnit3 = string;
export type ServingSizeNumerator3 = string | null;
export type ContainerServings3 = string | null;
export type FoodId = number;
export type FoodId1 = number;
export type Name30 = string;
export type ContainerServings4 = string | null;
export type ServingSizeUnit4 = string;
export type ContainerQuantity2 = string | null;
export type ContainerUnit2 = string;
export type Notes5 = string;
export type Name31 = string;
export type ContainerServings5 = string | null;
export type ServingSizeUnit5 = string;
export type ContainerQuantity3 = string | null;
export type ContainerUnit3 = string;
export type Notes6 = string;
export type RecipeId = number;
export type RecipeId1 = number;
export type RecipeId2 = number;
export type Name32 = string;
export type ContainerServings6 = string | null;
export type ServingSizeUnit6 = string;
export type ContainerQuantity4 = string | null;
export type ContainerUnit4 = string;
export type Notes7 = string;
export type MealId = string;
export type MealUuid = string;
export type MealUuid1 = string;
export type UserId17 = number;
export type Key7 = string;
export type SourceMealUuid = string;
export type UserId18 = number;
export type Key8 = string;
export type SourceMealUuid1 = string;
export type EntryUuid = string;
export type EntryUuid1 = string;
export type Uuid27 = string;
export type ExerciseTypes = (
  | Related
  | ("weight" | "waist" | "navel" | "body_fat" | "hips" | "neck" | "thigh" | "bicep" | "chest")
)[];
export type Stat = "VOLUME" | "ESTIMATED_1RM" | "ESTIMATED_1RM_RATIO" | "WORKOUT_MAX" | "WORKOUT_MAX_RATIO" | "REPS";
export type StartDate2 = string;
export type EndDate2 = string;
export type UserId19 = number;
export type UserId20 = number;
export type Email9 = string;
export type Password1 = string;
export type Ignored1 = string;
export type WeeksAgo = number;
export type Ignored2 = string;
export type Code = string;
export type Code1 = string;
export type Email10 = string;
export type Code2 = string;
export type DisplayName = string;
export type ImageUid1 = string | null;
export type Code3 = string;
export type DisplayName1 = string;
export type ImageUid2 = string | null;
export type ImageUid3 = string;
export type Filename = string;
export type Description4 = string;
export type Width = number;
export type Height4 = number;
export type Values = number[];
export type Orientation = number;
export type ImageUid4 = string;
export type Filename1 = string;
export type Barcode = string;
export type PromptUuid = string;
export type Description5 = string;
export type Description6 = string;
export type PeptideKey = string;
export type Label = string;
export type VialMg = string;
export type WaterMl = string;
export type MixedAt = string;
export type VialUuid = string;
export type VialUuid1 = string;
export type Units3 = string;
export type TakenAt = string;
export type InjectionSite = string;
export type Uuid28 = UUID;
export type Weight8 = string | null;
export type Weight9 = string;
export type ExerciseMaxes2 = Class_67C6C646Cfcb2943Ba5Afd1539D1296A[];
export type Id6 = number;
export type Name33 = string;
export type Waist2 = string | null;
export type BodyFat3 = string | null;
export type UseKilojoules1 = boolean;
export type IsImperial2 = boolean;
export type Activity4 = string | null;
export type Goal4 = number | null;
export type Gender5 = string | null;
export type DateOfBirth5 = string | null;
export type Height5 = string | null;
export type Weight10 = string | null;
export type EntriesCreated1 = number;
export type WorkoutsCompleted1 = number;
export type Id7 = number;
export type DateJoined = string;
export type Email11 = string;
export type HasBetaAccess = boolean;
export type ShouldCollectAnalytics = boolean;
export type Id8 = number;
export type Name34 = string;
export type CaloriesTarget3 = string | null;
export type ProteinTarget3 = string | null;
export type FatTarget3 = string | null;
export type CarbsTarget3 = string | null;
export type FiberTarget2 = string | null;
export type NetCarbsTarget3 = string | null;
export type MealPlanId = number | null;
export type Targets4 = ClassDc93A75E1893A2E3B0De0Ee7151Ce111[];
export type IsSubscriptionActive = boolean;
export type ManagerFullName = string;
export type ManagerSlug = string;
export type TargetId = number | null;
export type DayOfWeek1 = number;
export type DayTemplateId = number | null;
export type Id9 = number;
export type Assignments3 = ClassE686Da6Bf39Ca0B52D6578Ee92015C98[];
export type MeetParticipants = Class_5Cb0Ef9Ea3A45E1459B41F54Edd99Ffe[];
export type Title1 = string;
export type ImageUrl = string | null;
export type LinkType = string;
export type Instructions6 = string[];
export type Name35 = string;
export type DisplayText = string;
export type Quantity3 = number;
export type Unit4 = string;
export type Measurements = InstacartMeasurement[];
export type Ingredients = InstacartIngredient[];
export type PartnerLinkbackUrl = string;
export type EnablePantryItems = boolean;
export type StartDate3 = string;
export type EndDate3 = string;
export type Name36 = string;
export type Waist3 = string | null;
export type BodyFat4 = string | null;
export type HasHiddenMacros = boolean;
export type UseKilojoules2 = boolean;
export type IsImperial3 = boolean;
export type Activity5 = string | null;
export type Goal5 = number | null;
export type Gender6 = string | null;
export type DateOfBirth6 = string | null;
export type Height6 = string | null;
export type Weight11 = string | null;
export type EntriesCreated2 = number;
export type WorkoutsCompleted2 = number;
export type Id10 = number;
export type DateJoined1 = string;
export type ManagerName = string | null;
export type Email12 = string;
export type HasBetaAccess1 = boolean;
export type TrackingKey = string;
export type ShouldCollectAnalytics1 = boolean;
export type Targets5 = ClassDc93A75E1893A2E3B0De0Ee7151Ce111[];
export type IsSubscriptionActive1 = boolean;
export type IsReportsEnabled = boolean;
export type IsTrialActive = boolean;
export type IsClient = boolean;
export type IsManager = boolean;
export type HasPeptides = boolean;
export type HasWalkingClub = boolean;
export type CastedDismissedAnnouncements = Announcement[];
export type GetMeasurements = (
  | "weight"
  | "waist"
  | "navel"
  | "body_fat"
  | "hips"
  | "neck"
  | "thigh"
  | "bicep"
  | "chest"
)[];
export type ManagerFullName1 = string;
export type ManagerSlug1 = string;
export type RegistrationRecipeName = string | null;
export type MustVerifyEmail = boolean;
export type Assignments4 = ClassE686Da6Bf39Ca0B52D6578Ee92015C98[];
export type ShareUuid2 = string;
export type RpcCheckEmailOutput = boolean | ServerCoreRpc_ProfileOutput1;
export type RpcUpdateSettingsOutput = null;
export type RpcApplePingOutput = null;
export type RpcTrackEmailClickOutput = boolean;
export type RpcRegisterApnsDeviceOutput = null;
export type RpcLinkAnalyticsOutput = Primitive | ("LATER" | "NEVER");
export type Value2 = string;
export type RpcPostmarkWebhookOutput = boolean;
export type ImageUid5 = string;
export type UploadUrl = string;
export type RpcRequestLoginLinkOutput = boolean | ServerCoreRpc_ProfileOutput1;
export type RpcLogoutOutput = boolean;
export type RpcResetPasswordOutput = null;
export type RpcContactOutput = boolean;
export type RpcDismissAnnouncementOutput = null;
export type RpcUpdateProfileOutput = null;
export type RpcDeleteProfileOutput = null;
export type RpcGetClientDashboardLinkOutput = string;
export type RpcInviteUserOutput = null;
export type RpcAttributeShareOutput = null;
export type RpcAttributeUtmOutput = null;
export type RpcCreateTrackingLinkOutput = string;
export type RpcValidateIapOutput = number | null;
export type RpcSubscriptionDetailOutput = AppleSubscriptionType | StripeSubscription | NoSubscription;
export type Type4 = "apple";
export type ExpiresDate = string;
export type Type5 = "stripe";
export type CurrentPeriodEnd = string;
export type Status4 = "trialing" | "active" | "past_due" | "canceled" | "unpaid";
export type Type6 = "none";
export type RpcCreateSubscriptionOutput = StripeSubscription | string;
export type RpcDeleteSubscriptionOutput = null;
export type RpcCreatePaypalSubscriptionOutput = null;
export type RpcSaveOutput = null;
export type RpcUpdateMetricsOutput = null;
export type RpcUpdateMetricAggregatesOutput = null;
export type IncludeInReports2 = boolean;
export type Name37 = string;
export type ShareUuid3 = string;
export type UserId21 = number;
export type Gratitude2 = string;
export type Name38 = string;
export type CreatedAt = string;
export type Comment = string;
export type Comments = Class_758F8129F9260A9A36D9312A74281C9B[];
export type Weight12 = string | null;
export type Waist4 = string | null;
export type Navel1 = string | null;
export type BodyFat5 = string | null;
export type Hips1 = string | null;
export type Neck1 = string | null;
export type Thigh1 = string | null;
export type Bicep1 = string | null;
export type Chest1 = string | null;
export type Measurements1 = ClassEa45F5C4Bc91F4A7A40B119Bf769Ce26[];
export type Id11 = number;
export type Key9 = string;
export type RecentMeals = string[];
export type Notes8 = string;
export type Uuid29 = UUID;
export type ShareUuid4 = string;
export type Key10 = string;
export type Name39 = string;
export type Hour1 = number | null;
export type Name40 = string;
export type ContainerServings7 = string;
export type ServingSizeUnit7 = string;
export type ContainerQuantity5 = string | null;
export type ContainerUnit5 = string;
export type Notes9 = string;
export type Uuid30 = UUID;
export type Name41 = string;
export type Unit5 = string;
export type Quantity4 = string;
export type CaloriesPg4 = string | null;
export type ProteinPg4 = string | null;
export type FatPg4 = string | null;
export type CarbsPg4 = string | null;
export type NetCarbsPg4 = string | null;
export type FiberPg4 = string | null;
export type SodiumPg4 = string | null;
export type SaturatedFatPg4 = string | null;
export type MonounsaturatedFatPg4 = string | null;
export type PolyunsaturatedFatPg4 = string | null;
export type TransFatPg4 = string | null;
export type CholesterolPg4 = string | null;
export type SugarsPg4 = string | null;
export type AddedSugarsPg4 = string | null;
export type PotassiumPg4 = string | null;
export type MagnesiumPg4 = string | null;
export type VitaminADvPg4 = string | null;
export type VitaminCDvPg4 = string | null;
export type CalciumDvPg4 = string | null;
export type IronDvPg4 = string | null;
export type BaseUnit4 = ("" | "g" | "oz" | "ml" | "fl oz" | "mg" | "mcg" | "iu") | "grams";
export type BaseQuantity4 = string | null;
export type ServingSizeUnit8 = string;
export type ServingSizeNumerator4 = string;
export type ServingSizeDenominator2 = string;
export type ContainerUnit6 = string;
export type ContainerQuantity6 = string | null;
export type ContainerServings8 = string;
export type Unit7 = string;
export type Multiplier = string;
export type Calories1 = number | null;
export type Info = string;
export type IsSecondary = boolean;
export type Units4 = Unit6[];
export type UsdaFoodId2 = number | null;
export type Notes10 = string;
export type AdditionalUnits2 = USDARawUnit[];
export type Uuid31 = UUID;
export type Name42 = string;
export type Barcode1 = string;
export type Backend3 =
  | ""
  | "factual"
  | "recipes"
  | "foods"
  | "recent"
  | "nutritionix"
  | "nutritionix_v2"
  | "inline"
  | "usda"
  | "mfp"
  | "mfp_recipes";
export type BackendId3 = string;
export type Uuid32 = UUID;
export type Name43 = string;
export type Unit8 = string;
export type Quantity5 = string;
export type CaloriesPg5 = string | null;
export type ProteinPg5 = string | null;
export type FatPg5 = string | null;
export type CarbsPg5 = string | null;
export type NetCarbsPg5 = string | null;
export type FiberPg5 = string | null;
export type SodiumPg5 = string | null;
export type SaturatedFatPg5 = string | null;
export type MonounsaturatedFatPg5 = string | null;
export type PolyunsaturatedFatPg5 = string | null;
export type TransFatPg5 = string | null;
export type CholesterolPg5 = string | null;
export type SugarsPg5 = string | null;
export type AddedSugarsPg5 = string | null;
export type PotassiumPg5 = string | null;
export type MagnesiumPg5 = string | null;
export type VitaminADvPg5 = string | null;
export type VitaminCDvPg5 = string | null;
export type CalciumDvPg5 = string | null;
export type IronDvPg5 = string | null;
export type BaseUnit5 = ("" | "g" | "oz" | "ml" | "fl oz" | "mg" | "mcg" | "iu") | "grams";
export type BaseQuantity5 = string | null;
export type ServingSizeUnit9 = string;
export type ServingSizeNumerator5 = string;
export type ServingSizeDenominator3 = string;
export type ContainerUnit7 = string;
export type ContainerQuantity7 = string | null;
export type ContainerServings9 = string;
export type Units5 = Unit6[];
export type UsdaFoodId3 = number | null;
export type Notes11 = string;
export type AdditionalUnits3 = USDARawUnit[];
export type Backend4 =
  | ""
  | "factual"
  | "recipes"
  | "foods"
  | "recent"
  | "nutritionix"
  | "nutritionix_v2"
  | "inline"
  | "usda"
  | "mfp"
  | "mfp_recipes";
export type BackendId4 = string;
export type ExpandedRecipe1 = ServerJournalNutrition_EntryOutput[];
export type Entries4 = ServerJournalNutrition_ExpandedEntryOutput[];
export type Meals4 = ServerJournalNutrition_MealOutput[];
export type Pk1 = number;
export type Id12 = number;
export type UserId22 = number;
export type Name44 = string;
export type CaloriesTarget4 = string | null;
export type ProteinTarget4 = string | null;
export type FatTarget4 = string | null;
export type CarbsTarget4 = string | null;
export type FiberTarget3 = string | null;
export type NetCarbsTarget4 = string | null;
export type SodiumTarget1 = string | null;
export type SaturatedFatTarget1 = string | null;
export type MonounsaturatedFatTarget1 = string | null;
export type PolyunsaturatedFatTarget1 = string | null;
export type TransFatTarget1 = string | null;
export type CholesterolTarget1 = string | null;
export type SugarsTarget1 = string | null;
export type AddedSugarsTarget1 = string | null;
export type PotassiumTarget1 = string | null;
export type MagnesiumTarget1 = string | null;
export type VitaminADvTarget1 = string | null;
export type VitaminCDvTarget1 = string | null;
export type CalciumDvTarget1 = string | null;
export type IronDvTarget1 = string | null;
export type Name45 = string;
export type Source3 = string;
export type BackendId5 = string;
export type Backend5 =
  | ""
  | "factual"
  | "recipes"
  | "foods"
  | "recent"
  | "nutritionix"
  | "nutritionix_v2"
  | "inline"
  | "usda"
  | "mfp"
  | "mfp_recipes";
export type IsCupboard = boolean;
export type Supplements1 = SearchResult[];
export type Uuid33 = UUID;
export type Name46 = string | null;
export type Date5 = string | null;
export type Uuid34 = UUID;
export type Name47 = string | null;
export type Date6 = string | null;
export type Instructions7 = string;
export type Id13 = number;
export type UserId23 = number | null;
export type Workout__Status = "INCOMPLETE" | "COMPLETE";
export type Uuid35 = UUID;
export type Name48 = string | null;
export type Instructions8 = string;
export type Duration2 = number | null;
export type Rounds1 = number | null;
export type Uuid36 = UUID;
export type Uuid37 = UUID;
export type Instructions9 = string;
export type VideoUid2 = string | null;
export type RestDuration1 = number | null;
export type Uuid38 = UUID;
export type Id14 = number;
export type UserId24 = number | null;
export type VideoUrl1 = string;
export type VideoUid3 = string | null;
export type Name49 = string;
export type CardioMetric = "INCLINE" | "RESISTANCE";
export type CastedCardioMetrics = CardioMetric[];
export type Description7 = string;
export type VideoUid4 = string | null;
export type GifUid = string | null;
export type ImageUid6 = string | null;
export type WideImageUid = string | null;
export type Id15 = number;
export type Uuid39 = UUID;
export type RestDuration2 = number | null;
export type Uuid40 = UUID;
export type Instructions10 = string;
export type Reps3 = number | null;
export type Weight13 = string | null;
export type Rpe1 = string | null;
export type Duration3 = number | null;
export type Distance1 = string | null;
export type Speed1 = string | null;
export type Incline1 = string | null;
export type Resistance1 = number | null;
export type WeightPercentage1 = string | null;
export type Attributes1 = Attribute[];
export type Sets1 = ServerJournalWorkouts_ExerciseSetOutput[];
export type LatestInstances = ServerJournalWorkouts_LatestExerciseInstanceOutput[];
export type Uuid41 = UUID;
export type Name50 = string | null;
export type Weight14 = string | null;
export type Sets2 = ServerJournalWorkouts_ExerciseSetOutput[];
export type Exercises1 = ServerJournalWorkouts_ExerciseOutput[];
export type Groups1 = ServerJournalWorkouts_ExerciseGroupOutput[];
export type Sections2 = ServerJournalWorkouts_WorkoutSectionOutput[];
export type Uuid42 = UUID;
export type Answer1 = string;
export type Questions2 = ServerJournalWorkouts_QuestionOutput[];
export type Id16 = number;
export type ClientCheckInQuestion__Type = "SLEEP" | "HUNGER" | "STRESS" | "ENERGY" | "MOOD";
export type Label1 = string;
export type Label2 = string;
export type ResponseLabels = ResponseLabel[];
export type Responses1 = ServerJournalDay_CheckInResponseOutput[];
export type Notes12 = string;
export type NotesLabel = string;
export type DayOfWeek2 = number;
export type Supplements2 = Supplement[];
export type Targets6 = ServerJournalNutrition_TargetOutput[];
export type Weight15 = string;
export type Reps4 = number;
export type Actual = ServerJournalWorkouts_ExerciseMaxOutput[];
export type Id17 = number;
export type Uuid43 = UUID;
export type UserId25 = number | null;
export type Name51 = string;
export type Instructions11 = string;
export type Sections3 = ServerJournalWorkouts_WorkoutSectionOutput[];
export type Questions3 = ServerJournalWorkouts_QuestionOutput[];
export type WorkoutTemplates = ServerJournalWorkouts_WorkoutTemplateOutput[];
export type Id18 = number;
export type Uuid44 = UUID;
export type Name52 = string | null;
export type UserId26 = number;
export type Description8 = string;
export type Id19 = number;
export type Workouts2 = ClassDa38A4A8E60F1Eafb270501E7B48443D[];
export type WorkoutGroups1 = ClassC8C083D669916D427F5619E62727B61E[];
export type ProductCode = string;
export type ProgramTemplates = ServerJournalWorkouts_ListProgramOutput[];
export type Id20 = number;
export type Name53 = string | null;
export type Description9 = string;
export type UserId27 = number;
export type UpdatedAt = string;
export type Uuid45 = UUID;
export type ProductCode1 = string;
export type Uuid46 = UUID;
export type Id21 = number;
export type UserId28 = number;
export type IsActive1 = boolean;
export type ShouldSync1 = boolean;
export type Uuid47 = UUID;
export type Name54 = string;
export type Description10 = string;
export type Uuid48 = UUID;
export type Name55 = string | null;
export type Instructions12 = string;
export type UsedOn = string | null;
export type ExercisesCount = number;
export type Workouts3 = Class_473E5694Ae108C455C9Ce6673D2F6496[];
export type WorkoutGroups2 = ClassC07Df7F21E2E0C593087Ecbb999E1F26[];
export type Uuid49 = UUID;
export type UserId29 = number;
export type IsActive2 = boolean;
export type Instances = Class_43C5B25Fa3Fce14F2C8Ccf975Bd78Daa[];
export type StartDate4 = string;
export type EndDate4 = string;
export type IsManual1 = boolean;
export type Value3 = number | null;
export type AppleHealthUuids1 = string[];
export type AppleHealthUuid2 = UUID;
export type Timezone6 = string;
export type StartTime1 = string;
export type EndTime1 = string;
export type WorkoutActivityType1 = string;
export type WorkoutActivityId1 = number;
export type DurationSeconds1 = number;
export type Calories2 = string | null;
export type DistanceMeters1 = string | null;
export type Source4 = string;
export type SourceBundleId1 = string;
export type Activities = ServerJournalDay_WorkoutAggregateOutput[];
export type WorkoutStatus = "WORKOUT_DUE" | "REST_DAY";
export type Streak = number;
export type ClassName = string;
export type StartDate5 = string;
export type CurrentDayNumber = number;
export type StepsGoal = number;
export type MemberUuid = string;
export type DisplayName2 = string;
export type DayNumber = number;
export type Date7 = string;
export type HasLoggedMeals = boolean;
export type HasLoggedWeight = boolean;
export type HasHitSteps = boolean;
export type MealCount = number;
export type Steps1 = number | null;
export type Days = ServerJournalLearningWeek_LearningWeekDayStatusOutput[];
export type GroupStatuses = ServerJournalLearningWeek_LearningWeekMemberStatusOutput[];
export type RpcUpdateDayOutput = "SUBSCRIPTION_REQUIRED" | UpdateDayResult;
export type Streak1 = number;
export type RpcLegacyUpdateDayOutput = "SUBSCRIPTION_REQUIRED" | LegacyUpdateDayOutput;
export type Streak2 = number;
export type SubscriptionDollarsPerMonth = number;
export type SubscriptionDollarsPerYear = number;
export type StripePublishableKey = string;
export type MixpanelToken = string;
export type SentryDsn = string;
export type TrackingKey1 = string | null;
export type ShouldCollectAnalytics2 = boolean;
export type Update = UpdateRequired | NativeUpdateRequired | UpdateNotRequired;
export type Type7 = "UPDATE_REQUIRED";
export type IndexFile = string;
export type RequiresUpdate = boolean;
export type Version = string;
export type Folders = string[];
export type StaticFiles = string[];
export type MediaFiles = string[];
export type StaticUrl = string;
export type Type8 = "NATIVE_UPDATE_REQUIRED";
export type Type9 = "UPDATE_NOT_REQUIRED";
export type RpcPlannerOutput = null;
export type RpcStartOutput = null;
export type RpcResetChallengeOutput = null;
export type RpcShopifyOrderCreatedOutput = null;
export type RpcReplaceEntryOutput = null;
export type RpcVerifyPurchaseEntitlementOutput = ServerJournalDay_PurchaseVerificationOutput | false;
export type Email13 = string;
export type TrackingKey2 = string;
export type ShouldCollectAnalytics3 = boolean;
export type RpcMoveDayOutput = null;
export type RpcCopyDayOutput = null;
export type RpcAcceptMealPlanOutput = null;
export type RpcRejectMealPlanOutput = null;
export type RpcCheckInOutput = null;
export type RpcTargetPlannerOutput = null;
export type Id22 = number;
export type Name56 = string | null;
export type Description11 = string;
export type UserId30 = number;
export type UpdatedAt1 = string;
export type Uuid50 = UUID;
export type ProductCode2 = string;
export type Uuid51 = UUID;
export type Name57 = string;
export type Description12 = string;
export type Id23 = number;
export type UserId31 = number;
export type Order = number;
export type Uuid52 = UUID;
export type Name58 = string | null;
export type Instructions13 = string;
export type Date8 = string | null;
export type Pk2 = number;
export type Pk3 = number;
export type TemplateInstances = ClassBc8320968D5C615C82Cc66Ab21688Cb2[];
export type UsedOn1 = string | null;
export type Id24 = number;
export type UserId32 = number | null;
export type Date9 = string | null;
export type ExercisesCount1 = number;
export type Sections4 = ServerJournalWorkouts_WorkoutSectionOutput[];
export type Questions4 = ServerJournalWorkouts_QuestionOutput[];
export type Workouts4 = ServerJournalWorkouts_WorkoutGroupWorkoutOutput[];
export type WorkoutGroups3 = ServerJournalWorkouts_WorkoutGroupOutput[];
export type Instances1 = Class_43C5B25Fa3Fce14F2C8Ccf975Bd78Daa[];
export type ExerciseMaxes4 = Class_5827A8Dbcef8Beb664F2241Fa48B91Ee[];
export type Templates = ServerJournalWorkouts_WorkoutTemplateOutput[];
export type ExerciseTypes1 = ServerJournalWorkouts_ExerciseTypeOutput[];
export type Uuid53 = UUID;
export type Name59 = string;
export type QuestionTypes = ServerJournalWorkouts_QuestionTypeOutput[];
export type Id25 = number;
export type Uuid54 = UUID;
export type Name60 = string | null;
export type UpdatedAt2 = string;
export type CompletedOn = string | null;
export type Programs = ServerJournalWorkouts_PastProgramOutput[];
export type ProgramTemplates1 = ServerJournalWorkouts_ListProgramOutput[];
export type ExerciseMaxes5 = ServerJournalWorkouts_ExerciseMaxOutput[];
export type Uuid55 = UUID;
export type Id26 = number;
export type Name61 = string | null;
export type Uuid56 = UUID;
export type Name62 = string;
export type Weight16 = string | null;
export type ExerciseProgressions = ServerJournalWorkouts_ExerciseProgressionOutput[];
export type Related1 = string[];
export type FirstInWorkoutCount = number;
export type ExerciseTypeUsers = ServerJournalWorkouts_ExerciseTypeUserOutput[];
export type RpcCreateTemplateFromWorkoutOutput = null;
export type RpcDeleteGroupOutput = null;
export type RpcUpdateWorkoutOutput = null;
export type RpcUpdateProgramOutput = null;
export type RpcCreateProgramOutput = null;
export type RpcDeleteProgramOutput = null;
export type RpcCreateExerciseTypesOutput = ServerJournalWorkouts_ExerciseTypeOutput[];
export type RpcSetExerciseMaxesOutput = null;
export type RpcDeleteExerciseTypeOutput = null;
export type RpcDeleteExerciseGroupOutput = null;
export type RpcSelectProgramWorkoutOutput = "SUBSCRIPTION_REQUIRED" | ServerJournalWorkouts_WorkoutOutput;
export type RpcArchiveProgramOutput = null;
export type RpcDisableSyncOutput = null;
export type Uuid57 = UUID;
export type Uuid58 = UUID;
export type Name63 = string | null;
export type Uuid59 = UUID;
export type Name64 = string;
export type Uuid60 = UUID;
export type Name65 = string | null;
export type Name66 = string | null;
export type Instructions14 = string;
export type Duration4 = number | null;
export type Rounds2 = number | null;
export type Groups2 = ServerJournalWorkouts_ExerciseGroupOutput[];
export type RpcRecentSectionsOutput = ServerJournalWorkouts_WorkoutSectionHistoryOutput[];
export type Urls = string[][];
export type RpcUpdateExerciseMediaOutput = null;
export type RpcDeleteExerciseSetOutput = null;
export type RpcDeleteExerciseOutput = null;
export type RpcClearExerciseSetsOutput = null;
export type Id27 = number;
export type Order1 = number;
export type Uuid61 = UUID;
export type Instructions15 = string;
export type RestDuration3 = number | null;
export type Uuid62 = UUID;
export type Date10 = string | null;
export type Sets3 = ServerJournalWorkouts_ExerciseSetOutput[];
export type RpcExerciseDetailOutput = ServerJournalWorkouts_ExerciseHistoryOutput[];
export type RpcCompleteWorkoutOutput = null;
export type RpcIncompleteWorkoutOutput = null;
export type RpcDeleteEntryOutput = null;
export type RpcUpdateCupboardOutput = null;
export type Uuid63 = UUID;
export type Name67 = string;
export type Unit9 = string;
export type Quantity6 = string;
export type CaloriesPg6 = string | null;
export type ProteinPg6 = string | null;
export type FatPg6 = string | null;
export type CarbsPg6 = string | null;
export type NetCarbsPg6 = string | null;
export type FiberPg6 = string | null;
export type SodiumPg6 = string | null;
export type SaturatedFatPg6 = string | null;
export type MonounsaturatedFatPg6 = string | null;
export type PolyunsaturatedFatPg6 = string | null;
export type TransFatPg6 = string | null;
export type CholesterolPg6 = string | null;
export type SugarsPg6 = string | null;
export type AddedSugarsPg6 = string | null;
export type PotassiumPg6 = string | null;
export type MagnesiumPg6 = string | null;
export type VitaminADvPg6 = string | null;
export type VitaminCDvPg6 = string | null;
export type CalciumDvPg6 = string | null;
export type IronDvPg6 = string | null;
export type BaseUnit6 = ("" | "g" | "oz" | "ml" | "fl oz" | "mg" | "mcg" | "iu") | "grams";
export type BaseQuantity6 = string | null;
export type ServingSizeUnit10 = string;
export type ServingSizeNumerator6 = string;
export type ServingSizeDenominator4 = string;
export type ContainerUnit8 = string;
export type ContainerQuantity8 = string | null;
export type ContainerServings10 = string;
export type Units6 = Unit6[];
export type UsdaFoodId4 = number | null;
export type Notes13 = string;
export type AdditionalUnits4 = USDARawUnit[];
export type Id28 = number;
export type UserId33 = number | null;
export type Name68 = string;
export type Uuid64 = UUID;
export type Uuid65 = UUID;
export type Ingredients1 = Class_7B2B07D8F07437Ac098134546F8Dc2Ee[];
export type Sections5 = Class_2E85F80540A445D1B62A05122Ba75480[];
export type ExpandedRecipe2 = ServerJournalNutrition_ExpandedEntryOutput[];
export type Key11 = string[];
export type Hash = string;
export type Dates = string[];
export type Frequency1 = number;
export type Locator = string;
export type Name69 = string;
export type Entries5 = EntryItem[];
export type Recent = SearchResult[];
export type Foods = SearchResult[];
export type Recipes = SearchResult[];
export type Uuid66 = UUID;
export type Meal = string;
export type Food = string;
export type Related2 = string[];
export type FoodUser = ServerJournalNutrition_FoodUserOutput[];
export type Name70 = string;
export type RootLocator = string;
export type Hash1 = string;
export type Locators = string[];
export type Dates1 = string[];
export type Patterns = MealPattern[];
export type Roots = RootPatterns[];
export type RpcSearchOutput = SearchResult[];
export type RpcPublishNutritionalVisionPromptOutput = null;
export type RpcShareDetailOutput = DayShare | MealShare | ProfileShare | EntryShare | RecipeShare;
export type Type10 = "day";
export type ShareUuid5 = string;
export type Type11 = "meal";
export type ShareUuid6 = string;
export type Type12 = "profile";
export type DateOfBirth7 = string | null;
export type ShareUuid7 = string;
export type Type13 = "entry";
export type ShareUuid8 = string;
export type Type14 = "recipe";
export type ShareUuid9 = string;
export type IsFavorite = boolean;
export type RpcToggleRecipeFavoriteOutput = boolean;
export type Id29 = number;
export type Name71 = string;
export type Upc3 = string;
export type FromMissingUpc2 = boolean;
export type FromNutritionixBackendId = string;
export type CaloriesPg7 = string | null;
export type ProteinPg7 = string | null;
export type FatPg7 = string | null;
export type CarbsPg7 = string | null;
export type NetCarbsPg7 = string | null;
export type FiberPg7 = string | null;
export type SodiumPg7 = string | null;
export type SaturatedFatPg7 = string | null;
export type MonounsaturatedFatPg7 = string | null;
export type PolyunsaturatedFatPg7 = string | null;
export type TransFatPg7 = string | null;
export type CholesterolPg7 = string | null;
export type SugarsPg7 = string | null;
export type AddedSugarsPg7 = string | null;
export type PotassiumPg7 = string | null;
export type MagnesiumPg7 = string | null;
export type VitaminADvPg7 = string | null;
export type VitaminCDvPg7 = string | null;
export type CalciumDvPg7 = string | null;
export type IronDvPg7 = string | null;
export type BaseUnit7 = "" | "g" | "oz" | "ml" | "fl oz" | "mg" | "mcg" | "iu";
export type BaseQuantity7 = string | null;
export type ServingSizeUnit11 = string;
export type ServingSizeNumerator7 = string | null;
export type ContainerServings11 = string | null;
export type RpcFoodListOutput = ServerJournalNutrition_FoodOutput[];
export type Foods1 = ServerJournalNutrition_FoodOutput[];
export type RpcUpdateFoodOutput = ServerJournalNutrition_FoodOutput[];
export type RpcDeleteFoodOutput = ServerJournalNutrition_FoodOutput[];
export type RpcRecipeListOutput = ServerJournalNutrition_RecipeOutput[];
export type RpcUpdateRecipeMetadataOutput = ServerJournalNutrition_RecipeOutput[];
export type RpcDeleteRecipeOutput = ServerJournalNutrition_RecipeOutput[];
export type RpcPublishMealOutput = null;
export type RpcDeleteMealOutput = null;
export type RpcMoveMealOutput = null;
export type RpcCopyMealOutput = null;
export type RpcPublishEntryOutput = string;
export type RpcExpandEntryOutput = null;
export type Date11 = string;
export type Metric = string | null;
export type Position = number;
export type Measurements2 = ReportMeasurement[];
export type Trend = ReportMeasurement[];
export type Lines = Line[];
export type Date12 = string;
export type Weight17 = string | null;
export type Steps2 = string | null;
export type Calories3 = string | null;
export type ExpendedCalories = string | null;
export type Protein = string | null;
export type Fat = string | null;
export type Carbs = string | null;
export type Fiber = string | null;
export type Magnesium = string | null;
export type Potassium = string | null;
export type Sodium = string | null;
export type Sugars = string | null;
export type AddedSugars = string | null;
export type Cholesterol = string | null;
export type VitaminADv = string | null;
export type VitaminCDv = string | null;
export type CalciumDv = string | null;
export type IronDv = string | null;
export type NetCarbs = string | null;
export type SaturatedFat = string | null;
export type MonounsaturatedFat = string | null;
export type PolyunsaturatedFat = string | null;
export type TransFat = string | null;
export type IncludeInReports3 = boolean;
export type Tdee = string | null;
export type WeightDelta = string | null;
export type Date13 = string;
export type Weight18 = string | null;
export type Steps3 = string | null;
export type Calories4 = string | null;
export type ExpendedCalories1 = string | null;
export type Protein1 = string | null;
export type Fat1 = string | null;
export type Carbs1 = string | null;
export type Fiber1 = string | null;
export type Magnesium1 = string | null;
export type Potassium1 = string | null;
export type Sodium1 = string | null;
export type Sugars1 = string | null;
export type AddedSugars1 = string | null;
export type Cholesterol1 = string | null;
export type VitaminADv1 = string | null;
export type VitaminCDv1 = string | null;
export type CalciumDv1 = string | null;
export type IronDv1 = string | null;
export type NetCarbs1 = string | null;
export type SaturatedFat1 = string | null;
export type MonounsaturatedFat1 = string | null;
export type PolyunsaturatedFat1 = string | null;
export type TransFat1 = string | null;
export type IncludeInReports4 = boolean;
export type Tdee1 = string | null;
export type WeightDelta1 = string | null;
export type Days1 = Macros1[];
export type Statuses = WeeklyMacrosEntry[];
export type AverageTdee = string | null;
export type RpcMfpMigrationDetailOutput = ServerJournalMfp_MFPMigrationOutput | null;
export type MFPAccount__Status =
  | "VALIDATED"
  | "LOGGED_IN"
  | "ERROR_LOGGING_IN"
  | "POPULATED"
  | "ERROR_POPULATING"
  | "ERROR"
  | "MIGRATED"
  | "MIGRATED_WITH_RECIPES"
  | "ERROR_MIGRATING"
  | "NEEDS_REMIGRATION";
export type Uuid67 = UUID;
export type Uuid68 = UUID;
export type ClubName = string;
export type JoinCode = string | null;
export type StepsGoal1 = number;
export type LastCompleteWeekday = number;
export type WeekStart = string;
export type WeeksAvailable = number;
export type MemberUuid1 = string;
export type DisplayName3 = string;
export type ImageUid7 = string | null;
export type IsYou = boolean;
export type IsLive = boolean;
export type Resting = string | null;
export type TodayBuckets = number[];
export type TodayTotal = number;
export type WeekDaily = (number | null)[];
export type WeekTotal = number;
export type Members = ServerJournalClubs_WalkingClubMemberStatusOutput[];
export type RpcWalkingClubDemoAllowedOutput = boolean;
export type ClubName1 = string;
export type MemberCount = number;
export type TodayTotal1 = number;
export type StepsGoal2 = number;
export type ViewerName = string | null;
export type RpcWalkingClubLoginLinkOutput = boolean | ServerCoreRpc_ProfileOutput1;
export type Uuid69 = UUID;
export type Barcode2 = string;
export type Uuid70 = UUID;
export type ImageUid8 = UUID | null;
export type ShareUuid10 = string;
export type Name72 = string;
export type Entries8 = ServerJournalNutrition_ExpandedEntryOutput[];
export type Uuid71 = string;
export type PeptideKey1 = string;
export type Label3 = string;
export type VialMg1 = string;
export type WaterMl1 = string;
export type MixedAt1 = string;
export type CreatedAt1 = string;
export type Uuid72 = string;
export type Units7 = string;
export type TakenAt1 = string;
export type InjectionSite1 = string;
export type Doses = DoseOutput[];
export type TotalUnitsUsed = string;
export type Vials = VialWithComputed[];
export type RpcDeletePeptideVialOutput = null;
export type RpcUpdateMeetOutput = null;
export type RpcInstacartRecipeOutput = string | null;
export type FdcId = number;
export type NdbNumber = string;
export type Description13 = string;
export type FoodPortions = USDARawUnit[];
export type Unit10 = string;
export type Multiplier1 = string;
export type Units8 = USDAUnit[];
export type RpcUsdaFoodsOutput = ServerNutritionRpc_USDAFoodOutput[];
export type Date14 = string;
export type DisplayName4 = string;
export type Name73 = string;
export type Quantity7 = string;
export type Unit11 = string;
export type Calories5 = string | null;
export type Protein2 = string | null;
export type Fat2 = string | null;
export type NetCarbs2 = string | null;
export type Fiber2 = string | null;
export type Sodium2 = string | null;
export type SaturatedFat2 = string | null;
export type MonounsaturatedFat2 = string | null;
export type PolyunsaturatedFat2 = string | null;
export type TransFat2 = string | null;
export type Cholesterol2 = string | null;
export type Sugars2 = string | null;
export type AddedSugars2 = string | null;
export type Potassium2 = string | null;
export type Magnesium2 = string | null;
export type VitaminADv2 = string | null;
export type VitaminCDv2 = string | null;
export type CalciumDv2 = string | null;
export type IronDv2 = string | null;
export type Entries9 = ClassD96B761Babfb5Beb16A65069D0A280Cb[];
export type Meals5 = ServerNutritionRpc_ExportMealOutput[];
export type Name74 = string | null;
export type Name75 = string | null;
export type Name76 = string;
export type Reps5 = number | null;
export type Weight19 = string | null;
export type Rpe2 = string | null;
export type Duration5 = number | null;
export type Distance2 = string | null;
export type Sets4 = ClassF1Dcd5Ac04B7E185A925C5F8D26398A4[];
export type Exercises2 = ClassB4324092C1F795A0516D5B52D1E91A2A[];
export type Groups3 = Class_0Ff46Ed77Dfa6A24F68Edb178B3C013D[];
export type Sections6 = Class_90B405F4C9Dc72638Fc7B8Ebdcc1D9E3[];
export type RpcExportJournalOutput = ExportDay[];
export type Id30 = number;
export type Email14 = string;
export type RpcGetAvailablePredictionUsersOutput = AvailableUser[];
export type Id31 = number;
export type FullName = string;
export type Id32 = number;
export type LeadEmail = string;
export type FullName1 = string;
export type CreatedAt2 = string;
export type DayNumber1 = number;
export type Date15 = string;
export type HasLoggedMeals1 = boolean;
export type HasLoggedWeight1 = boolean;
export type HasHitSteps1 = boolean;
export type MealCount1 = number;
export type Steps4 = number | null;
export type MemberUuid2 = string;
export type DisplayName5 = string;
export type Days2 = ServerJournalLearningWeek_LearningWeekDayStatusInput[];
export type Uuid73 = UUID;
export type Name77 = string;
export type Entries10 = ServerJournalNutrition_ExpandedEntryInput[];
export type Uuid74 = UUID;
export type Name78 = string;
export type Unit12 = string;
export type Quantity8 = string;
export type CaloriesPg8 = string | null;
export type ProteinPg8 = string | null;
export type FatPg8 = string | null;
export type CarbsPg8 = string | null;
export type NetCarbsPg8 = string | null;
export type FiberPg8 = string | null;
export type SodiumPg8 = string | null;
export type SaturatedFatPg8 = string | null;
export type MonounsaturatedFatPg8 = string | null;
export type PolyunsaturatedFatPg8 = string | null;
export type TransFatPg8 = string | null;
export type CholesterolPg8 = string | null;
export type SugarsPg8 = string | null;
export type AddedSugarsPg8 = string | null;
export type PotassiumPg8 = string | null;
export type MagnesiumPg8 = string | null;
export type VitaminADvPg8 = string | null;
export type VitaminCDvPg8 = string | null;
export type CalciumDvPg8 = string | null;
export type IronDvPg8 = string | null;
export type BaseUnit8 = ("" | "g" | "oz" | "ml" | "fl oz" | "mg" | "mcg" | "iu") | "grams";
export type BaseQuantity8 = string | null;
export type ServingSizeUnit12 = string;
export type ServingSizeNumerator8 = string;
export type ServingSizeDenominator5 = string;
export type ContainerUnit9 = string;
export type ContainerQuantity9 = string | null;
export type ContainerServings12 = string;
export type UsdaFoodId5 = number | null;
export type Notes14 = string;
export type AdditionalUnits5 = USDARawUnit[];
export type Id33 = number;
export type UserId34 = number | null;
export type Sections7 = Class_2E85F80540A445D1B62A05122Ba75480[];
export type ExpandedRecipe3 = ServerJournalNutrition_ExpandedEntryInput[];
export type Name79 = string;
export type Hour2 = number | null;
export type Name80 = string;
export type Hour3 = number | null;
export type IncludeInReports5 = boolean;
export type Name81 = string;
export type UserId35 = number;
export type Gratitude3 = string;
export type Comment1 = string;
export type Comments1 = Class_2053Fc65B48C18869C79A8Df4Ab94Ca9[];
export type Measurements3 = ClassEa45F5C4Bc91F4A7A40B119Bf769Ce26[];
export type Id34 = number;
export type Notes15 = string;
export type Meals6 = ServerJournalNutrition_MealInput[];
export type Name82 = string;
export type Uuid75 = UUID;
export type CaloriesPg9 = string | null;
export type ProteinPg9 = string | null;
export type FatPg9 = string | null;
export type CarbsPg9 = string | null;
export type NetCarbsPg9 = string | null;
export type FiberPg9 = string | null;
export type SodiumPg9 = string | null;
export type SaturatedFatPg9 = string | null;
export type MonounsaturatedFatPg9 = string | null;
export type PolyunsaturatedFatPg9 = string | null;
export type TransFatPg9 = string | null;
export type CholesterolPg9 = string | null;
export type SugarsPg9 = string | null;
export type AddedSugarsPg9 = string | null;
export type PotassiumPg9 = string | null;
export type MagnesiumPg9 = string | null;
export type VitaminADvPg9 = string | null;
export type VitaminCDvPg9 = string | null;
export type CalciumDvPg9 = string | null;
export type IronDvPg9 = string | null;
export type BaseUnit9 = ("" | "g" | "oz" | "ml" | "fl oz" | "mg" | "mcg" | "iu") | "grams";
export type BaseQuantity9 = string | null;
export type ServingSizeUnit13 = string;
export type ServingSizeNumerator9 = string;
export type ServingSizeDenominator6 = string;
export type ContainerUnit10 = string;
export type ContainerQuantity10 = string | null;
export type ContainerServings13 = string;
export type UsdaFoodId6 = number | null;
export type Backend6 =
  | ""
  | "factual"
  | "recipes"
  | "foods"
  | "recent"
  | "nutritionix"
  | "nutritionix_v2"
  | "inline"
  | "usda"
  | "mfp"
  | "mfp_recipes";
export type BackendId6 = string;
export type ExpandedRecipe4 = ServerJournalNutrition_EntryInput[];
export type AdditionalUnits6 = USDARawUnit[];
export type Name83 = string;
export type Uuid76 = UUID;
export type Unit13 = string;
export type Quantity9 = string;
export type CaloriesPg10 = string | null;
export type ProteinPg10 = string | null;
export type FatPg10 = string | null;
export type CarbsPg10 = string | null;
export type NetCarbsPg10 = string | null;
export type FiberPg10 = string | null;
export type SodiumPg10 = string | null;
export type SaturatedFatPg10 = string | null;
export type MonounsaturatedFatPg10 = string | null;
export type PolyunsaturatedFatPg10 = string | null;
export type TransFatPg10 = string | null;
export type CholesterolPg10 = string | null;
export type SugarsPg10 = string | null;
export type AddedSugarsPg10 = string | null;
export type PotassiumPg10 = string | null;
export type MagnesiumPg10 = string | null;
export type VitaminADvPg10 = string | null;
export type VitaminCDvPg10 = string | null;
export type CalciumDvPg10 = string | null;
export type IronDvPg10 = string | null;
export type BaseUnit10 = ("" | "g" | "oz" | "ml" | "fl oz" | "mg" | "mcg" | "iu") | "grams";
export type BaseQuantity10 = string | null;
export type ServingSizeUnit14 = string;
export type ServingSizeNumerator10 = string;
export type ServingSizeDenominator7 = string;
export type ContainerUnit11 = string;
export type ContainerQuantity11 = string | null;
export type ContainerServings14 = string;
export type UsdaFoodId7 = number | null;
export type Backend7 =
  | ""
  | "factual"
  | "recipes"
  | "foods"
  | "recent"
  | "nutritionix"
  | "nutritionix_v2"
  | "inline"
  | "usda"
  | "mfp"
  | "mfp_recipes";
export type BackendId7 = string;
export type ExpandedRecipe5 = ServerJournalNutrition_EntryOutput[];
export type AdditionalUnits7 = USDARawUnit[];
export type Unit15 = string;
export type Multiplier2 = string;
export type Calories6 = number | null;
export type Info1 = string;
export type Units9 = Unit14[];
export type Uuid77 = UUID;
export type Meal1 = string;
export type Food1 = string;
export type Related3 = string[];
export type DateOfBirth8 = string | null;
export type BodyFat6 = string | null;
export type UseKilojoules3 = boolean;
export type IsImperial4 = boolean;
export type Activity6 = string | null;
export type Gender7 = string | null;
export type DateOfBirth9 = string | null;
export type Height7 = string | null;
export type Weight20 = string | null;
export type BodyFat7 = string | null;
export type UseKilojoules4 = boolean;
export type IsImperial5 = boolean;
export type Activity7 = string | null;
export type Gender8 = string | null;
export type DateOfBirth10 = string | null;
export type Height8 = string | null;
export type Weight21 = string | null;
export type Id35 = number;
export type Name84 = string;
export type Upc4 = string;
export type FromMissingUpc3 = boolean;
export type FromNutritionixBackendId1 = string;
export type CaloriesPg11 = string | null;
export type ProteinPg11 = string | null;
export type FatPg11 = string | null;
export type CarbsPg11 = string | null;
export type NetCarbsPg11 = string | null;
export type FiberPg11 = string | null;
export type SodiumPg11 = string | null;
export type SaturatedFatPg11 = string | null;
export type MonounsaturatedFatPg11 = string | null;
export type PolyunsaturatedFatPg11 = string | null;
export type TransFatPg11 = string | null;
export type CholesterolPg11 = string | null;
export type SugarsPg11 = string | null;
export type AddedSugarsPg11 = string | null;
export type PotassiumPg11 = string | null;
export type MagnesiumPg11 = string | null;
export type VitaminADvPg11 = string | null;
export type VitaminCDvPg11 = string | null;
export type CalciumDvPg11 = string | null;
export type IronDvPg11 = string | null;
export type BaseUnit11 = "" | "g" | "oz" | "ml" | "fl oz" | "mg" | "mcg" | "iu";
export type BaseQuantity11 = string | null;
export type ServingSizeUnit15 = string;
export type ServingSizeNumerator11 = string | null;
export type ContainerServings15 = string | null;
export type Uuid78 = UUID;
export type Uuid79 = UUID;
export type Name85 = string;
export type Quantity10 = string;
export type Unit16 = string;
export type OwnEntries = Class_5D7F38B061Ef1519C6952D7Eb236Efc1[];
export type Uuid80 = UUID;
export type Uuid81 = UUID;
export type Name86 = string;
export type Quantity11 = string;
export type Unit17 = string;
export type Calories7 = string | null;
export type OwnEntries1 = ClassAa152C0F2F94243091Eef591F4C36A4C[];
export type Uuid82 = UUID;
export type Uuid83 = UUID;
export type Id36 = number;
export type Uuid84 = UUID;
export type RestDuration4 = number | null;
export type Sets5 = ServerJournalWorkouts_ExerciseSetInput[];
export type Related4 = string[];
export type FirstInWorkoutCount1 = number;
export type Uuid85 = UUID;
export type Name87 = string | null;
export type Instructions16 = string;
export type Duration6 = number | null;
export type Rounds3 = number | null;
export type Groups4 = ServerJournalWorkouts_ExerciseGroupInput[];
export type Uuid86 = UUID;
export type Name88 = string;
export type Id37 = number;
export type Uuid87 = UUID;
export type UserId36 = number | null;
export type Name89 = string;
export type Instructions17 = string;
export type Sections8 = ServerJournalWorkouts_WorkoutSectionInput[];
export type Questions5 = ServerJournalWorkouts_QuestionInput[];
export type Id38 = number;
export type Uuid88 = UUID;
export type Name90 = string | null;
export type UserId37 = number;
export type Description14 = string;
export type WorkoutGroups4 = ClassC8C083D669916D427F5619E62727B61E[];
export type Id39 = number;
export type Name91 = string | null;
export type Description15 = string;
export type UserId38 = number;
export type Uuid89 = UUID;
export type Uuid90 = UUID;
export type Name92 = string;
export type Description16 = string;
export type Uuid91 = UUID;
export type Name93 = string | null;
export type Instructions18 = string;
export type Workouts6 = ClassE4134A856D3Dcb7417Cfe27D51C7142E[];
export type WorkoutGroups5 = Class_0Ac378Cd9A742672645C42Cf5F07C8Fd[];
export type Instances2 = Class_43C5B25Fa3Fce14F2C8Ccf975Bd78Daa[];
export type Id40 = number;
export type Uuid92 = UUID;
export type ShouldSync2 = boolean;
export type IsActive3 = boolean;
export type Id41 = number;
export type Uuid93 = UUID;
export type CreatedAt3 = string;
export type UpdatedAt3 = string;
export type ShouldSync3 = boolean;
export type IsActive4 = boolean;
export type Id42 = number;
export type Uuid94 = UUID;
export type Id43 = number;
export type Name94 = string | null;
export type Weight22 = string | null;
export type Uuid95 = UUID;
export type Name95 = string | null;
export type Date16 = string | null;
export type SourceTemplate1 = string | "BLANK";
export type UserId39 = number;
export type ShouldSync4 = boolean;
export type ExerciseMaxes6 = ServerJournalWorkouts_ExerciseMaxOutput[];
export type GymVisualCode1 = string;
export type GymVisualVideoPath1 = string;
export type GymVisualImagePath1 = string;
export type GymVisualGifPath1 = string;
export type GymVisualGreenVideoPath1 = string;
export type Id44 = number;
export type Order2 = number;
export type Uuid96 = UUID;
export type Instructions19 = string;
export type RestDuration5 = number | null;
export type Sets6 = ServerJournalWorkouts_ExerciseSetInput[];
export type Name96 = string | null;
export type Sections9 = Class_90B405F4C9Dc72638Fc7B8Ebdcc1D9E3[];
export type Name97 = string;
export type Quantity12 = string;
export type Unit18 = string;
export type Entries11 = Class_33D7240B1Beefdd41D4F41Ee1577512E[];
export type FdcId1 = number;
export type NdbNumber1 = string;
export type Description17 = string;
export type FoodPortions1 = USDARawUnit[];
export type ShareUuid11 = string;
export type ShareUuid12 = string;
export type Name98 = string;
export type Waist5 = string | null;
export type BodyFat8 = string | null;
export type UseKilojoules5 = boolean;
export type IsImperial6 = boolean;
export type Activity8 = string | null;
export type Goal6 = number | null;
export type Gender9 = string | null;
export type DateOfBirth11 = string | null;
export type Name99 = string;
export type Waist6 = string | null;
export type BodyFat9 = string | null;
export type HasHiddenMacros1 = boolean;
export type UseKilojoules6 = boolean;
export type IsImperial7 = boolean;
export type Activity9 = string | null;
export type Goal7 = number | null;
export type Gender10 = string | null;
export type DateOfBirth12 = string | null;
export type MemberUuid3 = string;
export type DisplayName6 = string;
export type ImageUid9 = string | null;
export type IsYou1 = boolean;
export type IsLive1 = boolean;
export type Resting1 = string | null;
export type TodayBuckets1 = number[];
export type TodayTotal2 = number;
export type WeekDaily1 = (number | null)[];
export type WeekTotal1 = number;
export type StartDate6 = string;
export type EndDate5 = string;
export type Value4 = string | null;
export type Timezone7 = string;
export type AppleHealthUuid3 = UUID | null;
export type Uuid97 = UUID;
export type AppleHealthData1 = string | null;
export type Id45 = number;
export type Notes16 = string;
export type Responses2 = ServerJournalDay_CheckInResponseInput[];
export type NotesLabel1 = string;
export type Supplements3 = SearchResult[];
export type Targets7 = ServerJournalNutrition_TargetInput[];
export type WorkoutTemplates1 = ServerJournalWorkouts_WorkoutTemplateInput[];
export type ProgramTemplates2 = ServerJournalWorkouts_ListProgramInput[];
export type Activities1 = ServerJournalDay_WorkoutAggregateInput[];
export type WorkoutStatus1 = "WORKOUT_DUE" | "REST_DAY";
export type Streak3 = number;
export type Weight23 = string | null;
export type Waist7 = string | null;
export type Navel2 = string | null;
export type BodyFat10 = string | null;
export type Hips2 = string | null;
export type Neck2 = string | null;
export type Thigh2 = string | null;
export type Bicep2 = string | null;
export type Chest2 = string | null;
export type Gratitude4 = string;
export type IncludeInReports6 = boolean;
export type Notes17 = string;
export type Meals7 = ServerJournalNutrition_MealOutput[];
export type Gratitude5 = string;
export type IncludeInReports7 = boolean;
export type Notes18 = string;
export type Meals8 = ServerJournalNutrition_MealOutput[];
export type Assignments5 = ServerJournalDay_AssignmentOutput[];
export type Uuid98 = UUID;
export type Name100 = string;
export type CaloriesTarget5 = string | null;
export type ProteinTarget5 = string | null;
export type FatTarget5 = string | null;
export type CarbsTarget5 = string | null;
export type FiberTarget4 = string | null;
export type NetCarbsTarget5 = string | null;
export type Name101 = string;
export type DateOfBirth13 = string | null;
export type Gender11 = string | null;
export type IsImperial8 = boolean;
export type Weight24 = string | null;
export type Height9 = string | null;
export type BodyFat11 = string | null;
export type Activity10 = string | null;
export type UserId40 = number | "REQUEST_USER";
export type Targets8 = ServerJournalDay_ConsumerTargetOutput[];
export type Email15 = string;
export type ShouldCollectAnalytics4 = boolean;
export type Uuid99 = UUID;
export type Uuid100 = UUID;
export type Uuid101 = UUID;
export type Name102 = string;
export type Uuid102 = UUID;
export type Weight25 = string | null;
export type ExerciseMaxes7 = Class_67C6C646Cfcb2943Ba5Afd1539D1296A[];
export type Id46 = number;
export type MeetParticipants1 = Class_89E77Af937F4Fb9Ae059B93A54B3Fd43[];
export type Id47 = number;
export type Uuid103 = UUID;
export type Name103 = string | null;
export type UserId41 = number;
export type Description18 = string;
export type WorkoutGroups6 = ClassC8C083D669916D427F5619E62727B61E[];
export type Id48 = number;
export type Uuid104 = UUID;
export type Name104 = string | null;
export type UserId42 = number;
export type Description19 = string;
export type WorkoutGroups7 = ClassC8C083D669916D427F5619E62727B61E[];
export type ProductCode3 = string;
export type Id49 = number;
export type Name105 = string | null;
export type Description20 = string;
export type Uuid105 = UUID;
export type UserId43 = number;
export type Name106 = string;
export type Uuid106 = UUID;
export type ExerciseTypeMaxesRequired = ClassD27326464A9Dd799D307996A78050028[];
export type Instances3 = Class_43C5B25Fa3Fce14F2C8Ccf975Bd78Daa[];
export type Id50 = number;
export type Name107 = string | null;
export type Description21 = string;
export type Uuid107 = UUID;
export type UserId44 = number;
export type UpdatedAt4 = string;
export type ExerciseTypeMaxesRequired1 = ClassD27326464A9Dd799D307996A78050028[];
export type Instances4 = Class_43C5B25Fa3Fce14F2C8Ccf975Bd78Daa[];
export type Id51 = number;
export type Name108 = string;
export type ClientManager__Type = "MANAGER_PAYS" | "CLIENT_PAYS";
export type Email16 = string;
export type Id52 = number;
export type IsSubscriptionActive2 = boolean;
export type IsImperial9 = boolean;
export type Id53 = number;
export type Name109 = string;
export type CreatedAt4 = string;
export type Email17 = string;
export type Id54 = number;
export type IsReportsEnabled1 = boolean;
export type IsSubscriptionActive3 = boolean;
export type CheckInQuestions = Class_74E923A857062D3Bd448E02436B7C1D1[];
export type CheckInQuestions1 = Class_74E923A857062D3Bd448E02436B7C1D1[];
export type Responses3 = Class_0Ceadf1997D3A890F62Aa54Ad5C979Ce[];
export type Notes19 = string;
export type Date17 = string;
export type Responses4 = Class_0Ceadf1997D3A890F62Aa54Ad5C979Ce[];
export type Notes20 = string;
export type Date18 = string | null;
export type Name110 = string;
export type Uuid108 = UUID;
export type Answer2 = string;
export type Questions6 = Class_11D7F6A74010C761637Dc131D2D10Ad2[];
export type Date19 = string | null;
export type Questions7 = Class_11D7F6A74010C761637Dc131D2D10Ad2[];
export type Email18 = string;
export type Email19 = string;
export type Id55 = number;
export type Name111 = string;
export type Id56 = number;
export type Name112 = string;
export type Calories8 = string | null;
export type Protein3 = string | null;
export type Fat3 = string | null;
export type Carbs2 = string | null;
export type Fiber3 = string | null;
export type NetCarbs3 = string | null;
export type DayOfWeek3 = number;
export type DayOfWeek4 = number;
export type Id57 = number;
export type Name113 = string;
export type Email20 = string;
export type Id58 = number;
export type Id59 = number;
export type Uuid109 = UUID;
export type Name114 = string | null;
export type Id60 = number;
export type Name115 = string;
export type CreatedAt5 = string;
export type Uuid110 = UUID;
export type Name116 = string;
export type Uuid111 = UUID;
export type Name117 = string;
export type InstancesCount = number;
export type TrackingKey3 = string;
export type Id61 = number;
export type Name118 = string;
export type Id62 = number;
export type Email21 = string;
export type Id63 = number;
export type Name119 = string;
export type SubscriptionDollarsPerMonth1 = number;
export type ExperimentGroup = "NO_PRICING" | "PRICING";
export type Username = string;
export type Id64 = number;
export type LeadEmail1 = string;
export type FullName2 = string;
export type CreatedAt6 = string;
export type Leads = ServerCoreTemplates_LeadCandidate_413C3245A6Output1[];
export type Title2 = string;
export type Title3 = string;
export type Title4 = string;
export type Module = VisionModule | NutritionModule | RPCRequestModule | TaskModule | LearningWeekModule;
export type Type15 = "vision";
export type Comparisons = VisionPromptComparison[];
export type Type16 = "text";
export type Name120 = string;
export type Type17 = "decimal";
export type Name121 = string;
export type Fields = (CharField | DecimalField)[];
export type Type18 = "nutrition";
export type IsChecked = string;
export type Name122 = string;
export type CaloriesPg12 = string | null;
export type BackendId8 = string | number;
export type Results = BackofficeResult[];
export type Type19 = "rpc_request";
export type IsChecked1 = string;
export type Id65 = number;
export type User = string;
export type Path = string;
export type RequestStatus = "ERROR" | "MALFORMED" | "INVALID" | "SUCCESS";
export type Type20 = string;
export type CreatedAt7 = string;
export type Results1 = RPCRequestResult[];
export type Type21 = "dbtaskresult";
export type IsChecked2 = string;
export type Id66 = string;
export type Status5 = string;
export type EnqueuedAt = string;
export type StartedAt = string | null;
export type FinishedAt = string | null;
export type Results2 = TaskResult[];
export type Type22 = "learningweek";
export type IsChecked3 = string;
export type Id67 = number;
export type Uuid112 = string;
export type Name123 = string;
export type Unit19 = string;
export type Quantity13 = string;
export type Calories9 = string | null;
export type UserEmail = string;
export type CreatedAt8 = string;
export type Results3 = LearningWeekEntry[];
export type IsCapacitor = boolean;
export type Title5 = string;
export type Description22 = string;
export type Image = string;
export type SsrResolved = {
  [k: string]: unknown;
} | null;
export type Share1 = PromptContainer | RecipeContainer;
export type RecipeExperimentName =
  | "CONTENT_MIDDLE_REGISTRATION_V2"
  | "CONTENT_START_REGISTRATION_V2"
  | "CTA_INLINE_REGISTRATION_V2";
export type RecipeButtonExperimentName = "FREE_TRIAL" | "OTHER";
export type RecipePriceExperimentName = "FULL_TERMS" | "SHORT" | "HIDDEN";
export type InstacartExperimentName = "INSTACART_CTA_TOP" | "INSTACART_CTA_BOTTOM";
export type PullUpExperimentName = "v1" | "v2_a" | "v2_b" | "v2_c";
export type Name124 = string;
export type Recipes1 = RecipeShare[];
export type EntitlementEmail = string | null;
export type IsPublic = boolean;
export type ProductLink = string | null;
export type ReadOnly = boolean;
export type ShareUuid13 = string;
export type MeetName = string;
export type ShareUuid14 = string;
export type ManagerName1 = string;
export type Id68 = number;
export type Name125 = string;
export type CreatedAt9 = string;
export type LastSeen = string;
export type Label4 = string;
export type Type23 = "weight" | "length" | "percent";
export type FieldName = "weight" | "waist" | "navel" | "body_fat" | "hips" | "neck" | "thigh" | "bicep" | "chest";
export type Previous = string | null;
export type Value5 = string | null;
export type Delta = string | null;
export type LastWeighIn = string | null;
export type Date20 = string | null;
export type WeighedIn = boolean;
export type LoggedEntries = boolean;
export type LoggedWorkout = boolean;
export type Target2 = number | null;
export type Total = string | null;
export type Status7 = "success" | "failure" | "na";
export type Percentage = number;
export type Total1 = string | null;
export type Target3 = string | null;
export type Remaining = string | null;
export type Deviation = string | null;
export type Status8 = "success" | "failure" | "na";
export type Status9 = "success" | "failure" | "na";
export type Statuses1 = Status6[];
export type Clients = ClientSnapshot[];
export type Id69 = number;
export type Name126 = string;
export type CreatedAt10 = string;
export type Invited = ServerManagerTemplates_ClientManagerPickOutput2[];
export type ManagerName2 = string;
export type Clients1 = ClientSnapshot[];
export type ShowHabits = boolean;
export type Id70 = number;
export type Name127 = string;
export type CreatedAt11 = string;
export type Statuses2 = Status6[];
export type Metrics3 = (
  | "calories"
  | "protein"
  | "carbs"
  | "fat"
  | "fiber"
  | "net_carbs"
  | "sodium"
  | "saturated_fat"
  | "monounsaturated_fat"
  | "polyunsaturated_fat"
  | "trans_fat"
  | "cholesterol"
  | "sugars"
  | "added_sugars"
  | "potassium"
  | "magnesium"
  | "vitamin_a_dv"
  | "vitamin_c_dv"
  | "calcium_dv"
  | "iron_dv"
)[];
export type HasSurvey = boolean;
export type PastPrograms = ServerJournalWorkouts_PastProgramOutput[];
export type Id71 = number;
export type Name128 = string | null;
export type Description23 = string;
export type Uuid113 = UUID;
export type UserId45 = number;
export type UpdatedAt5 = string;
export type ExerciseTypeMaxesRequired2 = ClassD27326464A9Dd799D307996A78050028[];
export type Instances5 = Class_43C5B25Fa3Fce14F2C8Ccf975Bd78Daa[];
export type ProgramTemplates3 = ServerManagerTemplates_ListWorkoutProgramOutput1[];
export type DateFrom = string;
export type DateTo = string;
export type HasCustomDateRange = boolean;
export type Id72 = number;
export type Name129 = string;
export type CreatedAt12 = string;
export type CheckInQuestions2 = Class_74E923A857062D3Bd448E02436B7C1D1[];
export type Responses5 = Class_0Ceadf1997D3A890F62Aa54Ad5C979Ce[];
export type Notes21 = string;
export type CheckIns = ServerManagerTemplates_ClientCheckIn_6Af5D6E9CcOutput1[];
export type Id73 = number;
export type Name130 = string;
export type CreatedAt13 = string;
export type Date21 = string | null;
export type Questions8 = Class_11D7F6A74010C761637Dc131D2D10Ad2[];
export type Workouts7 = ServerManagerTemplates_WorkoutC29Aee4E3EOutput1[];
export type Id74 = number;
export type Name131 = string;
export type CreatedAt14 = string;
export type Email22 = string;
export type IsRegistering = boolean;
export type Id75 = number;
export type Name132 = string;
export type CreatedAt15 = string;
export type CanScheduleCheckIn = boolean;
export type Targets9 = ServerJournalNutrition_TargetOutput[];
export type IsFirstClient = boolean;
export type ImmediateTotal = string;
export type NextInvoiceSum = string;
export type NextQuantity = number;
export type IsProrating = string | null;
export type Id76 = number;
export type Name133 = string;
export type CreatedAt16 = string;
export type NextInvoiceSum1 = number;
export type NextQuantity1 = number;
export type Id77 = number;
export type Name134 = string;
export type CreatedAt17 = string;
export type Date22 = string;
export type Position1 = number;
export type Metric1 = string | null;
export type Measurements4 = Measurement[];
export type Trend1 = Measurement[];
export type StripePublishableKey1 = string;
export type Email23 = string;
export type Id78 = number;
export type Uuid114 = UUID;
export type Name135 = string | null;
export type UserId46 = number;
export type Description24 = string;
export type WorkoutGroups8 = ClassC8C083D669916D427F5619E62727B61E[];
export type ProductCode4 = string;
export type Programs1 = ServerManagerTemplates_ProgramTemplateOutput1[];
export type ManagerName3 = string;
export type Handle = string;
export type Email24 = string;
export type Id79 = number;
export type Uuid115 = UUID;
export type Name136 = string | null;
export type UserId47 = number;
export type Description25 = string;
export type WorkoutGroups9 = ClassC8C083D669916D427F5619E62727B61E[];
export type ProductCode5 = string;
export type Programs2 = ServerManagerTemplates_ProgramTemplateOutput2[];
export type StripeAccount = string | null;
export type Description26 = string | null;
export type StripeProductPrice = number;
export type StripePublishableKey2 = string;
export type Id80 = number;
export type Name137 = string;
export type Calories10 = string | null;
export type Protein4 = string | null;
export type Fat4 = string | null;
export type Carbs3 = string | null;
export type Fiber4 = string | null;
export type NetCarbs4 = string | null;
export type MealPlans = ServerManagerTemplates_MealPlanPickOutput1[];
export type Id81 = number;
export type Name138 = string;
export type Calories11 = string | null;
export type Protein5 = string | null;
export type Fat5 = string | null;
export type Carbs4 = string | null;
export type Fiber5 = string | null;
export type NetCarbs5 = string | null;
export type Id82 = number;
export type Name139 = string;
export type Calories12 = string | null;
export type Protein6 = string | null;
export type Fat6 = string | null;
export type Carbs5 = string | null;
export type Fiber6 = string | null;
export type NetCarbs6 = string | null;
export type Id83 = number;
export type Name140 = string;
export type CreatedAt18 = string;
export type Id84 = number;
export type Name141 = string;
export type Calories13 = string | null;
export type Protein7 = string | null;
export type Fat7 = string | null;
export type Carbs6 = string | null;
export type Fiber7 = string | null;
export type NetCarbs7 = string | null;
export type MealPlans1 = ServerManagerTemplates_MealPlanPickOutput4[];
export type DayOfWeek5 = number;
export type Assignments7 = ServerManagerTemplates_TargetAssignmentF25C746Fc2Output1[];
export type Id85 = number;
export type Name142 = string;
export type CreatedAt19 = string;
export type Id86 = number;
export type Name143 = string;
export type Calories14 = string | null;
export type Protein8 = string | null;
export type Fat8 = string | null;
export type Carbs7 = string | null;
export type Fiber8 = string | null;
export type NetCarbs8 = string | null;
export type MealPlans2 = ServerManagerTemplates_MealPlanPickOutput5[];
export type Id87 = number;
export type Name144 = string | null;
export type Description27 = string;
export type Uuid116 = UUID;
export type UserId48 = number;
export type UpdatedAt6 = string;
export type ExerciseTypeMaxesRequired3 = ClassD27326464A9Dd799D307996A78050028[];
export type Instances6 = Class_43C5B25Fa3Fce14F2C8Ccf975Bd78Daa[];
export type Programs3 = ServerManagerTemplates_ListWorkoutProgramOutput2[];
export type Uuid117 = UUID;
export type Name145 = string;
export type QuestionTypes1 = ServerJournalWorkouts_QuestionTypeOutput1[];
export type Id88 = number;
export type Name146 = string;
export type CreatedAt20 = string;
export type Clients2 = ServerManagerTemplates_ClientManager_9963Dfc2DdOutput1[];
export type Uuid118 = UUID;
export type Name147 = string;
export type InstancesCount1 = number;
export type ExerciseTypes2 = ServerManagerTemplates_ExerciseTypeC80Bde974AOutput1[];
export type Id89 = number;
export type Name148 = string;
export type CreatedAt21 = string;
export type Supplements4 = SearchResult[];
export type Uuid119 = string;
export type Name149 = string;
export type Date23 = string;
export type Entries13 = EntryItem[];
export type Hash2 = string;
export type Notification = UpdatedProgramNotification | StepsNotification;
export type Type24 = "STEPS";
export type Type25 = "UPDATED_PROGRAM";
export type JournalNutritionBackend =
  | ""
  | "factual"
  | "recipes"
  | "foods"
  | "recent"
  | "nutritionix"
  | "nutritionix_v2"
  | "inline"
  | "usda"
  | "mfp"
  | "mfp_recipes";
export type Uuid120 = string;
export type Startdate = string;
export type Enddate = string;
export type Duration7 = number;
export type Workoutactivitytype = string;
export type Workoutactivityid = number;
export type Source5 = string;
export type Sourcebundleid = string;
export type Name150 = string;
export type Model = string;
export type Manufacturer = string;
export type Hardwareversion = string;
export type Softwareversion = string;
export type Totalenergyburned = number;
export type Totaldistance = number;
export type Sum = number;
export type Average = number;
export type Minimum = number;
export type Maximum = number;
export type Timezone8 = string;
export type Value6 = number;
export type Unit20 = string;
export type CorePaymentsSubscription = AppleSubscriptionType | StripeSubscription | NoSubscription;
export type Name151 = string;
export type IsImperial10 = boolean;
export type DateOfBirth14 = string | null;
export type Weight26 = string | null;
export type Height10 = string | null;
export type Gender12 = string;
export type Activity11 = string;
export type BodyFat12 = string | null;
export type Variance = string | null;
export type ProteinMultiplier = string | null;
export type FatCarbs = string | null;
export type Variance1 = string | null;
export type CarbLimit = string | null;
export type WorkoutDayVariance = string | null;
export type RestDayVariance = string | null;
export type ProteinMultiplier1 = string | null;
export type WorkoutDayFat = string | null;
export type RestDayFat = string | null;
export type Uuid121 = string;
export type Name152 = string;
export type Description28 = string;
export type Order3 = number;
export type SwapExercises = boolean;
export type AssistanceExercises = boolean;
export type DeloadWeek = boolean;
export type HeavySingle = boolean;
export type ProgressionPerWeek = string | null;
export type SmallestPlate = string | null;
export type Weeks = number;
export type Reps6 = number;
export type Weight27 = string | null;
export type SmallestPlate1 = string | null;
export type Name153 = string;
export type Description29 = string;
export type AutoAssign = boolean;
export type Weight28 = string | null;
export type Waist8 = string | null;
export type Navel3 = string | null;
export type BodyFat13 = string | null;
export type Hips3 = string | null;
export type Neck3 = string | null;
export type Thigh3 = string | null;
export type Bicep3 = string | null;
export type Chest3 = string | null;
export type TemplateName = string;
export type Path1 = string;
export type Url1 = string;
export type CspNonce = string | null;
export type Id90 = number | string | null;
export type Username1 = string;
export type IsAuthenticated = boolean;
export type IsStaff = boolean;
export type LevelTag = "info" | "success" | "error" | "warning" | "debug";
export type Message2 = string;
export type Level = number;
export type FromServer = boolean;
export type Messages = Message1[];
export type CsrfToken = string;
export type MobileOs = ("android" | "ios") | null;
export type UrlName = string | null;
export type StaticUrl1 = string;
export type Realm = "site" | "app";
export type SentryDsn1 = string;
export type MixpanelToken1 = string;
export type AnalyticsId = string;
export type StaticUrl2 = string;
export type MediaUrl = string;
export type Clients3 = ServerCoreContextProcessors_ClientManagerContextOutput[];

export interface Schema {
  rpc_register_input: Register;
  rpc_check_email_input: RpcCheckEmailInput;
  rpc_login_input: Login;
  rpc_set_password_input: SetPassword;
  rpc_update_settings_input: Settings;
  rpc_apple_ping_input: ApplePing;
  rpc_track_email_click_input: TrackEmailClick;
  rpc_register_apns_device_input: RegisterAPNSDevice;
  rpc_preview_email_input: PreviewEmail;
  rpc_postmark_webhook_input: PostmarkBounceWebhook;
  rpc_mfp_registration_input: MFPRegistration;
  rpc_learning_week_registration_input: LearningWeekRegistration;
  rpc_plan_registration_input: PlanRegistration;
  rpc_create_user_media_image_input: Input;
  rpc_request_login_link_input: RpcRequestLoginLinkInput;
  rpc_validate_login_link_input: ValidateLoginLink;
  rpc_reset_password_input: ResetPassword;
  rpc_contact_input: Contact;
  rpc_dismiss_announcement_input: DismissAnnouncement;
  rpc_update_profile_input: UpdateProfile;
  rpc_invite_user_input: InviteUser;
  rpc_attribute_share_input: ShareAttribution;
  rpc_attribute_utm_input: UTMAttribution;
  rpc_create_tracking_link_input: CreateTrackingLink;
  rpc_validate_iap_input: ValidateIAPInput;
  rpc_create_subscription_input: CreateSubscriptionInput;
  rpc_create_paypal_subscription_input: CreatePayPalSubscriptionInput;
  rpc_save_input: Save;
  rpc_update_metrics_input: RpcUpdateMetricsInput;
  rpc_update_metric_aggregates_input: UpdateMetricAggregates;
  rpc_journal_input: JournalForm;
  rpc_update_measurements_input: ServerJournalDay_MeasurementInput;
  rpc_update_day_input: ServerJournalDay_DayUpdateInput;
  rpc_legacy_update_day_input: ServerJournalDay_LegacyUpdateDayInput;
  rpc_delete_journal_workout_input: DayReference;
  rpc_fast_init_input: Input1;
  rpc_planner_input: ServerJournalDay_PlannerInput;
  rpc_consumer_planner_input: ServerJournalDay_ConsumerPlannerInput;
  rpc_start_input: Start;
  rpc_onboarding_input: Onboarding1;
  rpc_method_input: Method;
  rpc_shopify_order_created_input: ShopifyOrderCreated;
  rpc_replace_entry_input: ReplaceEntry;
  rpc_move_day_input: MoveDay;
  rpc_copy_day_input: CopyDay;
  rpc_accept_meal_plan_input: AcceptMealPlan;
  rpc_reject_meal_plan_input: RejectMealPlan;
  rpc_check_in_input: CheckInInput;
  rpc_target_planner_input: PlannerInput;
  rpc_create_template_from_workout_input: CreateTemplateFromWorkout;
  rpc_delete_workout_template_input: DeleteWorkout;
  rpc_delete_workout_input: DeleteWorkout;
  rpc_delete_group_input: DeleteGroup;
  rpc_update_workout_input: ServerJournalWorkouts_WorkoutInput;
  rpc_update_program_input: ServerJournalWorkouts_ProgramInput;
  rpc_create_program_input: ServerJournalWorkouts_ProgramInput;
  rpc_copy_program_input: CopyProgram;
  rpc_delete_program_input: DeleteProgram;
  rpc_select_program_template_input: ServerJournalWorkouts_SelectProgramTemplateInput;
  rpc_create_exercise_types_input: RpcCreateExerciseTypesInput;
  rpc_set_exercise_maxes_input: RpcSetExerciseMaxesInput;
  rpc_delete_exercise_group_input: DeleteExerciseGroup;
  rpc_select_program_workout_input: SelectProgramWorkout;
  rpc_archive_program_input: ArchiveProgram;
  rpc_disable_sync_input: DisableSync;
  rpc_recent_sections_input: RecentSections;
  rpc_exercise_media_lookup_input: ExerciseMediaLookup;
  rpc_update_exercise_media_input: ServerJournalWorkouts_ExerciseMediaInput;
  rpc_create_exercise_type_input: ExerciseTypeForm;
  rpc_update_exercise_type_input: ExerciseTypeForm;
  rpc_delete_exercise_set_input: DeleteExerciseSet;
  rpc_delete_exercise_input: DeleteExercise;
  rpc_clear_exercise_sets_input: ClearExerciseSets;
  rpc_exercise_detail_input: ExerciseDetailForm;
  rpc_copy_workout_input: CopyWorkoutForm;
  rpc_complete_workout_input: CompleteWorkoutForm;
  rpc_incomplete_workout_input: IncompleteWorkoutForm;
  rpc_create_workout_template_input: CreateWorkoutTemplateForm;
  rpc_create_question_type_input: QuestionTypeInput;
  rpc_update_cupboard_input: UpdateCupboard;
  rpc_update_recipe_input: UpdateRecipe;
  rpc_search_input: SearchForm;
  rpc_publish_nutritional_vision_prompt_input: PublishNutritionalVisionPrompt;
  rpc_publish_day_input: PublishDay;
  rpc_share_detail_input: ShareForm;
  rpc_share_recipe_input: ShareRecipe;
  rpc_food_list_input: ListFoods;
  rpc_create_food_input: CreateFood;
  rpc_update_food_input: UpdateFood;
  rpc_delete_food_input: DeleteFood;
  rpc_recipe_list_input: ListRecipes;
  rpc_create_recipe_input: CreateRecipe;
  rpc_update_recipe_metadata_input: UpdateRecipeMetadata;
  rpc_delete_recipe_input: DeleteRecipe;
  rpc_copy_recipe_input: CopyRecipe;
  rpc_create_recipe_from_meal_input: CreateRecipeFromMeal;
  rpc_publish_meal_input: PublishMeal;
  rpc_delete_meal_input: DeleteMeal;
  rpc_move_meal_input: MoveMeal;
  rpc_copy_meal_input: CopyMeal;
  rpc_publish_entry_input: PublishEntry;
  rpc_expand_entry_input: ExpandEntry;
  rpc_reports_input: Input2;
  rpc_weekly_macros_input: Input3;
  rpc_create_mfp_account_input: MFPAccountForm;
  rpc_walking_club_board_input: BoardForm;
  rpc_walking_club_demo_allowed_input: DemoForm;
  rpc_walking_club_info_input: InfoForm;
  rpc_walking_club_login_link_input: LoginLink;
  rpc_walking_club_join_input: JoinForm;
  rpc_walking_club_registration_input: WalkingClubRegistration;
  rpc_queue_meal_image_input: Input4;
  rpc_queue_barcode_input: QueueBarcode;
  rpc_reprocess_queued_image_input: ReprocessQueuedImage;
  rpc_import_recipe_input: ImportRecipe;
  rpc_create_peptide_vial_input: CreateVialInput;
  rpc_delete_peptide_vial_input: DeleteVialInput;
  rpc_create_peptide_dose_input: CreateDoseInput;
  rpc_update_meet_input: ServerJournalViews_MeetDataInput;
  rpc_instacart_recipe_input: InstacartRecipe;
  rpc_export_journal_input: ExportJournal;
  rpc_profile_detail_output: ServerCoreRpc_ProfileOutput;
  rpc_register_output: ServerCoreRpc_ProfileOutput1;
  rpc_check_email_output: RpcCheckEmailOutput;
  rpc_login_output: ServerCoreRpc_ProfileOutput2;
  rpc_set_password_output: ServerCoreRpc_ProfileOutput1;
  rpc_update_settings_output: RpcUpdateSettingsOutput;
  rpc_apple_ping_output: RpcApplePingOutput;
  rpc_track_email_click_output: RpcTrackEmailClickOutput;
  rpc_register_apns_device_output: RpcRegisterApnsDeviceOutput;
  rpc_preview_email_output: RpcPreviewEmailOutput;
  rpc_link_analytics_output: RpcLinkAnalyticsOutput;
  rpc_postmark_webhook_output: RpcPostmarkWebhookOutput;
  rpc_mfp_registration_output: ServerCoreRpc_ProfileOutput1;
  rpc_learning_week_registration_output: ServerCoreRpc_ProfileOutput1;
  rpc_plan_registration_output: ServerCoreRpc_ProfileOutput1;
  rpc_create_user_media_image_output: Output;
  rpc_request_login_link_output: RpcRequestLoginLinkOutput;
  rpc_validate_login_link_output: ServerCoreRpc_ProfileOutput1;
  rpc_logout_output: RpcLogoutOutput;
  rpc_reset_password_output: RpcResetPasswordOutput;
  rpc_contact_output: RpcContactOutput;
  rpc_dismiss_announcement_output: RpcDismissAnnouncementOutput;
  rpc_update_profile_output: RpcUpdateProfileOutput;
  rpc_delete_profile_output: RpcDeleteProfileOutput;
  rpc_get_client_dashboard_link_output: RpcGetClientDashboardLinkOutput;
  rpc_invite_user_output: RpcInviteUserOutput;
  rpc_attribute_share_output: RpcAttributeShareOutput;
  rpc_attribute_utm_output: RpcAttributeUtmOutput;
  rpc_create_tracking_link_output: RpcCreateTrackingLinkOutput;
  rpc_validate_iap_output: RpcValidateIapOutput;
  rpc_subscription_detail_output: RpcSubscriptionDetailOutput;
  rpc_create_subscription_output: RpcCreateSubscriptionOutput;
  rpc_delete_subscription_output: RpcDeleteSubscriptionOutput;
  rpc_create_paypal_subscription_output: RpcCreatePaypalSubscriptionOutput;
  rpc_save_output: RpcSaveOutput;
  rpc_update_metrics_output: RpcUpdateMetricsOutput;
  rpc_update_metric_aggregates_output: RpcUpdateMetricAggregatesOutput;
  rpc_journal_output: ServerJournalDay_JournalOutput;
  rpc_update_measurements_output: ServerJournalNutrition_DayOutput1;
  rpc_update_day_output: RpcUpdateDayOutput;
  rpc_legacy_update_day_output: RpcLegacyUpdateDayOutput;
  rpc_delete_journal_workout_output: ServerJournalDay_JournalOutput;
  rpc_fast_init_output: Output1;
  rpc_planner_output: RpcPlannerOutput;
  rpc_consumer_planner_output: ServerCoreRpc_ProfileOutput1;
  rpc_start_output: RpcStartOutput;
  rpc_onboarding_output: ServerCoreRpc_ProfileOutput1;
  rpc_method_output: ServerCoreRpc_ProfileOutput1;
  rpc_reset_challenge_output: RpcResetChallengeOutput;
  rpc_shopify_order_created_output: RpcShopifyOrderCreatedOutput;
  rpc_replace_entry_output: RpcReplaceEntryOutput;
  rpc_verify_purchase_entitlement_output: RpcVerifyPurchaseEntitlementOutput;
  rpc_move_day_output: RpcMoveDayOutput;
  rpc_copy_day_output: RpcCopyDayOutput;
  rpc_accept_meal_plan_output: RpcAcceptMealPlanOutput;
  rpc_reject_meal_plan_output: RpcRejectMealPlanOutput;
  rpc_check_in_output: RpcCheckInOutput;
  rpc_target_planner_output: RpcTargetPlannerOutput;
  rpc_program_detail_output: ServerJournalWorkouts_ProgramOutput;
  rpc_workouts_output: Workouts5;
  rpc_create_template_from_workout_output: RpcCreateTemplateFromWorkoutOutput;
  rpc_delete_workout_template_output: Workouts5;
  rpc_delete_workout_output: ServerJournalWorkouts_ProgramOutput | null;
  rpc_delete_group_output: RpcDeleteGroupOutput;
  rpc_update_workout_output: RpcUpdateWorkoutOutput;
  rpc_update_program_output: RpcUpdateProgramOutput;
  rpc_create_program_output: RpcCreateProgramOutput;
  rpc_copy_program_output: ServerJournalWorkouts_ProgramOutput;
  rpc_delete_program_output: RpcDeleteProgramOutput;
  rpc_select_program_template_output: ServerJournalWorkouts_ProgramOutput;
  rpc_preview_program_output: ServerJournalWorkouts_WorkoutGroupWorkoutOutput;
  rpc_create_exercise_types_output: RpcCreateExerciseTypesOutput;
  rpc_set_exercise_maxes_output: RpcSetExerciseMaxesOutput;
  rpc_delete_exercise_type_output: RpcDeleteExerciseTypeOutput;
  rpc_delete_exercise_group_output: RpcDeleteExerciseGroupOutput;
  rpc_select_program_workout_output: RpcSelectProgramWorkoutOutput;
  rpc_archive_program_output: RpcArchiveProgramOutput;
  rpc_disable_sync_output: RpcDisableSyncOutput;
  rpc_recent_sections_output: RpcRecentSectionsOutput;
  rpc_exercise_media_lookup_output: ExerciseMediaList;
  rpc_update_exercise_media_output: RpcUpdateExerciseMediaOutput;
  rpc_create_exercise_type_output: ServerJournalWorkouts_ExerciseTypeOutput;
  rpc_update_exercise_type_output: ServerJournalWorkouts_ExerciseTypeOutput;
  rpc_delete_exercise_set_output: RpcDeleteExerciseSetOutput;
  rpc_delete_exercise_output: RpcDeleteExerciseOutput;
  rpc_clear_exercise_sets_output: RpcClearExerciseSetsOutput;
  rpc_exercise_detail_output: RpcExerciseDetailOutput;
  rpc_copy_workout_output: ServerJournalWorkouts_WorkoutOutput;
  rpc_complete_workout_output: RpcCompleteWorkoutOutput;
  rpc_incomplete_workout_output: RpcIncompleteWorkoutOutput;
  rpc_create_workout_template_output: ServerJournalWorkouts_WorkoutTemplateOutput;
  rpc_create_question_type_output: ServerJournalWorkouts_QuestionTypeOutput;
  rpc_delete_entry_output: RpcDeleteEntryOutput;
  rpc_update_cupboard_output: RpcUpdateCupboardOutput;
  rpc_update_recipe_output: ServerJournalNutrition_RecipeOutput;
  rpc_predictions_data_output: PredictionsData;
  rpc_load_search_output: Search;
  rpc_search_output: RpcSearchOutput;
  rpc_publish_nutritional_vision_prompt_output: RpcPublishNutritionalVisionPromptOutput;
  rpc_publish_day_output: ServerJournalNutrition_DayOutput;
  rpc_share_detail_output: RpcShareDetailOutput;
  rpc_share_recipe_output: RecipeShare;
  rpc_toggle_recipe_favorite_output: RpcToggleRecipeFavoriteOutput;
  rpc_food_list_output: RpcFoodListOutput;
  rpc_create_food_output: CreateFoodResponse;
  rpc_update_food_output: RpcUpdateFoodOutput;
  rpc_delete_food_output: RpcDeleteFoodOutput;
  rpc_recipe_list_output: RpcRecipeListOutput;
  rpc_create_recipe_output: ServerJournalNutrition_RecipeOutput;
  rpc_update_recipe_metadata_output: RpcUpdateRecipeMetadataOutput;
  rpc_delete_recipe_output: RpcDeleteRecipeOutput;
  rpc_copy_recipe_output: ServerJournalNutrition_RecipeOutput;
  rpc_create_recipe_from_meal_output: ServerJournalNutrition_RecipeOutput;
  rpc_publish_meal_output: RpcPublishMealOutput;
  rpc_delete_meal_output: RpcDeleteMealOutput;
  rpc_move_meal_output: RpcMoveMealOutput;
  rpc_copy_meal_output: RpcCopyMealOutput;
  rpc_publish_entry_output: RpcPublishEntryOutput;
  rpc_expand_entry_output: RpcExpandEntryOutput;
  rpc_reports_output: Output2;
  rpc_weekly_macros_output: WeeklyMacros;
  rpc_mfp_migration_detail_output: RpcMfpMigrationDetailOutput;
  rpc_create_mfp_account_output: ServerJournalMfp_MFPMigrationOutput1;
  rpc_walking_club_board_output: WalkingClubBoard | null;
  rpc_walking_club_demo_allowed_output: RpcWalkingClubDemoAllowedOutput;
  rpc_walking_club_info_output: WalkingClubInfo | null;
  rpc_walking_club_login_link_output: RpcWalkingClubLoginLinkOutput;
  rpc_walking_club_join_output: WalkingClubBoard;
  rpc_walking_club_registration_output: ServerCoreRpc_ProfileOutput1;
  rpc_queue_meal_image_output: ServerJournalNutrition_NutritionalVisionPromptOutput;
  rpc_identify_meal_name_output: ServerJournalNutrition_NutritionalVisionPromptOutput;
  rpc_queue_barcode_output: ServerJournalNutrition_NutritionalVisionPromptOutput;
  rpc_process_queued_barcode_output: ServerJournalNutrition_ExpandedEntryOutput;
  rpc_process_queued_image_output: ServerJournalNutrition_ExpandedEntryOutput;
  rpc_reprocess_queued_image_output: ServerJournalNutrition_ExpandedEntryOutput;
  rpc_queue_audio_transcription_output: ServerJournalNutrition_NutritionalVisionPromptOutput;
  rpc_process_queued_audio_output: ServerJournalNutrition_ExpandedEntryOutput;
  rpc_import_recipe_output: ServerJournalNutrition_NutritionalVisionPromptOutput;
  rpc_peptides_output: Peptides;
  rpc_create_peptide_vial_output: VialWithComputed;
  rpc_delete_peptide_vial_output: RpcDeletePeptideVialOutput;
  rpc_create_peptide_dose_output: DoseOutput;
  rpc_update_meet_output: RpcUpdateMeetOutput;
  rpc_instacart_recipe_output: RpcInstacartRecipeOutput;
  rpc_usda_foods_output: RpcUsdaFoodsOutput;
  rpc_export_journal_output: RpcExportJournalOutput;
  rpc_get_available_prediction_users_output: RpcGetAvailablePredictionUsersOutput;
  server_core_templates_LeadCandidate_413c3245a6_input: ServerCoreTemplates_LeadCandidate_413C3245A6Input;
  server_core_templates_LeadCandidate_413c3245a6_output: ServerCoreTemplates_LeadCandidate_413C3245A6Output;
  server_journal_learning_week_LearningWeekDayStatus_input: ServerJournalLearningWeek_LearningWeekDayStatusInput;
  server_journal_learning_week_LearningWeekDayStatus_output: ServerJournalLearningWeek_LearningWeekDayStatusOutput;
  server_journal_learning_week_LearningWeekMemberStatus_input: ServerJournalLearningWeek_LearningWeekMemberStatusInput;
  server_journal_learning_week_LearningWeekMemberStatus_output: ServerJournalLearningWeek_LearningWeekMemberStatusOutput;
  server_journal_nutrition_Entry_input: ServerJournalNutrition_EntryInput;
  server_journal_nutrition_Entry_output: ServerJournalNutrition_EntryOutput;
  server_journal_nutrition_ExpandedEntry_input: ServerJournalNutrition_ExpandedEntryInput;
  server_journal_nutrition_ExpandedEntry_output: ServerJournalNutrition_ExpandedEntryOutput;
  server_journal_nutrition_NutritionalVisionPrompt_input: ServerJournalNutrition_NutritionalVisionPromptInput;
  server_journal_nutrition_NutritionalVisionPrompt_output: ServerJournalNutrition_NutritionalVisionPromptOutput;
  server_journal_nutrition_Recipe_input: ServerJournalNutrition_RecipeInput;
  server_journal_nutrition_Recipe_output: ServerJournalNutrition_RecipeOutput;
  server_journal_nutrition_Meal_input: ServerJournalNutrition_MealInput;
  server_journal_nutrition_Meal_output: ServerJournalNutrition_MealOutput;
  server_journal_nutrition_StagedMeal_input: ServerJournalNutrition_StagedMealInput;
  server_journal_nutrition_StagedMeal_output: ServerJournalNutrition_StagedMealOutput;
  server_journal_nutrition_Target_input: ServerJournalNutrition_TargetInput;
  server_journal_nutrition_Target_output: ServerJournalNutrition_TargetOutput;
  server_journal_nutrition_Day_input: ServerJournalNutrition_DayInput;
  server_journal_nutrition_Day_output: ServerJournalNutrition_DayOutput;
  server_journal_nutrition_InlineEntry_input: ServerJournalNutrition_InlineEntryInput;
  server_journal_nutrition_InlineEntry_output: ServerJournalNutrition_InlineEntryOutput;
  server_journal_nutrition_FoodUser_input: ServerJournalNutrition_FoodUserInput;
  server_journal_nutrition_FoodUser_output: ServerJournalNutrition_FoodUserOutput;
  server_journal_nutrition_SharedProfile_input: ServerJournalNutrition_SharedProfileInput;
  server_journal_nutrition_SharedProfile_output: ServerJournalNutrition_SharedProfileOutput;
  server_journal_nutrition_CalculatorProfile_input: ServerJournalNutrition_CalculatorProfileInput;
  server_journal_nutrition_CalculatorProfile_output: ServerJournalNutrition_CalculatorProfileOutput;
  server_journal_nutrition_Food_input: ServerJournalNutrition_FoodInput;
  server_journal_nutrition_Food_output: ServerJournalNutrition_FoodOutput;
  server_backoffice_views_VisionPrompt_input: ServerBackofficeViews_VisionPromptInput;
  server_backoffice_views_VisionPrompt_output: ServerBackofficeViews_VisionPromptOutput;
  server_backoffice_views_LearningWeekVisionPrompt_input: ServerBackofficeViews_LearningWeekVisionPromptInput;
  server_backoffice_views_LearningWeekVisionPrompt_output: ServerBackofficeViews_LearningWeekVisionPromptOutput;
  server_journal_workouts_ExerciseSet_input: ServerJournalWorkouts_ExerciseSetInput;
  server_journal_workouts_ExerciseSet_output: ServerJournalWorkouts_ExerciseSetOutput;
  server_journal_workouts_LatestExerciseInstance_input: ServerJournalWorkouts_LatestExerciseInstanceInput;
  server_journal_workouts_LatestExerciseInstance_output: ServerJournalWorkouts_LatestExerciseInstanceOutput;
  server_journal_workouts_ExerciseType_input: ServerJournalWorkouts_ExerciseTypeInput;
  server_journal_workouts_ExerciseType_output: ServerJournalWorkouts_ExerciseTypeOutput;
  server_journal_workouts_ExerciseTypeUser_input: ServerJournalWorkouts_ExerciseTypeUserInput;
  server_journal_workouts_ExerciseTypeUser_output: ServerJournalWorkouts_ExerciseTypeUserOutput;
  server_journal_workouts_ExerciseExerciseProgression_input: ServerJournalWorkouts_ExerciseExerciseProgressionInput;
  server_journal_workouts_ExerciseExerciseProgression_output: ServerJournalWorkouts_ExerciseExerciseProgressionOutput;
  server_journal_workouts_Exercise_input: ServerJournalWorkouts_ExerciseInput;
  server_journal_workouts_Exercise_output: ServerJournalWorkouts_ExerciseOutput;
  server_journal_workouts_Question_input: ServerJournalWorkouts_QuestionInput;
  server_journal_workouts_Question_output: ServerJournalWorkouts_QuestionOutput;
  server_journal_workouts_ExerciseGroup_input: ServerJournalWorkouts_ExerciseGroupInput;
  server_journal_workouts_ExerciseGroup_output: ServerJournalWorkouts_ExerciseGroupOutput;
  server_journal_workouts_WorkoutSection_input: ServerJournalWorkouts_WorkoutSectionInput;
  server_journal_workouts_WorkoutSection_output: ServerJournalWorkouts_WorkoutSectionOutput;
  server_journal_workouts_WorkoutSectionHistory_input: ServerJournalWorkouts_WorkoutSectionHistoryInput;
  server_journal_workouts_WorkoutSectionHistory_output: ServerJournalWorkouts_WorkoutSectionHistoryOutput;
  server_journal_workouts_QuestionType_input: ServerJournalWorkouts_QuestionTypeInput;
  server_journal_workouts_QuestionType_output: ServerJournalWorkouts_QuestionTypeOutput;
  server_journal_workouts_Workout_input: ServerJournalWorkouts_WorkoutInput;
  server_journal_workouts_Workout_output: ServerJournalWorkouts_WorkoutOutput;
  server_journal_workouts_WorkoutTemplate_input: ServerJournalWorkouts_WorkoutTemplateInput;
  server_journal_workouts_WorkoutTemplate_output: ServerJournalWorkouts_WorkoutTemplateOutput;
  server_journal_workouts_ExerciseMax_input: ServerJournalWorkouts_ExerciseMaxInput;
  server_journal_workouts_ExerciseMax_output: ServerJournalWorkouts_ExerciseMaxOutput;
  server_journal_workouts_ListProgram_input: ServerJournalWorkouts_ListProgramInput;
  server_journal_workouts_ListProgram_output: ServerJournalWorkouts_ListProgramOutput;
  server_journal_workouts_WorkoutGroupWorkout_input: ServerJournalWorkouts_WorkoutGroupWorkoutInput;
  server_journal_workouts_WorkoutGroupWorkout_output: ServerJournalWorkouts_WorkoutGroupWorkoutOutput;
  server_journal_workouts_WorkoutGroup_input: ServerJournalWorkouts_WorkoutGroupInput;
  server_journal_workouts_WorkoutGroup_output: ServerJournalWorkouts_WorkoutGroupOutput;
  server_journal_workouts_ActiveProgram_input: ServerJournalWorkouts_ActiveProgramInput;
  server_journal_workouts_ActiveProgram_output: ServerJournalWorkouts_ActiveProgramOutput;
  server_journal_workouts_Program_input: ServerJournalWorkouts_ProgramInput;
  server_journal_workouts_Program_output: ServerJournalWorkouts_ProgramOutput;
  server_journal_workouts_ProgramUser_input: ServerJournalWorkouts_ProgramUserInput;
  server_journal_workouts_ProgramUser_output: ServerJournalWorkouts_ProgramUserOutput;
  server_journal_workouts_PastProgram_input: ServerJournalWorkouts_PastProgramInput;
  server_journal_workouts_PastProgram_output: ServerJournalWorkouts_PastProgramOutput;
  server_journal_workouts_ExerciseProgression_input: ServerJournalWorkouts_ExerciseProgressionInput;
  server_journal_workouts_ExerciseProgression_output: ServerJournalWorkouts_ExerciseProgressionOutput;
  server_journal_workouts_IncompleteWorkout_input: ServerJournalWorkouts_IncompleteWorkoutInput;
  server_journal_workouts_IncompleteWorkout_output: ServerJournalWorkouts_IncompleteWorkoutOutput;
  server_journal_workouts_SelectProgramTemplate_input: ServerJournalWorkouts_SelectProgramTemplateInput;
  server_journal_workouts_SelectProgramTemplate_output: ServerJournalWorkouts_SelectProgramTemplateOutput;
  server_journal_workouts_ExerciseMedia_input: ServerJournalWorkouts_ExerciseMediaInput;
  server_journal_workouts_ExerciseMedia_output: ServerJournalWorkouts_ExerciseMediaOutput;
  server_journal_workouts_ExerciseHistory_input: ServerJournalWorkouts_ExerciseHistoryInput;
  server_journal_workouts_ExerciseHistory_output: ServerJournalWorkouts_ExerciseHistoryOutput;
  server_nutrition_rpc_ExportWorkout_input: ServerNutritionRpc_ExportWorkoutInput;
  server_nutrition_rpc_ExportWorkout_output: ServerNutritionRpc_ExportWorkoutOutput;
  server_nutrition_rpc_ExportMeal_input: ServerNutritionRpc_ExportMealInput;
  server_nutrition_rpc_ExportMeal_output: ServerNutritionRpc_ExportMealOutput;
  server_nutrition_rpc_USDAFood_input: ServerNutritionRpc_USDAFoodInput;
  server_nutrition_rpc_USDAFood_output: ServerNutritionRpc_USDAFoodOutput;
  server_journal_templates_PromptShare_input: ServerJournalTemplates_PromptShareInput;
  server_journal_templates_PromptShare_output: ServerJournalTemplates_PromptShareOutput;
  server_core_rpc_ProfileUpdatePick_input: ServerCoreRpc_ProfileUpdatePickInput;
  server_core_rpc_ProfileUpdatePick_output: ServerCoreRpc_ProfileUpdatePickOutput;
  server_core_rpc_Profile_input: ServerCoreRpc_ProfileInput;
  server_core_rpc_Profile_output: ServerCoreRpc_ProfileOutput1;
  server_journal_clubs_WalkingClubMemberStatus_input: ServerJournalClubs_WalkingClubMemberStatusInput;
  server_journal_clubs_WalkingClubMemberStatus_output: ServerJournalClubs_WalkingClubMemberStatusOutput;
  server_journal_day_Metric_input: ServerJournalDay_MetricInput;
  server_journal_day_Metric_output: ServerJournalDay_MetricOutput;
  server_journal_day_MetricAggregate_input: ServerJournalDay_MetricAggregateInput;
  server_journal_day_MetricAggregate_output: ServerJournalDay_MetricAggregateOutput;
  server_journal_day_WorkoutAggregate_input: ServerJournalDay_WorkoutAggregateInput;
  server_journal_day_WorkoutAggregate_output: ServerJournalDay_WorkoutAggregateOutput;
  server_journal_day_CheckInResponse_input: ServerJournalDay_CheckInResponseInput;
  server_journal_day_CheckInResponse_output: ServerJournalDay_CheckInResponseOutput;
  server_journal_day_ExistingCheckIn_input: ServerJournalDay_ExistingCheckInInput;
  server_journal_day_ExistingCheckIn_output: ServerJournalDay_ExistingCheckInOutput;
  server_journal_day_CheckIn_input: ServerJournalDay_CheckInInput;
  server_journal_day_CheckIn_output: ServerJournalDay_CheckInOutput;
  server_journal_day_Assignment_input: ServerJournalDay_AssignmentInput;
  server_journal_day_Assignment_output: ServerJournalDay_AssignmentOutput;
  server_journal_day_Journal_input: ServerJournalDay_JournalInput;
  server_journal_day_Journal_output: ServerJournalDay_JournalOutput;
  server_journal_day_Measurement_input: ServerJournalDay_MeasurementInput;
  server_journal_day_Measurement_output: ServerJournalDay_MeasurementOutput;
  server_journal_day_DayUpdate_input: ServerJournalDay_DayUpdateInput;
  server_journal_day_DayUpdate_output: ServerJournalDay_DayUpdateOutput;
  server_journal_day_LegacyDayUpdate_input: ServerJournalDay_LegacyDayUpdateInput;
  server_journal_day_LegacyDayUpdate_output: ServerJournalDay_LegacyDayUpdateOutput;
  server_journal_day_LegacyUpdateDay_input: ServerJournalDay_LegacyUpdateDayInput;
  server_journal_day_LegacyUpdateDay_output: ServerJournalDay_LegacyUpdateDayOutput;
  server_journal_day_Planner_input: ServerJournalDay_PlannerInput;
  server_journal_day_Planner_output: ServerJournalDay_PlannerOutput;
  server_journal_day_ConsumerTarget_input: ServerJournalDay_ConsumerTargetInput;
  server_journal_day_ConsumerTarget_output: ServerJournalDay_ConsumerTargetOutput;
  server_journal_day_ConsumerProfile_input: ServerJournalDay_ConsumerProfileInput;
  server_journal_day_ConsumerProfile_output: ServerJournalDay_ConsumerProfileOutput;
  server_journal_day_ConsumerPlanner_input: ServerJournalDay_ConsumerPlannerInput;
  server_journal_day_ConsumerPlanner_output: ServerJournalDay_ConsumerPlannerOutput;
  server_journal_day_PurchaseVerification_input: ServerJournalDay_PurchaseVerificationInput;
  server_journal_day_PurchaseVerification_output: ServerJournalDay_PurchaseVerificationOutput;
  server_journal_mfp_MFPMigration_input: ServerJournalMfp_MFPMigrationInput;
  server_journal_mfp_MFPMigration_output: ServerJournalMfp_MFPMigrationOutput2;
  server_journal_views_MeetData_input: ServerJournalViews_MeetDataInput;
  server_journal_views_MeetData_output: ServerJournalViews_MeetDataOutput;
  server_manager_templates_ProgramTemplate_input: ServerManagerTemplates_ProgramTemplateInput;
  server_manager_templates_ProgramTemplate_output: ServerManagerTemplates_ProgramTemplateOutput;
  server_manager_templates_ListWorkoutProgram_input: ServerManagerTemplates_ListWorkoutProgramInput;
  server_manager_templates_ListWorkoutProgram_output: ServerManagerTemplates_ListWorkoutProgramOutput;
  server_manager_templates_ClientManagerPick_input: ServerManagerTemplates_ClientManagerPickInput;
  server_manager_templates_ClientManagerPick_output: ServerManagerTemplates_ClientManagerPickOutput;
  server_manager_templates_Manager_e413b4138e_input: ServerManagerTemplates_ManagerE413B4138EInput;
  server_manager_templates_Manager_e413b4138e_output: ServerManagerTemplates_ManagerE413B4138EOutput;
  server_manager_templates_ClientCheckIn_6af5d6e9cc_input: ServerManagerTemplates_ClientCheckIn_6Af5D6E9CcInput;
  server_manager_templates_ClientCheckIn_6af5d6e9cc_output: ServerManagerTemplates_ClientCheckIn_6Af5D6E9CcOutput;
  server_manager_templates_Workout_c29aee4e3e_input: ServerManagerTemplates_WorkoutC29Aee4E3EInput;
  server_manager_templates_Workout_c29aee4e3e_output: ServerManagerTemplates_WorkoutC29Aee4E3EOutput;
  server_manager_templates_User_124424a5e9_input: ServerManagerTemplates_User_124424A5E9Input;
  server_manager_templates_User_124424a5e9_output: ServerManagerTemplates_User_124424A5E9Output;
  server_manager_templates_MealPlanPick_input: ServerManagerTemplates_MealPlanPickInput;
  server_manager_templates_MealPlanPick_output: ServerManagerTemplates_MealPlanPickOutput;
  server_manager_templates_TargetAssignment_f25c746fc2_input: ServerManagerTemplates_TargetAssignmentF25C746Fc2Input;
  server_manager_templates_TargetAssignment_f25c746fc2_output: ServerManagerTemplates_TargetAssignmentF25C746Fc2Output;
  server_manager_templates_ClientManager_9963dfc2dd_input: ServerManagerTemplates_ClientManager_9963Dfc2DdInput;
  server_manager_templates_ClientManager_9963dfc2dd_output: ServerManagerTemplates_ClientManager_9963Dfc2DdOutput;
  server_manager_templates_ExerciseType_c80bde974a_input: ServerManagerTemplates_ExerciseTypeC80Bde974AInput;
  server_manager_templates_ExerciseType_c80bde974a_output: ServerManagerTemplates_ExerciseTypeC80Bde974AOutput;
  server_core_context_processors_Lead_input: ServerCoreContextProcessors_LeadInput;
  server_core_context_processors_Lead_output: ServerCoreContextProcessors_LeadOutput;
  server_core_context_processors_ClientManagerContext_input: ServerCoreContextProcessors_ClientManagerContextInput;
  server_core_context_processors_ClientManagerContext_output: ServerCoreContextProcessors_ClientManagerContextOutput;
  template_HomePage: HomePage;
  template_BusinessPage: BusinessPage;
  template_DemoSetup: DemoSetup;
  template_LeadCandidateUpload: LeadCandidateUpload;
  template_LeadUpload: LeadUpload;
  template_LeadImport: LeadImport;
  template_NotFound: NotFound;
  template_TermsOfService: TermsOfService;
  template_PrivacyPolicy: PrivacyPolicy;
  template_Backoffice: Backoffice;
  template_Predictions: Predictions1;
  template_App: App;
  template_Share: Share;
  template_Leangains: Leangains;
  template_Start: Start1;
  template_PullUp: PullUp;
  template_SuperSmoothies: SuperSmoothies;
  template_Meet: Meet;
  template_JoinMeet: JoinMeet;
  template_ClientDashboard: ClientDashboard;
  template_WeeklySummaryEmail: WeeklySummaryEmail;
  template_ClientManagerDetail: ClientManagerDetail;
  template_ClientCheckInList: ClientCheckInList;
  template_ClientManagerSurvey: ClientManagerSurvey;
  template_ClientDayDetail: ClientDayDetail;
  template_ConfirmManager: ConfirmManager;
  template_ClientManagerPlanner: ClientManagerPlanner;
  template_CreateClient: CreateClient;
  template_DeleteClient: DeleteClient;
  template_ClientManagerReports: ClientManagerReports;
  template_ManagerRegistration: ManagerRegistration;
  template_ClientRegistration: ClientRegistration;
  template_HireRegistration: HireRegistration;
  template_ManagerSettings: ManagerSettings;
  template_MealPlanList: MealPlanList;
  template_MealPlanDetail: MealPlanDetail;
  template_DeleteMealPlan: DeleteMealPlan;
  template_CreateMealPlan: CreateMealPlan;
  template_CreateTarget: CreateTarget;
  template_UpdateTarget: UpdateTarget;
  template_ProgramList: ProgramList;
  template_UpdateProgram: UpdateProgram;
  template_MergeExercises: MergeExercises;
  template_ExerciseMedia: ExerciseMedia;
  template_ClientManagerSupplements: ClientManagerSupplements;
  models: Models;
  context: Context;
}
export interface Register {
  email: Email;
  invite_code: InviteCode;
  with_notification: WithNotification;
  recipe_uuid: RecipeUuid;
  source: Source;
  platform: Platform;
  timezone?: Timezone;
}
export interface Login {
  email: Email1;
  password: Password;
}
export interface SetPassword {
  uidb64: Uidb64;
  token: Token;
  new_password1: NewPassword1;
  new_password2: NewPassword2;
}
export interface Settings {
  askedForRating?: Askedforrating;
  by_device?: ByDevice;
  myfitnesspal?: Myfitnesspal;
  onboarding?: Onboarding;
  meals?: Meals;
  rating_request?: RatingRequest;
  follow_on_instagram?: FollowOnInstagram;
}
export interface ByDevice {
  [k: string]: DeviceSettings | null;
}
export interface DeviceSettings {
  apple_health?: AppleHealth;
  push_notifications?: PushNotifications;
  tracking_authorization?: TrackingAuthorization;
}
export interface Postponed {
  status: Status;
  postponed_until: PostponedUntil;
  postponements: Postponements;
  entries_created?: EntriesCreated;
  workouts_completed?: WorkoutsCompleted;
}
export interface Never {
  status: Status1;
}
export interface Enabled {
  status: Status2;
}
export interface ShouldRequest {
  status: Status3;
}
export interface ApplePing {
  device_id: DeviceId;
  type: Type;
  joy_tag?: JoyTag;
  data?: JsonValue;
}
export interface TrackEmailClick {
  email_uuid: EmailUuid;
}
export interface RegisterAPNSDevice {
  device_id: DeviceId1;
  registration_id: RegistrationId;
  application_id: ApplicationId;
}
export interface PreviewEmail {
  subject: Subject;
  body: Body;
}
export interface PostmarkBounceWebhook {
  ID: Id;
  Type: Type1;
  RecordType: Recordtype;
  TypeCode: Typecode;
  Tag?: Tag;
  MessageID: Messageid;
  Details: Details;
  Email: Email2;
  From: From;
  BouncedAt: Bouncedat;
  Inactive: Inactive;
  DumpAvailable: Dumpavailable;
  CanActivate: Canactivate;
  Subject: Subject1;
  ServerID: Serverid;
  MessageStream: Messagestream;
  Content?: Content;
  Name: Name;
  Description: Description;
  Metadata?: PostmarkMetadata;
}
export interface PostmarkMetadata {
  UUID?: Uuid;
}
export interface MFPRegistration {
  registration: Register;
  mfp_account_uuid: MfpAccountUuid;
  type: Type2;
}
export interface LearningWeekRegistration {
  registration: Register;
}
export interface PlanRegistration {
  registration: Register;
  date_of_birth: DateOfBirth;
  gender: Gender;
  units: Units;
  feet: Feet;
  inches: Inches;
  heightCm: Heightcm;
  weightLb: Weightlb;
  weightKg: Weightkg;
  goal: Goal;
  cookingFrequency: Cookingfrequency;
  assemblyWilling: Assemblywilling;
  repetitionTolerance: Repetitiontolerance;
  nightsOut: Nightsout;
}
export interface Input {
  ignored: Ignored;
}
export interface ValidateLoginLink {
  token: Token1;
}
export interface ResetPassword {
  email: Email3;
}
export interface Contact {
  email: Email4;
  message: Message;
  type: MessageType;
}
export interface DismissAnnouncement {
  announcement: Announcement;
}
export interface UpdateProfile {
  email?: Email5;
  name: Name1;
  date_of_birth: DateOfBirth1;
  is_imperial: IsImperial;
  use_kilojoules: UseKilojoules;
  weight: Weight;
  height: Height;
  waist: Waist;
  gender: Gender1;
  body_fat: BodyFat;
  activity: Activity;
  goal: Goal1;
}
export interface InviteUser {
  email: Email6;
}
export interface ShareAttribution {
  attribution_type: AttributionType;
  referrer: Referrer;
  share_uuid: ShareUuid;
  share_type: ShareType;
}
export interface UTMAttribution {
  attribution_type: AttributionType1;
  referrer: Referrer1;
  utm_source: UtmSource;
  utm_medium: UtmMedium;
  utm_campaign: UtmCampaign;
  utm_term: UtmTerm;
  utm_content: UtmContent;
}
export interface CreateTrackingLink {
  api_key: ApiKey;
  url: Url;
  subreddit: Subreddit;
}
export interface ValidateIAPInput {
  receipt_data: ReceiptData;
}
export interface CreateSubscriptionInput {
  token: Token2;
}
export interface CreatePayPalSubscriptionInput {
  payment_id: PaymentId;
  payer_id: PayerId;
}
export interface Save {
  data: Data;
  name: Name2;
}
export interface Data {
  [k: string]: unknown;
}
export interface ServerJournalDay_MetricInput {
  type: Metric__Type;
  start_date: StartDate;
  end_date: EndDate;
  value: Value;
  timezone: Timezone1;
  apple_health_uuid: AppleHealthUuid;
  uuid: Uuid1;
  apple_health_data: AppleHealthData;
}
export interface UpdateMetricAggregates {
  metrics: Metrics;
  workouts?: Workouts;
  user_id: UserId;
  type?: Type3;
  hourly_steps?: HourlySteps | null;
}
export interface Metrics {
  [k: string]: {
    [k: string]: ServerJournalDay_MetricAggregateInput | null;
  };
}
export interface ServerJournalDay_MetricAggregateInput {
  start_date: StartDate1;
  end_date: EndDate1;
  timezone: Timezone2;
  is_manual: IsManual;
  value: Value1;
  apple_health_uuids: AppleHealthUuids;
  human: Human;
}
export interface Workouts {
  [k: string]: ServerJournalDay_WorkoutAggregateInput[];
}
export interface ServerJournalDay_WorkoutAggregateInput {
  apple_health_uuid: AppleHealthUuid1;
  timezone: Timezone3;
  start_time: StartTime;
  end_time: EndTime;
  workout_activity_type: WorkoutActivityType;
  workout_activity_id: WorkoutActivityId;
  duration_seconds: DurationSeconds;
  calories: Calories;
  distance_meters: DistanceMeters;
  source: Source1;
  source_bundle_id: SourceBundleId;
}
export interface HourlySteps {
  date: Date;
  timezone: Timezone4;
  buckets: Buckets;
}
export interface JournalForm {
  key: Key;
  user_id: UserId1;
}
export interface ServerJournalDay_MeasurementInput {
  weight: Weight1;
  waist: Waist1;
  navel: Navel;
  body_fat: BodyFat1;
  hips: Hips;
  neck: Neck;
  thigh: Thigh;
  bicep: Bicep;
  chest: Chest;
  day: DayReference;
}
export interface DayReference {
  key: Key1;
  user_id: UserId2;
}
export interface ServerJournalDay_DayUpdateInput {
  target: ServerJournalNutrition_TargetInput | null;
  gratitude: Gratitude;
  include_in_reports: IncludeInReports;
  notes: Notes;
  meals: Meals1;
  deleted_meal_uuids: DeletedMealUuids;
}
export interface ServerJournalNutrition_TargetInput {
  pk: Pk;
  id: Id1;
  user_id: UserId3;
  name: Name3;
  type: TargetLike__Type;
  meal_plan: ClassEb62169D81C4C4119F84D68Baf1Df0F7 | null;
  calories_target: CaloriesTarget;
  calories_mode: TargetLike__Mode;
  protein_target: ProteinTarget;
  protein_mode: TargetLike__Mode;
  fat_target: FatTarget;
  fat_mode: TargetLike__Mode;
  carbs_target: CarbsTarget;
  carbs_mode: TargetLike__Mode;
  fiber_target: FiberTarget;
  fiber_mode: TargetLike__Mode;
  net_carbs_target: NetCarbsTarget;
  net_carbs_mode: TargetLike__Mode;
  sodium_target: SodiumTarget;
  sodium_mode: TargetLike__Mode;
  saturated_fat_target: SaturatedFatTarget;
  saturated_fat_mode: TargetLike__Mode;
  monounsaturated_fat_target: MonounsaturatedFatTarget;
  monounsaturated_fat_mode: TargetLike__Mode;
  polyunsaturated_fat_target: PolyunsaturatedFatTarget;
  polyunsaturated_fat_mode: TargetLike__Mode;
  trans_fat_target: TransFatTarget;
  trans_fat_mode: TargetLike__Mode;
  cholesterol_target: CholesterolTarget;
  cholesterol_mode: TargetLike__Mode;
  sugars_target: SugarsTarget;
  sugars_mode: TargetLike__Mode;
  added_sugars_target: AddedSugarsTarget;
  added_sugars_mode: TargetLike__Mode;
  potassium_target: PotassiumTarget;
  potassium_mode: TargetLike__Mode;
  magnesium_target: MagnesiumTarget;
  magnesium_mode: TargetLike__Mode;
  vitamin_a_dv_target: VitaminADvTarget;
  vitamin_a_dv_mode: TargetLike__Mode;
  vitamin_c_dv_target: VitaminCDvTarget;
  vitamin_c_dv_mode: TargetLike__Mode;
  calcium_dv_target: CalciumDvTarget;
  calcium_dv_mode: TargetLike__Mode;
  iron_dv_target: IronDvTarget;
  iron_dv_mode: TargetLike__Mode;
}
export interface ClassEb62169D81C4C4119F84D68Baf1Df0F7 {
  name: Name4;
}
export interface ServerJournalNutrition_MealInput {
  uuid: Uuid2;
  name: Name5;
  hour: Hour;
  type: Meal__Type;
  entries: Entries;
}
export interface ServerJournalNutrition_ExpandedEntryInput {
  uuid: Uuid3;
  name: Name6;
  unit: Unit;
  quantity: Quantity;
  calories_pg: CaloriesPg;
  protein_pg: ProteinPg;
  fat_pg: FatPg;
  carbs_pg: CarbsPg;
  net_carbs_pg: NetCarbsPg;
  fiber_pg: FiberPg;
  sodium_pg: SodiumPg;
  saturated_fat_pg: SaturatedFatPg;
  monounsaturated_fat_pg: MonounsaturatedFatPg;
  polyunsaturated_fat_pg: PolyunsaturatedFatPg;
  trans_fat_pg: TransFatPg;
  cholesterol_pg: CholesterolPg;
  sugars_pg: SugarsPg;
  added_sugars_pg: AddedSugarsPg;
  potassium_pg: PotassiumPg;
  magnesium_pg: MagnesiumPg;
  vitamin_a_dv_pg: VitaminADvPg;
  vitamin_c_dv_pg: VitaminCDvPg;
  calcium_dv_pg: CalciumDvPg;
  iron_dv_pg: IronDvPg;
  base_unit: BaseUnit;
  base_quantity: BaseQuantity;
  serving_size_unit: ServingSizeUnit;
  serving_size_numerator: ServingSizeNumerator;
  serving_size_denominator: ServingSizeDenominator;
  container_unit: ContainerUnit;
  container_quantity: ContainerQuantity;
  container_servings: ContainerServings;
  usda_food_id: UsdaFoodId;
  notes: Notes1;
  additional_units: AdditionalUnits;
  nutritional_vision_prompt: Class_14F806282A3930Ad766E21879D5Acb2B | null;
  backend: Backend;
  backend_id: BackendId;
  expanded_recipe: ExpandedRecipe;
}
export interface USDARawUnit {
  amount: Amount;
  gram_weight: GramWeight;
  modifier: Modifier;
}
export interface Class_14F806282A3930Ad766E21879D5Acb2B {
  uuid: Uuid4;
  image: Class_45D8694A11Ab403C35025433A2F7E2B6 | null;
  status: NutritionalVisionPrompt__Status;
  type: NutritionalVisionPrompt__Type;
  name: Name7;
}
export interface Class_45D8694A11Ab403C35025433A2F7E2B6 {
  image_uid: ImageUid;
}
export interface ServerJournalNutrition_EntryInput {
  uuid: Uuid5;
  name: Name8;
  unit: Unit1;
  quantity: Quantity1;
  calories_pg: CaloriesPg1;
  protein_pg: ProteinPg1;
  fat_pg: FatPg1;
  carbs_pg: CarbsPg1;
  net_carbs_pg: NetCarbsPg1;
  fiber_pg: FiberPg1;
  sodium_pg: SodiumPg1;
  saturated_fat_pg: SaturatedFatPg1;
  monounsaturated_fat_pg: MonounsaturatedFatPg1;
  polyunsaturated_fat_pg: PolyunsaturatedFatPg1;
  trans_fat_pg: TransFatPg1;
  cholesterol_pg: CholesterolPg1;
  sugars_pg: SugarsPg1;
  added_sugars_pg: AddedSugarsPg1;
  potassium_pg: PotassiumPg1;
  magnesium_pg: MagnesiumPg1;
  vitamin_a_dv_pg: VitaminADvPg1;
  vitamin_c_dv_pg: VitaminCDvPg1;
  calcium_dv_pg: CalciumDvPg1;
  iron_dv_pg: IronDvPg1;
  base_unit: BaseUnit1;
  base_quantity: BaseQuantity1;
  serving_size_unit: ServingSizeUnit1;
  serving_size_numerator: ServingSizeNumerator1;
  serving_size_denominator: ServingSizeDenominator1;
  container_unit: ContainerUnit1;
  container_quantity: ContainerQuantity1;
  container_servings: ContainerServings1;
  usda_food_id: UsdaFoodId1;
  notes: Notes2;
  additional_units: AdditionalUnits1;
  backend: Backend1;
  backend_id: BackendId1;
}
export interface ServerJournalDay_LegacyUpdateDayInput {
  day: ServerJournalDay_LegacyDayUpdateInput;
  reference: DayReference;
}
export interface ServerJournalDay_LegacyDayUpdateInput {
  target: ServerJournalNutrition_TargetInput | null;
  gratitude: Gratitude1;
  include_in_reports: IncludeInReports1;
  notes: Notes3;
  meals: Meals2;
}
export interface Input1 {
  client_version: ClientVersion;
  client_app_version: ClientAppVersion;
  date: Date1;
  platform: Platform;
  timezone?: Timezone5;
}
export interface ServerJournalDay_PlannerInput {
  assignments: Assignments;
}
export interface ServerJournalDay_AssignmentInput {
  day_of_week: DayOfWeek;
  profile: ClassA0Ab500Dfce7223467C7F5A0901Aece2;
  check_in: CheckIn;
  target: ServerJournalNutrition_TargetInput | null;
  habits: Habits;
  supplements: Supplements;
  entries: Entries1;
}
export interface ClassA0Ab500Dfce7223467C7F5A0901Aece2 {
  user_id: UserId4;
}
export interface Habits {
  SLEEP?: Sleep;
  CHECK_IN?: CheckIn1;
  STEPS?: Steps;
  WATER?: WaterHabit | null;
  MACROS?: Macros;
  MEALS?: Meals3;
  WEIGHT?: Weight2;
  WORKOUT?: Workout;
  GRATITUDE?: GratitudeHabit;
}
export interface WaterHabit {
  target: Target;
  unit?: Unit2;
}
export interface GratitudeHabit {
  prompt: Prompt;
}
export interface Supplement {
  uuid: Uuid6;
  backend: Backend2;
  backend_id: BackendId2;
  name: Name9;
  target: Target1;
  frequency: Frequency;
  unit: Unit3;
}
export interface ServerJournalDay_ConsumerPlannerInput {
  user_id: UserId5;
  assignments: Assignments1;
  targets: Targets;
  profile: ServerJournalDay_ConsumerProfileInput;
  habits: Habits;
}
export interface Assignments1 {
  [k: string]: string;
}
export interface ServerJournalDay_ConsumerTargetInput {
  uuid: Uuid7;
  name: Name10;
  calories_target: CaloriesTarget1;
  protein_target: ProteinTarget1;
  protein_mode: TargetLike__Mode;
  fat_target: FatTarget1;
  carbs_target: CarbsTarget1;
  fiber_target: FiberTarget1;
  net_carbs_target: NetCarbsTarget1;
}
export interface ServerJournalDay_ConsumerProfileInput {
  name: Name11;
  date_of_birth: DateOfBirth2;
  gender: Gender2;
  is_imperial: IsImperial1;
  weight: Weight3;
  height: Height1;
  body_fat: BodyFat2;
  activity: Activity1;
}
export interface Start {
  measurements: ServerJournalDay_MeasurementInput;
  program: ServerJournalWorkouts_ProgramInput | null;
  planner: ServerJournalDay_ConsumerPlannerInput;
}
export interface ServerJournalWorkouts_ProgramInput {
  uuid: Uuid8;
  program_users: ClassF7330Df3A537Eb09Ec459Babb4Ae2D8E | null;
  workout_groups: WorkoutGroups;
  exercise_maxes: ExerciseMaxes;
  template: ProgramTemplateForm;
  creation: ProgramCreation | null;
}
export interface ClassF7330Df3A537Eb09Ec459Babb4Ae2D8E {
  uuid: Uuid9;
  program: Class_878A7E831908A9Cbbc0493592A54Ea95;
  user_id: UserId6;
  is_active: IsActive;
}
export interface Class_878A7E831908A9Cbbc0493592A54Ea95 {
  uuid: Uuid10;
}
export interface ServerJournalWorkouts_WorkoutGroupInput {
  uuid: Uuid11;
  name: Name12;
  description: Description1;
  workouts: Workouts1;
}
export interface ServerJournalWorkouts_WorkoutGroupWorkoutInput {
  uuid: Uuid12;
  name: Name13;
  instructions: Instructions;
  maxes: Maxes;
  mode: Workout__Mode;
  sections: Sections;
  questions: Questions;
}
export interface ServerJournalWorkouts_WorkoutSectionInput {
  uuid: Uuid13;
  type: WorkoutSection__Type;
  name: Name14;
  instructions: Instructions1;
  copied_from: Class_0Da5D7Db9F079395B12887Cac01Bb665 | null;
  duration: Duration;
  rounds: Rounds;
  groups: Groups;
}
export interface Class_0Da5D7Db9F079395B12887Cac01Bb665 {
  uuid: Uuid14;
}
export interface ServerJournalWorkouts_ExerciseGroupInput {
  uuid: Uuid15;
  exercises: Exercises;
}
export interface ServerJournalWorkouts_ExerciseInput {
  uuid: Uuid16;
  instructions: Instructions2;
  video_uid: VideoUid;
  rest_duration: RestDuration;
  type: ServerJournalWorkouts_ExerciseTypeInput;
  progression: ServerJournalWorkouts_ExerciseExerciseProgressionInput | null;
  mode: Exercise__Mode;
  structure: Structure;
  sets: Sets;
}
export interface ServerJournalWorkouts_ExerciseTypeInput {
  uuid: Uuid17;
}
export interface ServerJournalWorkouts_ExerciseExerciseProgressionInput {
  uuid: Uuid18;
  name: Name15;
  weight: Weight4;
  type: ExerciseProgression__Type;
}
export interface ServerJournalWorkouts_ExerciseSetInput {
  uuid: Uuid19;
  type: ExerciseSet__Type;
  duration_type: DurationType | null;
  distance_type: DistanceType | null;
  speed_type: SpeedType | null;
  instructions: Instructions3;
  reps: Reps;
  weight: Weight5;
  rpe: Rpe;
  status: ExerciseSet__Status;
  duration: Duration1;
  distance: Distance;
  speed: Speed;
  incline: Incline;
  resistance: Resistance;
  weight_type: WeightType | null;
  weight_percentage: WeightPercentage;
  progression: Class_0Da5D7Db9F079395B12887Cac01Bb665 | null;
  attributes: Attributes;
}
export interface ServerJournalWorkouts_QuestionInput {
  uuid: Uuid20;
  type: ClassEf48Df2De43E51D6A2F5590A311D2153;
  answer: Answer;
}
export interface ClassEf48Df2De43E51D6A2F5590A311D2153 {
  uuid: Uuid21;
  name: Name16;
  type: QuestionType__Type;
}
export interface Class_5827A8Dbcef8Beb664F2241Fa48B91Ee {
  type: ExerciseMax__Type;
  exercise_type: Class_878A7E831908A9Cbbc0493592A54Ea95;
  reps: Reps1;
  weight: Weight6;
}
export interface ProgramTemplateForm {
  name: Name17;
  description: Description2;
  visibility: Visibility;
}
export interface ProgramCreation {
  type: WorkoutProgram__Type;
  mode: Mode;
  data: Data1;
}
export interface Onboarding1 {
  registration: Register | null;
  date_of_birth: DateOfBirth3;
  gender: Gender3;
  height: Height2;
  workout_experience: WorkoutExperience;
  mfp: Mfp;
  units: Units1;
  goal: Goal2;
  activity: Activity2;
  iap_method: IapMethod;
  weightLb: Weightlb1;
  weightKg: Weightkg1;
  targets: Targets1;
  today: Today;
}
export interface Method {
  registration: Register | null;
  date_of_birth: DateOfBirth4;
  gender: Gender4;
  height: Height3;
  workout_experience: WorkoutExperience1;
  mfp: Mfp1;
  units: Units2;
  goal: Goal3;
  activity: Activity3;
  iap_method: IapMethod1;
  weightLb: Weightlb2;
  weightKg: Weightkg2;
  targets: Targets2;
}
export interface ShopifyOrderCreated {
  id: Id2;
  email: Email7;
  contact_email: ContactEmail;
  name: Name18;
  order_number: OrderNumber;
  financial_status: FinancialStatus;
  fulfillment_status: FulfillmentStatus;
  total_price: TotalPrice;
  subtotal_price: SubtotalPrice;
  total_tax: TotalTax;
  currency: Currency;
  customer: ShopifyCustomer | null;
  line_items: LineItems;
}
export interface ShopifyCustomer {
  id: Id3;
  email: Email8;
  first_name: FirstName;
  last_name: LastName;
  state: State;
  verified_email: VerifiedEmail;
  phone: Phone;
  tags?: Tags;
  currency: Currency1;
}
export interface ShopifyLineItem {
  id: Id4;
  sku: Sku;
  name: Name19;
  title: Title;
  quantity: Quantity2;
  price: Price;
  vendor: Vendor;
  product_id: ProductId;
  variant_id: VariantId;
  variant_title: VariantTitle;
}
export interface ReplaceEntry {
  target_entry_uuid: TargetEntryUuid;
  replacement: ServerJournalNutrition_ExpandedEntryInput;
}
export interface MoveDay {
  user_id: UserId7;
  key: Key2;
  source_user_id?: SourceUserId;
  source_day_key: SourceDayKey;
}
export interface CopyDay {
  user_id: UserId8;
  key: Key3;
  source_user_id?: SourceUserId1;
  source_day_key: SourceDayKey1;
}
export interface AcceptMealPlan {
  user_id: UserId9;
  key: Key4;
}
export interface RejectMealPlan {
  user_id: UserId10;
  key: Key5;
}
export interface CheckInInput {
  user_id: UserId11;
  key: Key6;
  notes: Notes4;
  responses: Responses;
}
export interface CheckInResponseInput {
  question: Question;
  response: Response;
}
export interface PlannerInput {
  targets: Targets3;
  assignments: Assignments2;
}
export interface TargetInput {
  id?: Id5;
  name: Name20;
  calories_target: CaloriesTarget2;
  protein_target: ProteinTarget2;
  fat_target: FatTarget2;
  carbs_target: CarbsTarget2;
  net_carbs_target: NetCarbsTarget2;
}
export interface AssignmentInput {
  reference: Reference;
}
export interface CreateTemplateFromWorkout {
  source_workout: SourceWorkout;
  name: Name21;
}
export interface DeleteWorkout {
  source_workout: SourceWorkout1;
}
export interface DeleteGroup {
  source_group: SourceGroup;
}
export interface ServerJournalWorkouts_WorkoutInput {
  uuid: Uuid22;
  sections: Sections1;
  questions: Questions1;
  template: WorkoutTemplateForm | null;
}
export interface WorkoutTemplateForm {
  name: Name22;
  instructions: Instructions4;
  visibility: Visibility;
  maxes: Maxes;
}
export interface CopyProgram {
  source_program: SourceProgram;
  name: Name23;
}
export interface DeleteProgram {
  source_program: SourceProgram1;
}
export interface ServerJournalWorkouts_SelectProgramTemplateInput {
  source_template: SourceTemplate;
  user_id: UserId12;
  should_sync: ShouldSync;
  exercise_maxes: ExerciseMaxes1;
}
export interface ServerJournalWorkouts_ExerciseMaxInput {
  exercise_type: Class_878A7E831908A9Cbbc0493592A54Ea95;
  type: ExerciseMax__Type;
  weight: Weight7;
  reps: Reps2;
  workout: Class_0Da5D7Db9F079395B12887Cac01Bb665 | null;
}
export interface CreateExerciseType {
  uuid: Uuid23;
  name: Name24;
  category: Category;
}
export interface DeleteExerciseGroup {
  source_exercise_group: SourceExerciseGroup;
}
export interface SelectProgramWorkout {
  source_workout: SourceWorkout2;
  user_id: UserId13;
  date: Date2;
}
export interface ArchiveProgram {
  source_program: SourceProgram2;
}
export interface DisableSync {
  source_program: SourceProgram3;
}
export interface RecentSections {
  offset: Offset;
  exclude_workout: ExcludeWorkout;
}
export interface ExerciseMediaLookup {
  query: Query;
}
export interface ServerJournalWorkouts_ExerciseMediaInput {
  exercise_type: ClassC294Ea3Cad8Ac35Cc99Fda382A8B6D9D;
  gym_visual_side: Side;
  gym_visual_code: GymVisualCode;
  gym_visual_video_path: GymVisualVideoPath;
  gym_visual_image_path: GymVisualImagePath;
  gym_visual_gif_path: GymVisualGifPath;
  gym_visual_green_video_path: GymVisualGreenVideoPath;
}
export interface ClassC294Ea3Cad8Ac35Cc99Fda382A8B6D9D {
  uuid: Uuid24;
}
export interface ExerciseTypeForm {
  uuid: Uuid25;
  name: Name25;
  category:
    | "WEIGHT"
    | "BODYWEIGHT"
    | "CARDIO"
    | "DURATION"
    | "DURATION_DISTANCE"
    | "REPS_DISTANCE"
    | "MEDLEY"
    | "WEIGHT_DISTANCE"
    | "WEIGHT_DURATION_DISTANCE";
  video_url: VideoUrl;
  video_uid: VideoUid1;
  description: Description3;
}
export interface DeleteExerciseSet {
  exercise_set_uuid: ExerciseSetUuid;
}
export interface DeleteExercise {
  exercise_uuid: ExerciseUuid;
}
export interface ClearExerciseSets {
  exercise_uuid: ExerciseUuid1;
}
export interface ExerciseDetailForm {
  exercise_type_uuid: ExerciseTypeUuid;
  workout_uuid: WorkoutUuid;
  user_id?: UserId14;
}
export interface CopyWorkoutForm {
  date: Date3;
  user_id: UserId15;
  source_workout_uuid: SourceWorkoutUuid;
}
export interface CompleteWorkoutForm {
  workout_uuid: WorkoutUuid1;
}
export interface IncompleteWorkoutForm {
  workout_uuid: WorkoutUuid2;
}
export interface CreateWorkoutTemplateForm {
  name: Name26;
  instructions: Instructions5;
  visibility: "PRIVATE" | "PUBLIC" | "CLIENTS";
  maxes: "EXISTING_MAXES" | "UPDATE_MAXES" | "AUTOMATIC";
}
export interface QuestionTypeInput {
  uuid: Uuid26;
  name: Name27;
}
export interface UpdateCupboard {
  entries: Entries2;
}
export interface UpdateRecipe {
  recipe_uuid: RecipeUuid1;
  entries: Entries3;
}
export interface SearchForm {
  upc: Upc;
  keywords: Keywords;
  source: Source2;
}
export interface PublishNutritionalVisionPrompt {
  source_prompt: SourcePrompt;
}
export interface PublishDay {
  date: Date4;
  user_id: UserId16;
}
export interface ShareForm {
  share_uuid: ShareUuid1;
}
export interface ShareRecipe {
  recipe_uuid: RecipeUuid2;
}
export interface ListFoods {}
export interface CreateFood {
  name: Name28;
  upc: Upc1;
  from_missing_upc?: FromMissingUpc;
  calories_pg: CaloriesPg2;
  protein_pg: ProteinPg2;
  fat_pg: FatPg2;
  carbs_pg: CarbsPg2;
  net_carbs_pg: NetCarbsPg2;
  fiber_pg: FiberPg2;
  sodium_pg: SodiumPg2;
  saturated_fat_pg: SaturatedFatPg2;
  monounsaturated_fat_pg: MonounsaturatedFatPg2;
  polyunsaturated_fat_pg: PolyunsaturatedFatPg2;
  trans_fat_pg: TransFatPg2;
  cholesterol_pg: CholesterolPg2;
  sugars_pg: SugarsPg2;
  added_sugars_pg: AddedSugarsPg2;
  potassium_pg: PotassiumPg2;
  magnesium_pg: MagnesiumPg2;
  vitamin_a_dv_pg: VitaminADvPg2;
  vitamin_c_dv_pg: VitaminCDvPg2;
  calcium_dv_pg: CalciumDvPg2;
  iron_dv_pg: IronDvPg2;
  base_unit: BaseUnit2;
  base_quantity: BaseQuantity2;
  serving_size_unit: ServingSizeUnit2;
  serving_size_numerator: ServingSizeNumerator2;
  container_servings: ContainerServings2;
}
export interface UpdateFood {
  name: Name29;
  upc: Upc2;
  from_missing_upc?: FromMissingUpc1;
  calories_pg: CaloriesPg3;
  protein_pg: ProteinPg3;
  fat_pg: FatPg3;
  carbs_pg: CarbsPg3;
  net_carbs_pg: NetCarbsPg3;
  fiber_pg: FiberPg3;
  sodium_pg: SodiumPg3;
  saturated_fat_pg: SaturatedFatPg3;
  monounsaturated_fat_pg: MonounsaturatedFatPg3;
  polyunsaturated_fat_pg: PolyunsaturatedFatPg3;
  trans_fat_pg: TransFatPg3;
  cholesterol_pg: CholesterolPg3;
  sugars_pg: SugarsPg3;
  added_sugars_pg: AddedSugarsPg3;
  potassium_pg: PotassiumPg3;
  magnesium_pg: MagnesiumPg3;
  vitamin_a_dv_pg: VitaminADvPg3;
  vitamin_c_dv_pg: VitaminCDvPg3;
  calcium_dv_pg: CalciumDvPg3;
  iron_dv_pg: IronDvPg3;
  base_unit: BaseUnit3;
  base_quantity: BaseQuantity3;
  serving_size_unit: ServingSizeUnit3;
  serving_size_numerator: ServingSizeNumerator3;
  container_servings: ContainerServings3;
  food_id: FoodId;
}
export interface DeleteFood {
  food_id: FoodId1;
}
export interface ListRecipes {}
export interface CreateRecipe {
  name: Name30;
  container_servings: ContainerServings4;
  serving_size_unit: ServingSizeUnit4;
  container_quantity: ContainerQuantity2;
  container_unit: ContainerUnit2;
  notes: Notes5;
}
export interface UpdateRecipeMetadata {
  name: Name31;
  container_servings: ContainerServings5;
  serving_size_unit: ServingSizeUnit5;
  container_quantity: ContainerQuantity3;
  container_unit: ContainerUnit3;
  notes: Notes6;
  recipe_id: RecipeId;
}
export interface DeleteRecipe {
  recipe_id: RecipeId1;
}
export interface CopyRecipe {
  recipe_id: RecipeId2;
}
export interface CreateRecipeFromMeal {
  name: Name32;
  container_servings: ContainerServings6;
  serving_size_unit: ServingSizeUnit6;
  container_quantity: ContainerQuantity4;
  container_unit: ContainerUnit4;
  notes: Notes7;
  meal_id: MealId;
}
export interface PublishMeal {
  meal_uuid: MealUuid;
}
export interface DeleteMeal {
  meal_uuid: MealUuid1;
}
export interface MoveMeal {
  user_id: UserId17;
  key: Key7;
  source_meal_uuid: SourceMealUuid;
}
export interface CopyMeal {
  user_id: UserId18;
  key: Key8;
  source_meal_uuid: SourceMealUuid1;
}
export interface PublishEntry {
  entry_uuid: EntryUuid;
}
export interface ExpandEntry {
  entry_uuid: EntryUuid1;
}
export interface Input2 {
  exercise_types: ExerciseTypes;
  stat: Stat;
  start_date: StartDate2;
  end_date: EndDate2;
  user_id: UserId19;
}
export interface Related {
  uuid: Uuid27;
}
export interface Input3 {
  user_id: UserId20;
}
export interface MFPAccountForm {
  email: Email9;
  password: Password1;
}
export interface BoardForm {
  ignored: Ignored1;
  weeks_ago?: WeeksAgo;
}
export interface DemoForm {
  ignored: Ignored2;
}
export interface InfoForm {
  code: Code;
}
export interface LoginLink {
  code: Code1;
  email: Email10;
}
export interface JoinForm {
  code: Code2;
  display_name: DisplayName;
  image_uid: ImageUid1;
}
export interface WalkingClubRegistration {
  registration: Register;
  code: Code3;
  display_name: DisplayName1;
  image_uid: ImageUid2;
}
export interface Input4 {
  image_uid: ImageUid3;
  filename: Filename;
  description: Description4;
  depth_map?: DepthMap | null;
}
export interface DepthMap {
  width: Width;
  height: Height4;
  values: Values;
  orientation: Orientation;
}
export interface QueueBarcode {
  image_uid: ImageUid4;
  filename: Filename1;
  barcode: Barcode;
  depth_map?: DepthMap | null;
}
export interface ReprocessQueuedImage {
  prompt_uuid: PromptUuid;
  description: Description5;
}
export interface ImportRecipe {
  description: Description6;
}
export interface CreateVialInput {
  peptide_key: PeptideKey;
  label: Label;
  vial_mg: VialMg;
  water_ml: WaterMl;
  component_amounts: ComponentAmounts;
  mixed_at: MixedAt;
}
export interface ComponentAmounts {
  [k: string]: string;
}
export interface DeleteVialInput {
  vial_uuid: VialUuid;
}
export interface CreateDoseInput {
  vial_uuid: VialUuid1;
  units: Units3;
  taken_at: TakenAt;
  injection_site?: InjectionSite;
}
export interface ServerJournalViews_MeetDataInput {
  meet_participants: MeetParticipants;
}
export interface Class_5Cb0Ef9Ea3A45E1459B41F54Edd99Ffe {
  uuid: Uuid28;
  weight: Weight8;
  exercise_maxes: ExerciseMaxes2;
  user: ClassE09C21547Eff6Fbf7948Cef16Ad49Db1;
}
export interface Class_67C6C646Cfcb2943Ba5Afd1539D1296A {
  weight: Weight9;
  exercise_type: Class_878A7E831908A9Cbbc0493592A54Ea95;
}
export interface ClassE09C21547Eff6Fbf7948Cef16Ad49Db1 {
  id: Id6;
  profile: ServerCoreRpc_ProfileInput;
}
export interface ServerCoreRpc_ProfileInput {
  name: Name33;
  waist: Waist2;
  body_fat: BodyFat3;
  use_kilojoules: UseKilojoules1;
  is_imperial: IsImperial2;
  activity: Activity4;
  goal: Goal4;
  gender: Gender5;
  date_of_birth: DateOfBirth5;
  height: Height5;
  weight: Weight10;
  entries_created: EntriesCreated1;
  workouts_completed: WorkoutsCompleted1;
  user: ClassD4679081Dee20E85C6Cb52A226Fad7C9;
  assignments: Assignments3;
  settings: Settings;
}
export interface ClassD4679081Dee20E85C6Cb52A226Fad7C9 {
  id: Id7;
  date_joined: DateJoined;
  email: Email11;
  has_beta_access: HasBetaAccess;
  should_collect_analytics: ShouldCollectAnalytics;
  targets: Targets4;
  is_subscription_active: IsSubscriptionActive;
  manager_full_name: ManagerFullName;
  manager_slug: ManagerSlug;
}
export interface ClassDc93A75E1893A2E3B0De0Ee7151Ce111 {
  id: Id8;
  name: Name34;
  type: TargetLike__Type;
  calories_target: CaloriesTarget3;
  protein_target: ProteinTarget3;
  fat_target: FatTarget3;
  carbs_target: CarbsTarget3;
  fiber_target: FiberTarget2;
  net_carbs_target: NetCarbsTarget3;
  meal_plan_id: MealPlanId;
}
export interface ClassE686Da6Bf39Ca0B52D6578Ee92015C98 {
  check_in: CheckIn;
  target_id: TargetId;
  day_of_week: DayOfWeek1;
  day_template_id: DayTemplateId;
  id: Id9;
}
export interface InstacartRecipe {
  title: Title1;
  image_url: ImageUrl;
  link_type: LinkType;
  instructions: Instructions6;
  ingredients: Ingredients;
  landing_page_configuration: InstacartLandingPageConfiguration;
}
export interface InstacartIngredient {
  name: Name35;
  display_text: DisplayText;
  measurements: Measurements;
}
export interface InstacartMeasurement {
  quantity: Quantity3;
  unit: Unit4;
}
export interface InstacartLandingPageConfiguration {
  partner_linkback_url: PartnerLinkbackUrl;
  enable_pantry_items: EnablePantryItems;
}
export interface ExportJournal {
  start_date: StartDate3;
  end_date: EndDate3;
}
export interface ServerCoreRpc_ProfileOutput {
  name: Name36;
  waist: Waist3;
  body_fat: BodyFat4;
  has_hidden_macros: HasHiddenMacros;
  use_kilojoules: UseKilojoules2;
  is_imperial: IsImperial3;
  activity: Activity5;
  goal: Goal5;
  gender: Gender6;
  date_of_birth: DateOfBirth6;
  height: Height6;
  weight: Weight11;
  entries_created: EntriesCreated2;
  workouts_completed: WorkoutsCompleted2;
  user: Class_9E460C5B23A2310C95Ff6E8F9778F0F9;
  assignments: Assignments4;
  settings: Settings;
  share_uuid: ShareUuid2;
}
export interface Class_9E460C5B23A2310C95Ff6E8F9778F0F9 {
  id: Id10;
  date_joined: DateJoined1;
  manager_name: ManagerName;
  email: Email12;
  has_beta_access: HasBetaAccess1;
  tracking_key: TrackingKey;
  should_collect_analytics: ShouldCollectAnalytics1;
  targets: Targets5;
  is_subscription_active: IsSubscriptionActive1;
  is_reports_enabled: IsReportsEnabled;
  is_trial_active: IsTrialActive;
  is_client: IsClient;
  is_manager: IsManager;
  has_peptides: HasPeptides;
  has_walking_club: HasWalkingClub;
  casted_dismissed_announcements: CastedDismissedAnnouncements;
  get_measurements: GetMeasurements;
  manager_full_name: ManagerFullName1;
  manager_slug: ManagerSlug1;
  registration_recipe_name: RegistrationRecipeName;
  must_verify_email: MustVerifyEmail;
}
export interface ServerCoreRpc_ProfileOutput1 {
  name: Name36;
  waist: Waist3;
  body_fat: BodyFat4;
  has_hidden_macros: HasHiddenMacros;
  use_kilojoules: UseKilojoules2;
  is_imperial: IsImperial3;
  activity: Activity5;
  goal: Goal5;
  gender: Gender6;
  date_of_birth: DateOfBirth6;
  height: Height6;
  weight: Weight11;
  entries_created: EntriesCreated2;
  workouts_completed: WorkoutsCompleted2;
  user: Class_9E460C5B23A2310C95Ff6E8F9778F0F9;
  assignments: Assignments4;
  settings: Settings;
  share_uuid: ShareUuid2;
}
export interface ServerCoreRpc_ProfileOutput2 {
  name: Name36;
  waist: Waist3;
  body_fat: BodyFat4;
  has_hidden_macros: HasHiddenMacros;
  use_kilojoules: UseKilojoules2;
  is_imperial: IsImperial3;
  activity: Activity5;
  goal: Goal5;
  gender: Gender6;
  date_of_birth: DateOfBirth6;
  height: Height6;
  weight: Weight11;
  entries_created: EntriesCreated2;
  workouts_completed: WorkoutsCompleted2;
  user: Class_9E460C5B23A2310C95Ff6E8F9778F0F9;
  assignments: Assignments4;
  settings: Settings;
  share_uuid: ShareUuid2;
}
export interface RpcPreviewEmailOutput {
  [k: string]: string;
}
export interface Primitive {
  value: Value2;
}
export interface Output {
  image_uid: ImageUid5;
  upload_url: UploadUrl;
}
export interface AppleSubscriptionType {
  type: Type4;
  expires_date: ExpiresDate;
}
export interface StripeSubscription {
  type: Type5;
  current_period_end: CurrentPeriodEnd;
  status: Status4;
}
export interface NoSubscription {
  type: Type6;
}
export interface ServerJournalDay_JournalOutput {
  day: ServerJournalNutrition_DayOutput;
  supplements: Supplements1;
  meal_plan: ServerJournalNutrition_DayOutput | null;
  incomplete_workout: ServerJournalWorkouts_IncompleteWorkoutOutput | null;
  workout: ServerJournalWorkouts_WorkoutOutput | null;
  check_in: ServerJournalDay_CheckInOutput | null;
  assignment: ServerJournalDay_AssignmentOutput | null;
  targets: Targets6;
  exercise_maxes: ExerciseMaxes3;
  workout_templates: WorkoutTemplates;
  program_templates: ProgramTemplates;
  program: ServerJournalWorkouts_ActiveProgramOutput | null;
  metrics: Metrics1;
  activities: Activities;
  workout_status: WorkoutStatus;
  next_workout: NextWorkoutWrapper | null;
  streak: Streak;
  learning_week: LearningWeekData | null;
}
export interface ServerJournalNutrition_DayOutput {
  include_in_reports: IncludeInReports2;
  name: Name37;
  share_uuid: ShareUuid3;
  user_id: UserId21;
  gratitude: Gratitude2;
  comments: Comments;
  measurements: Measurements1;
  id: Id11;
  key: Key9;
  recent_meals: RecentMeals;
  notes: Notes8;
  meals: Meals4;
  target: ServerJournalNutrition_TargetOutput | null;
}
export interface Class_758F8129F9260A9A36D9312A74281C9B {
  manager: ClassBeb64919Cd8B03126E49512Ead4A696C;
  created_at: CreatedAt;
  comment: Comment;
}
export interface ClassBeb64919Cd8B03126E49512Ead4A696C {
  profile: Class_594132C627C53Ca28Bc71A63D8C57D95;
}
export interface Class_594132C627C53Ca28Bc71A63D8C57D95 {
  name: Name38;
}
export interface ClassEa45F5C4Bc91F4A7A40B119Bf769Ce26 {
  weight: Weight12;
  waist: Waist4;
  navel: Navel1;
  body_fat: BodyFat5;
  hips: Hips1;
  neck: Neck1;
  thigh: Thigh1;
  bicep: Bicep1;
  chest: Chest1;
}
export interface ServerJournalNutrition_MealOutput {
  uuid: Uuid29;
  share_uuid: ShareUuid4;
  key: Key10;
  name: Name39;
  hour: Hour1;
  recreate_recipe: RecreateRecipe | null;
  type: Meal__Type;
  entries: Entries4;
}
export interface RecreateRecipe {
  name: Name40;
  container_servings: ContainerServings7;
  serving_size_unit: ServingSizeUnit7;
  container_quantity: ContainerQuantity5;
  container_unit: ContainerUnit5;
  notes: Notes9;
}
export interface ServerJournalNutrition_ExpandedEntryOutput {
  uuid: Uuid30;
  name: Name41;
  unit: Unit5;
  quantity: Quantity4;
  calories_pg: CaloriesPg4;
  protein_pg: ProteinPg4;
  fat_pg: FatPg4;
  carbs_pg: CarbsPg4;
  net_carbs_pg: NetCarbsPg4;
  fiber_pg: FiberPg4;
  sodium_pg: SodiumPg4;
  saturated_fat_pg: SaturatedFatPg4;
  monounsaturated_fat_pg: MonounsaturatedFatPg4;
  polyunsaturated_fat_pg: PolyunsaturatedFatPg4;
  trans_fat_pg: TransFatPg4;
  cholesterol_pg: CholesterolPg4;
  sugars_pg: SugarsPg4;
  added_sugars_pg: AddedSugarsPg4;
  potassium_pg: PotassiumPg4;
  magnesium_pg: MagnesiumPg4;
  vitamin_a_dv_pg: VitaminADvPg4;
  vitamin_c_dv_pg: VitaminCDvPg4;
  calcium_dv_pg: CalciumDvPg4;
  iron_dv_pg: IronDvPg4;
  base_unit: BaseUnit4;
  base_quantity: BaseQuantity4;
  serving_size_unit: ServingSizeUnit8;
  serving_size_numerator: ServingSizeNumerator4;
  serving_size_denominator: ServingSizeDenominator2;
  container_unit: ContainerUnit6;
  container_quantity: ContainerQuantity6;
  container_servings: ContainerServings8;
  units: Units4;
  usda_food_id: UsdaFoodId2;
  notes: Notes10;
  additional_units: AdditionalUnits2;
  nutritional_vision_prompt: ClassAe1C07D2B641Eaf3413Ccd25829A7320 | null;
  backend: Backend3;
  backend_id: BackendId3;
  expanded_recipe: ExpandedRecipe1;
}
export interface Unit6 {
  unit: Unit7;
  multiplier: Multiplier;
  calories: Calories1;
  info: Info;
  is_secondary?: IsSecondary;
}
export interface ClassAe1C07D2B641Eaf3413Ccd25829A7320 {
  uuid: Uuid31;
  image: Class_45D8694A11Ab403C35025433A2F7E2B6 | null;
  status: NutritionalVisionPrompt__Status;
  type: NutritionalVisionPrompt__Type;
  name: Name42;
  barcode: Barcode1;
}
export interface ServerJournalNutrition_EntryOutput {
  uuid: Uuid32;
  name: Name43;
  unit: Unit8;
  quantity: Quantity5;
  calories_pg: CaloriesPg5;
  protein_pg: ProteinPg5;
  fat_pg: FatPg5;
  carbs_pg: CarbsPg5;
  net_carbs_pg: NetCarbsPg5;
  fiber_pg: FiberPg5;
  sodium_pg: SodiumPg5;
  saturated_fat_pg: SaturatedFatPg5;
  monounsaturated_fat_pg: MonounsaturatedFatPg5;
  polyunsaturated_fat_pg: PolyunsaturatedFatPg5;
  trans_fat_pg: TransFatPg5;
  cholesterol_pg: CholesterolPg5;
  sugars_pg: SugarsPg5;
  added_sugars_pg: AddedSugarsPg5;
  potassium_pg: PotassiumPg5;
  magnesium_pg: MagnesiumPg5;
  vitamin_a_dv_pg: VitaminADvPg5;
  vitamin_c_dv_pg: VitaminCDvPg5;
  calcium_dv_pg: CalciumDvPg5;
  iron_dv_pg: IronDvPg5;
  base_unit: BaseUnit5;
  base_quantity: BaseQuantity5;
  serving_size_unit: ServingSizeUnit9;
  serving_size_numerator: ServingSizeNumerator5;
  serving_size_denominator: ServingSizeDenominator3;
  container_unit: ContainerUnit7;
  container_quantity: ContainerQuantity7;
  container_servings: ContainerServings9;
  units: Units5;
  usda_food_id: UsdaFoodId3;
  notes: Notes11;
  additional_units: AdditionalUnits3;
  backend: Backend4;
  backend_id: BackendId4;
}
export interface ServerJournalNutrition_TargetOutput {
  pk: Pk1;
  id: Id12;
  user_id: UserId22;
  name: Name44;
  type: TargetLike__Type;
  meal_plan: ClassEb62169D81C4C4119F84D68Baf1Df0F7 | null;
  calories_target: CaloriesTarget4;
  calories_mode: TargetLike__Mode;
  protein_target: ProteinTarget4;
  protein_mode: TargetLike__Mode;
  fat_target: FatTarget4;
  fat_mode: TargetLike__Mode;
  carbs_target: CarbsTarget4;
  carbs_mode: TargetLike__Mode;
  fiber_target: FiberTarget3;
  fiber_mode: TargetLike__Mode;
  net_carbs_target: NetCarbsTarget4;
  net_carbs_mode: TargetLike__Mode;
  sodium_target: SodiumTarget1;
  sodium_mode: TargetLike__Mode;
  saturated_fat_target: SaturatedFatTarget1;
  saturated_fat_mode: TargetLike__Mode;
  monounsaturated_fat_target: MonounsaturatedFatTarget1;
  monounsaturated_fat_mode: TargetLike__Mode;
  polyunsaturated_fat_target: PolyunsaturatedFatTarget1;
  polyunsaturated_fat_mode: TargetLike__Mode;
  trans_fat_target: TransFatTarget1;
  trans_fat_mode: TargetLike__Mode;
  cholesterol_target: CholesterolTarget1;
  cholesterol_mode: TargetLike__Mode;
  sugars_target: SugarsTarget1;
  sugars_mode: TargetLike__Mode;
  added_sugars_target: AddedSugarsTarget1;
  added_sugars_mode: TargetLike__Mode;
  potassium_target: PotassiumTarget1;
  potassium_mode: TargetLike__Mode;
  magnesium_target: MagnesiumTarget1;
  magnesium_mode: TargetLike__Mode;
  vitamin_a_dv_target: VitaminADvTarget1;
  vitamin_a_dv_mode: TargetLike__Mode;
  vitamin_c_dv_target: VitaminCDvTarget1;
  vitamin_c_dv_mode: TargetLike__Mode;
  calcium_dv_target: CalciumDvTarget1;
  calcium_dv_mode: TargetLike__Mode;
  iron_dv_target: IronDvTarget1;
  iron_dv_mode: TargetLike__Mode;
}
export interface SearchResult {
  name: Name45;
  entry: ServerJournalNutrition_ExpandedEntryOutput;
  source: Source3;
  backend_id: BackendId5;
  backend: Backend5;
  raw?: Raw;
  is_cupboard?: IsCupboard;
}
export interface Raw {
  [k: string]: unknown;
}
export interface ServerJournalWorkouts_IncompleteWorkoutOutput {
  uuid: Uuid33;
  name: Name46;
  date: Date5;
}
export interface ServerJournalWorkouts_WorkoutOutput {
  uuid: Uuid34;
  name: Name47;
  date: Date6;
  instructions: Instructions7;
  id: Id13;
  user_id: UserId23;
  maxes: Maxes;
  status: Workout__Status;
  mode: Workout__Mode;
  sections: Sections2;
  questions: Questions2;
}
export interface ServerJournalWorkouts_WorkoutSectionOutput {
  uuid: Uuid35;
  type: WorkoutSection__Type;
  name: Name48;
  instructions: Instructions8;
  copied_from: Class_0Da5D7Db9F079395B12887Cac01Bb665 | null;
  duration: Duration2;
  rounds: Rounds1;
  groups: Groups1;
}
export interface ServerJournalWorkouts_ExerciseGroupOutput {
  uuid: Uuid36;
  exercises: Exercises1;
}
export interface ServerJournalWorkouts_ExerciseOutput {
  uuid: Uuid37;
  instructions: Instructions9;
  video_uid: VideoUid2;
  rest_duration: RestDuration1;
  type: ServerJournalWorkouts_ExerciseTypeOutput;
  progression: ServerJournalWorkouts_ExerciseExerciseProgressionOutput | null;
  mode: Exercise__Mode;
  structure: Structure;
  sets: Sets2;
}
export interface ServerJournalWorkouts_ExerciseTypeOutput {
  uuid: Uuid38;
  id: Id14;
  user_id: UserId24;
  video_url: VideoUrl1;
  video_uid: VideoUid3;
  name: Name49;
  category: Category;
  casted_cardio_metrics: CastedCardioMetrics;
  description: Description7;
  media: Class_1508D950B53B94Cfe382B56693Df253E | null;
  latest_instances: LatestInstances;
}
export interface Class_1508D950B53B94Cfe382B56693Df253E {
  video_uid: VideoUid4;
  gif_uid: GifUid;
  image_uid: ImageUid6;
  wide_image_uid: WideImageUid;
}
export interface ServerJournalWorkouts_LatestExerciseInstanceOutput {
  id: Id15;
  uuid: Uuid39;
  rest_duration: RestDuration2;
  sets: Sets1;
}
export interface ServerJournalWorkouts_ExerciseSetOutput {
  uuid: Uuid40;
  type: ExerciseSet__Type;
  duration_type: DurationType | null;
  distance_type: DistanceType | null;
  speed_type: SpeedType | null;
  instructions: Instructions10;
  reps: Reps3;
  weight: Weight13;
  rpe: Rpe1;
  status: ExerciseSet__Status;
  duration: Duration3;
  distance: Distance1;
  speed: Speed1;
  incline: Incline1;
  resistance: Resistance1;
  weight_type: WeightType | null;
  weight_percentage: WeightPercentage1;
  progression: Class_0Da5D7Db9F079395B12887Cac01Bb665 | null;
  attributes: Attributes1;
}
export interface ServerJournalWorkouts_ExerciseExerciseProgressionOutput {
  uuid: Uuid41;
  name: Name50;
  weight: Weight14;
  type: ExerciseProgression__Type;
}
export interface ServerJournalWorkouts_QuestionOutput {
  uuid: Uuid42;
  type: ClassEf48Df2De43E51D6A2F5590A311D2153;
  answer: Answer1;
}
export interface ServerJournalDay_CheckInOutput {
  responses: Responses1;
  existing: ServerJournalDay_ExistingCheckInOutput | null;
  notes_label: NotesLabel;
}
export interface ServerJournalDay_CheckInResponseOutput {
  question: ClassD847328B5766C99Fecfb626254A620E5;
  response: Response | null;
}
export interface ClassD847328B5766C99Fecfb626254A620E5 {
  id: Id16;
  type: ClientCheckInQuestion__Type;
  label: Label1;
  response_labels: ResponseLabels;
}
export interface ResponseLabel {
  value: Response;
  label: Label2;
}
export interface ServerJournalDay_ExistingCheckInOutput {
  notes: Notes12;
}
export interface ServerJournalDay_AssignmentOutput {
  day_of_week: DayOfWeek2;
  profile: ClassA0Ab500Dfce7223467C7F5A0901Aece2;
  check_in: CheckIn;
  target: ServerJournalNutrition_TargetOutput | null;
  habits: Habits;
  supplements: Supplements2;
}
export interface ExerciseMaxes3 {
  actual: Actual;
  estimated: Estimated;
}
export interface ServerJournalWorkouts_ExerciseMaxOutput {
  exercise_type: Class_878A7E831908A9Cbbc0493592A54Ea95;
  type: ExerciseMax__Type;
  weight: Weight15;
  reps: Reps4;
  workout: Class_0Da5D7Db9F079395B12887Cac01Bb665 | null;
}
export interface Estimated {
  [k: string]: string;
}
export interface ServerJournalWorkouts_WorkoutTemplateOutput {
  id: Id17;
  uuid: Uuid43;
  user_id: UserId25;
  name: Name51;
  instructions: Instructions11;
  visibility: Visibility;
  status: Workout__Status;
  mode: Workout__Mode;
  sections: Sections3;
  questions: Questions3;
}
export interface ServerJournalWorkouts_ListProgramOutput {
  id: Id18;
  uuid: Uuid44;
  name: Name52;
  user_id: UserId26;
  description: Description8;
  workout_groups: WorkoutGroups1;
  product_code: ProductCode;
}
export interface ClassC8C083D669916D427F5619E62727B61E {
  workouts: Workouts2;
}
export interface ClassDa38A4A8E60F1Eafb270501E7B48443D {
  id: Id19;
}
export interface ServerJournalWorkouts_ActiveProgramOutput {
  id: Id20;
  name: Name53;
  description: Description9;
  type: WorkoutProgram__Type;
  user_id: UserId27;
  visibility: Visibility;
  updated_at: UpdatedAt;
  uuid: Uuid45;
  product_code: ProductCode1;
  program_users: ClassC139A98167Ae1341B5F31E7E67561B43 | null;
  workout_groups: WorkoutGroups2;
  instances: Instances;
}
export interface ClassC139A98167Ae1341B5F31E7E67561B43 {
  uuid: Uuid46;
  id: Id21;
  program: Class_878A7E831908A9Cbbc0493592A54Ea95;
  user_id: UserId28;
  is_active: IsActive1;
  should_sync: ShouldSync1;
}
export interface ClassC07Df7F21E2E0C593087Ecbb999E1F26 {
  uuid: Uuid47;
  name: Name54;
  description: Description10;
  workouts: Workouts3;
}
export interface Class_473E5694Ae108C455C9Ce6673D2F6496 {
  uuid: Uuid48;
  name: Name55;
  instructions: Instructions12;
  used_on: UsedOn;
  exercises_count: ExercisesCount;
}
export interface Class_43C5B25Fa3Fce14F2C8Ccf975Bd78Daa {
  uuid: Uuid49;
  user_id: UserId29;
  is_active: IsActive2;
}
export interface Metrics1 {
  [k: string]: ServerJournalDay_MetricAggregateOutput | null;
}
export interface ServerJournalDay_MetricAggregateOutput {
  start_date: StartDate4;
  end_date: EndDate4;
  is_manual: IsManual1;
  value: Value3;
  apple_health_uuids: AppleHealthUuids1;
}
export interface ServerJournalDay_WorkoutAggregateOutput {
  apple_health_uuid: AppleHealthUuid2;
  timezone: Timezone6;
  start_time: StartTime1;
  end_time: EndTime1;
  workout_activity_type: WorkoutActivityType1;
  workout_activity_id: WorkoutActivityId1;
  duration_seconds: DurationSeconds1;
  calories: Calories2;
  distance_meters: DistanceMeters1;
  source: Source4;
  source_bundle_id: SourceBundleId1;
}
export interface NextWorkoutWrapper {
  next_workout: ServerJournalWorkouts_WorkoutInput;
}
export interface LearningWeekData {
  class_name: ClassName;
  start_date: StartDate5;
  current_day_number: CurrentDayNumber;
  steps_goal: StepsGoal;
  my_status: ServerJournalLearningWeek_LearningWeekMemberStatusOutput;
  group_statuses: GroupStatuses;
}
export interface ServerJournalLearningWeek_LearningWeekMemberStatusOutput {
  member_uuid: MemberUuid;
  display_name: DisplayName2;
  days: Days;
}
export interface ServerJournalLearningWeek_LearningWeekDayStatusOutput {
  day_number: DayNumber;
  date: Date7;
  has_logged_meals: HasLoggedMeals;
  has_logged_weight: HasLoggedWeight;
  has_hit_steps: HasHitSteps;
  meal_count: MealCount;
  steps: Steps1;
}
export interface ServerJournalNutrition_DayOutput1 {
  include_in_reports: IncludeInReports2;
  name: Name37;
  share_uuid: ShareUuid3;
  user_id: UserId21;
  gratitude: Gratitude2;
  comments: Comments;
  measurements: Measurements1;
  id: Id11;
  key: Key9;
  recent_meals: RecentMeals;
  notes: Notes8;
  meals: Meals4;
  target: ServerJournalNutrition_TargetOutput | null;
}
export interface UpdateDayResult {
  streak: Streak1;
}
export interface LegacyUpdateDayOutput {
  day: ServerJournalNutrition_DayOutput;
  streak: Streak2;
}
export interface Output1 {
  credentials: APICredentials;
  data: InitialData | null;
  update: Update;
}
export interface APICredentials {
  SUBSCRIPTION_DOLLARS_PER_MONTH: SubscriptionDollarsPerMonth;
  SUBSCRIPTION_DOLLARS_PER_YEAR: SubscriptionDollarsPerYear;
  STRIPE_PUBLISHABLE_KEY: StripePublishableKey;
  MIXPANEL_TOKEN: MixpanelToken;
  SENTRY_DSN: SentryDsn;
  tracking_key: TrackingKey1;
  should_collect_analytics: ShouldCollectAnalytics2;
}
export interface InitialData {
  profile: ServerCoreRpc_ProfileOutput1;
  journal: ServerJournalDay_JournalOutput;
}
export interface UpdateRequired {
  type: Type7;
  index_file: IndexFile;
  requires_update: RequiresUpdate;
  version: Version;
  folders: Folders;
  static_files: StaticFiles;
  media_files: MediaFiles;
  STATIC_URL: StaticUrl;
}
export interface NativeUpdateRequired {
  type: Type8;
}
export interface UpdateNotRequired {
  type: Type9;
}
export interface ServerJournalDay_PurchaseVerificationOutput {
  email: Email13;
  tracking_key: TrackingKey2;
  should_collect_analytics: ShouldCollectAnalytics3;
}
export interface ServerJournalWorkouts_ProgramOutput {
  id: Id22;
  name: Name56;
  description: Description11;
  type: WorkoutProgram__Type;
  user_id: UserId30;
  visibility: Visibility;
  updated_at: UpdatedAt1;
  uuid: Uuid50;
  product_code: ProductCode2;
  program_users: ClassC139A98167Ae1341B5F31E7E67561B43 | null;
  workout_groups: WorkoutGroups3;
  instances: Instances1;
  exercise_maxes: ExerciseMaxes4;
}
export interface ServerJournalWorkouts_WorkoutGroupOutput {
  uuid: Uuid51;
  name: Name57;
  description: Description12;
  id: Id23;
  user_id: UserId31;
  order: Order;
  workouts: Workouts4;
}
export interface ServerJournalWorkouts_WorkoutGroupWorkoutOutput {
  uuid: Uuid52;
  name: Name58;
  instructions: Instructions13;
  maxes: Maxes;
  template_instances: TemplateInstances;
  used_on: UsedOn1;
  id: Id24;
  user_id: UserId32;
  date: Date9;
  status: Workout__Status;
  mode: Workout__Mode;
  exercises_count: ExercisesCount1;
  sections: Sections4;
  questions: Questions4;
}
export interface ClassBc8320968D5C615C82Cc66Ab21688Cb2 {
  date: Date8;
  user: ClassD22F4B7C9F39D5A7803C5E7A6B293726 | null;
}
export interface ClassD22F4B7C9F39D5A7803C5E7A6B293726 {
  client_manager: Class_4C0C61A48798344F39B0Af84104D34B1 | null;
  pk: Pk3;
}
export interface Class_4C0C61A48798344F39B0Af84104D34B1 {
  pk: Pk2;
}
export interface Workouts5 {
  templates: Templates;
  exercise_types: ExerciseTypes1;
  question_types: QuestionTypes;
  active_program: ServerJournalWorkouts_ProgramOutput | null;
  programs: Programs;
  program_templates: ProgramTemplates1;
  exercise_maxes: ExerciseMaxes5;
  exercise_progressions: ExerciseProgressions;
  exercise_type_users: ExerciseTypeUsers;
  next_workout: NextWorkoutWrapper | null;
}
export interface ServerJournalWorkouts_QuestionTypeOutput {
  uuid: Uuid53;
  name: Name59;
  type: QuestionType__Type;
}
export interface ServerJournalWorkouts_PastProgramOutput {
  id: Id25;
  program: ClassCd58079E2233550364Db00Ff42B070E5;
  completed_on: CompletedOn;
}
export interface ClassCd58079E2233550364Db00Ff42B070E5 {
  uuid: Uuid54;
  name: Name60;
  updated_at: UpdatedAt2;
}
export interface ServerJournalWorkouts_ExerciseProgressionOutput {
  uuid: Uuid55;
  id: Id26;
  name: Name61;
  exercise_type: ClassF3Abe49Fca5C85Ebb60269B70701A03B;
  type: ExerciseProgression__Type;
  weight: Weight16;
}
export interface ClassF3Abe49Fca5C85Ebb60269B70701A03B {
  uuid: Uuid56;
  name: Name62;
}
export interface ServerJournalWorkouts_ExerciseTypeUserOutput {
  exercise_type: ClassF3Abe49Fca5C85Ebb60269B70701A03B;
  related: Related1;
  first_in_workout_count: FirstInWorkoutCount;
}
export interface ServerJournalWorkouts_WorkoutSectionHistoryOutput {
  uuid: Uuid57;
  type: WorkoutSection__Type;
  workout: ClassAecf57Fb8F5C29E657C86356673Bd34B;
  copied_from: Class_0Da5D7Db9F079395B12887Cac01Bb665 | null;
  name: Name66;
  instructions: Instructions14;
  duration: Duration4;
  rounds: Rounds2;
  groups: Groups2;
}
export interface ClassAecf57Fb8F5C29E657C86356673Bd34B {
  uuid: Uuid58;
  name: Name63;
  group: Class_445C56Abfba3Af7C71F869536A9Bcb49 | null;
}
export interface Class_445C56Abfba3Af7C71F869536A9Bcb49 {
  uuid: Uuid59;
  name: Name64;
  program: ClassDdffdf4560F21Dbc797255221759B681;
}
export interface ClassDdffdf4560F21Dbc797255221759B681 {
  uuid: Uuid60;
  name: Name65;
}
export interface ExerciseMediaList {
  urls: Urls;
}
export interface ServerJournalWorkouts_ExerciseHistoryOutput {
  id: Id27;
  order: Order1;
  uuid: Uuid61;
  instructions: Instructions15;
  rest_duration: RestDuration3;
  group: Class_88C40Bd99299238A252B8E9Ad6Bb5562;
  type: ServerJournalWorkouts_ExerciseTypeOutput;
  sets: Sets3;
}
export interface Class_88C40Bd99299238A252B8E9Ad6Bb5562 {
  section: Class_78Ff362F882648A45Ebeae68A4Dddfe2;
}
export interface Class_78Ff362F882648A45Ebeae68A4Dddfe2 {
  workout: ClassD8B266500116F3497682F0F4878Edebe;
}
export interface ClassD8B266500116F3497682F0F4878Edebe {
  uuid: Uuid62;
  date: Date10;
}
export interface ServerJournalNutrition_RecipeOutput {
  uuid: Uuid63;
  name: Name67;
  unit: Unit9;
  quantity: Quantity6;
  calories_pg: CaloriesPg6;
  protein_pg: ProteinPg6;
  fat_pg: FatPg6;
  carbs_pg: CarbsPg6;
  net_carbs_pg: NetCarbsPg6;
  fiber_pg: FiberPg6;
  sodium_pg: SodiumPg6;
  saturated_fat_pg: SaturatedFatPg6;
  monounsaturated_fat_pg: MonounsaturatedFatPg6;
  polyunsaturated_fat_pg: PolyunsaturatedFatPg6;
  trans_fat_pg: TransFatPg6;
  cholesterol_pg: CholesterolPg6;
  sugars_pg: SugarsPg6;
  added_sugars_pg: AddedSugarsPg6;
  potassium_pg: PotassiumPg6;
  magnesium_pg: MagnesiumPg6;
  vitamin_a_dv_pg: VitaminADvPg6;
  vitamin_c_dv_pg: VitaminCDvPg6;
  calcium_dv_pg: CalciumDvPg6;
  iron_dv_pg: IronDvPg6;
  base_unit: BaseUnit6;
  base_quantity: BaseQuantity6;
  serving_size_unit: ServingSizeUnit10;
  serving_size_numerator: ServingSizeNumerator6;
  serving_size_denominator: ServingSizeDenominator4;
  container_unit: ContainerUnit8;
  container_quantity: ContainerQuantity8;
  container_servings: ContainerServings10;
  units: Units6;
  usda_food_id: UsdaFoodId4;
  notes: Notes13;
  additional_units: AdditionalUnits4;
  id: Id28;
  image: Class_45D8694A11Ab403C35025433A2F7E2B6 | null;
  preview: Class_45D8694A11Ab403C35025433A2F7E2B6 | null;
  user_id: UserId33;
  sections: Sections5;
  expanded_recipe: ExpandedRecipe2;
}
export interface Class_2E85F80540A445D1B62A05122Ba75480 {
  name: Name68;
  uuid: Uuid64;
  ingredients: Ingredients1;
}
export interface Class_7B2B07D8F07437Ac098134546F8Dc2Ee {
  uuid: Uuid65;
}
export interface PredictionsData {
  predictions: Predictions;
  entries: Entries6;
}
export interface Predictions {
  [k: string]: PatternListItem[];
}
export interface PatternListItem {
  key: Key11;
  item: MealDigest;
}
export interface MealDigest {
  hash: Hash;
  dates: Dates;
  frequency: Frequency1;
  entries: Entries5;
}
export interface EntryItem {
  locator: Locator;
  name: Name69;
}
export interface Entries6 {
  [k: string]: EntryItem;
}
export interface Search {
  recent: Recent;
  foods: Foods;
  recipes: Recipes;
  food_user: FoodUser;
  predictions: MealPredictions;
}
export interface ServerJournalNutrition_FoodUserOutput {
  uuid: Uuid66;
  meal: Meal;
  food: Food;
  related: Related2;
}
export interface MealPredictions {
  entries: Entries7;
  roots: Roots;
}
export interface Entries7 {
  [k: string]: EntryInfo;
}
export interface EntryInfo {
  name: Name70;
}
export interface RootPatterns {
  root_locator: RootLocator;
  patterns: Patterns;
}
export interface MealPattern {
  hash: Hash1;
  locators: Locators;
  dates: Dates1;
}
export interface DayShare {
  type: Type10;
  day: ServerJournalNutrition_DayOutput;
  share_uuid: ShareUuid5;
}
export interface MealShare {
  type: Type11;
  meal: ServerJournalNutrition_MealOutput;
  share_uuid: ShareUuid6;
}
export interface ProfileShare {
  type: Type12;
  profile: ServerJournalNutrition_SharedProfileOutput;
  share_uuid: ShareUuid7;
}
export interface ServerJournalNutrition_SharedProfileOutput {
  date_of_birth: DateOfBirth7;
}
export interface EntryShare {
  type: Type13;
  entry: ServerJournalNutrition_ExpandedEntryOutput;
  share_uuid: ShareUuid8;
}
export interface RecipeShare {
  type: Type14;
  recipe: ServerJournalNutrition_RecipeOutput;
  share_uuid: ShareUuid9;
  is_favorite: IsFavorite;
}
export interface ServerJournalNutrition_FoodOutput {
  id: Id29;
  name: Name71;
  upc: Upc3;
  from_missing_upc: FromMissingUpc2;
  from_nutritionix_backend_id: FromNutritionixBackendId;
  calories_pg: CaloriesPg7;
  protein_pg: ProteinPg7;
  fat_pg: FatPg7;
  carbs_pg: CarbsPg7;
  net_carbs_pg: NetCarbsPg7;
  fiber_pg: FiberPg7;
  sodium_pg: SodiumPg7;
  saturated_fat_pg: SaturatedFatPg7;
  monounsaturated_fat_pg: MonounsaturatedFatPg7;
  polyunsaturated_fat_pg: PolyunsaturatedFatPg7;
  trans_fat_pg: TransFatPg7;
  cholesterol_pg: CholesterolPg7;
  sugars_pg: SugarsPg7;
  added_sugars_pg: AddedSugarsPg7;
  potassium_pg: PotassiumPg7;
  magnesium_pg: MagnesiumPg7;
  vitamin_a_dv_pg: VitaminADvPg7;
  vitamin_c_dv_pg: VitaminCDvPg7;
  calcium_dv_pg: CalciumDvPg7;
  iron_dv_pg: IronDvPg7;
  base_unit: BaseUnit7;
  base_quantity: BaseQuantity7;
  serving_size_unit: ServingSizeUnit11;
  serving_size_numerator: ServingSizeNumerator7;
  container_servings: ContainerServings11;
}
export interface CreateFoodResponse {
  food: ServerJournalNutrition_FoodOutput;
  search_result: SearchResult;
  foods: Foods1;
}
export interface Output2 {
  lines: Lines;
  weight: Line;
}
export interface Line {
  measurements: Measurements2;
  trend: Trend;
}
export interface ReportMeasurement {
  date: Date11;
  metric: Metric;
  position: Position;
}
export interface WeeklyMacros {
  statuses: Statuses;
  average_tdee: AverageTdee;
}
export interface WeeklyMacrosEntry {
  date: Date12;
  weight: Weight17;
  steps: Steps2;
  calories: Calories3;
  expended_calories: ExpendedCalories;
  protein: Protein;
  fat: Fat;
  carbs: Carbs;
  fiber: Fiber;
  magnesium: Magnesium;
  potassium: Potassium;
  sodium: Sodium;
  sugars: Sugars;
  added_sugars: AddedSugars;
  cholesterol: Cholesterol;
  vitamin_a_dv: VitaminADv;
  vitamin_c_dv: VitaminCDv;
  calcium_dv: CalciumDv;
  iron_dv: IronDv;
  net_carbs: NetCarbs;
  saturated_fat: SaturatedFat;
  monounsaturated_fat: MonounsaturatedFat;
  polyunsaturated_fat: PolyunsaturatedFat;
  trans_fat: TransFat;
  include_in_reports?: IncludeInReports3;
  tdee?: Tdee;
  weight_delta?: WeightDelta;
  days: Days1;
}
export interface Macros1 {
  date: Date13;
  weight: Weight18;
  steps: Steps3;
  calories: Calories4;
  expended_calories: ExpendedCalories1;
  protein: Protein1;
  fat: Fat1;
  carbs: Carbs1;
  fiber: Fiber1;
  magnesium: Magnesium1;
  potassium: Potassium1;
  sodium: Sodium1;
  sugars: Sugars1;
  added_sugars: AddedSugars1;
  cholesterol: Cholesterol1;
  vitamin_a_dv: VitaminADv1;
  vitamin_c_dv: VitaminCDv1;
  calcium_dv: CalciumDv1;
  iron_dv: IronDv1;
  net_carbs: NetCarbs1;
  saturated_fat: SaturatedFat1;
  monounsaturated_fat: MonounsaturatedFat1;
  polyunsaturated_fat: PolyunsaturatedFat1;
  trans_fat: TransFat1;
  include_in_reports?: IncludeInReports4;
  tdee?: Tdee1;
  weight_delta?: WeightDelta1;
}
export interface ServerJournalMfp_MFPMigrationOutput {
  status: MFPAccount__Status;
  uuid: Uuid67;
}
export interface ServerJournalMfp_MFPMigrationOutput1 {
  status: MFPAccount__Status;
  uuid: Uuid68;
}
export interface WalkingClubBoard {
  club_name: ClubName;
  join_code: JoinCode;
  steps_goal: StepsGoal1;
  last_complete_weekday: LastCompleteWeekday;
  week_start: WeekStart;
  weeks_available: WeeksAvailable;
  members: Members;
}
export interface ServerJournalClubs_WalkingClubMemberStatusOutput {
  member_uuid: MemberUuid1;
  display_name: DisplayName3;
  image_uid: ImageUid7;
  is_you: IsYou;
  is_live: IsLive;
  resting: Resting;
  today_buckets: TodayBuckets;
  today_total: TodayTotal;
  week_daily: WeekDaily;
  week_total: WeekTotal;
}
export interface WalkingClubInfo {
  club_name: ClubName1;
  member_count: MemberCount;
  today_total: TodayTotal1;
  steps_goal: StepsGoal2;
  viewer_name: ViewerName;
}
export interface ServerJournalNutrition_NutritionalVisionPromptOutput {
  uuid: Uuid69;
  status: NutritionalVisionPrompt__Status;
  type: NutritionalVisionPrompt__Type;
  barcode: Barcode2;
  image: Class_8Ac47C0Eaddb76Eaca1Afef07De55F09 | null;
  share_uuid: ShareUuid10;
  name: Name72;
  entries: Entries8;
}
export interface Class_8Ac47C0Eaddb76Eaca1Afef07De55F09 {
  uuid: Uuid70;
  image_uid: ImageUid8;
}
export interface Peptides {
  vials: Vials;
}
export interface VialWithComputed {
  vial: VialOutput;
  component_amounts: ComponentAmounts1;
  total_units_used: TotalUnitsUsed;
}
export interface VialOutput {
  uuid: Uuid71;
  peptide_key: PeptideKey1;
  label: Label3;
  vial_mg: VialMg1;
  water_ml: WaterMl1;
  mixed_at: MixedAt1;
  created_at: CreatedAt1;
  doses: Doses;
}
export interface DoseOutput {
  uuid: Uuid72;
  units: Units7;
  taken_at: TakenAt1;
  injection_site: InjectionSite1;
}
export interface ComponentAmounts1 {
  [k: string]: string;
}
export interface ServerNutritionRpc_USDAFoodOutput {
  fdc_id: FdcId;
  ndb_number: NdbNumber;
  description: Description13;
  food_portions: FoodPortions;
  units: Units8;
  food_nutrients: FoodNutrients;
}
export interface USDAUnit {
  unit: Unit10;
  multiplier: Multiplier1;
}
export interface FoodNutrients {
  [k: string]: unknown;
}
export interface ExportDay {
  date: Date14;
  meals: Meals5;
  workout: ServerNutritionRpc_ExportWorkoutOutput | null;
}
export interface ServerNutritionRpc_ExportMealOutput {
  display_name: DisplayName4;
  entries: Entries9;
}
export interface ClassD96B761Babfb5Beb16A65069D0A280Cb {
  name: Name73;
  quantity: Quantity7;
  unit: Unit11;
  calories: Calories5;
  protein: Protein2;
  fat: Fat2;
  net_carbs: NetCarbs2;
  fiber: Fiber2;
  sodium: Sodium2;
  saturated_fat: SaturatedFat2;
  monounsaturated_fat: MonounsaturatedFat2;
  polyunsaturated_fat: PolyunsaturatedFat2;
  trans_fat: TransFat2;
  cholesterol: Cholesterol2;
  sugars: Sugars2;
  added_sugars: AddedSugars2;
  potassium: Potassium2;
  magnesium: Magnesium2;
  vitamin_a_dv: VitaminADv2;
  vitamin_c_dv: VitaminCDv2;
  calcium_dv: CalciumDv2;
  iron_dv: IronDv2;
}
export interface ServerNutritionRpc_ExportWorkoutOutput {
  name: Name74;
  status: Workout__Status;
  sections: Sections6;
}
export interface Class_90B405F4C9Dc72638Fc7B8Ebdcc1D9E3 {
  name: Name75;
  type: WorkoutSection__Type;
  groups: Groups3;
}
export interface Class_0Ff46Ed77Dfa6A24F68Edb178B3C013D {
  exercises: Exercises2;
}
export interface ClassB4324092C1F795A0516D5B52D1E91A2A {
  type: Class_23D27E31200Cf5968639821C4622B928;
  sets: Sets4;
}
export interface Class_23D27E31200Cf5968639821C4622B928 {
  name: Name76;
  category: Category;
}
export interface ClassF1Dcd5Ac04B7E185A925C5F8D26398A4 {
  type: ExerciseSet__Type;
  status: ExerciseSet__Status;
  reps: Reps5;
  weight: Weight19;
  rpe: Rpe2;
  duration: Duration5;
  distance: Distance2;
  distance_type: DistanceType | null;
}
export interface AvailableUser {
  id: Id30;
  email: Email14;
}
export interface ServerCoreTemplates_LeadCandidate_413C3245A6Input {
  id: Id31;
  full_name: FullName;
}
export interface ServerCoreTemplates_LeadCandidate_413C3245A6Output {
  id: Id32;
  lead_email: LeadEmail;
  full_name: FullName1;
  created_at: CreatedAt2;
}
export interface ServerJournalLearningWeek_LearningWeekDayStatusInput {
  day_number: DayNumber1;
  date: Date15;
  has_logged_meals: HasLoggedMeals1;
  has_logged_weight: HasLoggedWeight1;
  has_hit_steps: HasHitSteps1;
  meal_count: MealCount1;
  steps: Steps4;
}
export interface ServerJournalLearningWeek_LearningWeekMemberStatusInput {
  member_uuid: MemberUuid2;
  display_name: DisplayName5;
  days: Days2;
}
export interface ServerJournalNutrition_NutritionalVisionPromptInput {
  uuid: Uuid73;
  status: NutritionalVisionPrompt__Status;
  type: NutritionalVisionPrompt__Type;
  image: Class_8Ac47C0Eaddb76Eaca1Afef07De55F09 | null;
  name: Name77;
  entries: Entries10;
}
export interface ServerJournalNutrition_RecipeInput {
  uuid: Uuid74;
  name: Name78;
  unit: Unit12;
  quantity: Quantity8;
  calories_pg: CaloriesPg8;
  protein_pg: ProteinPg8;
  fat_pg: FatPg8;
  carbs_pg: CarbsPg8;
  net_carbs_pg: NetCarbsPg8;
  fiber_pg: FiberPg8;
  sodium_pg: SodiumPg8;
  saturated_fat_pg: SaturatedFatPg8;
  monounsaturated_fat_pg: MonounsaturatedFatPg8;
  polyunsaturated_fat_pg: PolyunsaturatedFatPg8;
  trans_fat_pg: TransFatPg8;
  cholesterol_pg: CholesterolPg8;
  sugars_pg: SugarsPg8;
  added_sugars_pg: AddedSugarsPg8;
  potassium_pg: PotassiumPg8;
  magnesium_pg: MagnesiumPg8;
  vitamin_a_dv_pg: VitaminADvPg8;
  vitamin_c_dv_pg: VitaminCDvPg8;
  calcium_dv_pg: CalciumDvPg8;
  iron_dv_pg: IronDvPg8;
  base_unit: BaseUnit8;
  base_quantity: BaseQuantity8;
  serving_size_unit: ServingSizeUnit12;
  serving_size_numerator: ServingSizeNumerator8;
  serving_size_denominator: ServingSizeDenominator5;
  container_unit: ContainerUnit9;
  container_quantity: ContainerQuantity9;
  container_servings: ContainerServings12;
  usda_food_id: UsdaFoodId5;
  notes: Notes14;
  additional_units: AdditionalUnits5;
  id: Id33;
  image: Class_45D8694A11Ab403C35025433A2F7E2B6 | null;
  preview: Class_45D8694A11Ab403C35025433A2F7E2B6 | null;
  user_id: UserId34;
  sections: Sections7;
  expanded_recipe: ExpandedRecipe3;
}
export interface ServerJournalNutrition_StagedMealInput {
  name: Name79;
  hour: Hour2;
  type: Meal__Type;
}
export interface ServerJournalNutrition_StagedMealOutput {
  name: Name80;
  hour: Hour3;
  type: Meal__Type;
}
export interface ServerJournalNutrition_DayInput {
  include_in_reports: IncludeInReports5;
  name: Name81;
  user_id: UserId35;
  gratitude: Gratitude3;
  comments: Comments1;
  measurements: Measurements3;
  id: Id34;
  notes: Notes15;
  meals: Meals6;
  target: ServerJournalNutrition_TargetInput | null;
}
export interface Class_2053Fc65B48C18869C79A8Df4Ab94Ca9 {
  manager: ClassBeb64919Cd8B03126E49512Ead4A696C;
  comment: Comment1;
}
export interface ServerJournalNutrition_InlineEntryInput {
  name: Name82;
  uuid: Uuid75;
  calories_pg: CaloriesPg9;
  protein_pg: ProteinPg9;
  fat_pg: FatPg9;
  carbs_pg: CarbsPg9;
  net_carbs_pg: NetCarbsPg9;
  fiber_pg: FiberPg9;
  sodium_pg: SodiumPg9;
  saturated_fat_pg: SaturatedFatPg9;
  monounsaturated_fat_pg: MonounsaturatedFatPg9;
  polyunsaturated_fat_pg: PolyunsaturatedFatPg9;
  trans_fat_pg: TransFatPg9;
  cholesterol_pg: CholesterolPg9;
  sugars_pg: SugarsPg9;
  added_sugars_pg: AddedSugarsPg9;
  potassium_pg: PotassiumPg9;
  magnesium_pg: MagnesiumPg9;
  vitamin_a_dv_pg: VitaminADvPg9;
  vitamin_c_dv_pg: VitaminCDvPg9;
  calcium_dv_pg: CalciumDvPg9;
  iron_dv_pg: IronDvPg9;
  base_unit: BaseUnit9;
  base_quantity: BaseQuantity9;
  serving_size_unit: ServingSizeUnit13;
  serving_size_numerator: ServingSizeNumerator9;
  serving_size_denominator: ServingSizeDenominator6;
  container_unit: ContainerUnit10;
  container_quantity: ContainerQuantity10;
  container_servings: ContainerServings13;
  nutritional_vision_prompt: Class_0Da5D7Db9F079395B12887Cac01Bb665 | null;
  usda_food_id: UsdaFoodId6;
  backend: Backend6;
  backend_id: BackendId6;
  expanded_recipe: ExpandedRecipe4;
  additional_units: AdditionalUnits6;
}
export interface ServerJournalNutrition_InlineEntryOutput {
  name: Name83;
  uuid: Uuid76;
  unit: Unit13;
  quantity: Quantity9;
  calories_pg: CaloriesPg10;
  protein_pg: ProteinPg10;
  fat_pg: FatPg10;
  carbs_pg: CarbsPg10;
  net_carbs_pg: NetCarbsPg10;
  fiber_pg: FiberPg10;
  sodium_pg: SodiumPg10;
  saturated_fat_pg: SaturatedFatPg10;
  monounsaturated_fat_pg: MonounsaturatedFatPg10;
  polyunsaturated_fat_pg: PolyunsaturatedFatPg10;
  trans_fat_pg: TransFatPg10;
  cholesterol_pg: CholesterolPg10;
  sugars_pg: SugarsPg10;
  added_sugars_pg: AddedSugarsPg10;
  potassium_pg: PotassiumPg10;
  magnesium_pg: MagnesiumPg10;
  vitamin_a_dv_pg: VitaminADvPg10;
  vitamin_c_dv_pg: VitaminCDvPg10;
  calcium_dv_pg: CalciumDvPg10;
  iron_dv_pg: IronDvPg10;
  base_unit: BaseUnit10;
  base_quantity: BaseQuantity10;
  serving_size_unit: ServingSizeUnit14;
  serving_size_numerator: ServingSizeNumerator10;
  serving_size_denominator: ServingSizeDenominator7;
  container_unit: ContainerUnit11;
  container_quantity: ContainerQuantity11;
  container_servings: ContainerServings14;
  nutritional_vision_prompt: Class_0Da5D7Db9F079395B12887Cac01Bb665 | null;
  usda_food_id: UsdaFoodId7;
  backend: Backend7;
  backend_id: BackendId7;
  expanded_recipe: ExpandedRecipe5;
  additional_units: AdditionalUnits7;
  units: Units9;
}
export interface Unit14 {
  unit: Unit15;
  multiplier: Multiplier2;
  calories?: Calories6;
  info?: Info1;
}
export interface ServerJournalNutrition_FoodUserInput {
  uuid: Uuid77;
  meal: Meal1;
  food: Food1;
  related: Related3;
}
export interface ServerJournalNutrition_SharedProfileInput {
  date_of_birth: DateOfBirth8;
}
export interface ServerJournalNutrition_CalculatorProfileInput {
  body_fat: BodyFat6;
  use_kilojoules: UseKilojoules3;
  is_imperial: IsImperial4;
  activity: Activity6;
  gender: Gender7;
  date_of_birth: DateOfBirth9;
  height: Height7;
  weight: Weight20;
}
export interface ServerJournalNutrition_CalculatorProfileOutput {
  body_fat: BodyFat7;
  use_kilojoules: UseKilojoules4;
  is_imperial: IsImperial5;
  activity: Activity7;
  gender: Gender8;
  date_of_birth: DateOfBirth10;
  height: Height8;
  weight: Weight21;
}
export interface ServerJournalNutrition_FoodInput {
  id: Id35;
  name: Name84;
  upc: Upc4;
  from_missing_upc: FromMissingUpc3;
  from_nutritionix_backend_id: FromNutritionixBackendId1;
  calories_pg: CaloriesPg11;
  protein_pg: ProteinPg11;
  fat_pg: FatPg11;
  carbs_pg: CarbsPg11;
  net_carbs_pg: NetCarbsPg11;
  fiber_pg: FiberPg11;
  sodium_pg: SodiumPg11;
  saturated_fat_pg: SaturatedFatPg11;
  monounsaturated_fat_pg: MonounsaturatedFatPg11;
  polyunsaturated_fat_pg: PolyunsaturatedFatPg11;
  trans_fat_pg: TransFatPg11;
  cholesterol_pg: CholesterolPg11;
  sugars_pg: SugarsPg11;
  added_sugars_pg: AddedSugarsPg11;
  potassium_pg: PotassiumPg11;
  magnesium_pg: MagnesiumPg11;
  vitamin_a_dv_pg: VitaminADvPg11;
  vitamin_c_dv_pg: VitaminCDvPg11;
  calcium_dv_pg: CalciumDvPg11;
  iron_dv_pg: IronDvPg11;
  base_unit: BaseUnit11;
  base_quantity: BaseQuantity11;
  serving_size_unit: ServingSizeUnit15;
  serving_size_numerator: ServingSizeNumerator11;
  container_servings: ContainerServings15;
}
export interface ServerBackofficeViews_VisionPromptInput {
  uuid: Uuid78;
  own_entries: OwnEntries;
  image: Class_45D8694A11Ab403C35025433A2F7E2B6 | null;
}
export interface Class_5D7F38B061Ef1519C6952D7Eb236Efc1 {
  uuid: Uuid79;
  name: Name85;
  quantity: Quantity10;
  unit: Unit16;
}
export interface ServerBackofficeViews_VisionPromptOutput {
  uuid: Uuid80;
  own_entries: OwnEntries1;
  image: Class_45D8694A11Ab403C35025433A2F7E2B6 | null;
}
export interface ClassAa152C0F2F94243091Eef591F4C36A4C {
  uuid: Uuid81;
  name: Name86;
  quantity: Quantity11;
  unit: Unit17;
  calories: Calories7;
}
export interface ServerBackofficeViews_LearningWeekVisionPromptInput {
  uuid: Uuid82;
  status: NutritionalVisionPrompt__Status;
  type: NutritionalVisionPrompt__Type;
  image: Class_45D8694A11Ab403C35025433A2F7E2B6 | null;
}
export interface ServerBackofficeViews_LearningWeekVisionPromptOutput {
  uuid: Uuid83;
  status: NutritionalVisionPrompt__Status;
  type: NutritionalVisionPrompt__Type;
  image: Class_45D8694A11Ab403C35025433A2F7E2B6 | null;
}
export interface ServerJournalWorkouts_LatestExerciseInstanceInput {
  id: Id36;
  uuid: Uuid84;
  rest_duration: RestDuration4;
  sets: Sets5;
}
export interface ServerJournalWorkouts_ExerciseTypeUserInput {
  exercise_type: ClassF3Abe49Fca5C85Ebb60269B70701A03B;
  related: Related4;
  first_in_workout_count: FirstInWorkoutCount1;
}
export interface ServerJournalWorkouts_WorkoutSectionHistoryInput {
  uuid: Uuid85;
  type: WorkoutSection__Type;
  workout: ClassAecf57Fb8F5C29E657C86356673Bd34B;
  copied_from: Class_0Da5D7Db9F079395B12887Cac01Bb665 | null;
  name: Name87;
  instructions: Instructions16;
  duration: Duration6;
  rounds: Rounds3;
  groups: Groups4;
}
export interface ServerJournalWorkouts_QuestionTypeInput {
  uuid: Uuid86;
  name: Name88;
  type: QuestionType__Type;
}
export interface ServerJournalWorkouts_WorkoutTemplateInput {
  id: Id37;
  uuid: Uuid87;
  user_id: UserId36;
  name: Name89;
  instructions: Instructions17;
  visibility: Visibility;
  status: Workout__Status;
  mode: Workout__Mode;
  sections: Sections8;
  questions: Questions5;
}
export interface ServerJournalWorkouts_ListProgramInput {
  id: Id38;
  uuid: Uuid88;
  name: Name90;
  user_id: UserId37;
  description: Description14;
  workout_groups: WorkoutGroups4;
}
export interface ServerJournalWorkouts_ActiveProgramInput {
  id: Id39;
  name: Name91;
  description: Description15;
  type: WorkoutProgram__Type;
  user_id: UserId38;
  visibility: Visibility;
  uuid: Uuid89;
  program_users: ClassC139A98167Ae1341B5F31E7E67561B43 | null;
  workout_groups: WorkoutGroups5;
  instances: Instances2;
}
export interface Class_0Ac378Cd9A742672645C42Cf5F07C8Fd {
  uuid: Uuid90;
  name: Name92;
  description: Description16;
  workouts: Workouts6;
}
export interface ClassE4134A856D3Dcb7417Cfe27D51C7142E {
  uuid: Uuid91;
  name: Name93;
  instructions: Instructions18;
}
export interface ServerJournalWorkouts_ProgramUserInput {
  id: Id40;
  uuid: Uuid92;
  should_sync: ShouldSync2;
  is_active: IsActive3;
  program: ServerJournalWorkouts_ProgramInput;
}
export interface ServerJournalWorkouts_ProgramUserOutput {
  id: Id41;
  uuid: Uuid93;
  created_at: CreatedAt3;
  updated_at: UpdatedAt3;
  should_sync: ShouldSync3;
  is_active: IsActive4;
  program: ServerJournalWorkouts_ProgramOutput;
}
export interface ServerJournalWorkouts_PastProgramInput {
  id: Id42;
  program: ClassDdffdf4560F21Dbc797255221759B681;
}
export interface ServerJournalWorkouts_ExerciseProgressionInput {
  uuid: Uuid94;
  id: Id43;
  name: Name94;
  exercise_type: ClassF3Abe49Fca5C85Ebb60269B70701A03B;
  type: ExerciseProgression__Type;
  weight: Weight22;
}
export interface ServerJournalWorkouts_IncompleteWorkoutInput {
  uuid: Uuid95;
  name: Name95;
  date: Date16;
}
export interface ServerJournalWorkouts_SelectProgramTemplateOutput {
  source_template: SourceTemplate1;
  user_id: UserId39;
  should_sync: ShouldSync4;
  exercise_maxes: ExerciseMaxes6;
}
export interface ServerJournalWorkouts_ExerciseMediaOutput {
  exercise_type: ClassC294Ea3Cad8Ac35Cc99Fda382A8B6D9D;
  gym_visual_side: Side;
  gym_visual_code: GymVisualCode1;
  gym_visual_video_path: GymVisualVideoPath1;
  gym_visual_image_path: GymVisualImagePath1;
  gym_visual_gif_path: GymVisualGifPath1;
  gym_visual_green_video_path: GymVisualGreenVideoPath1;
}
export interface ServerJournalWorkouts_ExerciseHistoryInput {
  id: Id44;
  order: Order2;
  uuid: Uuid96;
  instructions: Instructions19;
  rest_duration: RestDuration5;
  group: Class_88C40Bd99299238A252B8E9Ad6Bb5562;
  type: ServerJournalWorkouts_ExerciseTypeInput;
  sets: Sets6;
}
export interface ServerNutritionRpc_ExportWorkoutInput {
  name: Name96;
  status: Workout__Status;
  sections: Sections9;
}
export interface ServerNutritionRpc_ExportMealInput {
  entries: Entries11;
}
export interface Class_33D7240B1Beefdd41D4F41Ee1577512E {
  name: Name97;
  quantity: Quantity12;
  unit: Unit18;
}
export interface ServerNutritionRpc_USDAFoodInput {
  fdc_id: FdcId1;
  ndb_number: NdbNumber1;
  description: Description17;
  food_portions: FoodPortions1;
  food_nutrients: FoodNutrients1;
}
export interface FoodNutrients1 {
  [k: string]: unknown;
}
export interface ServerJournalTemplates_PromptShareInput {
  share_uuid: ShareUuid11;
  prompt: ServerJournalNutrition_NutritionalVisionPromptInput;
}
export interface ServerJournalTemplates_PromptShareOutput {
  share_uuid: ShareUuid12;
  prompt: ServerJournalNutrition_NutritionalVisionPromptOutput;
}
export interface ServerCoreRpc_ProfileUpdatePickInput {
  name: Name98;
  waist: Waist5;
  body_fat: BodyFat8;
  use_kilojoules: UseKilojoules5;
  is_imperial: IsImperial6;
  activity: Activity8;
  goal: Goal6;
  gender: Gender9;
  date_of_birth: DateOfBirth11;
}
export interface ServerCoreRpc_ProfileUpdatePickOutput {
  name: Name99;
  waist: Waist6;
  body_fat: BodyFat9;
  has_hidden_macros: HasHiddenMacros1;
  use_kilojoules: UseKilojoules6;
  is_imperial: IsImperial7;
  activity: Activity9;
  goal: Goal7;
  gender: Gender10;
  date_of_birth: DateOfBirth12;
}
export interface ServerJournalClubs_WalkingClubMemberStatusInput {
  member_uuid: MemberUuid3;
  display_name: DisplayName6;
  image_uid: ImageUid9;
  is_you: IsYou1;
  is_live: IsLive1;
  resting: Resting1;
  today_buckets: TodayBuckets1;
  today_total: TodayTotal2;
  week_daily: WeekDaily1;
  week_total: WeekTotal1;
}
export interface ServerJournalDay_MetricOutput {
  type: Metric__Type;
  start_date: StartDate6;
  end_date: EndDate5;
  value: Value4;
  timezone: Timezone7;
  apple_health_uuid: AppleHealthUuid3;
  uuid: Uuid97;
  apple_health_data: AppleHealthData1;
}
export interface ServerJournalDay_CheckInResponseInput {
  question: ClassFb0D903934C5Af80Bb43498E8A887339;
  response: Response | null;
}
export interface ClassFb0D903934C5Af80Bb43498E8A887339 {
  id: Id45;
  type: ClientCheckInQuestion__Type;
}
export interface ServerJournalDay_ExistingCheckInInput {
  notes: Notes16;
}
export interface ServerJournalDay_CheckInInput {
  responses: Responses2;
  existing: ServerJournalDay_ExistingCheckInInput | null;
  notes_label: NotesLabel1;
}
export interface ServerJournalDay_JournalInput {
  day: ServerJournalNutrition_DayInput;
  supplements: Supplements3;
  meal_plan: ServerJournalNutrition_DayInput | null;
  incomplete_workout: ServerJournalWorkouts_IncompleteWorkoutInput | null;
  workout: ServerJournalWorkouts_WorkoutInput | null;
  check_in: ServerJournalDay_CheckInInput | null;
  assignment: ServerJournalDay_AssignmentInput | null;
  targets: Targets7;
  exercise_maxes: ExerciseMaxes3;
  workout_templates: WorkoutTemplates1;
  program_templates: ProgramTemplates2;
  program: ServerJournalWorkouts_ActiveProgramInput | null;
  metrics: Metrics2;
  activities: Activities1;
  workout_status: WorkoutStatus1;
  next_workout: NextWorkoutWrapper | null;
  streak: Streak3;
  learning_week: LearningWeekData | null;
}
export interface Metrics2 {
  [k: string]: ServerJournalDay_MetricAggregateInput | null;
}
export interface ServerJournalDay_MeasurementOutput {
  weight: Weight23;
  waist: Waist7;
  navel: Navel2;
  body_fat: BodyFat10;
  hips: Hips2;
  neck: Neck2;
  thigh: Thigh2;
  bicep: Bicep2;
  chest: Chest2;
  day: DayReference;
}
export interface ServerJournalDay_DayUpdateOutput {
  target: ServerJournalNutrition_TargetOutput | null;
  gratitude: Gratitude4;
  include_in_reports: IncludeInReports6;
  notes: Notes17;
  meals: Meals7;
}
export interface ServerJournalDay_LegacyDayUpdateOutput {
  target: ServerJournalNutrition_TargetOutput | null;
  gratitude: Gratitude5;
  include_in_reports: IncludeInReports7;
  notes: Notes18;
  meals: Meals8;
}
export interface ServerJournalDay_LegacyUpdateDayOutput {
  day: ServerJournalDay_LegacyDayUpdateOutput;
  reference: DayReference;
}
export interface ServerJournalDay_PlannerOutput {
  assignments: Assignments5;
}
export interface ServerJournalDay_ConsumerTargetOutput {
  uuid: Uuid98;
  name: Name100;
  calories_target: CaloriesTarget5;
  protein_target: ProteinTarget5;
  protein_mode: TargetLike__Mode;
  fat_target: FatTarget5;
  carbs_target: CarbsTarget5;
  fiber_target: FiberTarget4;
  net_carbs_target: NetCarbsTarget5;
}
export interface ServerJournalDay_ConsumerProfileOutput {
  name: Name101;
  date_of_birth: DateOfBirth13;
  gender: Gender11;
  is_imperial: IsImperial8;
  weight: Weight24;
  height: Height9;
  body_fat: BodyFat11;
  activity: Activity10;
}
export interface ServerJournalDay_ConsumerPlannerOutput {
  user_id: UserId40;
  assignments: Assignments6;
  targets: Targets8;
  profile: ServerJournalDay_ConsumerProfileOutput;
  habits: Habits;
}
export interface Assignments6 {
  [k: string]: string;
}
export interface ServerJournalDay_PurchaseVerificationInput {
  email: Email15;
  should_collect_analytics: ShouldCollectAnalytics4;
}
export interface ServerJournalMfp_MFPMigrationInput {
  status: MFPAccount__Status;
  uuid: Uuid99;
}
export interface ServerJournalMfp_MFPMigrationOutput2 {
  status: MFPAccount__Status;
  uuid: Uuid100;
}
export interface ServerJournalViews_MeetDataOutput {
  uuid: Uuid101;
  name: Name102;
  meet_participants: MeetParticipants1;
}
export interface Class_89E77Af937F4Fb9Ae059B93A54B3Fd43 {
  uuid: Uuid102;
  weight: Weight25;
  exercise_maxes: ExerciseMaxes7;
  user: Class_5644A45Ca7125Bb1Cbc6152556Bb3C3E;
}
export interface Class_5644A45Ca7125Bb1Cbc6152556Bb3C3E {
  id: Id46;
  profile: ServerCoreRpc_ProfileOutput1;
}
export interface ServerManagerTemplates_ProgramTemplateInput {
  id: Id47;
  uuid: Uuid103;
  name: Name103;
  user_id: UserId41;
  description: Description18;
  workout_groups: WorkoutGroups6;
}
export interface ServerManagerTemplates_ProgramTemplateOutput {
  id: Id48;
  uuid: Uuid104;
  name: Name104;
  user_id: UserId42;
  description: Description19;
  workout_groups: WorkoutGroups7;
  product_code: ProductCode3;
}
export interface ServerManagerTemplates_ListWorkoutProgramInput {
  id: Id49;
  name: Name105;
  description: Description20;
  uuid: Uuid105;
  type: WorkoutProgram__Type;
  user_id: UserId43;
  visibility: Visibility;
  exercise_type_maxes_required: ExerciseTypeMaxesRequired;
  instances: Instances3;
}
export interface ClassD27326464A9Dd799D307996A78050028 {
  name: Name106;
  uuid: Uuid106;
}
export interface ServerManagerTemplates_ListWorkoutProgramOutput {
  id: Id50;
  name: Name107;
  description: Description21;
  uuid: Uuid107;
  type: WorkoutProgram__Type;
  user_id: UserId44;
  updated_at: UpdatedAt4;
  visibility: Visibility;
  exercise_type_maxes_required: ExerciseTypeMaxesRequired1;
  instances: Instances4;
}
export interface ServerManagerTemplates_ClientManagerPickInput {
  id: Id51;
  name: Name108;
  type: ClientManager__Type;
  client: ClassBccd9207C9Bf7739E8D13B970F8C243D;
}
export interface ClassBccd9207C9Bf7739E8D13B970F8C243D {
  email: Email16;
  id: Id52;
  is_subscription_active: IsSubscriptionActive2;
  profile: Class_12C742467544397C840460F456353A58;
}
export interface Class_12C742467544397C840460F456353A58 {
  is_imperial: IsImperial9;
}
export interface ServerManagerTemplates_ClientManagerPickOutput {
  id: Id53;
  name: Name109;
  created_at: CreatedAt4;
  type: ClientManager__Type;
  client: Class_4B1C46D7Df5Ca803F5C6C9B8B56D0D29;
}
export interface Class_4B1C46D7Df5Ca803F5C6C9B8B56D0D29 {
  email: Email17;
  id: Id54;
  is_reports_enabled: IsReportsEnabled1;
  is_subscription_active: IsSubscriptionActive3;
  profile: Class_12C742467544397C840460F456353A58;
}
export interface ServerManagerTemplates_ManagerE413B4138EInput {
  check_in_questions: CheckInQuestions;
}
export interface Class_74E923A857062D3Bd448E02436B7C1D1 {
  type: ClientCheckInQuestion__Type;
}
export interface ServerManagerTemplates_ManagerE413B4138EOutput {
  check_in_questions: CheckInQuestions1;
}
export interface ServerManagerTemplates_ClientCheckIn_6Af5D6E9CcInput {
  responses: Responses3;
  notes: Notes19;
}
export interface Class_0Ceadf1997D3A890F62Aa54Ad5C979Ce {
  question: Class_1D9D49D210C70Cbb8A21581F7269A36F;
  response: Response;
}
export interface Class_1D9D49D210C70Cbb8A21581F7269A36F {
  type: ClientCheckInQuestion__Type;
}
export interface ServerManagerTemplates_ClientCheckIn_6Af5D6E9CcOutput {
  day: ClassD68509570918651Bfca2280C268822B8;
  responses: Responses4;
  notes: Notes20;
}
export interface ClassD68509570918651Bfca2280C268822B8 {
  date: Date17;
}
export interface ServerManagerTemplates_WorkoutC29Aee4E3EInput {
  date: Date18;
  questions: Questions6;
}
export interface Class_11D7F6A74010C761637Dc131D2D10Ad2 {
  type: Class_3231Cf84Fb0A011968D34C8381Df1652;
  answer: Answer2;
}
export interface Class_3231Cf84Fb0A011968D34C8381Df1652 {
  type: QuestionType__Type;
  name: Name110;
  uuid: Uuid108;
}
export interface ServerManagerTemplates_WorkoutC29Aee4E3EOutput {
  date: Date19;
  questions: Questions7;
}
export interface ServerManagerTemplates_User_124424A5E9Input {
  email: Email18;
}
export interface ServerManagerTemplates_User_124424A5E9Output {
  email: Email19;
}
export interface ServerManagerTemplates_MealPlanPickInput {
  id: Id55;
  name: Name111;
}
export interface ServerManagerTemplates_MealPlanPickOutput {
  id: Id56;
  name: Name112;
  calories: Calories8;
  protein: Protein3;
  fat: Fat3;
  carbs: Carbs2;
  fiber: Fiber3;
  net_carbs: NetCarbs3;
}
export interface ServerManagerTemplates_TargetAssignmentF25C746Fc2Input {
  day_of_week: DayOfWeek3;
  target: ClassEb62169D81C4C4119F84D68Baf1Df0F7 | null;
}
export interface ServerManagerTemplates_TargetAssignmentF25C746Fc2Output {
  day_of_week: DayOfWeek4;
  target: ClassEb62169D81C4C4119F84D68Baf1Df0F7 | null;
}
export interface ServerManagerTemplates_ClientManager_9963Dfc2DdInput {
  id: Id57;
  name: Name113;
  client: Class_888Cf0A00535D770737Eddee2781Edd7;
}
export interface Class_888Cf0A00535D770737Eddee2781Edd7 {
  email: Email20;
  id: Id58;
  active_program: ClassC1D2A8D9A62735A389C7D591Babe11F4 | null;
}
export interface ClassC1D2A8D9A62735A389C7D591Babe11F4 {
  program: Class_35Ba827491200Ef204559Beda2A6Fb92;
}
export interface Class_35Ba827491200Ef204559Beda2A6Fb92 {
  id: Id59;
  uuid: Uuid109;
  name: Name114;
}
export interface ServerManagerTemplates_ClientManager_9963Dfc2DdOutput {
  id: Id60;
  name: Name115;
  created_at: CreatedAt5;
  client: Class_888Cf0A00535D770737Eddee2781Edd7;
}
export interface ServerManagerTemplates_ExerciseTypeC80Bde974AInput {
  uuid: Uuid110;
  name: Name116;
  media: Class_0Da5D7Db9F079395B12887Cac01Bb665 | null;
}
export interface ServerManagerTemplates_ExerciseTypeC80Bde974AOutput {
  uuid: Uuid111;
  name: Name117;
  instances_count: InstancesCount;
  media: Class_0Da5D7Db9F079395B12887Cac01Bb665 | null;
}
export interface ServerCoreContextProcessors_LeadInput {}
export interface ServerCoreContextProcessors_LeadOutput {
  tracking_key: TrackingKey3;
}
export interface ServerCoreContextProcessors_ClientManagerContextInput {
  id: Id61;
  name: Name118;
  client: Class_5D04Be4F56D037E53627D3704Afa3Bc2;
}
export interface Class_5D04Be4F56D037E53627D3704Afa3Bc2 {
  id: Id62;
  email: Email21;
}
export interface ServerCoreContextProcessors_ClientManagerContextOutput {
  id: Id63;
  name: Name119;
  client: Class_5D04Be4F56D037E53627D3704Afa3Bc2;
}
export interface HomePage {
  form: Form;
  SUBSCRIPTION_DOLLARS_PER_MONTH: SubscriptionDollarsPerMonth1;
}
export interface Form {
  name: "server.core.forms.RegistrationForm";
  errors: {
    email?: string[];
    invite_code?: string[];
    with_notification?: string[];
  } | null;
  fields: {
    email: {
      name: "email";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsEmailInput;
    };
    invite_code: {
      name: "invite_code";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput;
    };
    with_notification: {
      name: "with_notification";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput;
    };
  };
  iterator: ("email" | "invite_code" | "with_notification")[];
  hidden_fields: ("email" | "invite_code" | "with_notification")[];
  prefix: string;
}
export interface DjangoFormsWidgetsEmailInput {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsTextInput {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsCheckboxInput {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface BusinessPage {
  experiment_group: ExperimentGroup;
}
export interface DemoSetup {}
export interface LeadCandidateUpload {
  username: Username;
  form_set: FormSet;
  upload_csv_form: UploadCsvForm;
  leads: Leads;
  title: Title2;
}
export interface FormSet {
  initial_form_count: number;
  total_form_count: number;
  max_num: number;
  min_num: number;
  can_delete: boolean;
  can_order: boolean;
  non_form_errors: string[];
  forms: {
    name: "django.forms.widgets.LeadCandidateForm";
    errors: {
      preferred_name?: string[];
      full_name?: string[];
      email?: string[];
      instagram?: string[];
      twitter?: string[];
      facebook?: string[];
      website?: string[];
      phone_number?: string[];
      unverified_type?: string[];
      city?: string[];
      state?: string[];
      zip_code?: string[];
      tags?: string[];
    } | null;
    fields: {
      preferred_name: {
        name: "preferred_name";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput1;
      };
      full_name: {
        name: "full_name";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput2;
      };
      email: {
        name: "email";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsEmailInput1;
      };
      instagram: {
        name: "instagram";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput3;
      };
      twitter: {
        name: "twitter";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput4;
      };
      facebook: {
        name: "facebook";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsURLInput;
      };
      website: {
        name: "website";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsURLInput1;
      };
      phone_number: {
        name: "phone_number";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput5;
      };
      unverified_type: {
        name: "unverified_type";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect;
        enum:
          | (
              | "UNKNOWN"
              | "GYM"
              | "CROSSFIT"
              | "INTUITIVE_EATING"
              | "NUTRITIONIST"
              | "DIETITIAN"
              | "PERSONAL_TRAINER"
              | "HEALTH_COACH"
              | "PHYSICIAN"
            )
          | null;
      };
      city: {
        name: "city";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput6;
      };
      state: {
        name: "state";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect1;
      };
      zip_code: {
        name: "zip_code";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput7;
      };
      tags: {
        name: "tags";
        label: string;
        help_text: string | null;
        widget: TaggitFormsTagWidget;
      };
    };
    iterator: (
      | "preferred_name"
      | "full_name"
      | "email"
      | "instagram"
      | "twitter"
      | "facebook"
      | "website"
      | "phone_number"
      | "unverified_type"
      | "city"
      | "state"
      | "zip_code"
      | "tags"
    )[];
    hidden_fields: (
      | "preferred_name"
      | "full_name"
      | "email"
      | "instagram"
      | "twitter"
      | "facebook"
      | "website"
      | "phone_number"
      | "unverified_type"
      | "city"
      | "state"
      | "zip_code"
      | "tags"
    )[];
    prefix: string;
  }[];
  empty_form: {
    name: "django.forms.widgets.LeadCandidateForm";
    errors: {
      preferred_name?: string[];
      full_name?: string[];
      email?: string[];
      instagram?: string[];
      twitter?: string[];
      facebook?: string[];
      website?: string[];
      phone_number?: string[];
      unverified_type?: string[];
      city?: string[];
      state?: string[];
      zip_code?: string[];
      tags?: string[];
    } | null;
    fields: {
      preferred_name: {
        name: "preferred_name";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput8;
      };
      full_name: {
        name: "full_name";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput9;
      };
      email: {
        name: "email";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsEmailInput2;
      };
      instagram: {
        name: "instagram";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput10;
      };
      twitter: {
        name: "twitter";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput11;
      };
      facebook: {
        name: "facebook";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsURLInput2;
      };
      website: {
        name: "website";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsURLInput3;
      };
      phone_number: {
        name: "phone_number";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput12;
      };
      unverified_type: {
        name: "unverified_type";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect2;
        enum:
          | (
              | "UNKNOWN"
              | "GYM"
              | "CROSSFIT"
              | "INTUITIVE_EATING"
              | "NUTRITIONIST"
              | "DIETITIAN"
              | "PERSONAL_TRAINER"
              | "HEALTH_COACH"
              | "PHYSICIAN"
            )
          | null;
      };
      city: {
        name: "city";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput13;
      };
      state: {
        name: "state";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect3;
      };
      zip_code: {
        name: "zip_code";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput14;
      };
      tags: {
        name: "tags";
        label: string;
        help_text: string | null;
        widget: TaggitFormsTagWidget1;
      };
    };
    iterator: (
      | "preferred_name"
      | "full_name"
      | "email"
      | "instagram"
      | "twitter"
      | "facebook"
      | "website"
      | "phone_number"
      | "unverified_type"
      | "city"
      | "state"
      | "zip_code"
      | "tags"
    )[];
    hidden_fields: (
      | "preferred_name"
      | "full_name"
      | "email"
      | "instagram"
      | "twitter"
      | "facebook"
      | "website"
      | "phone_number"
      | "unverified_type"
      | "city"
      | "state"
      | "zip_code"
      | "tags"
    )[];
    prefix: string;
  };
  management_form: {
    name: "django.forms.formsets.ManagementForm";
    errors: {
      TOTAL_FORMS?: string[];
      INITIAL_FORMS?: string[];
      MIN_NUM_FORMS?: string[];
      MAX_NUM_FORMS?: string[];
    } | null;
    fields: {
      TOTAL_FORMS: {
        name: "TOTAL_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput;
      };
      INITIAL_FORMS: {
        name: "INITIAL_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput1;
      };
      MIN_NUM_FORMS: {
        name: "MIN_NUM_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput2;
      };
      MAX_NUM_FORMS: {
        name: "MAX_NUM_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput3;
      };
    };
    iterator: ("TOTAL_FORMS" | "INITIAL_FORMS" | "MIN_NUM_FORMS" | "MAX_NUM_FORMS")[];
    hidden_fields: ("TOTAL_FORMS" | "INITIAL_FORMS" | "MIN_NUM_FORMS" | "MAX_NUM_FORMS")[];
    prefix: string;
  };
  prefix: string;
}
export interface DjangoFormsWidgetsTextInput1 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs1;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs1 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsTextInput2 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs2;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs2 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsEmailInput1 {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs1;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs1 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsTextInput3 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs3;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs3 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsTextInput4 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs4;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs4 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsURLInput {
  template_name: "django/forms/widgets/url.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs5;
  type: "url";
  tag: "django.forms.widgets.URLInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs5 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsURLInput1 {
  template_name: "django/forms/widgets/url.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs6;
  type: "url";
  tag: "django.forms.widgets.URLInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs6 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsTextInput5 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs7;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs7 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsSelect {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs2;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs2 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsTextInput6 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs8;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs8 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsSelect1 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs3;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember1], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs3 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember1 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsTextInput7 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs9;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs9 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface TaggitFormsTagWidget {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs10;
  type: "text";
  tag: "taggit.forms.TagWidget";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs10 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsTextInput8 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs11;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs11 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsTextInput9 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs12;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs12 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsEmailInput2 {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs4;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs4 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsTextInput10 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs13;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs13 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsTextInput11 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs14;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs14 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsURLInput2 {
  template_name: "django/forms/widgets/url.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs15;
  type: "url";
  tag: "django.forms.widgets.URLInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs15 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsURLInput3 {
  template_name: "django/forms/widgets/url.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs16;
  type: "url";
  tag: "django.forms.widgets.URLInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs16 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsTextInput12 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs17;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs17 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsSelect2 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs5;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember2], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs5 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember2 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsTextInput13 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs18;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs18 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsSelect3 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs6;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember3], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs6 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember3 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsTextInput14 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs19;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs19 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface TaggitFormsTagWidget1 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs20;
  type: "text";
  tag: "taggit.forms.TagWidget";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs20 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsHiddenInput {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs7;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs7 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsHiddenInput1 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs8;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs8 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsHiddenInput2 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs9;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs9 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsHiddenInput3 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs10;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs10 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface UploadCsvForm {
  name: "server.core.forms.UploadCSVForm";
  errors: {
    csv?: string[];
  } | null;
  fields: {
    csv: {
      name: "csv";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsClearableFileInput;
    };
  };
  iterator: "csv"[];
  hidden_fields: "csv"[];
  prefix: string;
}
export interface DjangoFormsWidgetsClearableFileInput {
  template_name: "django/forms/widgets/clearable_file_input.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs11;
  type: "file";
  checkbox_name: string;
  checkbox_id: string;
  is_initial: boolean;
  input_text: string;
  initial_text: string;
  clear_checkbox_label: string;
  tag: "django.forms.widgets.ClearableFileInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs11 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ServerCoreTemplates_LeadCandidate_413C3245A6Output1 {
  id: Id64;
  lead_email: LeadEmail1;
  full_name: FullName2;
  created_at: CreatedAt6;
}
export interface LeadUpload {
  form_set: FormSet1;
  upload_csv_form: UploadCsvForm1;
  title: Title3;
}
export interface FormSet1 {
  initial_form_count: number;
  total_form_count: number;
  max_num: number;
  min_num: number;
  can_delete: boolean;
  can_order: boolean;
  non_form_errors: string[];
  forms: {
    name: "django.forms.widgets.LeadForm";
    errors: {
      email?: string[];
      name?: string[];
      source?: string[];
      type?: string[];
      unverified_type?: string[];
    } | null;
    fields: {
      email: {
        name: "email";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsEmailInput3;
      };
      name: {
        name: "name";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput15;
      };
      source: {
        name: "source";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect4;
        enum:
          | (
              | "SHA"
              | "ANGEL"
              | "MARK"
              | "CHRISTIAN"
              | "BENNI"
              | "MIKE"
              | "BETTY"
              | "BURGER"
              | "SILVIO"
              | "REBECCA"
              | "ROSS"
              | "CHANDLER"
              | "KRIK"
              | "PRECISION_NUTRITION"
            )
          | null;
      };
      type: {
        name: "type";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect5;
        enum:
          | (
              | "UNKNOWN"
              | "GYM"
              | "CROSSFIT"
              | "INTUITIVE_EATING"
              | "NUTRITIONIST"
              | "DIETITIAN"
              | "PERSONAL_TRAINER"
              | "HEALTH_COACH"
              | "PHYSICIAN"
            )
          | null;
      };
      unverified_type: {
        name: "unverified_type";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect6;
        enum:
          | (
              | "UNKNOWN"
              | "GYM"
              | "CROSSFIT"
              | "INTUITIVE_EATING"
              | "NUTRITIONIST"
              | "DIETITIAN"
              | "PERSONAL_TRAINER"
              | "HEALTH_COACH"
              | "PHYSICIAN"
            )
          | null;
      };
    };
    iterator: ("email" | "name" | "source" | "type" | "unverified_type")[];
    hidden_fields: ("email" | "name" | "source" | "type" | "unverified_type")[];
    prefix: string;
  }[];
  empty_form: {
    name: "django.forms.widgets.LeadForm";
    errors: {
      email?: string[];
      name?: string[];
      source?: string[];
      type?: string[];
      unverified_type?: string[];
    } | null;
    fields: {
      email: {
        name: "email";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsEmailInput4;
      };
      name: {
        name: "name";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput16;
      };
      source: {
        name: "source";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect7;
        enum:
          | (
              | "SHA"
              | "ANGEL"
              | "MARK"
              | "CHRISTIAN"
              | "BENNI"
              | "MIKE"
              | "BETTY"
              | "BURGER"
              | "SILVIO"
              | "REBECCA"
              | "ROSS"
              | "CHANDLER"
              | "KRIK"
              | "PRECISION_NUTRITION"
            )
          | null;
      };
      type: {
        name: "type";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect8;
        enum:
          | (
              | "UNKNOWN"
              | "GYM"
              | "CROSSFIT"
              | "INTUITIVE_EATING"
              | "NUTRITIONIST"
              | "DIETITIAN"
              | "PERSONAL_TRAINER"
              | "HEALTH_COACH"
              | "PHYSICIAN"
            )
          | null;
      };
      unverified_type: {
        name: "unverified_type";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect9;
        enum:
          | (
              | "UNKNOWN"
              | "GYM"
              | "CROSSFIT"
              | "INTUITIVE_EATING"
              | "NUTRITIONIST"
              | "DIETITIAN"
              | "PERSONAL_TRAINER"
              | "HEALTH_COACH"
              | "PHYSICIAN"
            )
          | null;
      };
    };
    iterator: ("email" | "name" | "source" | "type" | "unverified_type")[];
    hidden_fields: ("email" | "name" | "source" | "type" | "unverified_type")[];
    prefix: string;
  };
  management_form: {
    name: "django.forms.formsets.ManagementForm";
    errors: {
      TOTAL_FORMS?: string[];
      INITIAL_FORMS?: string[];
      MIN_NUM_FORMS?: string[];
      MAX_NUM_FORMS?: string[];
    } | null;
    fields: {
      TOTAL_FORMS: {
        name: "TOTAL_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput4;
      };
      INITIAL_FORMS: {
        name: "INITIAL_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput5;
      };
      MIN_NUM_FORMS: {
        name: "MIN_NUM_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput6;
      };
      MAX_NUM_FORMS: {
        name: "MAX_NUM_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput7;
      };
    };
    iterator: ("TOTAL_FORMS" | "INITIAL_FORMS" | "MIN_NUM_FORMS" | "MAX_NUM_FORMS")[];
    hidden_fields: ("TOTAL_FORMS" | "INITIAL_FORMS" | "MIN_NUM_FORMS" | "MAX_NUM_FORMS")[];
    prefix: string;
  };
  prefix: string;
}
export interface DjangoFormsWidgetsEmailInput3 {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs12;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs12 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsTextInput15 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs21;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs21 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsSelect4 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs13;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember4], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs13 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember4 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect5 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs14;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember5], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs14 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember5 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect6 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs15;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember6], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs15 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember6 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsEmailInput4 {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs16;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs16 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsTextInput16 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs22;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs22 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsSelect7 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs17;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember7], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs17 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember7 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect8 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs18;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember8], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs18 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember8 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect9 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs19;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember9], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs19 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember9 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsHiddenInput4 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs20;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs20 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsHiddenInput5 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs21;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs21 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsHiddenInput6 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs22;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs22 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsHiddenInput7 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs23;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs23 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface UploadCsvForm1 {
  name: "server.core.forms.UploadCSVForm";
  errors: {
    csv?: string[];
  } | null;
  fields: {
    csv: {
      name: "csv";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsClearableFileInput1;
    };
  };
  iterator: "csv"[];
  hidden_fields: "csv"[];
  prefix: string;
}
export interface DjangoFormsWidgetsClearableFileInput1 {
  template_name: "django/forms/widgets/clearable_file_input.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs24;
  type: "file";
  checkbox_name: string;
  checkbox_id: string;
  is_initial: boolean;
  input_text: string;
  initial_text: string;
  clear_checkbox_label: string;
  tag: "django.forms.widgets.ClearableFileInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs24 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface LeadImport {
  form_set: FormSet2;
  upload_csv_form: UploadCsvForm2;
  title: Title4;
}
export interface FormSet2 {
  initial_form_count: number;
  total_form_count: number;
  max_num: number;
  min_num: number;
  can_delete: boolean;
  can_order: boolean;
  non_form_errors: string[];
  forms: {
    name: "django.forms.widgets.LeadForm";
    errors: {
      email?: string[];
      name?: string[];
      type?: string[];
      experiment_group?: string[];
      from_email?: string[];
      source?: string[];
      sent_at?: string[];
      unsubscribed_at?: string[];
      bounced_at?: string[];
      replied_at?: string[];
      scheduled_demo_at?: string[];
      is_automated?: string[];
    } | null;
    fields: {
      email: {
        name: "email";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsEmailInput5;
      };
      name: {
        name: "name";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput17;
      };
      type: {
        name: "type";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect10;
        enum:
          | (
              | "UNKNOWN"
              | "GYM"
              | "CROSSFIT"
              | "INTUITIVE_EATING"
              | "NUTRITIONIST"
              | "DIETITIAN"
              | "PERSONAL_TRAINER"
              | "HEALTH_COACH"
              | "PHYSICIAN"
            )
          | null;
      };
      experiment_group: {
        name: "experiment_group";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect11;
        enum: ("NO_PRICING" | "PRICING") | null;
      };
      from_email: {
        name: "from_email";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect12;
      };
      source: {
        name: "source";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect13;
        enum:
          | (
              | "SHA"
              | "ANGEL"
              | "MARK"
              | "CHRISTIAN"
              | "BENNI"
              | "MIKE"
              | "BETTY"
              | "BURGER"
              | "SILVIO"
              | "REBECCA"
              | "ROSS"
              | "CHANDLER"
              | "KRIK"
              | "PRECISION_NUTRITION"
            )
          | null;
      };
      sent_at: {
        name: "sent_at";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsDateTimeInput;
      };
      unsubscribed_at: {
        name: "unsubscribed_at";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsDateTimeInput1;
      };
      bounced_at: {
        name: "bounced_at";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsDateTimeInput2;
      };
      replied_at: {
        name: "replied_at";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsDateTimeInput3;
      };
      scheduled_demo_at: {
        name: "scheduled_demo_at";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsDateTimeInput4;
      };
      is_automated: {
        name: "is_automated";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect14;
      };
    };
    iterator: (
      | "email"
      | "name"
      | "type"
      | "experiment_group"
      | "from_email"
      | "source"
      | "sent_at"
      | "unsubscribed_at"
      | "bounced_at"
      | "replied_at"
      | "scheduled_demo_at"
      | "is_automated"
    )[];
    hidden_fields: (
      | "email"
      | "name"
      | "type"
      | "experiment_group"
      | "from_email"
      | "source"
      | "sent_at"
      | "unsubscribed_at"
      | "bounced_at"
      | "replied_at"
      | "scheduled_demo_at"
      | "is_automated"
    )[];
    prefix: string;
  }[];
  empty_form: {
    name: "django.forms.widgets.LeadForm";
    errors: {
      email?: string[];
      name?: string[];
      type?: string[];
      experiment_group?: string[];
      from_email?: string[];
      source?: string[];
      sent_at?: string[];
      unsubscribed_at?: string[];
      bounced_at?: string[];
      replied_at?: string[];
      scheduled_demo_at?: string[];
      is_automated?: string[];
    } | null;
    fields: {
      email: {
        name: "email";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsEmailInput6;
      };
      name: {
        name: "name";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsTextInput18;
      };
      type: {
        name: "type";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect15;
        enum:
          | (
              | "UNKNOWN"
              | "GYM"
              | "CROSSFIT"
              | "INTUITIVE_EATING"
              | "NUTRITIONIST"
              | "DIETITIAN"
              | "PERSONAL_TRAINER"
              | "HEALTH_COACH"
              | "PHYSICIAN"
            )
          | null;
      };
      experiment_group: {
        name: "experiment_group";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect16;
        enum: ("NO_PRICING" | "PRICING") | null;
      };
      from_email: {
        name: "from_email";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect17;
      };
      source: {
        name: "source";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect18;
        enum:
          | (
              | "SHA"
              | "ANGEL"
              | "MARK"
              | "CHRISTIAN"
              | "BENNI"
              | "MIKE"
              | "BETTY"
              | "BURGER"
              | "SILVIO"
              | "REBECCA"
              | "ROSS"
              | "CHANDLER"
              | "KRIK"
              | "PRECISION_NUTRITION"
            )
          | null;
      };
      sent_at: {
        name: "sent_at";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsDateTimeInput5;
      };
      unsubscribed_at: {
        name: "unsubscribed_at";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsDateTimeInput6;
      };
      bounced_at: {
        name: "bounced_at";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsDateTimeInput7;
      };
      replied_at: {
        name: "replied_at";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsDateTimeInput8;
      };
      scheduled_demo_at: {
        name: "scheduled_demo_at";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsDateTimeInput9;
      };
      is_automated: {
        name: "is_automated";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect19;
      };
    };
    iterator: (
      | "email"
      | "name"
      | "type"
      | "experiment_group"
      | "from_email"
      | "source"
      | "sent_at"
      | "unsubscribed_at"
      | "bounced_at"
      | "replied_at"
      | "scheduled_demo_at"
      | "is_automated"
    )[];
    hidden_fields: (
      | "email"
      | "name"
      | "type"
      | "experiment_group"
      | "from_email"
      | "source"
      | "sent_at"
      | "unsubscribed_at"
      | "bounced_at"
      | "replied_at"
      | "scheduled_demo_at"
      | "is_automated"
    )[];
    prefix: string;
  };
  management_form: {
    name: "django.forms.formsets.ManagementForm";
    errors: {
      TOTAL_FORMS?: string[];
      INITIAL_FORMS?: string[];
      MIN_NUM_FORMS?: string[];
      MAX_NUM_FORMS?: string[];
    } | null;
    fields: {
      TOTAL_FORMS: {
        name: "TOTAL_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput8;
      };
      INITIAL_FORMS: {
        name: "INITIAL_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput9;
      };
      MIN_NUM_FORMS: {
        name: "MIN_NUM_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput10;
      };
      MAX_NUM_FORMS: {
        name: "MAX_NUM_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput11;
      };
    };
    iterator: ("TOTAL_FORMS" | "INITIAL_FORMS" | "MIN_NUM_FORMS" | "MAX_NUM_FORMS")[];
    hidden_fields: ("TOTAL_FORMS" | "INITIAL_FORMS" | "MIN_NUM_FORMS" | "MAX_NUM_FORMS")[];
    prefix: string;
  };
  prefix: string;
}
export interface DjangoFormsWidgetsEmailInput5 {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs25;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs25 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsTextInput17 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs23;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs23 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsSelect10 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs26;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember10], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs26 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember10 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect11 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs27;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember11], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs27 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember11 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect12 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs28;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember12], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs28 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember12 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect13 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs29;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember13], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs29 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember13 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsDateTimeInput {
  template_name: "django/forms/widgets/datetime.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsDateTimeAttrs;
  type: "text";
  tag: "django.forms.widgets.DateTimeInput";
}
export interface ReactivatedFormsWidgetsDateTimeAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  format: string;
}
export interface DjangoFormsWidgetsDateTimeInput1 {
  template_name: "django/forms/widgets/datetime.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsDateTimeAttrs1;
  type: "text";
  tag: "django.forms.widgets.DateTimeInput";
}
export interface ReactivatedFormsWidgetsDateTimeAttrs1 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  format: string;
}
export interface DjangoFormsWidgetsDateTimeInput2 {
  template_name: "django/forms/widgets/datetime.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsDateTimeAttrs2;
  type: "text";
  tag: "django.forms.widgets.DateTimeInput";
}
export interface ReactivatedFormsWidgetsDateTimeAttrs2 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  format: string;
}
export interface DjangoFormsWidgetsDateTimeInput3 {
  template_name: "django/forms/widgets/datetime.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsDateTimeAttrs3;
  type: "text";
  tag: "django.forms.widgets.DateTimeInput";
}
export interface ReactivatedFormsWidgetsDateTimeAttrs3 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  format: string;
}
export interface DjangoFormsWidgetsDateTimeInput4 {
  template_name: "django/forms/widgets/datetime.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsDateTimeAttrs4;
  type: "text";
  tag: "django.forms.widgets.DateTimeInput";
}
export interface ReactivatedFormsWidgetsDateTimeAttrs4 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  format: string;
}
export interface DjangoFormsWidgetsSelect14 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs30;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember14], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs30 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember14 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsEmailInput6 {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs31;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs31 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsTextInput18 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs24;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs24 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsSelect15 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs32;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember15], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs32 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember15 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect16 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs33;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember16], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs33 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember16 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect17 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs34;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember17], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs34 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember17 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect18 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs35;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember18], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs35 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember18 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsDateTimeInput5 {
  template_name: "django/forms/widgets/datetime.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsDateTimeAttrs5;
  type: "text";
  tag: "django.forms.widgets.DateTimeInput";
}
export interface ReactivatedFormsWidgetsDateTimeAttrs5 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  format: string;
}
export interface DjangoFormsWidgetsDateTimeInput6 {
  template_name: "django/forms/widgets/datetime.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsDateTimeAttrs6;
  type: "text";
  tag: "django.forms.widgets.DateTimeInput";
}
export interface ReactivatedFormsWidgetsDateTimeAttrs6 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  format: string;
}
export interface DjangoFormsWidgetsDateTimeInput7 {
  template_name: "django/forms/widgets/datetime.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsDateTimeAttrs7;
  type: "text";
  tag: "django.forms.widgets.DateTimeInput";
}
export interface ReactivatedFormsWidgetsDateTimeAttrs7 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  format: string;
}
export interface DjangoFormsWidgetsDateTimeInput8 {
  template_name: "django/forms/widgets/datetime.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsDateTimeAttrs8;
  type: "text";
  tag: "django.forms.widgets.DateTimeInput";
}
export interface ReactivatedFormsWidgetsDateTimeAttrs8 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  format: string;
}
export interface DjangoFormsWidgetsDateTimeInput9 {
  template_name: "django/forms/widgets/datetime.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsDateTimeAttrs9;
  type: "text";
  tag: "django.forms.widgets.DateTimeInput";
}
export interface ReactivatedFormsWidgetsDateTimeAttrs9 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  format: string;
}
export interface DjangoFormsWidgetsSelect19 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs36;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember19], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs36 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember19 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsHiddenInput8 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs37;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs37 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsHiddenInput9 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs38;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs38 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsHiddenInput10 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs39;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs39 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsHiddenInput11 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs40;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs40 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface UploadCsvForm2 {
  name: "server.core.forms.UploadCSVForm";
  errors: {
    csv?: string[];
  } | null;
  fields: {
    csv: {
      name: "csv";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsClearableFileInput2;
    };
  };
  iterator: "csv"[];
  hidden_fields: "csv"[];
  prefix: string;
}
export interface DjangoFormsWidgetsClearableFileInput2 {
  template_name: "django/forms/widgets/clearable_file_input.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs41;
  type: "file";
  checkbox_name: string;
  checkbox_id: string;
  is_initial: boolean;
  input_text: string;
  initial_text: string;
  clear_checkbox_label: string;
  tag: "django.forms.widgets.ClearableFileInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs41 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface NotFound {}
export interface TermsOfService {}
export interface PrivacyPolicy {}
export interface Backoffice {
  module: ReactivatedWrapper;
}
export interface ReactivatedWrapper {
  module: Module;
}
export interface VisionModule {
  type: Type15;
  comparisons: Comparisons;
}
export interface VisionPromptComparison {
  prompt: ServerBackofficeViews_VisionPromptOutput;
  new_version: ServerBackofficeViews_VisionPromptOutput | null;
}
export interface NutritionModule {
  form: Form1;
  type: Type18;
  results: Results;
}
export interface Form1 {
  fields: Fields;
}
export interface CharField {
  type: Type16;
  name: Name120;
}
export interface DecimalField {
  type: Type17;
  name: Name121;
}
export interface BackofficeResult {
  is_checked: IsChecked;
  item: NutritionixResult;
}
export interface NutritionixResult {
  name: Name122;
  calories_pg: CaloriesPg12;
  backend_id: BackendId8;
}
export interface RPCRequestModule {
  form: Form1;
  type: Type19;
  results: Results1;
}
export interface RPCRequestResult {
  is_checked: IsChecked1;
  id: Id65;
  user: User;
  path: Path;
  status: RequestStatus;
  type: Type20;
  created_at: CreatedAt7;
}
export interface TaskModule {
  form: Form1;
  type: Type21;
  results: Results2;
}
export interface TaskResult {
  is_checked: IsChecked2;
  id: Id66;
  status: Status5;
  return_value: ReturnValue;
  enqueued_at: EnqueuedAt;
  started_at: StartedAt;
  finished_at: FinishedAt;
}
export interface ReturnValue {
  [k: string]: unknown;
}
export interface LearningWeekModule {
  form: Form1;
  type: Type22;
  results: Results3;
}
export interface LearningWeekEntry {
  is_checked: IsChecked3;
  id: Id67;
  uuid: Uuid112;
  name: Name123;
  unit: Unit19;
  quantity: Quantity13;
  calories: Calories9;
  user_email: UserEmail;
  created_at: CreatedAt8;
  vision_prompt: ServerBackofficeViews_LearningWeekVisionPromptOutput | null;
}
export interface Predictions1 {
  predictions: Predictions2;
  entries: Entries12;
}
export interface Predictions2 {
  [k: string]: PatternListItem[];
}
export interface Entries12 {
  [k: string]: EntryItem;
}
export interface App {
  is_capacitor: IsCapacitor;
  open_graph?: OpenGraph | null;
  ssr_resolved?: SsrResolved;
}
export interface OpenGraph {
  title: Title5;
  description: Description22;
  image: Image;
}
export interface Share {
  share: Share1;
}
export interface PromptContainer {
  prompt: ServerJournalTemplates_PromptShareOutput;
}
export interface RecipeContainer {
  recipe_experiment_name: RecipeExperimentName;
  recipe_button_experiment_name: RecipeButtonExperimentName;
  recipe_price_experiment_name: RecipePriceExperimentName;
  instacart_experiment_name: InstacartExperimentName;
  recipe: RecipeShare;
}
export interface Leangains {
  workouts: Workouts5;
}
export interface Start1 {
  workouts: Workouts5;
}
export interface PullUp {
  pull_up_experiment_name: PullUpExperimentName;
}
export interface SuperSmoothies {
  name: Name124;
  recipes: Recipes1;
  entitlement_email: EntitlementEmail;
  is_public: IsPublic;
  product_link: ProductLink;
}
export interface Meet {
  meet: ServerJournalViews_MeetDataOutput;
  workouts: Workouts5;
  read_only: ReadOnly;
  share_uuid: ShareUuid13;
}
export interface JoinMeet {
  form: Form2;
  meet_name: MeetName;
  share_uuid: ShareUuid14;
}
export interface Form2 {
  name: "server.journal.views.JoinMeetForm";
  errors: {
    email?: string[];
    full_name?: string[];
    name?: string[];
    date_of_birth?: string[];
    gender?: string[];
    invite_code?: string[];
    with_notification?: string[];
    distinct_id?: string[];
  } | null;
  fields: {
    email: {
      name: "email";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsEmailInput7;
    };
    full_name: {
      name: "full_name";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput19;
    };
    name: {
      name: "name";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput20;
    };
    date_of_birth: {
      name: "date_of_birth";
      label: string;
      help_text: string | null;
      widget: ServerManagerFormsSelectBirthDate;
    };
    gender: {
      name: "gender";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect23;
    };
    invite_code: {
      name: "invite_code";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput21;
    };
    with_notification: {
      name: "with_notification";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput1;
    };
    distinct_id: {
      name: "distinct_id";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput22;
    };
  };
  iterator: (
    | "email"
    | "full_name"
    | "name"
    | "date_of_birth"
    | "gender"
    | "invite_code"
    | "with_notification"
    | "distinct_id"
  )[];
  hidden_fields: (
    | "email"
    | "full_name"
    | "name"
    | "date_of_birth"
    | "gender"
    | "invite_code"
    | "with_notification"
    | "distinct_id"
  )[];
  prefix: string;
}
export interface DjangoFormsWidgetsEmailInput7 {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs42;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs42 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsTextInput19 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs25;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs25 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsTextInput20 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs26;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs26 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface ServerManagerFormsSelectBirthDate {
  template_name: "django/forms/widgets/select_date.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: unknown;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs43;
  _reactivated_value_do_not_use?: {
    year: string | null;
    month: string | null;
    day: string | null;
  };
  /**
   * @minItems 3
   * @maxItems 3
   */
  subwidgets: [DjangoFormsWidgetsSelect20, DjangoFormsWidgetsSelect21, DjangoFormsWidgetsSelect22];
  tag: "server.manager.forms.SelectBirthDate";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs43 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsSelect20 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs44;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember20], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs44 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember20 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect21 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs45;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember21], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs45 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember21 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect22 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs46;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember22], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs46 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember22 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect23 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs47;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember23], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs47 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember23 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsTextInput21 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs27;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs27 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsCheckboxInput1 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs1;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs1 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsTextInput22 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs28;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs28 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface ClientDashboard {
  manager_name: ManagerName1;
  clients: Clients;
  invited: Invited;
}
export interface ClientSnapshot {
  client_manager: ServerManagerTemplates_ClientManagerPickOutput1;
  last_seen: LastSeen;
  primary_metric: ImportantMetric | null;
  secondary_metric: ImportantMetric | null;
  tertiary_metric: ImportantMetric | null;
  last_weigh_in: LastWeighIn;
  statuses: Statuses1;
}
export interface ServerManagerTemplates_ClientManagerPickOutput1 {
  id: Id68;
  name: Name125;
  created_at: CreatedAt9;
  type: ClientManager__Type;
  client: Class_4B1C46D7Df5Ca803F5C6C9B8B56D0D29;
}
export interface ImportantMetric {
  metric: MeasurementMember;
  previous: Previous;
  value: Value5;
  delta: Delta;
}
export interface MeasurementMember {
  label: Label4;
  type: Type23;
  field_name: FieldName;
}
export interface Status6 {
  date: Date20;
  type: TargetLike__Type;
  weighed_in: WeighedIn;
  logged_entries: LoggedEntries;
  logged_workout: LoggedWorkout;
  primary_metric: ImportantMetric | null;
  secondary_metric: ImportantMetric | null;
  tertiary_metric: ImportantMetric | null;
  GRATITUDE: HabitStatus;
  SLEEP: HabitStatus;
  STEPS: HabitStatus;
  WATER: HabitStatus;
  calories: MetricStatus;
  protein: MetricStatus;
  fat: MetricStatus;
  carbs: MetricStatus;
  fiber: MetricStatus;
  net_carbs: MetricStatus;
  sodium: MetricStatus;
  saturated_fat: MetricStatus;
  monounsaturated_fat: MetricStatus;
  polyunsaturated_fat: MetricStatus;
  trans_fat: MetricStatus;
  cholesterol: MetricStatus;
  sugars: MetricStatus;
  added_sugars: MetricStatus;
  potassium: MetricStatus;
  magnesium: MetricStatus;
  vitamin_a_dv: MetricStatus;
  vitamin_c_dv: MetricStatus;
  calcium_dv: MetricStatus;
  iron_dv: MetricStatus;
  status: Status9;
}
export interface HabitStatus {
  target: Target2;
  total: Total;
  status: Status7;
}
export interface MetricStatus {
  percentage: Percentage;
  total: Total1;
  target: Target3;
  remaining: Remaining;
  deviation: Deviation;
  status: Status8;
}
export interface ServerManagerTemplates_ClientManagerPickOutput2 {
  id: Id69;
  name: Name126;
  created_at: CreatedAt10;
  type: ClientManager__Type;
  client: Class_4B1C46D7Df5Ca803F5C6C9B8B56D0D29;
}
export interface WeeklySummaryEmail {
  manager_name: ManagerName2;
  clients: Clients1;
}
export interface ClientManagerDetail {
  show_habits: ShowHabits;
  primary_metric: MeasurementMember | null;
  client_manager: ServerManagerTemplates_ClientManagerPickOutput3;
  statuses: Statuses2;
  profile_form: ProfileForm;
  metrics: Metrics3;
  has_survey: HasSurvey;
  program: ServerJournalWorkouts_ProgramOutput | null;
  past_programs: PastPrograms;
  program_templates: ProgramTemplates3;
  exercise_maxes: ExerciseMaxes3;
  date_from: DateFrom;
  date_to: DateTo;
  has_custom_date_range: HasCustomDateRange;
}
export interface ServerManagerTemplates_ClientManagerPickOutput3 {
  id: Id70;
  name: Name127;
  created_at: CreatedAt11;
  type: ClientManager__Type;
  client: Class_4B1C46D7Df5Ca803F5C6C9B8B56D0D29;
}
export interface ProfileForm {
  name: "server.core.forms.ProfileForm";
  errors: {
    email?: string[];
    name?: string[];
    date_of_birth?: string[];
    is_imperial?: string[];
    use_kilojoules?: string[];
    weight?: string[];
    height?: string[];
    waist?: string[];
    gender?: string[];
    body_fat?: string[];
    activity?: string[];
    goal?: string[];
  } | null;
  fields: {
    email: {
      name: "email";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsEmailInput8;
    };
    name: {
      name: "name";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput23;
    };
    date_of_birth: {
      name: "date_of_birth";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsDateInput;
    };
    is_imperial: {
      name: "is_imperial";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect24;
    };
    use_kilojoules: {
      name: "use_kilojoules";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect25;
    };
    weight: {
      name: "weight";
      label: string;
      help_text: string | null;
      widget: ServerCoreFormsWeightInput;
    };
    height: {
      name: "height";
      label: string;
      help_text: string | null;
      widget: ServerCoreFormsLengthInput;
    };
    waist: {
      name: "waist";
      label: string;
      help_text: string | null;
      widget: ServerCoreFormsLengthInput1;
    };
    gender: {
      name: "gender";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect26;
    };
    body_fat: {
      name: "body_fat";
      label: string;
      help_text: string | null;
      widget: ServerCoreFormsPercentInput;
    };
    activity: {
      name: "activity";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect27;
    };
    goal: {
      name: "goal";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect28;
    };
  };
  iterator: (
    | "email"
    | "name"
    | "date_of_birth"
    | "is_imperial"
    | "use_kilojoules"
    | "weight"
    | "height"
    | "waist"
    | "gender"
    | "body_fat"
    | "activity"
    | "goal"
  )[];
  hidden_fields: (
    | "email"
    | "name"
    | "date_of_birth"
    | "is_imperial"
    | "use_kilojoules"
    | "weight"
    | "height"
    | "waist"
    | "gender"
    | "body_fat"
    | "activity"
    | "goal"
  )[];
  prefix: string;
}
export interface DjangoFormsWidgetsEmailInput8 {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs48;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs48 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsTextInput23 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs29;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs29 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsDateInput {
  template_name: "django/forms/widgets/date.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsDateAttrs;
  type: "text";
  tag: "django.forms.widgets.DateInput";
}
export interface ReactivatedFormsWidgetsDateAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  format?: string;
}
export interface DjangoFormsWidgetsSelect24 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs49;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember24], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs49 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember24 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect25 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs50;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember25], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs50 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember25 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface ServerCoreFormsWeightInput {
  template_name: "weight";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs;
  type: "number";
  tag: "server.core.forms.WeightInput";
}
export interface ReactivatedFormsWidgetsStepAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface ServerCoreFormsLengthInput {
  template_name: "length";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs1;
  type: "number";
  tag: "server.core.forms.LengthInput";
}
export interface ReactivatedFormsWidgetsStepAttrs1 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface ServerCoreFormsLengthInput1 {
  template_name: "length";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs2;
  type: "number";
  tag: "server.core.forms.LengthInput";
}
export interface ReactivatedFormsWidgetsStepAttrs2 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect26 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs51;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember26], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs51 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember26 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface ServerCoreFormsPercentInput {
  template_name: "percent";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs3;
  type: "number";
  tag: "server.core.forms.PercentInput";
}
export interface ReactivatedFormsWidgetsStepAttrs3 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect27 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs52;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember27], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs52 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember27 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect28 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs53;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember28], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs53 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember28 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface ServerManagerTemplates_ListWorkoutProgramOutput1 {
  id: Id71;
  name: Name128;
  description: Description23;
  uuid: Uuid113;
  type: WorkoutProgram__Type;
  user_id: UserId45;
  updated_at: UpdatedAt5;
  visibility: Visibility;
  exercise_type_maxes_required: ExerciseTypeMaxesRequired2;
  instances: Instances5;
}
export interface ClientCheckInList {
  client_manager: ServerManagerTemplates_ClientManagerPickOutput4;
  settings: ServerManagerTemplates_ManagerE413B4138EOutput1;
  check_ins: CheckIns;
}
export interface ServerManagerTemplates_ClientManagerPickOutput4 {
  id: Id72;
  name: Name129;
  created_at: CreatedAt12;
  type: ClientManager__Type;
  client: Class_4B1C46D7Df5Ca803F5C6C9B8B56D0D29;
}
export interface ServerManagerTemplates_ManagerE413B4138EOutput1 {
  check_in_questions: CheckInQuestions2;
}
export interface ServerManagerTemplates_ClientCheckIn_6Af5D6E9CcOutput1 {
  day: ClassD68509570918651Bfca2280C268822B8;
  responses: Responses5;
  notes: Notes21;
}
export interface ClientManagerSurvey {
  client_manager: ServerManagerTemplates_ClientManagerPickOutput5;
  workouts: Workouts7;
}
export interface ServerManagerTemplates_ClientManagerPickOutput5 {
  id: Id73;
  name: Name130;
  created_at: CreatedAt13;
  type: ClientManager__Type;
  client: Class_4B1C46D7Df5Ca803F5C6C9B8B56D0D29;
}
export interface ServerManagerTemplates_WorkoutC29Aee4E3EOutput1 {
  date: Date21;
  questions: Questions8;
}
export interface ClientDayDetail {
  client_manager: ServerManagerTemplates_ClientManagerPickOutput6;
  profile: ServerCoreRpc_ProfileOutput1;
  day: ServerJournalNutrition_DayOutput;
  measurement_form: MeasurementForm;
  comment_form: CommentForm;
  status: Status6;
  journal: ServerJournalDay_JournalOutput;
}
export interface ServerManagerTemplates_ClientManagerPickOutput6 {
  id: Id74;
  name: Name131;
  created_at: CreatedAt14;
  type: ClientManager__Type;
  client: Class_4B1C46D7Df5Ca803F5C6C9B8B56D0D29;
}
export interface MeasurementForm {
  name: "server.journal.forms.MeasurementForm";
  errors: {
    weight?: string[];
    waist?: string[];
    navel?: string[];
    body_fat?: string[];
    hips?: string[];
    neck?: string[];
    thigh?: string[];
    bicep?: string[];
    chest?: string[];
  } | null;
  fields: {
    weight: {
      name: "weight";
      label: string;
      help_text: string | null;
      widget: ServerCoreFormsWeightInput1;
    };
    waist: {
      name: "waist";
      label: string;
      help_text: string | null;
      widget: ServerCoreFormsLengthInput2;
    };
    navel: {
      name: "navel";
      label: string;
      help_text: string | null;
      widget: ServerCoreFormsLengthInput3;
    };
    body_fat: {
      name: "body_fat";
      label: string;
      help_text: string | null;
      widget: ServerCoreFormsPercentInput1;
    };
    hips: {
      name: "hips";
      label: string;
      help_text: string | null;
      widget: ServerCoreFormsLengthInput4;
    };
    neck: {
      name: "neck";
      label: string;
      help_text: string | null;
      widget: ServerCoreFormsLengthInput5;
    };
    thigh: {
      name: "thigh";
      label: string;
      help_text: string | null;
      widget: ServerCoreFormsLengthInput6;
    };
    bicep: {
      name: "bicep";
      label: string;
      help_text: string | null;
      widget: ServerCoreFormsLengthInput7;
    };
    chest: {
      name: "chest";
      label: string;
      help_text: string | null;
      widget: ServerCoreFormsLengthInput8;
    };
  };
  iterator: ("weight" | "waist" | "navel" | "body_fat" | "hips" | "neck" | "thigh" | "bicep" | "chest")[];
  hidden_fields: ("weight" | "waist" | "navel" | "body_fat" | "hips" | "neck" | "thigh" | "bicep" | "chest")[];
  prefix: string;
}
export interface ServerCoreFormsWeightInput1 {
  template_name: "weight";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs4;
  type: "number";
  tag: "server.core.forms.WeightInput";
}
export interface ReactivatedFormsWidgetsStepAttrs4 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface ServerCoreFormsLengthInput2 {
  template_name: "length";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs5;
  type: "number";
  tag: "server.core.forms.LengthInput";
}
export interface ReactivatedFormsWidgetsStepAttrs5 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface ServerCoreFormsLengthInput3 {
  template_name: "length";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs6;
  type: "number";
  tag: "server.core.forms.LengthInput";
}
export interface ReactivatedFormsWidgetsStepAttrs6 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface ServerCoreFormsPercentInput1 {
  template_name: "percent";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs7;
  type: "number";
  tag: "server.core.forms.PercentInput";
}
export interface ReactivatedFormsWidgetsStepAttrs7 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface ServerCoreFormsLengthInput4 {
  template_name: "length";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs8;
  type: "number";
  tag: "server.core.forms.LengthInput";
}
export interface ReactivatedFormsWidgetsStepAttrs8 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface ServerCoreFormsLengthInput5 {
  template_name: "length";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs9;
  type: "number";
  tag: "server.core.forms.LengthInput";
}
export interface ReactivatedFormsWidgetsStepAttrs9 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface ServerCoreFormsLengthInput6 {
  template_name: "length";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs10;
  type: "number";
  tag: "server.core.forms.LengthInput";
}
export interface ReactivatedFormsWidgetsStepAttrs10 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface ServerCoreFormsLengthInput7 {
  template_name: "length";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs11;
  type: "number";
  tag: "server.core.forms.LengthInput";
}
export interface ReactivatedFormsWidgetsStepAttrs11 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface ServerCoreFormsLengthInput8 {
  template_name: "length";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs12;
  type: "number";
  tag: "server.core.forms.LengthInput";
}
export interface ReactivatedFormsWidgetsStepAttrs12 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface CommentForm {
  name: "server.manager.forms.ManagerCommentForm";
  errors: {
    notes?: string[];
    comment?: string[];
  } | null;
  fields: {
    notes: {
      name: "notes";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextarea;
    };
    comment: {
      name: "comment";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextarea1;
    };
  };
  iterator: ("notes" | "comment")[];
  hidden_fields: ("notes" | "comment")[];
  prefix: string;
}
export interface DjangoFormsWidgetsTextarea {
  template_name: "django/forms/widgets/textarea.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsTextareaAttrs;
  tag: "django.forms.widgets.Textarea";
}
export interface ReactivatedFormsWidgetsTextareaAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  cols: string;
  rows: string;
}
export interface DjangoFormsWidgetsTextarea1 {
  template_name: "django/forms/widgets/textarea.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsTextareaAttrs1;
  tag: "django.forms.widgets.Textarea";
}
export interface ReactivatedFormsWidgetsTextareaAttrs1 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  cols: string;
  rows: string;
}
export interface ConfirmManager {
  manager: ServerManagerTemplates_User_124424A5E9Output1;
  profile_form: ProfileForm1;
  password_form: PasswordForm;
  is_registering: IsRegistering;
}
export interface ServerManagerTemplates_User_124424A5E9Output1 {
  email: Email22;
}
export interface ProfileForm1 {
  name: "server.manager.forms.ConfirmManagerProfileForm";
  errors: {
    email?: string[];
    name?: string[];
    date_of_birth?: string[];
    gender?: string[];
    zip_code?: string[];
  } | null;
  fields: {
    email: {
      name: "email";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsEmailInput9;
    };
    name: {
      name: "name";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput24;
    };
    date_of_birth: {
      name: "date_of_birth";
      label: string;
      help_text: string | null;
      widget: ServerManagerFormsSelectBirthDate1;
    };
    gender: {
      name: "gender";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect32;
    };
    zip_code: {
      name: "zip_code";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput25;
    };
  };
  iterator: ("email" | "name" | "date_of_birth" | "gender" | "zip_code")[];
  hidden_fields: ("email" | "name" | "date_of_birth" | "gender" | "zip_code")[];
  prefix: string;
}
export interface DjangoFormsWidgetsEmailInput9 {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs54;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs54 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsTextInput24 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs30;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs30 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface ServerManagerFormsSelectBirthDate1 {
  template_name: "django/forms/widgets/select_date.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: unknown;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs55;
  _reactivated_value_do_not_use?: {
    year: string | null;
    month: string | null;
    day: string | null;
  };
  /**
   * @minItems 3
   * @maxItems 3
   */
  subwidgets: [DjangoFormsWidgetsSelect29, DjangoFormsWidgetsSelect30, DjangoFormsWidgetsSelect31];
  tag: "server.manager.forms.SelectBirthDate";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs55 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsSelect29 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs56;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember29], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs56 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember29 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect30 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs57;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember30], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs57 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember30 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect31 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs58;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember31], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs58 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember31 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect32 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs59;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember32], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs59 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember32 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsTextInput25 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs31;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs31 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface PasswordForm {
  name: "django.contrib.auth.forms.SetPasswordForm";
  errors: {
    new_password1?: string[];
    new_password2?: string[];
  } | null;
  fields: {
    new_password1: {
      name: "new_password1";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsPasswordInput;
    };
    new_password2: {
      name: "new_password2";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsPasswordInput1;
    };
  };
  iterator: ("new_password1" | "new_password2")[];
  hidden_fields: ("new_password1" | "new_password2")[];
  prefix: string;
}
export interface DjangoFormsWidgetsPasswordInput {
  template_name: "django/forms/widgets/password.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs60;
  type: "password";
  tag: "django.forms.widgets.PasswordInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs60 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsPasswordInput1 {
  template_name: "django/forms/widgets/password.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs61;
  type: "password";
  tag: "django.forms.widgets.PasswordInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs61 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ClientManagerPlanner {
  client_manager: ServerManagerTemplates_ClientManagerPickOutput7;
  planner: ServerJournalDay_PlannerOutput;
  settings_form: SettingsForm;
  target_assignment_form_set: TargetAssignmentFormSet;
  can_schedule_check_in: CanScheduleCheckIn;
  targets: Targets9;
}
export interface ServerManagerTemplates_ClientManagerPickOutput7 {
  id: Id75;
  name: Name132;
  created_at: CreatedAt15;
  type: ClientManager__Type;
  client: Class_4B1C46D7Df5Ca803F5C6C9B8B56D0D29;
}
export interface SettingsForm {
  name: "server.manager.forms.ClientSettingsForm";
  errors: {
    has_hidden_macros?: string[];
  } | null;
  fields: {
    has_hidden_macros: {
      name: "has_hidden_macros";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput2;
    };
  };
  iterator: "has_hidden_macros"[];
  hidden_fields: "has_hidden_macros"[];
  prefix: string;
}
export interface DjangoFormsWidgetsCheckboxInput2 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs2;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs2 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface TargetAssignmentFormSet {
  initial_form_count: number;
  total_form_count: number;
  max_num: number;
  min_num: number;
  can_delete: boolean;
  can_order: boolean;
  non_form_errors: string[];
  forms: {
    name: "django.forms.widgets.TargetAssignmentForm";
    errors: {
      target?: string[];
      check_in?: string[];
    } | null;
    fields: {
      target: {
        name: "target";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect33;
      };
      check_in: {
        name: "check_in";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect34;
        enum: ("DISABLED" | "ENABLED") | null;
      };
    };
    iterator: ("target" | "check_in")[];
    hidden_fields: ("target" | "check_in")[];
    prefix: string;
  }[];
  empty_form: {
    name: "django.forms.widgets.TargetAssignmentForm";
    errors: {
      target?: string[];
      check_in?: string[];
    } | null;
    fields: {
      target: {
        name: "target";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect35;
      };
      check_in: {
        name: "check_in";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsSelect36;
        enum: ("DISABLED" | "ENABLED") | null;
      };
    };
    iterator: ("target" | "check_in")[];
    hidden_fields: ("target" | "check_in")[];
    prefix: string;
  };
  management_form: {
    name: "django.forms.formsets.ManagementForm";
    errors: {
      TOTAL_FORMS?: string[];
      INITIAL_FORMS?: string[];
      MIN_NUM_FORMS?: string[];
      MAX_NUM_FORMS?: string[];
    } | null;
    fields: {
      TOTAL_FORMS: {
        name: "TOTAL_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput12;
      };
      INITIAL_FORMS: {
        name: "INITIAL_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput13;
      };
      MIN_NUM_FORMS: {
        name: "MIN_NUM_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput14;
      };
      MAX_NUM_FORMS: {
        name: "MAX_NUM_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput15;
      };
    };
    iterator: ("TOTAL_FORMS" | "INITIAL_FORMS" | "MIN_NUM_FORMS" | "MAX_NUM_FORMS")[];
    hidden_fields: ("TOTAL_FORMS" | "INITIAL_FORMS" | "MIN_NUM_FORMS" | "MAX_NUM_FORMS")[];
    prefix: string;
  };
  prefix: string;
}
export interface DjangoFormsWidgetsSelect33 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs62;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember33], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs62 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember33 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect34 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs63;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember34], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs63 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember34 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect35 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs64;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember35], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs64 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember35 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect36 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs65;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember36], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs65 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember36 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsHiddenInput12 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs66;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs66 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsHiddenInput13 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs67;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs67 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsHiddenInput14 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs68;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs68 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsHiddenInput15 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs69;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs69 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface CreateClient {
  is_first_client: IsFirstClient;
  form: Form3;
  immediate_total: ImmediateTotal;
  next_invoice_sum: NextInvoiceSum;
  next_quantity: NextQuantity;
}
export interface Form3 {
  name: "server.manager.forms.CreateClientForm";
  errors: {
    name?: string[];
    email?: string[];
    meal_plan?: string[];
  } | null;
  fields: {
    name: {
      name: "name";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput26;
    };
    email: {
      name: "email";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsEmailInput10;
    };
    meal_plan: {
      name: "meal_plan";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect37;
    };
  };
  iterator: ("name" | "email" | "meal_plan")[];
  hidden_fields: ("name" | "email" | "meal_plan")[];
  prefix: string;
}
export interface DjangoFormsWidgetsTextInput26 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs32;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs32 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsEmailInput10 {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs70;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs70 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsSelect37 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs71;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember37], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs71 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember37 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DeleteClient {
  is_prorating: IsProrating;
  client_manager: ServerManagerTemplates_ClientManagerPickOutput8;
  form: Form4;
  next_invoice_sum: NextInvoiceSum1;
  next_quantity: NextQuantity1;
}
export interface ServerManagerTemplates_ClientManagerPickOutput8 {
  id: Id76;
  name: Name133;
  created_at: CreatedAt16;
  type: ClientManager__Type;
  client: Class_4B1C46D7Df5Ca803F5C6C9B8B56D0D29;
}
export interface Form4 {
  name: "server.manager.forms.DeleteClientForm";
  errors: {} | null;
  fields: {};
  iterator: [];
  hidden_fields: [];
  prefix: string;
}
export interface ClientManagerReports {
  client_manager: ServerManagerTemplates_ClientManagerPickOutput9;
  measurements: Measurements4;
  trend: Trend1;
  form: Form5;
  profile: ServerCoreRpc_ProfileOutput1;
}
export interface ServerManagerTemplates_ClientManagerPickOutput9 {
  id: Id77;
  name: Name134;
  created_at: CreatedAt17;
  type: ClientManager__Type;
  client: Class_4B1C46D7Df5Ca803F5C6C9B8B56D0D29;
}
export interface Measurement {
  date: Date22;
  position: Position1;
  metric: Metric1;
}
export interface Form5 {
  name: "server.journal.forms.ReportForm";
  errors: {
    date_after?: string[];
    date_before?: string[];
    metric?: string[];
  } | null;
  fields: {
    date_after: {
      name: "date_after";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsDateInput1;
    };
    date_before: {
      name: "date_before";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsDateInput2;
    };
    metric: {
      name: "metric";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect38;
    };
  };
  iterator: ("date_after" | "date_before" | "metric")[];
  hidden_fields: ("date_after" | "date_before" | "metric")[];
  prefix: string;
}
export interface DjangoFormsWidgetsDateInput1 {
  template_name: "django/forms/widgets/date.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsDateAttrs1;
  type: "text";
  tag: "django.forms.widgets.DateInput";
}
export interface ReactivatedFormsWidgetsDateAttrs1 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  format?: string;
}
export interface DjangoFormsWidgetsDateInput2 {
  template_name: "django/forms/widgets/date.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsDateAttrs2;
  type: "text";
  tag: "django.forms.widgets.DateInput";
}
export interface ReactivatedFormsWidgetsDateAttrs2 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  format?: string;
}
export interface DjangoFormsWidgetsSelect38 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs72;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember38], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs72 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember38 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface ManagerRegistration {
  form: Form6;
  STRIPE_PUBLISHABLE_KEY: StripePublishableKey1;
}
export interface Form6 {
  name: "server.manager.forms.TrainerForm";
  errors: {
    email?: string[];
    invite_code?: string[];
    with_notification?: string[];
    full_name?: string[];
    name?: string[];
    token?: string[];
    distinct_id?: string[];
  } | null;
  fields: {
    email: {
      name: "email";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsEmailInput11;
    };
    invite_code: {
      name: "invite_code";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput27;
    };
    with_notification: {
      name: "with_notification";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput3;
    };
    full_name: {
      name: "full_name";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput28;
    };
    name: {
      name: "name";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput29;
    };
    token: {
      name: "token";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput30;
    };
    distinct_id: {
      name: "distinct_id";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput31;
    };
  };
  iterator: ("email" | "invite_code" | "with_notification" | "full_name" | "name" | "token" | "distinct_id")[];
  hidden_fields: ("email" | "invite_code" | "with_notification" | "full_name" | "name" | "token" | "distinct_id")[];
  prefix: string;
}
export interface DjangoFormsWidgetsEmailInput11 {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs73;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs73 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsTextInput27 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs33;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs33 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsCheckboxInput3 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs3;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs3 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsTextInput28 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs34;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs34 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsTextInput29 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs35;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs35 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsTextInput30 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs36;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs36 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsTextInput31 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs37;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs37 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface ClientRegistration {
  manager: ServerManagerTemplates_User_124424A5E9Output2;
  registration_form: RegistrationForm;
  programs: Programs1;
}
export interface ServerManagerTemplates_User_124424A5E9Output2 {
  email: Email23;
}
export interface RegistrationForm {
  name: "server.manager.forms.ClientRegistrationForm";
  errors: {
    email?: string[];
    full_name?: string[];
    name?: string[];
    date_of_birth?: string[];
    gender?: string[];
    zip_code?: string[];
    invite_code?: string[];
    with_notification?: string[];
    selected_program?: string[];
  } | null;
  fields: {
    email: {
      name: "email";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsEmailInput12;
    };
    full_name: {
      name: "full_name";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput32;
    };
    name: {
      name: "name";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput33;
    };
    date_of_birth: {
      name: "date_of_birth";
      label: string;
      help_text: string | null;
      widget: ServerManagerFormsSelectBirthDate2;
    };
    gender: {
      name: "gender";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect42;
    };
    zip_code: {
      name: "zip_code";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput34;
    };
    invite_code: {
      name: "invite_code";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput35;
    };
    with_notification: {
      name: "with_notification";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput4;
    };
    selected_program: {
      name: "selected_program";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput36;
    };
  };
  iterator: (
    | "email"
    | "full_name"
    | "name"
    | "date_of_birth"
    | "gender"
    | "zip_code"
    | "invite_code"
    | "with_notification"
    | "selected_program"
  )[];
  hidden_fields: (
    | "email"
    | "full_name"
    | "name"
    | "date_of_birth"
    | "gender"
    | "zip_code"
    | "invite_code"
    | "with_notification"
    | "selected_program"
  )[];
  prefix: string;
}
export interface DjangoFormsWidgetsEmailInput12 {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs74;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs74 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsTextInput32 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs38;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs38 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsTextInput33 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs39;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs39 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface ServerManagerFormsSelectBirthDate2 {
  template_name: "django/forms/widgets/select_date.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: unknown;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs75;
  _reactivated_value_do_not_use?: {
    year: string | null;
    month: string | null;
    day: string | null;
  };
  /**
   * @minItems 3
   * @maxItems 3
   */
  subwidgets: [DjangoFormsWidgetsSelect39, DjangoFormsWidgetsSelect40, DjangoFormsWidgetsSelect41];
  tag: "server.manager.forms.SelectBirthDate";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs75 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsSelect39 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs76;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember39], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs76 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember39 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect40 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs77;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember40], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs77 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember40 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect41 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs78;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember41], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs78 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember41 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect42 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs79;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember42], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs79 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember42 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsTextInput34 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs40;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs40 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsTextInput35 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs41;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs41 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsCheckboxInput4 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs4;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs4 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsTextInput36 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs42;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs42 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface ServerManagerTemplates_ProgramTemplateOutput1 {
  id: Id78;
  uuid: Uuid114;
  name: Name135;
  user_id: UserId46;
  description: Description24;
  workout_groups: WorkoutGroups8;
  product_code: ProductCode4;
}
export interface HireRegistration {
  manager_name: ManagerName3;
  handle: Handle;
  manager: ServerManagerTemplates_User_124424A5E9Output3;
  registration_form: RegistrationForm1;
  programs: Programs2;
  stripe_account: StripeAccount;
  description: Description26;
  stripe_product_price: StripeProductPrice;
  STRIPE_PUBLISHABLE_KEY: StripePublishableKey2;
}
export interface ServerManagerTemplates_User_124424A5E9Output3 {
  email: Email24;
}
export interface RegistrationForm1 {
  name: "server.manager.forms.HireRegistrationForm";
  errors: {
    email?: string[];
    full_name?: string[];
    name?: string[];
    date_of_birth?: string[];
    gender?: string[];
    height?: string[];
    weight?: string[];
    invite_code?: string[];
    with_notification?: string[];
    distinct_id?: string[];
    selected_program?: string[];
    agreed_to_billing?: string[];
    token?: string[];
  } | null;
  fields: {
    email: {
      name: "email";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsEmailInput13;
    };
    full_name: {
      name: "full_name";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput37;
    };
    name: {
      name: "name";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput38;
    };
    date_of_birth: {
      name: "date_of_birth";
      label: string;
      help_text: string | null;
      widget: ServerManagerFormsSelectBirthDate3;
    };
    gender: {
      name: "gender";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect46;
    };
    height: {
      name: "height";
      label: string;
      help_text: string | null;
      widget: ServerCoreFormsLengthInput9;
    };
    weight: {
      name: "weight";
      label: string;
      help_text: string | null;
      widget: ServerCoreFormsWeightInput2;
    };
    invite_code: {
      name: "invite_code";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput39;
    };
    with_notification: {
      name: "with_notification";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput5;
    };
    distinct_id: {
      name: "distinct_id";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput40;
    };
    selected_program: {
      name: "selected_program";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput41;
    };
    agreed_to_billing: {
      name: "agreed_to_billing";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput6;
    };
    token: {
      name: "token";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput42;
    };
  };
  iterator: (
    | "email"
    | "full_name"
    | "name"
    | "date_of_birth"
    | "gender"
    | "height"
    | "weight"
    | "invite_code"
    | "with_notification"
    | "distinct_id"
    | "selected_program"
    | "agreed_to_billing"
    | "token"
  )[];
  hidden_fields: (
    | "email"
    | "full_name"
    | "name"
    | "date_of_birth"
    | "gender"
    | "height"
    | "weight"
    | "invite_code"
    | "with_notification"
    | "distinct_id"
    | "selected_program"
    | "agreed_to_billing"
    | "token"
  )[];
  prefix: string;
}
export interface DjangoFormsWidgetsEmailInput13 {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs80;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs80 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsTextInput37 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs43;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs43 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsTextInput38 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs44;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs44 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface ServerManagerFormsSelectBirthDate3 {
  template_name: "django/forms/widgets/select_date.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: unknown;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs81;
  _reactivated_value_do_not_use?: {
    year: string | null;
    month: string | null;
    day: string | null;
  };
  /**
   * @minItems 3
   * @maxItems 3
   */
  subwidgets: [DjangoFormsWidgetsSelect43, DjangoFormsWidgetsSelect44, DjangoFormsWidgetsSelect45];
  tag: "server.manager.forms.SelectBirthDate";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs81 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsSelect43 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs82;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember43], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs82 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember43 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect44 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs83;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember44], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs83 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember44 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect45 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs84;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember45], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs84 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember45 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect46 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs85;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember46], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs85 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember46 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface ServerCoreFormsLengthInput9 {
  template_name: "length";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs13;
  type: "number";
  tag: "server.core.forms.LengthInput";
}
export interface ReactivatedFormsWidgetsStepAttrs13 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface ServerCoreFormsWeightInput2 {
  template_name: "weight";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs14;
  type: "number";
  tag: "server.core.forms.WeightInput";
}
export interface ReactivatedFormsWidgetsStepAttrs14 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsTextInput39 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs45;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs45 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsCheckboxInput5 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs5;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs5 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsTextInput40 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs46;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs46 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsTextInput41 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs47;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs47 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsCheckboxInput6 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs6;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs6 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsTextInput42 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs48;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs48 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface ServerManagerTemplates_ProgramTemplateOutput2 {
  id: Id79;
  uuid: Uuid115;
  name: Name136;
  user_id: UserId47;
  description: Description25;
  workout_groups: WorkoutGroups9;
  product_code: ProductCode5;
}
export interface ManagerSettings {
  settings_form: SettingsForm1;
  client_check_in_question_form_set: ClientCheckInQuestionFormSet;
}
export interface SettingsForm1 {
  name: "server.manager.forms.ManagerSettingsForm";
  errors: {
    weight?: string[];
    waist?: string[];
    navel?: string[];
    body_fat?: string[];
    hips?: string[];
    neck?: string[];
    thigh?: string[];
    bicep?: string[];
    chest?: string[];
    check_in_notification?: string[];
    check_in_notes_label?: string[];
    primary_metric?: string[];
    secondary_metric?: string[];
    tertiary_metric?: string[];
    has_hidden_macros?: string[];
  } | null;
  fields: {
    weight: {
      name: "weight";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput7;
    };
    waist: {
      name: "waist";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput8;
    };
    navel: {
      name: "navel";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput9;
    };
    body_fat: {
      name: "body_fat";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput10;
    };
    hips: {
      name: "hips";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput11;
    };
    neck: {
      name: "neck";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput12;
    };
    thigh: {
      name: "thigh";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput13;
    };
    bicep: {
      name: "bicep";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput14;
    };
    chest: {
      name: "chest";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput15;
    };
    check_in_notification: {
      name: "check_in_notification";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput16;
    };
    check_in_notes_label: {
      name: "check_in_notes_label";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput43;
    };
    primary_metric: {
      name: "primary_metric";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect47;
      enum: ("WEIGHT" | "WAIST" | "NAVEL" | "BODY_FAT" | "HIPS" | "NECK" | "THIGH" | "BICEP" | "CHEST") | null;
    };
    secondary_metric: {
      name: "secondary_metric";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect48;
      enum: ("WEIGHT" | "WAIST" | "NAVEL" | "BODY_FAT" | "HIPS" | "NECK" | "THIGH" | "BICEP" | "CHEST") | null;
    };
    tertiary_metric: {
      name: "tertiary_metric";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect49;
      enum: ("WEIGHT" | "WAIST" | "NAVEL" | "BODY_FAT" | "HIPS" | "NECK" | "THIGH" | "BICEP" | "CHEST") | null;
    };
    has_hidden_macros: {
      name: "has_hidden_macros";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput17;
    };
  };
  iterator: (
    | "weight"
    | "waist"
    | "navel"
    | "body_fat"
    | "hips"
    | "neck"
    | "thigh"
    | "bicep"
    | "chest"
    | "check_in_notification"
    | "check_in_notes_label"
    | "primary_metric"
    | "secondary_metric"
    | "tertiary_metric"
    | "has_hidden_macros"
  )[];
  hidden_fields: (
    | "weight"
    | "waist"
    | "navel"
    | "body_fat"
    | "hips"
    | "neck"
    | "thigh"
    | "bicep"
    | "chest"
    | "check_in_notification"
    | "check_in_notes_label"
    | "primary_metric"
    | "secondary_metric"
    | "tertiary_metric"
    | "has_hidden_macros"
  )[];
  prefix: string;
}
export interface DjangoFormsWidgetsCheckboxInput7 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs7;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs7 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput8 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs8;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs8 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput9 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs9;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs9 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput10 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs10;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs10 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput11 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs11;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs11 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput12 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs12;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs12 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput13 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs13;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs13 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput14 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs14;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs14 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput15 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs15;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs15 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput16 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs16;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs16 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsTextInput43 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs49;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs49 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsSelect47 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs86;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember47], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs86 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember47 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect48 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs87;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember48], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs87 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember48 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect49 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs88;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember49], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs88 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember49 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput17 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs17;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs17 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface ClientCheckInQuestionFormSet {
  initial_form_count: number;
  total_form_count: number;
  max_num: number;
  min_num: number;
  can_delete: boolean;
  can_order: boolean;
  non_form_errors: string[];
  forms: {
    name: "server.manager.forms.ClientCheckInQuestionForm";
    errors: {
      is_enabled?: string[];
    } | null;
    fields: {
      is_enabled: {
        name: "is_enabled";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsCheckboxInput18;
      };
    };
    iterator: "is_enabled"[];
    hidden_fields: "is_enabled"[];
    prefix: string;
  }[];
  empty_form: {
    name: "server.manager.forms.ClientCheckInQuestionForm";
    errors: {
      is_enabled?: string[];
    } | null;
    fields: {
      is_enabled: {
        name: "is_enabled";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsCheckboxInput19;
      };
    };
    iterator: "is_enabled"[];
    hidden_fields: "is_enabled"[];
    prefix: string;
  };
  management_form: {
    name: "django.forms.formsets.ManagementForm";
    errors: {
      TOTAL_FORMS?: string[];
      INITIAL_FORMS?: string[];
      MIN_NUM_FORMS?: string[];
      MAX_NUM_FORMS?: string[];
    } | null;
    fields: {
      TOTAL_FORMS: {
        name: "TOTAL_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput16;
      };
      INITIAL_FORMS: {
        name: "INITIAL_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput17;
      };
      MIN_NUM_FORMS: {
        name: "MIN_NUM_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput18;
      };
      MAX_NUM_FORMS: {
        name: "MAX_NUM_FORMS";
        label: string;
        help_text: string | null;
        widget: DjangoFormsWidgetsHiddenInput19;
      };
    };
    iterator: ("TOTAL_FORMS" | "INITIAL_FORMS" | "MIN_NUM_FORMS" | "MAX_NUM_FORMS")[];
    hidden_fields: ("TOTAL_FORMS" | "INITIAL_FORMS" | "MIN_NUM_FORMS" | "MAX_NUM_FORMS")[];
    prefix: string;
  };
  prefix: string;
}
export interface DjangoFormsWidgetsCheckboxInput18 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs18;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs18 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput19 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs19;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs19 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsHiddenInput16 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs89;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs89 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsHiddenInput17 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs90;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs90 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsHiddenInput18 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs91;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs91 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsHiddenInput19 {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs92;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs92 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface MealPlanList {
  meal_plans: MealPlans;
}
export interface ServerManagerTemplates_MealPlanPickOutput1 {
  id: Id80;
  name: Name137;
  calories: Calories10;
  protein: Protein4;
  fat: Fat4;
  carbs: Carbs3;
  fiber: Fiber4;
  net_carbs: NetCarbs4;
}
export interface MealPlanDetail {
  meal_plan: ServerManagerTemplates_MealPlanPickOutput2;
  form: Form7;
  day: ServerJournalNutrition_DayOutput;
  status: Status6;
}
export interface ServerManagerTemplates_MealPlanPickOutput2 {
  id: Id81;
  name: Name138;
  calories: Calories11;
  protein: Protein5;
  fat: Fat5;
  carbs: Carbs4;
  fiber: Fiber5;
  net_carbs: NetCarbs5;
}
export interface Form7 {
  name: "server.manager.forms.MealPlanForm";
  errors: {
    name?: string[];
  } | null;
  fields: {
    name: {
      name: "name";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput44;
    };
  };
  iterator: "name"[];
  hidden_fields: "name"[];
  prefix: string;
}
export interface DjangoFormsWidgetsTextInput44 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs50;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs50 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DeleteMealPlan {
  meal_plan: ServerManagerTemplates_MealPlanPickOutput3;
  form: Form8;
}
export interface ServerManagerTemplates_MealPlanPickOutput3 {
  id: Id82;
  name: Name139;
  calories: Calories12;
  protein: Protein6;
  fat: Fat6;
  carbs: Carbs5;
  fiber: Fiber6;
  net_carbs: NetCarbs6;
}
export interface Form8 {
  name: "server.manager.forms.DeleteMealPlanForm";
  errors: {} | null;
  fields: {};
  iterator: [];
  hidden_fields: [];
  prefix: string;
}
export interface CreateMealPlan {
  form: Form9;
}
export interface Form9 {
  name: "server.manager.forms.MealPlanForm";
  errors: {
    name?: string[];
  } | null;
  fields: {
    name: {
      name: "name";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput45;
    };
  };
  iterator: "name"[];
  hidden_fields: "name"[];
  prefix: string;
}
export interface DjangoFormsWidgetsTextInput45 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs51;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs51 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface CreateTarget {
  client_manager: ServerManagerTemplates_ClientManagerPickOutput10;
  form: Form10;
  meal_plans: MealPlans1;
  schedule_form: ScheduleForm;
  assignments: Assignments7;
}
export interface ServerManagerTemplates_ClientManagerPickOutput10 {
  id: Id83;
  name: Name140;
  created_at: CreatedAt18;
  type: ClientManager__Type;
  client: Class_4B1C46D7Df5Ca803F5C6C9B8B56D0D29;
}
export interface Form10 {
  name: "server.manager.forms.ClientTargetForm";
  errors: {
    type?: string[];
    meal_plan?: string[];
    name?: string[];
    calories_target?: string[];
    calories_mode?: string[];
    protein_target?: string[];
    protein_mode?: string[];
    fat_target?: string[];
    fat_mode?: string[];
    carbs_target?: string[];
    carbs_mode?: string[];
    net_carbs_target?: string[];
    net_carbs_mode?: string[];
    fiber_target?: string[];
    fiber_mode?: string[];
    sodium_target?: string[];
    sodium_mode?: string[];
    saturated_fat_target?: string[];
    saturated_fat_mode?: string[];
    monounsaturated_fat_target?: string[];
    monounsaturated_fat_mode?: string[];
    polyunsaturated_fat_target?: string[];
    polyunsaturated_fat_mode?: string[];
    trans_fat_target?: string[];
    trans_fat_mode?: string[];
    cholesterol_target?: string[];
    cholesterol_mode?: string[];
    sugars_target?: string[];
    sugars_mode?: string[];
    added_sugars_target?: string[];
    added_sugars_mode?: string[];
    potassium_target?: string[];
    potassium_mode?: string[];
    magnesium_target?: string[];
    magnesium_mode?: string[];
    vitamin_a_dv_target?: string[];
    vitamin_a_dv_mode?: string[];
    vitamin_c_dv_target?: string[];
    vitamin_c_dv_mode?: string[];
    calcium_dv_target?: string[];
    calcium_dv_mode?: string[];
    iron_dv_target?: string[];
    iron_dv_mode?: string[];
  } | null;
  fields: {
    type: {
      name: "type";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect50;
      enum: ("LOG" | "BASIC" | "ADVANCED") | null;
    };
    meal_plan: {
      name: "meal_plan";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect51;
    };
    name: {
      name: "name";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput46;
    };
    calories_target: {
      name: "calories_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput;
    };
    calories_mode: {
      name: "calories_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect52;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    protein_target: {
      name: "protein_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput1;
    };
    protein_mode: {
      name: "protein_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect53;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    fat_target: {
      name: "fat_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput2;
    };
    fat_mode: {
      name: "fat_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect54;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    carbs_target: {
      name: "carbs_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput3;
    };
    carbs_mode: {
      name: "carbs_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect55;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    net_carbs_target: {
      name: "net_carbs_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput4;
    };
    net_carbs_mode: {
      name: "net_carbs_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect56;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    fiber_target: {
      name: "fiber_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput5;
    };
    fiber_mode: {
      name: "fiber_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect57;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    sodium_target: {
      name: "sodium_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput6;
    };
    sodium_mode: {
      name: "sodium_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect58;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    saturated_fat_target: {
      name: "saturated_fat_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput7;
    };
    saturated_fat_mode: {
      name: "saturated_fat_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect59;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    monounsaturated_fat_target: {
      name: "monounsaturated_fat_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput8;
    };
    monounsaturated_fat_mode: {
      name: "monounsaturated_fat_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect60;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    polyunsaturated_fat_target: {
      name: "polyunsaturated_fat_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput9;
    };
    polyunsaturated_fat_mode: {
      name: "polyunsaturated_fat_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect61;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    trans_fat_target: {
      name: "trans_fat_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput10;
    };
    trans_fat_mode: {
      name: "trans_fat_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect62;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    cholesterol_target: {
      name: "cholesterol_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput11;
    };
    cholesterol_mode: {
      name: "cholesterol_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect63;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    sugars_target: {
      name: "sugars_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput12;
    };
    sugars_mode: {
      name: "sugars_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect64;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    added_sugars_target: {
      name: "added_sugars_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput13;
    };
    added_sugars_mode: {
      name: "added_sugars_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect65;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    potassium_target: {
      name: "potassium_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput14;
    };
    potassium_mode: {
      name: "potassium_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect66;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    magnesium_target: {
      name: "magnesium_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput15;
    };
    magnesium_mode: {
      name: "magnesium_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect67;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    vitamin_a_dv_target: {
      name: "vitamin_a_dv_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput16;
    };
    vitamin_a_dv_mode: {
      name: "vitamin_a_dv_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect68;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    vitamin_c_dv_target: {
      name: "vitamin_c_dv_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput17;
    };
    vitamin_c_dv_mode: {
      name: "vitamin_c_dv_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect69;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    calcium_dv_target: {
      name: "calcium_dv_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput18;
    };
    calcium_dv_mode: {
      name: "calcium_dv_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect70;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    iron_dv_target: {
      name: "iron_dv_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput19;
    };
    iron_dv_mode: {
      name: "iron_dv_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect71;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
  };
  iterator: (
    | "type"
    | "meal_plan"
    | "name"
    | "calories_target"
    | "calories_mode"
    | "protein_target"
    | "protein_mode"
    | "fat_target"
    | "fat_mode"
    | "carbs_target"
    | "carbs_mode"
    | "net_carbs_target"
    | "net_carbs_mode"
    | "fiber_target"
    | "fiber_mode"
    | "sodium_target"
    | "sodium_mode"
    | "saturated_fat_target"
    | "saturated_fat_mode"
    | "monounsaturated_fat_target"
    | "monounsaturated_fat_mode"
    | "polyunsaturated_fat_target"
    | "polyunsaturated_fat_mode"
    | "trans_fat_target"
    | "trans_fat_mode"
    | "cholesterol_target"
    | "cholesterol_mode"
    | "sugars_target"
    | "sugars_mode"
    | "added_sugars_target"
    | "added_sugars_mode"
    | "potassium_target"
    | "potassium_mode"
    | "magnesium_target"
    | "magnesium_mode"
    | "vitamin_a_dv_target"
    | "vitamin_a_dv_mode"
    | "vitamin_c_dv_target"
    | "vitamin_c_dv_mode"
    | "calcium_dv_target"
    | "calcium_dv_mode"
    | "iron_dv_target"
    | "iron_dv_mode"
  )[];
  hidden_fields: (
    | "type"
    | "meal_plan"
    | "name"
    | "calories_target"
    | "calories_mode"
    | "protein_target"
    | "protein_mode"
    | "fat_target"
    | "fat_mode"
    | "carbs_target"
    | "carbs_mode"
    | "net_carbs_target"
    | "net_carbs_mode"
    | "fiber_target"
    | "fiber_mode"
    | "sodium_target"
    | "sodium_mode"
    | "saturated_fat_target"
    | "saturated_fat_mode"
    | "monounsaturated_fat_target"
    | "monounsaturated_fat_mode"
    | "polyunsaturated_fat_target"
    | "polyunsaturated_fat_mode"
    | "trans_fat_target"
    | "trans_fat_mode"
    | "cholesterol_target"
    | "cholesterol_mode"
    | "sugars_target"
    | "sugars_mode"
    | "added_sugars_target"
    | "added_sugars_mode"
    | "potassium_target"
    | "potassium_mode"
    | "magnesium_target"
    | "magnesium_mode"
    | "vitamin_a_dv_target"
    | "vitamin_a_dv_mode"
    | "vitamin_c_dv_target"
    | "vitamin_c_dv_mode"
    | "calcium_dv_target"
    | "calcium_dv_mode"
    | "iron_dv_target"
    | "iron_dv_mode"
  )[];
  prefix: string;
}
export interface DjangoFormsWidgetsSelect50 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs93;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember50], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs93 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember50 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect51 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs94;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember51], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs94 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember51 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsTextInput46 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs52;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs52 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsNumberInput {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs15;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs15 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect52 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs95;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember52], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs95 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember52 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput1 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs16;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs16 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect53 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs96;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember53], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs96 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember53 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput2 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs17;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs17 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect54 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs97;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember54], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs97 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember54 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput3 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs18;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs18 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect55 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs98;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember55], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs98 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember55 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput4 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs19;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs19 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect56 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs99;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember56], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs99 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember56 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput5 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs20;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs20 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect57 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs100;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember57], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs100 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember57 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput6 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs21;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs21 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect58 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs101;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember58], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs101 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember58 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput7 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs22;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs22 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect59 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs102;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember59], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs102 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember59 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput8 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs23;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs23 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect60 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs103;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember60], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs103 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember60 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput9 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs24;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs24 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect61 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs104;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember61], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs104 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember61 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput10 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs25;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs25 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect62 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs105;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember62], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs105 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember62 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput11 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs26;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs26 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect63 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs106;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember63], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs106 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember63 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput12 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs27;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs27 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect64 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs107;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember64], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs107 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember64 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput13 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs28;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs28 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect65 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs108;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember65], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs108 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember65 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput14 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs29;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs29 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect66 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs109;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember66], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs109 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember66 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput15 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs30;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs30 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect67 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs110;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember67], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs110 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember67 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput16 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs31;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs31 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect68 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs111;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember68], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs111 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember68 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput17 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs32;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs32 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect69 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs112;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember69], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs112 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember69 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput18 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs33;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs33 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect70 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs113;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember70], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs113 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember70 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput19 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs34;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs34 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect71 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs114;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember71], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs114 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember71 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface ServerManagerTemplates_MealPlanPickOutput4 {
  id: Id84;
  name: Name141;
  calories: Calories13;
  protein: Protein7;
  fat: Fat7;
  carbs: Carbs6;
  fiber: Fiber7;
  net_carbs: NetCarbs7;
}
export interface ScheduleForm {
  name: "server.manager.forms.ScheduleForm";
  errors: {
    monday?: string[];
    tuesday?: string[];
    wednesday?: string[];
    thursday?: string[];
    friday?: string[];
    saturday?: string[];
    sunday?: string[];
  } | null;
  fields: {
    monday: {
      name: "monday";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput20;
    };
    tuesday: {
      name: "tuesday";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput21;
    };
    wednesday: {
      name: "wednesday";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput22;
    };
    thursday: {
      name: "thursday";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput23;
    };
    friday: {
      name: "friday";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput24;
    };
    saturday: {
      name: "saturday";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput25;
    };
    sunday: {
      name: "sunday";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsCheckboxInput26;
    };
  };
  iterator: ("monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday" | "sunday")[];
  hidden_fields: ("monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday" | "sunday")[];
  prefix: string;
}
export interface DjangoFormsWidgetsCheckboxInput20 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs20;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs20 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput21 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs21;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs21 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput22 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs22;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs22 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput23 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs23;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs23 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput24 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs24;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs24 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput25 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs25;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs25 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface DjangoFormsWidgetsCheckboxInput26 {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedFormsWidgetsCheckAttrs26;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedFormsWidgetsCheckAttrs26 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface ServerManagerTemplates_TargetAssignmentF25C746Fc2Output1 {
  day_of_week: DayOfWeek5;
  target: ClassEb62169D81C4C4119F84D68Baf1Df0F7 | null;
}
export interface UpdateTarget {
  client_manager: ServerManagerTemplates_ClientManagerPickOutput11;
  form: Form11;
  meal_plans: MealPlans2;
}
export interface ServerManagerTemplates_ClientManagerPickOutput11 {
  id: Id85;
  name: Name142;
  created_at: CreatedAt19;
  type: ClientManager__Type;
  client: Class_4B1C46D7Df5Ca803F5C6C9B8B56D0D29;
}
export interface Form11 {
  name: "server.manager.forms.ClientTargetForm";
  errors: {
    type?: string[];
    meal_plan?: string[];
    name?: string[];
    calories_target?: string[];
    calories_mode?: string[];
    protein_target?: string[];
    protein_mode?: string[];
    fat_target?: string[];
    fat_mode?: string[];
    carbs_target?: string[];
    carbs_mode?: string[];
    net_carbs_target?: string[];
    net_carbs_mode?: string[];
    fiber_target?: string[];
    fiber_mode?: string[];
    sodium_target?: string[];
    sodium_mode?: string[];
    saturated_fat_target?: string[];
    saturated_fat_mode?: string[];
    monounsaturated_fat_target?: string[];
    monounsaturated_fat_mode?: string[];
    polyunsaturated_fat_target?: string[];
    polyunsaturated_fat_mode?: string[];
    trans_fat_target?: string[];
    trans_fat_mode?: string[];
    cholesterol_target?: string[];
    cholesterol_mode?: string[];
    sugars_target?: string[];
    sugars_mode?: string[];
    added_sugars_target?: string[];
    added_sugars_mode?: string[];
    potassium_target?: string[];
    potassium_mode?: string[];
    magnesium_target?: string[];
    magnesium_mode?: string[];
    vitamin_a_dv_target?: string[];
    vitamin_a_dv_mode?: string[];
    vitamin_c_dv_target?: string[];
    vitamin_c_dv_mode?: string[];
    calcium_dv_target?: string[];
    calcium_dv_mode?: string[];
    iron_dv_target?: string[];
    iron_dv_mode?: string[];
  } | null;
  fields: {
    type: {
      name: "type";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect72;
      enum: ("LOG" | "BASIC" | "ADVANCED") | null;
    };
    meal_plan: {
      name: "meal_plan";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect73;
    };
    name: {
      name: "name";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsTextInput47;
    };
    calories_target: {
      name: "calories_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput20;
    };
    calories_mode: {
      name: "calories_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect74;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    protein_target: {
      name: "protein_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput21;
    };
    protein_mode: {
      name: "protein_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect75;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    fat_target: {
      name: "fat_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput22;
    };
    fat_mode: {
      name: "fat_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect76;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    carbs_target: {
      name: "carbs_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput23;
    };
    carbs_mode: {
      name: "carbs_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect77;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    net_carbs_target: {
      name: "net_carbs_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput24;
    };
    net_carbs_mode: {
      name: "net_carbs_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect78;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    fiber_target: {
      name: "fiber_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput25;
    };
    fiber_mode: {
      name: "fiber_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect79;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    sodium_target: {
      name: "sodium_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput26;
    };
    sodium_mode: {
      name: "sodium_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect80;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    saturated_fat_target: {
      name: "saturated_fat_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput27;
    };
    saturated_fat_mode: {
      name: "saturated_fat_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect81;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    monounsaturated_fat_target: {
      name: "monounsaturated_fat_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput28;
    };
    monounsaturated_fat_mode: {
      name: "monounsaturated_fat_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect82;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    polyunsaturated_fat_target: {
      name: "polyunsaturated_fat_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput29;
    };
    polyunsaturated_fat_mode: {
      name: "polyunsaturated_fat_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect83;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    trans_fat_target: {
      name: "trans_fat_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput30;
    };
    trans_fat_mode: {
      name: "trans_fat_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect84;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    cholesterol_target: {
      name: "cholesterol_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput31;
    };
    cholesterol_mode: {
      name: "cholesterol_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect85;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    sugars_target: {
      name: "sugars_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput32;
    };
    sugars_mode: {
      name: "sugars_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect86;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    added_sugars_target: {
      name: "added_sugars_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput33;
    };
    added_sugars_mode: {
      name: "added_sugars_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect87;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    potassium_target: {
      name: "potassium_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput34;
    };
    potassium_mode: {
      name: "potassium_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect88;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    magnesium_target: {
      name: "magnesium_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput35;
    };
    magnesium_mode: {
      name: "magnesium_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect89;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    vitamin_a_dv_target: {
      name: "vitamin_a_dv_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput36;
    };
    vitamin_a_dv_mode: {
      name: "vitamin_a_dv_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect90;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    vitamin_c_dv_target: {
      name: "vitamin_c_dv_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput37;
    };
    vitamin_c_dv_mode: {
      name: "vitamin_c_dv_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect91;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    calcium_dv_target: {
      name: "calcium_dv_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput38;
    };
    calcium_dv_mode: {
      name: "calcium_dv_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect92;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
    iron_dv_target: {
      name: "iron_dv_target";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsNumberInput39;
    };
    iron_dv_mode: {
      name: "iron_dv_mode";
      label: string;
      help_text: string | null;
      widget: DjangoFormsWidgetsSelect93;
      enum: ("AT_LEAST" | "AT_MOST" | "EQUAL") | null;
    };
  };
  iterator: (
    | "type"
    | "meal_plan"
    | "name"
    | "calories_target"
    | "calories_mode"
    | "protein_target"
    | "protein_mode"
    | "fat_target"
    | "fat_mode"
    | "carbs_target"
    | "carbs_mode"
    | "net_carbs_target"
    | "net_carbs_mode"
    | "fiber_target"
    | "fiber_mode"
    | "sodium_target"
    | "sodium_mode"
    | "saturated_fat_target"
    | "saturated_fat_mode"
    | "monounsaturated_fat_target"
    | "monounsaturated_fat_mode"
    | "polyunsaturated_fat_target"
    | "polyunsaturated_fat_mode"
    | "trans_fat_target"
    | "trans_fat_mode"
    | "cholesterol_target"
    | "cholesterol_mode"
    | "sugars_target"
    | "sugars_mode"
    | "added_sugars_target"
    | "added_sugars_mode"
    | "potassium_target"
    | "potassium_mode"
    | "magnesium_target"
    | "magnesium_mode"
    | "vitamin_a_dv_target"
    | "vitamin_a_dv_mode"
    | "vitamin_c_dv_target"
    | "vitamin_c_dv_mode"
    | "calcium_dv_target"
    | "calcium_dv_mode"
    | "iron_dv_target"
    | "iron_dv_mode"
  )[];
  hidden_fields: (
    | "type"
    | "meal_plan"
    | "name"
    | "calories_target"
    | "calories_mode"
    | "protein_target"
    | "protein_mode"
    | "fat_target"
    | "fat_mode"
    | "carbs_target"
    | "carbs_mode"
    | "net_carbs_target"
    | "net_carbs_mode"
    | "fiber_target"
    | "fiber_mode"
    | "sodium_target"
    | "sodium_mode"
    | "saturated_fat_target"
    | "saturated_fat_mode"
    | "monounsaturated_fat_target"
    | "monounsaturated_fat_mode"
    | "polyunsaturated_fat_target"
    | "polyunsaturated_fat_mode"
    | "trans_fat_target"
    | "trans_fat_mode"
    | "cholesterol_target"
    | "cholesterol_mode"
    | "sugars_target"
    | "sugars_mode"
    | "added_sugars_target"
    | "added_sugars_mode"
    | "potassium_target"
    | "potassium_mode"
    | "magnesium_target"
    | "magnesium_mode"
    | "vitamin_a_dv_target"
    | "vitamin_a_dv_mode"
    | "vitamin_c_dv_target"
    | "vitamin_c_dv_mode"
    | "calcium_dv_target"
    | "calcium_dv_mode"
    | "iron_dv_target"
    | "iron_dv_mode"
  )[];
  prefix: string;
}
export interface DjangoFormsWidgetsSelect72 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs115;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember72], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs115 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember72 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsSelect73 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs116;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember73], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs116 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember73 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsTextInput47 {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsMaxLengthAttrs53;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedFormsWidgetsMaxLengthAttrs53 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsNumberInput20 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs35;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs35 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect74 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs117;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember74], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs117 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember74 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput21 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs36;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs36 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect75 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs118;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember75], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs118 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember75 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput22 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs37;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs37 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect76 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs119;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember76], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs119 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember76 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput23 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs38;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs38 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect77 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs120;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember77], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs120 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember77 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput24 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs39;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs39 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect78 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs121;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember78], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs121 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember78 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput25 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs40;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs40 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect79 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs122;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember79], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs122 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember79 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput26 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs41;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs41 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect80 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs123;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember80], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs123 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember80 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput27 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs42;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs42 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect81 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs124;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember81], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs124 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember81 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput28 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs43;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs43 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect82 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs125;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember82], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs125 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember82 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput29 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs44;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs44 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect83 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs126;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember83], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs126 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember83 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput30 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs45;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs45 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect84 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs127;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember84], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs127 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember84 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput31 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs46;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs46 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect85 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs128;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember85], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs128 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember85 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput32 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs47;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs47 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect86 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs129;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember86], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs129 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember86 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput33 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs48;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs48 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect87 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs130;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember87], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs130 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember87 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput34 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs49;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs49 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect88 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs131;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember88], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs131 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember88 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput35 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs50;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs50 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect89 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs132;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember89], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs132 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember89 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput36 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs51;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs51 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect90 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs133;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember90], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs133 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember90 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput37 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs52;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs52 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect91 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs134;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember91], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs134 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember91 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput38 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs53;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs53 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect92 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs135;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember92], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs135 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember92 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsNumberInput39 {
  template_name: "django/forms/widgets/number.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsStepAttrs54;
  type: "number";
  tag: "django.forms.widgets.NumberInput";
}
export interface ReactivatedFormsWidgetsStepAttrs54 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  step?: string;
}
export interface DjangoFormsWidgetsSelect93 {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedFormsWidgetsBaseWidgetAttrs136;
  optgroups: [null, [ReactivatedFormsWidgetsOptgroupMember93], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedFormsWidgetsBaseWidgetAttrs136 {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedFormsWidgetsOptgroupMember93 {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface ServerManagerTemplates_MealPlanPickOutput5 {
  id: Id86;
  name: Name143;
  calories: Calories14;
  protein: Protein8;
  fat: Fat8;
  carbs: Carbs7;
  fiber: Fiber8;
  net_carbs: NetCarbs8;
}
export interface ProgramList {
  programs: Programs3;
}
export interface ServerManagerTemplates_ListWorkoutProgramOutput2 {
  id: Id87;
  name: Name144;
  description: Description27;
  uuid: Uuid116;
  type: WorkoutProgram__Type;
  user_id: UserId48;
  updated_at: UpdatedAt6;
  visibility: Visibility;
  exercise_type_maxes_required: ExerciseTypeMaxesRequired3;
  instances: Instances6;
}
export interface UpdateProgram {
  question_types: QuestionTypes1;
  program: ServerJournalWorkouts_ProgramOutput;
  clients: Clients2;
}
export interface ServerJournalWorkouts_QuestionTypeOutput1 {
  uuid: Uuid117;
  name: Name145;
  type: QuestionType__Type;
}
export interface ServerManagerTemplates_ClientManager_9963Dfc2DdOutput1 {
  id: Id88;
  name: Name146;
  created_at: CreatedAt20;
  client: Class_888Cf0A00535D770737Eddee2781Edd7;
}
export interface MergeExercises {}
export interface ExerciseMedia {
  exercise_types: ExerciseTypes2;
}
export interface ServerManagerTemplates_ExerciseTypeC80Bde974AOutput1 {
  uuid: Uuid118;
  name: Name147;
  instances_count: InstancesCount1;
  media: Class_0Da5D7Db9F079395B12887Cac01Bb665 | null;
}
export interface ClientManagerSupplements {
  client_manager: ServerManagerTemplates_ClientManagerPickOutput12;
  planner: ServerJournalDay_PlannerOutput;
  supplements: Supplements4;
}
export interface ServerManagerTemplates_ClientManagerPickOutput12 {
  id: Id89;
  name: Name148;
  created_at: CreatedAt21;
  type: ClientManager__Type;
  client: Class_4B1C46D7Df5Ca803F5C6C9B8B56D0D29;
}
export interface Models {
  "core.templates.LeadCandidate_413c3245a6": ServerCoreTemplates_LeadCandidate_413C3245A6;
  "journal.learning_week.LearningWeekDayStatus": ServerJournalLearningWeek_LearningWeekDayStatus;
  "journal.learning_week.LearningWeekMemberStatus": ServerJournalLearningWeek_LearningWeekMemberStatus;
  "journal.nutrition.Entry": ServerJournalNutrition_Entry;
  "journal.nutrition.ExpandedEntry": ServerJournalNutrition_ExpandedEntry;
  "journal.nutrition.NutritionalVisionPrompt": ServerJournalNutrition_NutritionalVisionPrompt;
  "journal.nutrition.Recipe": ServerJournalNutrition_Recipe;
  "journal.nutrition.Meal": ServerJournalNutrition_Meal;
  "journal.nutrition.StagedMeal": ServerJournalNutrition_StagedMeal;
  "journal.nutrition.Target": ServerJournalNutrition_Target;
  "journal.nutrition.Day": ServerJournalNutrition_Day;
  "journal.nutrition.InlineEntry": ServerJournalNutrition_InlineEntry;
  "journal.nutrition.FoodUser": ServerJournalNutrition_FoodUser;
  "journal.nutrition.SharedProfile": ServerJournalNutrition_SharedProfile;
  "journal.nutrition.CalculatorProfile": ServerJournalNutrition_CalculatorProfile;
  "journal.nutrition.Food": ServerJournalNutrition_Food;
  "backoffice.views.VisionPrompt": ServerBackofficeViews_VisionPrompt;
  "backoffice.views.LearningWeekVisionPrompt": ServerBackofficeViews_LearningWeekVisionPrompt;
  "journal.workouts.ExerciseSet": ServerJournalWorkouts_ExerciseSet;
  "journal.workouts.LatestExerciseInstance": ServerJournalWorkouts_LatestExerciseInstance;
  "journal.workouts.ExerciseType": ServerJournalWorkouts_ExerciseType;
  "journal.workouts.ExerciseTypeUser": ServerJournalWorkouts_ExerciseTypeUser;
  "journal.workouts.ExerciseExerciseProgression": ServerJournalWorkouts_ExerciseExerciseProgression;
  "journal.workouts.Exercise": ServerJournalWorkouts_Exercise;
  "journal.workouts.Question": ServerJournalWorkouts_Question;
  "journal.workouts.ExerciseGroup": ServerJournalWorkouts_ExerciseGroup;
  "journal.workouts.WorkoutSection": ServerJournalWorkouts_WorkoutSection;
  "journal.workouts.WorkoutSectionHistory": ServerJournalWorkouts_WorkoutSectionHistory;
  "journal.workouts.QuestionType": ServerJournalWorkouts_QuestionType;
  "journal.workouts.Workout": ServerJournalWorkouts_Workout;
  "journal.workouts.WorkoutTemplate": ServerJournalWorkouts_WorkoutTemplate;
  "journal.workouts.ExerciseMax": ServerJournalWorkouts_ExerciseMax;
  "journal.workouts.ListProgram": ServerJournalWorkouts_ListProgram;
  "journal.workouts.WorkoutGroupWorkout": ServerJournalWorkouts_WorkoutGroupWorkout;
  "journal.workouts.WorkoutGroup": ServerJournalWorkouts_WorkoutGroup;
  "journal.workouts.ActiveProgram": ServerJournalWorkouts_ActiveProgram;
  "journal.workouts.Program": ServerJournalWorkouts_Program;
  "journal.workouts.ProgramUser": ServerJournalWorkouts_ProgramUser;
  "journal.workouts.PastProgram": ServerJournalWorkouts_PastProgram;
  "journal.workouts.ExerciseProgression": ServerJournalWorkouts_ExerciseProgression;
  "journal.workouts.IncompleteWorkout": ServerJournalWorkouts_IncompleteWorkout;
  "journal.workouts.SelectProgramTemplate": ServerJournalWorkouts_SelectProgramTemplate;
  "journal.workouts.ExerciseMedia": ServerJournalWorkouts_ExerciseMedia;
  "journal.workouts.ExerciseHistory": ServerJournalWorkouts_ExerciseHistory;
  "nutrition.rpc.ExportWorkout": ServerNutritionRpc_ExportWorkout;
  "nutrition.rpc.ExportMeal": ServerNutritionRpc_ExportMeal;
  "nutrition.rpc.USDAFood": ServerNutritionRpc_USDAFood;
  "journal.templates.PromptShare": ServerJournalTemplates_PromptShare;
  "core.rpc.ProfileUpdatePick": ServerCoreRpc_ProfileUpdatePick;
  "core.rpc.Profile": ServerCoreRpc_Profile;
  "journal.clubs.WalkingClubMemberStatus": ServerJournalClubs_WalkingClubMemberStatus;
  "journal.day.Metric": ServerJournalDay_Metric;
  "journal.day.MetricAggregate": ServerJournalDay_MetricAggregate;
  "journal.day.WorkoutAggregate": ServerJournalDay_WorkoutAggregate;
  "journal.day.CheckInResponse": ServerJournalDay_CheckInResponse;
  "journal.day.ExistingCheckIn": ServerJournalDay_ExistingCheckIn;
  "journal.day.CheckIn": ServerJournalDay_CheckIn;
  "journal.day.Assignment": ServerJournalDay_Assignment;
  "journal.day.Journal": ServerJournalDay_Journal;
  "journal.day.Measurement": ServerJournalDay_Measurement;
  "journal.day.DayUpdate": ServerJournalDay_DayUpdate;
  "journal.day.LegacyDayUpdate": ServerJournalDay_LegacyDayUpdate;
  "journal.day.LegacyUpdateDay": ServerJournalDay_LegacyUpdateDay;
  "journal.day.Planner": ServerJournalDay_Planner;
  "journal.day.ConsumerTarget": ServerJournalDay_ConsumerTarget;
  "journal.day.ConsumerProfile": ServerJournalDay_ConsumerProfile;
  "journal.day.ConsumerPlanner": ServerJournalDay_ConsumerPlanner;
  "journal.day.PurchaseVerification": ServerJournalDay_PurchaseVerification;
  "journal.mfp.MFPMigration": ServerJournalMfp_MFPMigration;
  "journal.views.MeetData": ServerJournalViews_MeetData;
  "manager.templates.ProgramTemplate": ServerManagerTemplates_ProgramTemplate;
  "manager.templates.ListWorkoutProgram": ServerManagerTemplates_ListWorkoutProgram;
  "manager.templates.ClientManagerPick": ServerManagerTemplates_ClientManagerPick;
  "manager.templates.Manager_e413b4138e": ServerManagerTemplates_ManagerE413B4138E;
  "manager.templates.ClientCheckIn_6af5d6e9cc": ServerManagerTemplates_ClientCheckIn_6Af5D6E9Cc;
  "manager.templates.Workout_c29aee4e3e": ServerManagerTemplates_WorkoutC29Aee4E3E;
  "manager.templates.User_124424a5e9": ServerManagerTemplates_User_124424A5E9;
  "manager.templates.MealPlanPick": ServerManagerTemplates_MealPlanPick;
  "manager.templates.TargetAssignment_f25c746fc2": ServerManagerTemplates_TargetAssignmentF25C746Fc2;
  "manager.templates.ClientManager_9963dfc2dd": ServerManagerTemplates_ClientManager_9963Dfc2Dd;
  "manager.templates.ExerciseType_c80bde974a": ServerManagerTemplates_ExerciseTypeC80Bde974A;
  "core.context_processors.Lead": ServerCoreContextProcessors_Lead;
  "core.context_processors.ClientManagerContext": ServerCoreContextProcessors_ClientManagerContext;
  "core.constants.Announcement": Announcement;
  "core.models.TargetLike.Mode": TargetLike__Mode;
  "core.models.WorkoutProgram.Type": WorkoutProgram__Type;
  "core.models.ExerciseType.CardioMetric": CardioMetric;
  "core.models.WorkoutSection.Type": WorkoutSection__Type;
  "core.models.Exercise.Attribute": Attribute;
  "core.models.ExerciseSet.Type": ExerciseSet__Type;
  "journal.learning_week.LearningWeekData": LearningWeekData;
  "journal.predictions.EntryItem": EntryItem;
  "journal.predictions.MealItem": MealItem;
  "journal.predictions.MealDigest": MealDigest;
  "journal.predictions.EntryInfo": EntryInfo;
  "journal.predictions.MealPattern": MealPattern;
  "journal.predictions.RootPatterns": RootPatterns;
  "journal.predictions.MealPredictions": MealPredictions;
  "journal.tasks.NotifcationModel": NotifcationModel;
  "journal.nutrition.SearchResult": SearchResult;
  "journal.nutrition.Backend": JournalNutritionBackend;
  "journal.nutrition.PredictionsData": PredictionsData;
  "journal.nutrition.Search": Search;
  "journal.nutrition.RecipeShare": RecipeShare;
  "forms.CharField": CharField;
  "forms.DecimalField": DecimalField;
  "forms.Form": Form1;
  "backoffice.views.AvailableUser": AvailableUser;
  "journal.workouts.NextWorkoutWrapper": NextWorkoutWrapper;
  "journal.workouts.Workouts": Workouts5;
  "journal.workouts.ExerciseMaxes": ExerciseMaxes3;
  "journal.reports.WeeklyMacrosEntry": WeeklyMacrosEntry;
  "nutrition.rpc.ExportDay": ExportDay;
  "journal.templates.RecipeExperimentName": RecipeExperimentName;
  "journal.templates.RecipeButtonExperimentName": RecipeButtonExperimentName;
  "journal.templates.RecipePriceExperimentName": RecipePriceExperimentName;
  "journal.templates.InstacartExperimentName": InstacartExperimentName;
  "core.types.AppleHealthWorkoutData": AppleHealthWorkoutData;
  "core.rpc.ApplePing": ApplePing;
  "core.rpc.TrackEmailClick": TrackEmailClick;
  "core.rpc.RegisterAPNSDevice": RegisterAPNSDevice;
  "core.rpc.PreviewEmail": PreviewEmail;
  "core.rpc.MFPRegistration": MFPRegistration;
  "core.rpc.LearningWeekRegistration": LearningWeekRegistration;
  "core.rpc.PlanRegistration": PlanRegistration;
  "core.rpc.CreateUserMedia.input": Input;
  "core.rpc.CreateUserMedia.output": Output;
  "core.rpc.ValidateLoginLink": ValidateLoginLink;
  "core.rpc.DismissAnnouncement": DismissAnnouncement;
  "core.rpc.ShareAttribution": ShareAttribution;
  "core.rpc.UTMAttribution": UTMAttribution;
  "core.rpc.CreateTrackingLink": CreateTrackingLink;
  "core.payments.ValidateIAPInput": ValidateIAPInput;
  "core.payments.Subscription": CorePaymentsSubscription;
  "core.payments.CreateSubscriptionInput": CreateSubscriptionInput;
  "core.payments.CreatePayPalSubscriptionInput": CreatePayPalSubscriptionInput;
  "journal.day.Save": Save;
  "journal.day.UpdateMetricAggregates": UpdateMetricAggregates;
  "journal.day.JournalForm": JournalForm;
  "journal.day.FastInit.input": Input1;
  "journal.day.Onboarding": Onboarding1;
  "journal.day.Method": Method;
  "journal.day.ShopifyOrderCreated": ShopifyOrderCreated;
  "journal.day.MoveDay": MoveDay;
  "journal.day.CopyDay": CopyDay;
  "journal.day.AcceptMealPlan": AcceptMealPlan;
  "journal.day.RejectMealPlan": RejectMealPlan;
  "journal.day.CheckInInput": CheckInInput;
  "journal.day.PlannerInput": PlannerInput;
  "journal.workouts.CreateTemplateFromWorkout": CreateTemplateFromWorkout;
  "journal.workouts.DeleteWorkout": DeleteWorkout;
  "journal.workouts.DeleteGroup": DeleteGroup;
  "journal.workouts.CopyProgram": CopyProgram;
  "journal.workouts.DeleteProgram": DeleteProgram;
  "journal.workouts.DeleteExerciseGroup": DeleteExerciseGroup;
  "journal.workouts.SelectProgramWorkout": SelectProgramWorkout;
  "journal.workouts.ArchiveProgram": ArchiveProgram;
  "journal.workouts.DisableSync": DisableSync;
  "journal.workouts.RecentSections": RecentSections;
  "journal.workouts.ExerciseMediaLookup": ExerciseMediaLookup;
  "journal.workouts.ExerciseMediaList": ExerciseMediaList;
  "journal.workouts.DeleteExerciseSet": DeleteExerciseSet;
  "journal.workouts.DeleteExercise": DeleteExercise;
  "journal.workouts.ClearExerciseSets": ClearExerciseSets;
  "journal.workouts.ExerciseDetailForm": ExerciseDetailForm;
  "journal.workouts.CopyWorkoutForm": CopyWorkoutForm;
  "journal.workouts.CompleteWorkoutForm": CompleteWorkoutForm;
  "journal.workouts.IncompleteWorkoutForm": IncompleteWorkoutForm;
  "journal.nutrition.UpdateCupboard": UpdateCupboard;
  "journal.nutrition.UpdateRecipe": UpdateRecipe;
  "journal.nutrition.PublishNutritionalVisionPrompt": PublishNutritionalVisionPrompt;
  "journal.nutrition.PublishDay": PublishDay;
  "journal.nutrition.ShareForm": ShareForm;
  "journal.nutrition.ShareRecipe": ShareRecipe;
  "journal.nutrition.ListFoods": ListFoods;
  "journal.nutrition.CreateFoodResponse": CreateFoodResponse;
  "journal.nutrition.UpdateFood": UpdateFood;
  "journal.nutrition.DeleteFood": DeleteFood;
  "journal.nutrition.ListRecipes": ListRecipes;
  "journal.nutrition.UpdateRecipeMetadata": UpdateRecipeMetadata;
  "journal.nutrition.DeleteRecipe": DeleteRecipe;
  "journal.nutrition.CopyRecipe": CopyRecipe;
  "journal.nutrition.PublishMeal": PublishMeal;
  "journal.nutrition.DeleteMeal": DeleteMeal;
  "journal.nutrition.MoveMeal": MoveMeal;
  "journal.nutrition.CopyMeal": CopyMeal;
  "journal.nutrition.PublishEntry": PublishEntry;
  "journal.nutrition.ExpandEntry": ExpandEntry;
  "journal.reports.Reports.input": Input2;
  "journal.reports.Reports.output": Output2;
  "journal.reports.WeeklyMacros.input": Input3;
  "journal.reports.WeeklyMacros": WeeklyMacros;
  "journal.clubs.BoardForm": BoardForm;
  "journal.clubs.WalkingClubBoard": WalkingClubBoard;
  "journal.clubs.DemoForm": DemoForm;
  "journal.clubs.InfoForm": InfoForm;
  "journal.clubs.WalkingClubInfo": WalkingClubInfo;
  "journal.clubs.LoginLink": LoginLink;
  "journal.clubs.JoinForm": JoinForm;
  "journal.clubs.WalkingClubRegistration": WalkingClubRegistration;
  "journal.nutritional_ai.ProcessMealImage.input": Input4;
  "journal.nutritional_ai.QueueBarcode": QueueBarcode;
  "journal.nutritional_ai.ImportRecipe": ImportRecipe;
  "journal.peptides.CreateVialInput": CreateVialInput;
  "journal.peptides.DeleteVialInput": DeleteVialInput;
  "journal.peptides.CreateDoseInput": CreateDoseInput;
  "journal.nutrition.CalculatorProfileForm": CalculatorProfileForm;
  "journal.nutrition.GeneralCalculatorForm": GeneralCalculatorForm;
  "journal.nutrition.KetoCalculatorForm": KetoCalculatorForm;
  "journal.nutrition.LeangainsCalculatorForm": LeangainsCalculatorForm;
  "journal.nutrition.CreateFood": CreateFood;
  "journal.nutrition.CreateRecipe": CreateRecipe;
  "journal.nutrition.CreateRecipeFromMeal": CreateRecipeFromMeal;
  "journal.workouts.WorkoutTemplateForm": WorkoutTemplateForm;
  "journal.workouts.WorkoutGroupForm": WorkoutGroupForm;
  "journal.workouts.ExerciseTypeForm": ExerciseTypeForm;
  "journal.workouts.CreateWorkoutTemplateForm": CreateWorkoutTemplateForm;
  "journal.workouts.FiveThreeOneSettingsForm": FiveThreeOneSettingsForm;
  "journal.workouts.LinearLiftConfigForm": LinearLiftConfigForm;
  "journal.workouts.LinearProgramSettingsForm": LinearProgramSettingsForm;
  "journal.workouts.ExerciseMaxForm": ExerciseMaxForm;
  "journal.workouts.WorkoutProgramConfigForm": WorkoutProgramConfigForm;
  "journal.workouts.QuestionTypeInput": QuestionTypeInput;
  "core.rpc.Register": Register;
  "core.rpc.Login": Login;
  "core.rpc.SetPassword": SetPassword;
  "core.rpc.ResetPassword": ResetPassword;
  "core.rpc.Contact": Contact;
  "core.rpc.UpdateProfile": UpdateProfile;
  "core.rpc.InviteUser": InviteUser;
  "journal.day.MeasurementForm": MeasurementForm1;
  "journal.day.TargetInput": TargetInput;
  "journal.mfp.MFPAccountForm": MFPAccountForm;
}
export interface ServerCoreTemplates_LeadCandidate_413C3245A6 {
  input: ServerCoreTemplates_LeadCandidate_413C3245A6Input;
  output: ServerCoreTemplates_LeadCandidate_413C3245A6Output;
}
export interface ServerJournalLearningWeek_LearningWeekDayStatus {
  input: ServerJournalLearningWeek_LearningWeekDayStatusInput;
  output: ServerJournalLearningWeek_LearningWeekDayStatusOutput;
}
export interface ServerJournalLearningWeek_LearningWeekMemberStatus {
  input: ServerJournalLearningWeek_LearningWeekMemberStatusInput;
  output: ServerJournalLearningWeek_LearningWeekMemberStatusOutput;
}
export interface ServerJournalNutrition_Entry {
  input: ServerJournalNutrition_EntryInput;
  output: ServerJournalNutrition_EntryOutput;
}
export interface ServerJournalNutrition_ExpandedEntry {
  input: ServerJournalNutrition_ExpandedEntryInput;
  output: ServerJournalNutrition_ExpandedEntryOutput;
}
export interface ServerJournalNutrition_NutritionalVisionPrompt {
  input: ServerJournalNutrition_NutritionalVisionPromptInput;
  output: ServerJournalNutrition_NutritionalVisionPromptOutput;
}
export interface ServerJournalNutrition_Recipe {
  input: ServerJournalNutrition_RecipeInput;
  output: ServerJournalNutrition_RecipeOutput;
}
export interface ServerJournalNutrition_Meal {
  input: ServerJournalNutrition_MealInput;
  output: ServerJournalNutrition_MealOutput;
}
export interface ServerJournalNutrition_StagedMeal {
  input: ServerJournalNutrition_StagedMealInput;
  output: ServerJournalNutrition_StagedMealOutput;
}
export interface ServerJournalNutrition_Target {
  input: ServerJournalNutrition_TargetInput;
  output: ServerJournalNutrition_TargetOutput;
}
export interface ServerJournalNutrition_Day {
  input: ServerJournalNutrition_DayInput;
  output: ServerJournalNutrition_DayOutput;
}
export interface ServerJournalNutrition_InlineEntry {
  input: ServerJournalNutrition_InlineEntryInput;
  output: ServerJournalNutrition_InlineEntryOutput;
}
export interface ServerJournalNutrition_FoodUser {
  input: ServerJournalNutrition_FoodUserInput;
  output: ServerJournalNutrition_FoodUserOutput;
}
export interface ServerJournalNutrition_SharedProfile {
  input: ServerJournalNutrition_SharedProfileInput;
  output: ServerJournalNutrition_SharedProfileOutput;
}
export interface ServerJournalNutrition_CalculatorProfile {
  input: ServerJournalNutrition_CalculatorProfileInput;
  output: ServerJournalNutrition_CalculatorProfileOutput;
}
export interface ServerJournalNutrition_Food {
  input: ServerJournalNutrition_FoodInput;
  output: ServerJournalNutrition_FoodOutput;
}
export interface ServerBackofficeViews_VisionPrompt {
  input: ServerBackofficeViews_VisionPromptInput;
  output: ServerBackofficeViews_VisionPromptOutput;
}
export interface ServerBackofficeViews_LearningWeekVisionPrompt {
  input: ServerBackofficeViews_LearningWeekVisionPromptInput;
  output: ServerBackofficeViews_LearningWeekVisionPromptOutput;
}
export interface ServerJournalWorkouts_ExerciseSet {
  input: ServerJournalWorkouts_ExerciseSetInput;
  output: ServerJournalWorkouts_ExerciseSetOutput;
}
export interface ServerJournalWorkouts_LatestExerciseInstance {
  input: ServerJournalWorkouts_LatestExerciseInstanceInput;
  output: ServerJournalWorkouts_LatestExerciseInstanceOutput;
}
export interface ServerJournalWorkouts_ExerciseType {
  input: ServerJournalWorkouts_ExerciseTypeInput;
  output: ServerJournalWorkouts_ExerciseTypeOutput;
}
export interface ServerJournalWorkouts_ExerciseTypeUser {
  input: ServerJournalWorkouts_ExerciseTypeUserInput;
  output: ServerJournalWorkouts_ExerciseTypeUserOutput;
}
export interface ServerJournalWorkouts_ExerciseExerciseProgression {
  input: ServerJournalWorkouts_ExerciseExerciseProgressionInput;
  output: ServerJournalWorkouts_ExerciseExerciseProgressionOutput;
}
export interface ServerJournalWorkouts_Exercise {
  input: ServerJournalWorkouts_ExerciseInput;
  output: ServerJournalWorkouts_ExerciseOutput;
}
export interface ServerJournalWorkouts_Question {
  input: ServerJournalWorkouts_QuestionInput;
  output: ServerJournalWorkouts_QuestionOutput;
}
export interface ServerJournalWorkouts_ExerciseGroup {
  input: ServerJournalWorkouts_ExerciseGroupInput;
  output: ServerJournalWorkouts_ExerciseGroupOutput;
}
export interface ServerJournalWorkouts_WorkoutSection {
  input: ServerJournalWorkouts_WorkoutSectionInput;
  output: ServerJournalWorkouts_WorkoutSectionOutput;
}
export interface ServerJournalWorkouts_WorkoutSectionHistory {
  input: ServerJournalWorkouts_WorkoutSectionHistoryInput;
  output: ServerJournalWorkouts_WorkoutSectionHistoryOutput;
}
export interface ServerJournalWorkouts_QuestionType {
  input: ServerJournalWorkouts_QuestionTypeInput;
  output: ServerJournalWorkouts_QuestionTypeOutput;
}
export interface ServerJournalWorkouts_Workout {
  input: ServerJournalWorkouts_WorkoutInput;
  output: ServerJournalWorkouts_WorkoutOutput;
}
export interface ServerJournalWorkouts_WorkoutTemplate {
  input: ServerJournalWorkouts_WorkoutTemplateInput;
  output: ServerJournalWorkouts_WorkoutTemplateOutput;
}
export interface ServerJournalWorkouts_ExerciseMax {
  input: ServerJournalWorkouts_ExerciseMaxInput;
  output: ServerJournalWorkouts_ExerciseMaxOutput;
}
export interface ServerJournalWorkouts_ListProgram {
  input: ServerJournalWorkouts_ListProgramInput;
  output: ServerJournalWorkouts_ListProgramOutput;
}
export interface ServerJournalWorkouts_WorkoutGroupWorkout {
  input: ServerJournalWorkouts_WorkoutGroupWorkoutInput;
  output: ServerJournalWorkouts_WorkoutGroupWorkoutOutput;
}
export interface ServerJournalWorkouts_WorkoutGroup {
  input: ServerJournalWorkouts_WorkoutGroupInput;
  output: ServerJournalWorkouts_WorkoutGroupOutput;
}
export interface ServerJournalWorkouts_ActiveProgram {
  input: ServerJournalWorkouts_ActiveProgramInput;
  output: ServerJournalWorkouts_ActiveProgramOutput;
}
export interface ServerJournalWorkouts_Program {
  input: ServerJournalWorkouts_ProgramInput;
  output: ServerJournalWorkouts_ProgramOutput;
}
export interface ServerJournalWorkouts_ProgramUser {
  input: ServerJournalWorkouts_ProgramUserInput;
  output: ServerJournalWorkouts_ProgramUserOutput;
}
export interface ServerJournalWorkouts_PastProgram {
  input: ServerJournalWorkouts_PastProgramInput;
  output: ServerJournalWorkouts_PastProgramOutput;
}
export interface ServerJournalWorkouts_ExerciseProgression {
  input: ServerJournalWorkouts_ExerciseProgressionInput;
  output: ServerJournalWorkouts_ExerciseProgressionOutput;
}
export interface ServerJournalWorkouts_IncompleteWorkout {
  input: ServerJournalWorkouts_IncompleteWorkoutInput;
  output: ServerJournalWorkouts_IncompleteWorkoutOutput;
}
export interface ServerJournalWorkouts_SelectProgramTemplate {
  input: ServerJournalWorkouts_SelectProgramTemplateInput;
  output: ServerJournalWorkouts_SelectProgramTemplateOutput;
}
export interface ServerJournalWorkouts_ExerciseMedia {
  input: ServerJournalWorkouts_ExerciseMediaInput;
  output: ServerJournalWorkouts_ExerciseMediaOutput;
}
export interface ServerJournalWorkouts_ExerciseHistory {
  input: ServerJournalWorkouts_ExerciseHistoryInput;
  output: ServerJournalWorkouts_ExerciseHistoryOutput;
}
export interface ServerNutritionRpc_ExportWorkout {
  input: ServerNutritionRpc_ExportWorkoutInput;
  output: ServerNutritionRpc_ExportWorkoutOutput;
}
export interface ServerNutritionRpc_ExportMeal {
  input: ServerNutritionRpc_ExportMealInput;
  output: ServerNutritionRpc_ExportMealOutput;
}
export interface ServerNutritionRpc_USDAFood {
  input: ServerNutritionRpc_USDAFoodInput;
  output: ServerNutritionRpc_USDAFoodOutput;
}
export interface ServerJournalTemplates_PromptShare {
  input: ServerJournalTemplates_PromptShareInput;
  output: ServerJournalTemplates_PromptShareOutput;
}
export interface ServerCoreRpc_ProfileUpdatePick {
  input: ServerCoreRpc_ProfileUpdatePickInput;
  output: ServerCoreRpc_ProfileUpdatePickOutput;
}
export interface ServerCoreRpc_Profile {
  input: ServerCoreRpc_ProfileInput;
  output: ServerCoreRpc_ProfileOutput1;
}
export interface ServerJournalClubs_WalkingClubMemberStatus {
  input: ServerJournalClubs_WalkingClubMemberStatusInput;
  output: ServerJournalClubs_WalkingClubMemberStatusOutput;
}
export interface ServerJournalDay_Metric {
  input: ServerJournalDay_MetricInput;
  output: ServerJournalDay_MetricOutput;
}
export interface ServerJournalDay_MetricAggregate {
  input: ServerJournalDay_MetricAggregateInput;
  output: ServerJournalDay_MetricAggregateOutput;
}
export interface ServerJournalDay_WorkoutAggregate {
  input: ServerJournalDay_WorkoutAggregateInput;
  output: ServerJournalDay_WorkoutAggregateOutput;
}
export interface ServerJournalDay_CheckInResponse {
  input: ServerJournalDay_CheckInResponseInput;
  output: ServerJournalDay_CheckInResponseOutput;
}
export interface ServerJournalDay_ExistingCheckIn {
  input: ServerJournalDay_ExistingCheckInInput;
  output: ServerJournalDay_ExistingCheckInOutput;
}
export interface ServerJournalDay_CheckIn {
  input: ServerJournalDay_CheckInInput;
  output: ServerJournalDay_CheckInOutput;
}
export interface ServerJournalDay_Assignment {
  input: ServerJournalDay_AssignmentInput;
  output: ServerJournalDay_AssignmentOutput;
}
export interface ServerJournalDay_Journal {
  input: ServerJournalDay_JournalInput;
  output: ServerJournalDay_JournalOutput;
}
export interface ServerJournalDay_Measurement {
  input: ServerJournalDay_MeasurementInput;
  output: ServerJournalDay_MeasurementOutput;
}
export interface ServerJournalDay_DayUpdate {
  input: ServerJournalDay_DayUpdateInput;
  output: ServerJournalDay_DayUpdateOutput;
}
export interface ServerJournalDay_LegacyDayUpdate {
  input: ServerJournalDay_LegacyDayUpdateInput;
  output: ServerJournalDay_LegacyDayUpdateOutput;
}
export interface ServerJournalDay_LegacyUpdateDay {
  input: ServerJournalDay_LegacyUpdateDayInput;
  output: ServerJournalDay_LegacyUpdateDayOutput;
}
export interface ServerJournalDay_Planner {
  input: ServerJournalDay_PlannerInput;
  output: ServerJournalDay_PlannerOutput;
}
export interface ServerJournalDay_ConsumerTarget {
  input: ServerJournalDay_ConsumerTargetInput;
  output: ServerJournalDay_ConsumerTargetOutput;
}
export interface ServerJournalDay_ConsumerProfile {
  input: ServerJournalDay_ConsumerProfileInput;
  output: ServerJournalDay_ConsumerProfileOutput;
}
export interface ServerJournalDay_ConsumerPlanner {
  input: ServerJournalDay_ConsumerPlannerInput;
  output: ServerJournalDay_ConsumerPlannerOutput;
}
export interface ServerJournalDay_PurchaseVerification {
  input: ServerJournalDay_PurchaseVerificationInput;
  output: ServerJournalDay_PurchaseVerificationOutput;
}
export interface ServerJournalMfp_MFPMigration {
  input: ServerJournalMfp_MFPMigrationInput;
  output: ServerJournalMfp_MFPMigrationOutput2;
}
export interface ServerJournalViews_MeetData {
  input: ServerJournalViews_MeetDataInput;
  output: ServerJournalViews_MeetDataOutput;
}
export interface ServerManagerTemplates_ProgramTemplate {
  input: ServerManagerTemplates_ProgramTemplateInput;
  output: ServerManagerTemplates_ProgramTemplateOutput;
}
export interface ServerManagerTemplates_ListWorkoutProgram {
  input: ServerManagerTemplates_ListWorkoutProgramInput;
  output: ServerManagerTemplates_ListWorkoutProgramOutput;
}
export interface ServerManagerTemplates_ClientManagerPick {
  input: ServerManagerTemplates_ClientManagerPickInput;
  output: ServerManagerTemplates_ClientManagerPickOutput;
}
export interface ServerManagerTemplates_ManagerE413B4138E {
  input: ServerManagerTemplates_ManagerE413B4138EInput;
  output: ServerManagerTemplates_ManagerE413B4138EOutput;
}
export interface ServerManagerTemplates_ClientCheckIn_6Af5D6E9Cc {
  input: ServerManagerTemplates_ClientCheckIn_6Af5D6E9CcInput;
  output: ServerManagerTemplates_ClientCheckIn_6Af5D6E9CcOutput;
}
export interface ServerManagerTemplates_WorkoutC29Aee4E3E {
  input: ServerManagerTemplates_WorkoutC29Aee4E3EInput;
  output: ServerManagerTemplates_WorkoutC29Aee4E3EOutput;
}
export interface ServerManagerTemplates_User_124424A5E9 {
  input: ServerManagerTemplates_User_124424A5E9Input;
  output: ServerManagerTemplates_User_124424A5E9Output;
}
export interface ServerManagerTemplates_MealPlanPick {
  input: ServerManagerTemplates_MealPlanPickInput;
  output: ServerManagerTemplates_MealPlanPickOutput;
}
export interface ServerManagerTemplates_TargetAssignmentF25C746Fc2 {
  input: ServerManagerTemplates_TargetAssignmentF25C746Fc2Input;
  output: ServerManagerTemplates_TargetAssignmentF25C746Fc2Output;
}
export interface ServerManagerTemplates_ClientManager_9963Dfc2Dd {
  input: ServerManagerTemplates_ClientManager_9963Dfc2DdInput;
  output: ServerManagerTemplates_ClientManager_9963Dfc2DdOutput;
}
export interface ServerManagerTemplates_ExerciseTypeC80Bde974A {
  input: ServerManagerTemplates_ExerciseTypeC80Bde974AInput;
  output: ServerManagerTemplates_ExerciseTypeC80Bde974AOutput;
}
export interface ServerCoreContextProcessors_Lead {
  input: ServerCoreContextProcessors_LeadInput;
  output: ServerCoreContextProcessors_LeadOutput;
}
export interface ServerCoreContextProcessors_ClientManagerContext {
  input: ServerCoreContextProcessors_ClientManagerContextInput;
  output: ServerCoreContextProcessors_ClientManagerContextOutput;
}
export interface MealItem {
  uuid: Uuid119;
  name: Name149;
  date: Date23;
  entries: Entries13;
  hash: Hash2;
}
export interface NotifcationModel {
  notification: Notification;
}
export interface UpdatedProgramNotification {
  type: Type24;
}
export interface StepsNotification {
  type: Type25;
}
export interface AppleHealthWorkoutData {
  uuid: Uuid120;
  startDate: Startdate;
  endDate: Enddate;
  duration: Duration7;
  workoutActivityType: Workoutactivitytype;
  workoutActivityId: Workoutactivityid;
  source: Source5;
  sourceBundleId: Sourcebundleid;
  device?: AppleHealthDeviceInfo;
  totalEnergyBurned?: Totalenergyburned;
  totalDistance?: Totaldistance;
  allStatistics: Allstatistics;
  timezone?: Timezone8;
  metadata?: Metadata;
}
export interface AppleHealthDeviceInfo {
  name?: Name150;
  model?: Model;
  manufacturer?: Manufacturer;
  hardwareVersion?: Hardwareversion;
  softwareVersion?: Softwareversion;
}
export interface Allstatistics {
  [k: string]: AppleHealthStatisticValue;
}
export interface AppleHealthStatisticValue {
  sum?: Sum;
  average?: Average;
  minimum?: Minimum;
  maximum?: Maximum;
}
export interface Metadata {
  [k: string]: string | number | boolean | QuantityValue;
}
export interface QuantityValue {
  value: Value6;
  unit: Unit20;
}
export interface CalculatorProfileForm {
  name: Name151;
  diet: "GENERAL" | "LEANGAINS" | "KETO";
  is_imperial: IsImperial10;
  date_of_birth: DateOfBirth14;
  weight: Weight26;
  height: Height10;
  gender: Gender12;
  activity: Activity11;
  body_fat: BodyFat12;
}
export interface GeneralCalculatorForm {
  variance: Variance;
  protein_multiplier: ProteinMultiplier;
  fat_carbs: FatCarbs;
}
export interface KetoCalculatorForm {
  variance: Variance1;
  carb_limit: CarbLimit;
}
export interface LeangainsCalculatorForm {
  workout_day_variance: WorkoutDayVariance;
  rest_day_variance: RestDayVariance;
  protein_multiplier: ProteinMultiplier1;
  workout_day_fat: WorkoutDayFat;
  rest_day_fat: RestDayFat;
}
export interface WorkoutGroupForm {
  uuid: Uuid121;
  name: Name152;
  description: Description28;
  order: Order3;
}
export interface FiveThreeOneSettingsForm {
  template: "BORING_BUT_BIG" | "BORING_BUT_STRONG" | "FIRST_SET_LAST" | "SECOND_SET_LAST";
  cycle_type: "ANCHOR" | "LEADER";
  swap_exercises?: SwapExercises;
  assistance_exercises?: AssistanceExercises;
  deload_week?: DeloadWeek;
  heavy_single?: HeavySingle;
}
export interface LinearLiftConfigForm {
  progression_per_week: ProgressionPerWeek;
  smallest_plate: SmallestPlate;
}
export interface LinearProgramSettingsForm {
  weeks?: Weeks;
}
export interface ExerciseMaxForm {
  reps?: Reps6;
  weight: Weight27;
  smallest_plate: SmallestPlate1;
}
export interface WorkoutProgramConfigForm {
  name: Name153;
  description: Description29;
  auto_assign?: AutoAssign;
}
export interface MeasurementForm1 {
  weight: Weight28;
  waist: Waist8;
  navel: Navel3;
  body_fat: BodyFat13;
  hips: Hips3;
  neck: Neck3;
  thigh: Thigh3;
  bicep: Bicep3;
  chest: Chest3;
}
export interface Context {
  template_name: TemplateName;
  request: Request;
  user: SafeUser | null;
  messages: Messages;
  csrf_token: CsrfToken;
  mobile_os: MobileOs;
  view: View;
  STATIC_URL: StaticUrl1;
  realm: Realm;
  environment: Settings1;
  profile: ServerCoreRpc_ProfileOutput1 | null;
  lead: ServerCoreContextProcessors_LeadOutput | null;
  clients: Clients3;
}
export interface Request {
  path: Path1;
  url: Url1;
  csp_nonce: CspNonce;
}
/**
 * The safe default shape for ``django.contrib.auth``'s context
 * processor: the user's own identity, nothing more. No email (keep PII
 * out of rendered props by default), no perms (PermWrapper is a lazy,
 * query-bearing proxy). Override by registering a replacement Pick via
 * ``register_processor_type`` — or skip Django's processor and write
 * your own, which supersedes this entirely.
 */
export interface SafeUser {
  id: Id90;
  username: Username1;
  is_authenticated: IsAuthenticated;
  is_staff: IsStaff;
}
export interface Message1 {
  level_tag: LevelTag;
  message: Message2;
  level: Level;
  from_server?: FromServer;
}
export interface View {
  url_name: UrlName;
}
export interface Settings1 {
  SENTRY_DSN: SentryDsn1;
  MIXPANEL_TOKEN: MixpanelToken1;
  ANALYTICS_ID: AnalyticsId;
  STATIC_URL: StaticUrl2;
  MEDIA_URL: MediaUrl;
}


    import {getCookieFromCookieString} from "reactivated/dist/rpc";

    export type RPCResult<TSuccess> = {
        type: "success";
        data: TSuccess;
        // request: Request;
    } | {
        type: "invalid";
        errors: {loc: string[]; msg: string}[];
        // request: Request;
    } | {
        type: "denied";
        reason: unknown;
        // request: Request;
    } | {
        type: "unauthorized";
        // request: Request;
    } | {
        type: "exception";
        exception: unknown;
        // request: Request;
    }

    export type models = Schema["models"];
    

export namespace server {
    export namespace backoffice {
        export namespace views {
            export type AvailableUser = Schema["models"]["backoffice.views.AvailableUser"];
            export type Backoffice = Schema["template_Backoffice"];
            export type Predictions = Schema["template_Predictions"];
            export async function get_available_prediction_users() {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/get_available_prediction_users/", {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_get_available_prediction_users_output"]>>;
}
            export namespace LearningWeekVisionPrompt {
                export type input = Schema["models"]["backoffice.views.LearningWeekVisionPrompt"]["input"];
                export type output = Schema["models"]["backoffice.views.LearningWeekVisionPrompt"]["output"];
            }
            export namespace VisionPrompt {
                export type input = Schema["models"]["backoffice.views.VisionPrompt"]["input"];
                export type output = Schema["models"]["backoffice.views.VisionPrompt"]["output"];
            }
            export namespace get_available_prediction_users {
                export type output = Schema["rpc_get_available_prediction_users_output"];
            }
        }
    }
    export namespace core {
        export const ICON_MAP = {
    "0003-home3": "Icon0003Home3",
    "0009-bed": "Icon0009Bed",
    "0014-pencil": "Icon0014Pencil",
    "0018-eraser": "Icon0018Eraser",
    "0020-pencil5": "Icon0020Pencil5",
    "0044-magic-wand": "Icon0044MagicWand",
    "0057-fire": "Icon0057Fire",
    "0104-shield": "Icon0104Shield",
    "0105-shield-check": "Icon0105ShieldCheck",
    "0108-lock": "Icon0108Lock",
    "0115-cog": "Icon0115Cog",
    "0117-wrench": "Icon0117Wrench",
    "0120-hammer": "Icon0120Hammer",
    "0130-trash2": "Icon0130Trash2",
    "0134-gamepad": "Icon0134Gamepad",
    "0141-heart": "Icon0141Heart",
    "0151-envelope": "Icon0151Envelope",
    "0154-paper-plane": "Icon0154PaperPlane",
    "0175-floppy-disk": "Icon0175FloppyDisk",
    "0184-files": "Icon0184Files",
    "0185-copy": "Icon0185Copy",
    "0200-scissors": "Icon0200Scissors",
    "0205-clipboard-check": "Icon0205ClipboardCheck",
    "0209-clipboard-user": "Icon0209ClipboardUser",
    "0217-document": "Icon0217Document",
    "0219-graduation-hat": "Icon0219GraduationHat",
    "0222-medal-empty": "Icon0222MedalEmpty",
    "0243-equalizer": "Icon0243Equalizer",
    "0284-profile": "Icon0284Profile",
    "0287-user": "Icon0287User",
    "0291-users": "Icon0291Users",
    "0302-walk": "Icon0302Walk",
    "0310-weight": "Icon0310Weight",
    "0346-credit-card": "Icon0346CreditCard",
    "0360-calculator2": "Icon0360Calculator2",
    "0393-calendar-31": "Icon0393Calendar31",
    "0394-calendar-full": "Icon0394CalendarFull",
    "0432-desktop": "Icon0432Desktop",
    "0442-power": "Icon0442Power",
    "0445-lamp": "Icon0445Lamp",
    "0489-heart-pulse": "Icon0489HeartPulse",
    "0492-pills": "Icon0492Pills",
    "0507-graph": "Icon0507Graph",
    "0508-chart-growth": "Icon0508ChartGrowth",
    "0512-gift": "Icon0512Gift",
    "0516-rank3": "Icon0516Rank3",
    "0529-glass2": "Icon0529Glass2",
    "0531-dinner2": "Icon0531Dinner2",
    "0532-chef": "Icon0532Chef",
    "0537-platter": "Icon0537Platter",
    "0564-footprint": "Icon0564Footprint",
    "0567-speed-fast": "Icon0567SpeedFast",
    "0611-bench-press": "Icon0611BenchPress",
    "0618-ping-pong": "Icon0618PingPong",
    "0625-archery": "Icon0625Archery",
    "0654-sad": "Icon0654Sad",
    "0687-bullhorn": "Icon0687Bullhorn",
    "0721-loading": "Icon0721Loading",
    "0724-refresh": "Icon0724Refresh",
    "0730-redo2": "Icon0730Redo2",
    "0741-history2": "Icon0741History2",
    "0752-timer": "Icon0752Timer",
    "0758-download2": "Icon0758Download2",
    "0794-thumbs-up": "Icon0794ThumbsUp",
    "0801-share2": "Icon0801Share2",
    "0803-magnifier": "Icon0803Magnifier",
    "0812-menu": "Icon0812Menu",
    "0814-list2": "Icon0814List2",
    "0815-list3": "Icon0815List3",
    "0817-list4": "Icon0817List4",
    "0821-check": "Icon0821Check",
    "0822-cross2": "Icon0822Cross2",
    "0823-plus": "Icon0823Plus",
    "0830-chevrons-expand-vertical": "Icon0830ChevronsExpandVertical",
    "0837-arrow-right": "Icon0837ArrowRight",
    "0845-expand2": "Icon0845Expand2",
    "0846-contract2": "Icon0846Contract2",
    "0849-arrow-wave": "Icon0849ArrowWave",
    "0856-question-circle": "Icon0856QuestionCircle",
    "0859-cross-circle": "Icon0859CrossCircle",
    "0862-percent-circle": "Icon0862PercentCircle",
    "0875-play-circle": "Icon0875PlayCircle",
    "0879-forward-circle": "Icon0879ForwardCircle",
    "0892-ruler": "Icon0892Ruler",
    "custom-0151-envelope": "IconCustom0151Envelope",
    "custom-0283-contacts": "IconCustom0283Contacts",
    "custom-0763-enter-right": "IconCustom0763EnterRight",
    "custom-0767-exit-right": "IconCustom0767ExitRight",
    "custom-app-icon": "IconCustomAppIcon",
    "custom-app-store": "IconCustomAppStore",
    "custom-apple-share": "IconCustomAppleShare",
    "custom-barcode-enlarged": "IconCustomBarcodeEnlarged",
    "custom-barcode": "IconCustomBarcode",
    "custom-bolder-check": "IconCustomBolderCheck",
    "custom-bolder-cross": "IconCustomBolderCross",
    "custom-calendar-today": "IconCustomCalendarToday",
    "custom-camera-bigger-hero-icon": "IconCustomCameraBiggerHeroIcon",
    "custom-chevron-down": "IconCustomChevronDown",
    "custom-chevron-left": "IconCustomChevronLeft",
    "custom-chevron-right": "IconCustomChevronRight",
    "custom-chevron-up": "IconCustomChevronUp",
    "custom-dumbbell": "IconCustomDumbbell",
    "custom-facebook": "IconCustomFacebook",
    "custom-flash": "IconCustomFlash",
    "custom-instagram": "IconCustomInstagram",
    "custom-photos": "IconCustomPhotos",
    "custom-play-store": "IconCustomPlayStore",
    "custom-thick-minus": "IconCustomThickMinus",
    "custom-thick-plus": "IconCustomThickPlus",
    "custom-trophy": "IconCustomTrophy",
    "joy": "IconJoy",
    "mfp-silhouette": "IconMfpSilhouette"
} as const;
        export const IMAGE_MAP = {
    "background": "SvgBackground",
    "business-app": "SvgBusinessApp",
    "business-check-ins": "SvgBusinessCheckIns",
    "business-dashboard": "SvgBusinessDashboard",
    "business-hero": "SvgBusinessHero",
    "business-planner": "SvgBusinessPlanner",
    "business-reports": "SvgBusinessReports",
    "calories-left": "SvgCaloriesLeft",
    "circles": "SvgCircles",
    "empty-clients": "SvgEmptyClients",
    "empty-invitations": "SvgEmptyInvitations",
    "empty-target": "SvgEmptyTarget",
    "foods": "SvgFoods",
    "graph": "SvgGraph",
    "phone": "SvgPhone"
} as const;
        export namespace constants {
            export const Announcement = {
    "HIDDEN_MACROS": [
        1,
        true
    ],
    "SWIPE_TO_GO_BACK": [
        2,
        false
    ],
    "MEAL_PLANS_BETA": [
        3,
        true
    ],
    "CLIENT_MEASUREMENTS": [
        4,
        true
    ],
    "COPY_MEAL_PLANS": [
        5,
        true
    ],
    "MIGRATE_FROM_MYFITNESSPAL": [
        6,
        false
    ],
    "SHOW_MIGRATE_FROM_MYFITNESS_PAL": [
        7,
        true
    ],
    "FITNESS_BETA": [
        8,
        true
    ],
    "MANAGER_FITNESS_BETA": [
        9,
        true
    ],
    "WORKOUT_TEMPLATES": [
        10,
        true
    ],
    "APPLE_HEALTH": [
        11,
        false
    ],
    "NUTRITIONAL_AI": [
        12,
        false
    ],
    "AI_COHORT": [
        13,
        true
    ],
    "MODAL_ENTRY": [
        14,
        false
    ],
    "CHALLENGE": [
        15,
        false
    ],
    "HAS_USED_MYFITNESSPAL": [
        16,
        false
    ],
    "NUTRITIONAL_VISION_INSTRUCTIONS": [
        17,
        false
    ],
    "METHOD": [
        18,
        false
    ],
    "NUTRITIONAL_AUDIO_INSTRUCTIONS": [
        19,
        false
    ],
    "FIXED_SYNC_BUTTON": [
        20,
        true
    ],
    "IAP_TRIAL": [
        21,
        false
    ],
    "ENTRY_INSTRUCTIONS": [
        22,
        false
    ],
    "SHARED_RECIPES": [
        23,
        false
    ],
    "SHOW_INSTAGRAM_PROMPT": [
        24,
        false
    ],
    "SHOW_REQUEST_TRACKING_AUTHORIZATION": [
        25,
        false
    ],
    "SHOW_RECIPE_REGISTRATION": [
        26,
        false
    ],
    "HIDE_RECIPE_REGISTRATION": [
        27,
        false
    ],
    "DEBUG_HEALTHKIT": [
        28,
        false
    ],
    "HAS_VIDEO_ACCESS": [
        29,
        false
    ],
    "DEMO_MODE": [
        30,
        false
    ],
    "PREDICTIONS": [
        31,
        false
    ],
    "HOTJAR": [
        32,
        false
    ],
    "PREDICTIONS_V2": [
        33,
        true
    ],
    "LEARNING_WEEK": [
        34,
        false
    ],
    "LEARNING_WEEK_TOUR": [
        35,
        false
    ],
    "PLAN_WAITLIST": [
        36,
        false
    ],
    "CAMERA_SEARCH_TUTORIAL": [
        37,
        false
    ],
    "NEEDS_APPLE_HEALTH_RESYNC": [
        38,
        false
    ],
    "RESYNCED_APPLE_HEALTH": [
        39,
        false
    ],
    "WALKING_CLUB": [
        40,
        false
    ]
} as const;
            export type Announcement = (typeof Announcement)[keyof typeof Announcement];
            export const ANNOUNCEMENTS = [
    "HIDDEN_MACROS",
    "SWIPE_TO_GO_BACK",
    "MEAL_PLANS_BETA",
    "CLIENT_MEASUREMENTS",
    "COPY_MEAL_PLANS",
    "MIGRATE_FROM_MYFITNESSPAL",
    "SHOW_MIGRATE_FROM_MYFITNESS_PAL",
    "FITNESS_BETA",
    "MANAGER_FITNESS_BETA",
    "WORKOUT_TEMPLATES",
    "APPLE_HEALTH",
    "NUTRITIONAL_AI",
    "AI_COHORT",
    "MODAL_ENTRY",
    "CHALLENGE",
    "HAS_USED_MYFITNESSPAL",
    "NUTRITIONAL_VISION_INSTRUCTIONS",
    "METHOD",
    "NUTRITIONAL_AUDIO_INSTRUCTIONS",
    "FIXED_SYNC_BUTTON",
    "IAP_TRIAL",
    "ENTRY_INSTRUCTIONS",
    "SHARED_RECIPES",
    "SHOW_INSTAGRAM_PROMPT",
    "SHOW_REQUEST_TRACKING_AUTHORIZATION",
    "SHOW_RECIPE_REGISTRATION",
    "HIDE_RECIPE_REGISTRATION",
    "DEBUG_HEALTHKIT",
    "HAS_VIDEO_ACCESS",
    "DEMO_MODE",
    "PREDICTIONS",
    "HOTJAR",
    "PREDICTIONS_V2",
    "LEARNING_WEEK",
    "LEARNING_WEEK_TOUR",
    "PLAN_WAITLIST",
    "CAMERA_SEARCH_TUTORIAL",
    "NEEDS_APPLE_HEALTH_RESYNC",
    "RESYNCED_APPLE_HEALTH",
    "WALKING_CLUB"
] as const;
            export const WORKOUT_ACTIVITY_TYPES = {
    "americanFootball": "American Football",
    "archery": "Archery",
    "australianFootball": "Australian Football",
    "badminton": "Badminton",
    "baseball": "Baseball",
    "basketball": "Basketball",
    "bowling": "Bowling",
    "boxing": "Boxing",
    "climbing": "Climbing",
    "cricket": "Cricket",
    "crossTraining": "Cross Training",
    "curling": "Curling",
    "cycling": "Cycling",
    "dance": "Dance",
    "danceInspiredTraining": "Dance Inspired Training",
    "elliptical": "Elliptical",
    "equestrianSports": "Equestrian Sports",
    "fencing": "Fencing",
    "fishing": "Fishing",
    "functionalStrengthTraining": "Functional Strength Training",
    "golf": "Golf",
    "gymnastics": "Gymnastics",
    "handball": "Handball",
    "hiking": "Hiking",
    "hockey": "Hockey",
    "hunting": "Hunting",
    "lacrosse": "Lacrosse",
    "martialArts": "Martial Arts",
    "mindAndBody": "Mind and Body",
    "mixedMetabolicCardioTraining": "Mixed Metabolic Cardio Training",
    "paddleSports": "Paddle Sports",
    "play": "Play",
    "preparationAndRecovery": "Preparation and Recovery",
    "racquetball": "Racquetball",
    "rowing": "Rowing",
    "rugby": "Rugby",
    "running": "Running",
    "sailing": "Sailing",
    "skatingSports": "Skating Sports",
    "snowSports": "Snow Sports",
    "soccer": "Soccer",
    "softball": "Softball",
    "squash": "Squash",
    "stairClimbing": "Stair Climbing",
    "surfingSports": "Surfing Sports",
    "swimming": "Swimming",
    "tableTennis": "Table Tennis",
    "tennis": "Tennis",
    "trackAndField": "Track and Field",
    "traditionalStrengthTraining": "Strength Training",
    "volleyball": "Volleyball",
    "walking": "Walking",
    "waterFitness": "Water Fitness",
    "waterPolo": "Water Polo",
    "waterSports": "Water Sports",
    "wrestling": "Wrestling",
    "yoga": "Yoga",
    "barre": "Barre",
    "coreTraining": "Core Training",
    "crossCountrySkiing": "Cross Country Skiing",
    "downhillSkiing": "Downhill Skiing",
    "flexibility": "Flexibility",
    "highIntensityIntervalTraining": "HIIT",
    "jumpRope": "Jump Rope",
    "kickboxing": "Kickboxing",
    "pilates": "Pilates",
    "snowboarding": "Snowboarding",
    "stairs": "Stairs",
    "stepTraining": "Step Training",
    "wheelchairWalkPace": "Wheelchair Walk Pace",
    "wheelchairRunPace": "Wheelchair Run Pace",
    "taiChi": "Tai Chi",
    "mixedCardio": "Mixed Cardio",
    "handCycling": "Hand Cycling",
    "discSports": "Disc Sports",
    "fitnessGaming": "Fitness Gaming",
    "pickleball": "Pickleball",
    "cooldown": "Cooldown",
    "swimBikeRun": "Triathlon",
    "transition": "Transition",
    "other": "Other exercise"
} as const;
            export const PEPTIDE_ALIAS_DOMAINS = [
    "freepeptidecalculator.com",
    "peptidecalc.ai",
    "researchpeptidecalculator.com",
    "mixingcalculator.com",
    "reconstitutionguide.com"
] as const;
        }
        export namespace context_processors {
            export namespace ClientManagerContext {
                export type input = Schema["models"]["core.context_processors.ClientManagerContext"]["input"];
                export type output = Schema["models"]["core.context_processors.ClientManagerContext"]["output"];
            }
            export namespace Lead {
                export type input = Schema["models"]["core.context_processors.Lead"]["input"];
                export type output = Schema["models"]["core.context_processors.Lead"]["output"];
            }
        }
        export namespace models {
            export namespace Exercise {
                export const Attribute = {
    "BELT": "Belt",
    "STRAPS": "Straps",
    "CHALK": "Chalk",
    "MIXED_GRIP": "Mixed Grip",
    "HOOK_GRIP": "Hook Grip"
} as const;
                export type Attribute = (typeof Attribute)[keyof typeof Attribute];
            }
            export namespace ExerciseSet {
                export const Type = {
    "WARM_UP": "Warm-up",
    "WORKING": "Working",
    "FAILURE": "Failure",
    "MAX": "Max",
    "AMRAP": "AMRAP",
    "RPE": "RPE",
    "REST": "Rest",
    "COOL_DOWN": "Cool-down"
} as const;
                export type Type = (typeof Type)[keyof typeof Type];
            }
            export namespace ExerciseType {
                export const CardioMetric = {
    "INCLINE": "Incline",
    "RESISTANCE": "Resistance"
} as const;
                export type CardioMetric = (typeof CardioMetric)[keyof typeof CardioMetric];
            }
            export namespace TargetLike {
                export const Mode = {
    "AT_LEAST": "At least",
    "AT_MOST": "At most",
    "EQUAL": "Around"
} as const;
                export type Mode = (typeof Mode)[keyof typeof Mode];
            }
            export namespace WorkoutProgram {
                export const Type = {
    "FIVE_THREE_ONE": "5/3/1",
    "FIVE_BY_FIVE": "5x5",
    "DUMBBELL_PROGRESSION_V1": "Dumbbell Progression v1",
    "BARBELL_PROGRESSION_V1": "Barbell Progression v1",
    "CUSTOM": "Custom"
} as const;
                export type Type = (typeof Type)[keyof typeof Type];
            }
            export namespace WorkoutSection {
                export const Type = {
    "BASIC": "Basic",
    "ROUNDS": "Rounds",
    "DURATION": "Duration"
} as const;
                export type Type = (typeof Type)[keyof typeof Type];
            }
        }
        export namespace payments {
            export type ValidateIAPInput = Schema["models"]["core.payments.ValidateIAPInput"];
            export type Subscription = Schema["models"]["core.payments.Subscription"];
            export type CreateSubscriptionInput = Schema["models"]["core.payments.CreateSubscriptionInput"];
            export type CreatePayPalSubscriptionInput = Schema["models"]["core.payments.CreatePayPalSubscriptionInput"];
            export async function validate_iap(form: Schema["rpc_validate_iap_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/validate_iap/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_validate_iap_output"]>>;
}
            export async function subscription_detail() {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/subscription_detail/", {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_subscription_detail_output"]>>;
}
            export async function create_subscription(form: Schema["rpc_create_subscription_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/create_subscription/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_create_subscription_output"]>>;
}
            export async function delete_subscription() {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/delete_subscription/", {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_delete_subscription_output"]>>;
}
            export async function create_paypal_subscription(form: Schema["rpc_create_paypal_subscription_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/create_paypal_subscription/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_create_paypal_subscription_output"]>>;
}
            export namespace create_paypal_subscription {
                export type output = Schema["rpc_create_paypal_subscription_output"];
                export type input = Schema["rpc_create_paypal_subscription_input"];
            }
            export namespace create_subscription {
                export type output = Schema["rpc_create_subscription_output"];
                export type input = Schema["rpc_create_subscription_input"];
            }
            export namespace delete_subscription {
                export type output = Schema["rpc_delete_subscription_output"];
            }
            export namespace subscription_detail {
                export type output = Schema["rpc_subscription_detail_output"];
            }
            export namespace validate_iap {
                export type output = Schema["rpc_validate_iap_output"];
                export type input = Schema["rpc_validate_iap_input"];
            }
        }
        export namespace rpc {
            export type ApplePing = Schema["models"]["core.rpc.ApplePing"];
            export type TrackEmailClick = Schema["models"]["core.rpc.TrackEmailClick"];
            export type RegisterAPNSDevice = Schema["models"]["core.rpc.RegisterAPNSDevice"];
            export type PreviewEmail = Schema["models"]["core.rpc.PreviewEmail"];
            export type MFPRegistration = Schema["models"]["core.rpc.MFPRegistration"];
            export type LearningWeekRegistration = Schema["models"]["core.rpc.LearningWeekRegistration"];
            export type PlanRegistration = Schema["models"]["core.rpc.PlanRegistration"];
            export type ValidateLoginLink = Schema["models"]["core.rpc.ValidateLoginLink"];
            export type DismissAnnouncement = Schema["models"]["core.rpc.DismissAnnouncement"];
            export type ShareAttribution = Schema["models"]["core.rpc.ShareAttribution"];
            export type UTMAttribution = Schema["models"]["core.rpc.UTMAttribution"];
            export type CreateTrackingLink = Schema["models"]["core.rpc.CreateTrackingLink"];
            export const Register = {
    "fields": {
        "email": {
            "type": "email",
            "widget": "email",
            "readOnly": false,
            "label": "Your email",
            "placeholder": "Your email",
            "required": true
        },
        "invite_code": {
            "type": "text",
            "readOnly": false,
            "label": "Type \"I am not a robot\" below",
            "required": true
        }
    },
    "defaults": {
        "email": "",
        "invite_code": ""
    },
    "iterator": [
        "email",
        "invite_code"
    ]
} as const;
            export type Register = typeof Register;
            export const Login = {
    "fields": {
        "email": {
            "type": "email",
            "widget": "email",
            "readOnly": false,
            "label": "Email",
            "required": true
        },
        "password": {
            "type": "password",
            "widget": "password",
            "readOnly": false,
            "label": "Password",
            "required": true
        }
    },
    "defaults": {
        "email": "",
        "password": ""
    },
    "iterator": [
        "email",
        "password"
    ]
} as const;
            export type Login = typeof Login;
            export const SetPassword = {
    "fields": {
        "new_password1": {
            "type": "password",
            "widget": "password",
            "readOnly": false,
            "label": "New password",
            "required": true
        },
        "new_password2": {
            "type": "password",
            "widget": "password",
            "readOnly": false,
            "label": "Confirm password",
            "required": true
        }
    },
    "defaults": {
        "new_password1": "",
        "new_password2": ""
    },
    "iterator": [
        "new_password1",
        "new_password2"
    ]
} as const;
            export type SetPassword = typeof SetPassword;
            export const ResetPassword = {
    "fields": {
        "email": {
            "type": "email",
            "widget": "email",
            "readOnly": false,
            "label": "Your email",
            "required": true
        }
    },
    "defaults": {
        "email": ""
    },
    "iterator": [
        "email"
    ]
} as const;
            export type ResetPassword = typeof ResetPassword;
            export const Contact = {
    "fields": {
        "email": {
            "type": "email",
            "readOnly": false,
            "label": "My email",
            "required": true
        },
        "message": {
            "type": "textarea",
            "widget": "textarea",
            "readOnly": false,
            "label": "Message",
            "required": true
        },
        "type": {
            "type": "select",
            "readOnly": false,
            "label": "Type",
            "options": [
                [
                    "SUPPORT",
                    "Support"
                ],
                [
                    "MANAGER",
                    "Manager"
                ],
                [
                    "FEEDBACK",
                    "Feedback"
                ]
            ],
            "required": true
        }
    },
    "defaults": {
        "email": "",
        "message": "",
        "type": "SUPPORT"
    },
    "iterator": [
        "email",
        "message",
        "type"
    ]
} as const;
            export type Contact = typeof Contact;
            export const UpdateProfile = {
    "fields": {
        "email": {
            "type": "email",
            "widget": "email",
            "readOnly": true,
            "label": "Your email and username",
            "required": true
        },
        "name": {
            "type": "text",
            "readOnly": false,
            "label": "What should we call you?",
            "required": true
        },
        "date_of_birth": {
            "type": "date",
            "widget": "date",
            "readOnly": false,
            "label": "Date of birth",
            "required": true
        },
        "is_imperial": {
            "type": "select",
            "widget": "select",
            "readOnly": false,
            "label": "Use imperial or metric units",
            "options": [
                [
                    true,
                    "Imperial"
                ],
                [
                    false,
                    "Metric"
                ]
            ],
            "required": true
        },
        "use_kilojoules": {
            "type": "select",
            "widget": "select",
            "readOnly": false,
            "label": "Use calories or kilojoules",
            "options": [
                [
                    false,
                    "Calories"
                ],
                [
                    true,
                    "Kilojoules"
                ]
            ],
            "required": true
        },
        "weight": {
            "type": "weight",
            "widget": "weight",
            "readOnly": false,
            "label": "Starting weight",
            "required": true
        },
        "height": {
            "type": "length",
            "widget": "length",
            "readOnly": false,
            "label": "Height",
            "required": true
        },
        "waist": {
            "type": "length",
            "widget": "length",
            "readOnly": false,
            "label": "Starting waist size",
            "required": true
        },
        "gender": {
            "type": "select",
            "widget": "select",
            "readOnly": false,
            "label": "Gender",
            "options": [
                [
                    "",
                    "-----"
                ],
                [
                    "m",
                    "Male"
                ],
                [
                    "f",
                    "Female"
                ],
                [
                    "o",
                    "Other"
                ],
                [
                    "r",
                    "Rather not say"
                ]
            ],
            "required": true
        },
        "body_fat": {
            "type": "percent",
            "widget": "percent",
            "readOnly": false,
            "label": "Starting body fat",
            "required": true
        },
        "activity": {
            "type": "select",
            "widget": "select",
            "readOnly": false,
            "label": "How active are you?",
            "options": [
                [
                    "",
                    "-----"
                ],
                [
                    "1.2",
                    "Sedentary"
                ],
                [
                    "1.375",
                    "Lightly active"
                ],
                [
                    "1.55",
                    "Moderately active"
                ],
                [
                    "1.725",
                    "Very active"
                ],
                [
                    "1.9",
                    "Extremely active"
                ]
            ],
            "required": true
        },
        "goal": {
            "type": "text",
            "readOnly": false,
            "label": "What's your goal?",
            "required": true
        }
    },
    "defaults": {
        "email": null,
        "name": "",
        "date_of_birth": null,
        "is_imperial": true,
        "use_kilojoules": false,
        "weight": null,
        "height": null,
        "waist": null,
        "gender": "",
        "body_fat": null,
        "activity": "",
        "goal": ""
    },
    "iterator": [
        "email",
        "name",
        "date_of_birth",
        "is_imperial",
        "use_kilojoules",
        "weight",
        "height",
        "waist",
        "gender",
        "body_fat",
        "activity",
        "goal"
    ]
} as const;
            export type UpdateProfile = typeof UpdateProfile;
            export const InviteUser = {
    "fields": {
        "email": {
            "type": "email",
            "readOnly": false,
            "label": "Email",
            "required": true
        }
    },
    "defaults": {
        "email": ""
    },
    "iterator": [
        "email"
    ]
} as const;
            export type InviteUser = typeof InviteUser;
            export async function profile_detail() {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/profile_detail/", {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_profile_detail_output"]>>;
}
            export async function register(form: Schema["rpc_register_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/register/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_register_output"]>>;
}
            export async function check_email(form: Schema["rpc_check_email_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/check_email/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_check_email_output"]>>;
}
            export async function login(form: Schema["rpc_login_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/login/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_login_output"]>>;
}
            export async function set_password(form: Schema["rpc_set_password_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/set_password/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_set_password_output"]>>;
}
            export async function update_settings(form: Schema["rpc_update_settings_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/update_settings/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_update_settings_output"]>>;
}
            export async function apple_ping(form: Schema["rpc_apple_ping_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/apple_ping/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_apple_ping_output"]>>;
}
            export async function track_email_click(form: Schema["rpc_track_email_click_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/track_email_click/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_track_email_click_output"]>>;
}
            export async function register_apns_device(form: Schema["rpc_register_apns_device_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/register_apns_device/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_register_apns_device_output"]>>;
}
            export async function preview_email(form: Schema["rpc_preview_email_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/preview_email/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_preview_email_output"]>>;
}
            export async function link_analytics({form}: {form: string}) {
    const {rpc} = await import("@reactivated");
    return rpc.requester(`/rpc/link_analytics/${form}/`, {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_link_analytics_output"]>>;
}
            export async function postmark_webhook(form: Schema["rpc_postmark_webhook_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/postmark_webhook/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_postmark_webhook_output"]>>;
}
            export async function mfp_registration(form: Schema["rpc_mfp_registration_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/mfp_registration/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_mfp_registration_output"]>>;
}
            export async function learning_week_registration(form: Schema["rpc_learning_week_registration_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/learning_week_registration/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_learning_week_registration_output"]>>;
}
            export async function plan_registration(form: Schema["rpc_plan_registration_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/plan_registration/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_plan_registration_output"]>>;
}
            export async function create_user_media_image(form: Schema["rpc_create_user_media_image_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/create_user_media_image/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_create_user_media_image_output"]>>;
}
            export async function request_login_link(form: Schema["rpc_request_login_link_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/request_login_link/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_request_login_link_output"]>>;
}
            export async function validate_login_link(form: Schema["rpc_validate_login_link_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/validate_login_link/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_validate_login_link_output"]>>;
}
            export async function logout() {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/logout/", {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_logout_output"]>>;
}
            export async function reset_password(form: Schema["rpc_reset_password_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/reset_password/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_reset_password_output"]>>;
}
            export async function contact(form: Schema["rpc_contact_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/contact/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_contact_output"]>>;
}
            export async function dismiss_announcement(form: Schema["rpc_dismiss_announcement_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/dismiss_announcement/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_dismiss_announcement_output"]>>;
}
            export async function update_profile(form: Schema["rpc_update_profile_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/update_profile/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_update_profile_output"]>>;
}
            export async function delete_profile() {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/delete_profile/", {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_delete_profile_output"]>>;
}
            export async function get_client_dashboard_link() {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/get_client_dashboard_link/", {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_get_client_dashboard_link_output"]>>;
}
            export async function invite_user(form: Schema["rpc_invite_user_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/invite_user/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_invite_user_output"]>>;
}
            export async function attribute_share(form: Schema["rpc_attribute_share_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/attribute_share/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_attribute_share_output"]>>;
}
            export async function attribute_utm(form: Schema["rpc_attribute_utm_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/attribute_utm/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_attribute_utm_output"]>>;
}
            export async function create_tracking_link(form: Schema["rpc_create_tracking_link_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/create_tracking_link/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_create_tracking_link_output"]>>;
}
            export namespace CreateUserMedia {
                export type input = Schema["models"]["core.rpc.CreateUserMedia.input"];
                export type output = Schema["models"]["core.rpc.CreateUserMedia.output"];
            }
            export namespace Profile {
                export type input = Schema["models"]["core.rpc.Profile"]["input"];
                export type output = Schema["models"]["core.rpc.Profile"]["output"];
            }
            export namespace ProfileUpdatePick {
                export type input = Schema["models"]["core.rpc.ProfileUpdatePick"]["input"];
                export type output = Schema["models"]["core.rpc.ProfileUpdatePick"]["output"];
            }
            export namespace apple_ping {
                export type output = Schema["rpc_apple_ping_output"];
                export type input = Schema["rpc_apple_ping_input"];
            }
            export namespace attribute_share {
                export type output = Schema["rpc_attribute_share_output"];
                export type input = Schema["rpc_attribute_share_input"];
            }
            export namespace attribute_utm {
                export type output = Schema["rpc_attribute_utm_output"];
                export type input = Schema["rpc_attribute_utm_input"];
            }
            export namespace check_email {
                export type output = Schema["rpc_check_email_output"];
                export type input = Schema["rpc_check_email_input"];
            }
            export namespace contact {
                export type output = Schema["rpc_contact_output"];
                export type input = Schema["rpc_contact_input"];
            }
            export namespace create_tracking_link {
                export type output = Schema["rpc_create_tracking_link_output"];
                export type input = Schema["rpc_create_tracking_link_input"];
            }
            export namespace create_user_media_image {
                export type output = Schema["rpc_create_user_media_image_output"];
                export type input = Schema["rpc_create_user_media_image_input"];
            }
            export namespace delete_profile {
                export type output = Schema["rpc_delete_profile_output"];
            }
            export namespace dismiss_announcement {
                export type output = Schema["rpc_dismiss_announcement_output"];
                export type input = Schema["rpc_dismiss_announcement_input"];
            }
            export namespace get_client_dashboard_link {
                export type output = Schema["rpc_get_client_dashboard_link_output"];
            }
            export namespace invite_user {
                export type output = Schema["rpc_invite_user_output"];
                export type input = Schema["rpc_invite_user_input"];
            }
            export namespace learning_week_registration {
                export type output = Schema["rpc_learning_week_registration_output"];
                export type input = Schema["rpc_learning_week_registration_input"];
            }
            export namespace link_analytics {
                export type output = Schema["rpc_link_analytics_output"];
            }
            export namespace login {
                export type output = Schema["rpc_login_output"];
                export type input = Schema["rpc_login_input"];
            }
            export namespace logout {
                export type output = Schema["rpc_logout_output"];
            }
            export namespace mfp_registration {
                export type output = Schema["rpc_mfp_registration_output"];
                export type input = Schema["rpc_mfp_registration_input"];
            }
            export namespace plan_registration {
                export type output = Schema["rpc_plan_registration_output"];
                export type input = Schema["rpc_plan_registration_input"];
            }
            export namespace postmark_webhook {
                export type output = Schema["rpc_postmark_webhook_output"];
                export type input = Schema["rpc_postmark_webhook_input"];
            }
            export namespace preview_email {
                export type output = Schema["rpc_preview_email_output"];
                export type input = Schema["rpc_preview_email_input"];
            }
            export namespace profile_detail {
                export type output = Schema["rpc_profile_detail_output"];
            }
            export namespace register {
                export type output = Schema["rpc_register_output"];
                export type input = Schema["rpc_register_input"];
            }
            export namespace register_apns_device {
                export type output = Schema["rpc_register_apns_device_output"];
                export type input = Schema["rpc_register_apns_device_input"];
            }
            export namespace request_login_link {
                export type output = Schema["rpc_request_login_link_output"];
                export type input = Schema["rpc_request_login_link_input"];
            }
            export namespace reset_password {
                export type output = Schema["rpc_reset_password_output"];
                export type input = Schema["rpc_reset_password_input"];
            }
            export namespace set_password {
                export type output = Schema["rpc_set_password_output"];
                export type input = Schema["rpc_set_password_input"];
            }
            export namespace track_email_click {
                export type output = Schema["rpc_track_email_click_output"];
                export type input = Schema["rpc_track_email_click_input"];
            }
            export namespace update_profile {
                export type output = Schema["rpc_update_profile_output"];
                export type input = Schema["rpc_update_profile_input"];
            }
            export namespace update_settings {
                export type output = Schema["rpc_update_settings_output"];
                export type input = Schema["rpc_update_settings_input"];
            }
            export namespace validate_login_link {
                export type output = Schema["rpc_validate_login_link_output"];
                export type input = Schema["rpc_validate_login_link_input"];
            }
        }
        export namespace templates {
            export type HomePage = Schema["template_HomePage"];
            export type BusinessPage = Schema["template_BusinessPage"];
            export type DemoSetup = Schema["template_DemoSetup"];
            export type LeadCandidateUpload = Schema["template_LeadCandidateUpload"];
            export type LeadUpload = Schema["template_LeadUpload"];
            export type LeadImport = Schema["template_LeadImport"];
            export type NotFound = Schema["template_NotFound"];
            export type TermsOfService = Schema["template_TermsOfService"];
            export type PrivacyPolicy = Schema["template_PrivacyPolicy"];
            export namespace LeadCandidate_413c3245a6 {
                export type input = Schema["models"]["core.templates.LeadCandidate_413c3245a6"]["input"];
                export type output = Schema["models"]["core.templates.LeadCandidate_413c3245a6"]["output"];
            }
        }
        export namespace types {
            export type AppleHealthWorkoutData = Schema["models"]["core.types.AppleHealthWorkoutData"];
        }
    }
    export namespace finance {
        export namespace rpc {
            export async function instacart_recipe(form: Schema["rpc_instacart_recipe_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/instacart_recipe/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_instacart_recipe_output"]>>;
}
            export namespace instacart_recipe {
                export type output = Schema["rpc_instacart_recipe_output"];
                export type input = Schema["rpc_instacart_recipe_input"];
            }
        }
    }
    export namespace forms {
        export type CharField = Schema["models"]["forms.CharField"];
        export type DecimalField = Schema["models"]["forms.DecimalField"];
        export type Form = Schema["models"]["forms.Form"];
    }
    export namespace journal {
        export namespace clubs {
            export type BoardForm = Schema["models"]["journal.clubs.BoardForm"];
            export type WalkingClubBoard = Schema["models"]["journal.clubs.WalkingClubBoard"];
            export type DemoForm = Schema["models"]["journal.clubs.DemoForm"];
            export type InfoForm = Schema["models"]["journal.clubs.InfoForm"];
            export type WalkingClubInfo = Schema["models"]["journal.clubs.WalkingClubInfo"];
            export type LoginLink = Schema["models"]["journal.clubs.LoginLink"];
            export type JoinForm = Schema["models"]["journal.clubs.JoinForm"];
            export type WalkingClubRegistration = Schema["models"]["journal.clubs.WalkingClubRegistration"];
            export async function walking_club_board(form: Schema["rpc_walking_club_board_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/walking_club_board/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_walking_club_board_output"]>>;
}
            export async function walking_club_demo_allowed(form: Schema["rpc_walking_club_demo_allowed_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/walking_club_demo_allowed/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_walking_club_demo_allowed_output"]>>;
}
            export async function walking_club_info(form: Schema["rpc_walking_club_info_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/walking_club_info/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_walking_club_info_output"]>>;
}
            export async function walking_club_login_link(form: Schema["rpc_walking_club_login_link_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/walking_club_login_link/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_walking_club_login_link_output"]>>;
}
            export async function walking_club_join(form: Schema["rpc_walking_club_join_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/walking_club_join/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_walking_club_join_output"]>>;
}
            export async function walking_club_registration(form: Schema["rpc_walking_club_registration_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/walking_club_registration/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_walking_club_registration_output"]>>;
}
            export namespace WalkingClubMemberStatus {
                export type input = Schema["models"]["journal.clubs.WalkingClubMemberStatus"]["input"];
                export type output = Schema["models"]["journal.clubs.WalkingClubMemberStatus"]["output"];
            }
            export namespace walking_club_board {
                export type output = Schema["rpc_walking_club_board_output"];
                export type input = Schema["rpc_walking_club_board_input"];
            }
            export namespace walking_club_demo_allowed {
                export type output = Schema["rpc_walking_club_demo_allowed_output"];
                export type input = Schema["rpc_walking_club_demo_allowed_input"];
            }
            export namespace walking_club_info {
                export type output = Schema["rpc_walking_club_info_output"];
                export type input = Schema["rpc_walking_club_info_input"];
            }
            export namespace walking_club_join {
                export type output = Schema["rpc_walking_club_join_output"];
                export type input = Schema["rpc_walking_club_join_input"];
            }
            export namespace walking_club_login_link {
                export type output = Schema["rpc_walking_club_login_link_output"];
                export type input = Schema["rpc_walking_club_login_link_input"];
            }
            export namespace walking_club_registration {
                export type output = Schema["rpc_walking_club_registration_output"];
                export type input = Schema["rpc_walking_club_registration_input"];
            }
        }
        export namespace day {
            export type Save = Schema["models"]["journal.day.Save"];
            export type UpdateMetricAggregates = Schema["models"]["journal.day.UpdateMetricAggregates"];
            export type JournalForm = Schema["models"]["journal.day.JournalForm"];
            export type Onboarding = Schema["models"]["journal.day.Onboarding"];
            export type Method = Schema["models"]["journal.day.Method"];
            export type ShopifyOrderCreated = Schema["models"]["journal.day.ShopifyOrderCreated"];
            export type MoveDay = Schema["models"]["journal.day.MoveDay"];
            export type CopyDay = Schema["models"]["journal.day.CopyDay"];
            export type AcceptMealPlan = Schema["models"]["journal.day.AcceptMealPlan"];
            export type RejectMealPlan = Schema["models"]["journal.day.RejectMealPlan"];
            export type CheckInInput = Schema["models"]["journal.day.CheckInInput"];
            export type PlannerInput = Schema["models"]["journal.day.PlannerInput"];
            export const MeasurementForm = {
    "fields": {
        "weight": {
            "type": "weight",
            "widget": "weight",
            "readOnly": false,
            "label": "Weight"
        },
        "waist": {
            "type": "length",
            "widget": "length",
            "readOnly": false,
            "label": "Waist"
        },
        "navel": {
            "type": "length",
            "widget": "length",
            "readOnly": false,
            "label": "Navel"
        },
        "body_fat": {
            "type": "percent",
            "widget": "percent",
            "readOnly": false,
            "label": "Body fat"
        },
        "hips": {
            "type": "length",
            "widget": "length",
            "readOnly": false,
            "label": "Hips"
        },
        "neck": {
            "type": "length",
            "widget": "length",
            "readOnly": false,
            "label": "Neck"
        },
        "thigh": {
            "type": "length",
            "widget": "length",
            "readOnly": false,
            "label": "Thigh"
        },
        "bicep": {
            "type": "length",
            "widget": "length",
            "readOnly": false,
            "label": "Bicep"
        },
        "chest": {
            "type": "length",
            "widget": "length",
            "readOnly": false,
            "label": "Chest"
        }
    },
    "defaults": {
        "weight": null,
        "waist": null,
        "navel": null,
        "body_fat": null,
        "hips": null,
        "neck": null,
        "thigh": null,
        "bicep": null,
        "chest": null
    },
    "iterator": [
        "weight",
        "waist",
        "navel",
        "body_fat",
        "hips",
        "neck",
        "thigh",
        "bicep",
        "chest"
    ]
} as const;
            export type MeasurementForm = typeof MeasurementForm;
            export const TargetInput = {
    "fields": {
        "name": {
            "type": "text",
            "readOnly": false,
            "label": "Name",
            "placeholder": "Ex: Workout day",
            "required": true
        },
        "calories_target": {
            "type": "energy",
            "widget": "energy",
            "readOnly": false,
            "label": "Calories"
        },
        "protein_target": {
            "type": "decimal",
            "readOnly": false,
            "label": "Protein"
        },
        "fat_target": {
            "type": "decimal",
            "readOnly": false,
            "label": "Fat"
        },
        "carbs_target": {
            "type": "decimal",
            "readOnly": false,
            "label": "Carbs"
        },
        "net_carbs_target": {
            "type": "decimal",
            "readOnly": false,
            "label": "Net carbs"
        }
    },
    "defaults": {
        "name": "",
        "calories_target": null,
        "protein_target": null,
        "fat_target": null,
        "carbs_target": null,
        "net_carbs_target": null
    },
    "iterator": [
        "name",
        "calories_target",
        "protein_target",
        "fat_target",
        "carbs_target",
        "net_carbs_target"
    ]
} as const;
            export type TargetInput = typeof TargetInput;
            export async function save(form: Schema["rpc_save_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/save/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_save_output"]>>;
}
            export async function update_metrics(form: Schema["rpc_update_metrics_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/update_metrics/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_update_metrics_output"]>>;
}
            export async function update_metric_aggregates(form: Schema["rpc_update_metric_aggregates_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/update_metric_aggregates/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_update_metric_aggregates_output"]>>;
}
            export async function journal(form: Schema["rpc_journal_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/journal/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_journal_output"]>>;
}
            export async function update_measurements(form: Schema["rpc_update_measurements_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/update_measurements/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_update_measurements_output"]>>;
}
            export async function update_day({user_id, key}: {user_id: number; key: string}, form: Schema["rpc_update_day_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester(`/rpc/update_day/${user_id}/${key}/`, form, "POST") as unknown as Promise<RPCResult<Schema["rpc_update_day_output"]>>;
}
            export async function legacy_update_day(form: Schema["rpc_legacy_update_day_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/legacy_update_day/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_legacy_update_day_output"]>>;
}
            export async function delete_journal_workout(form: Schema["rpc_delete_journal_workout_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/delete_journal_workout/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_delete_journal_workout_output"]>>;
}
            export async function fast_init(form: Schema["rpc_fast_init_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/fast_init/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_fast_init_output"]>>;
}
            export async function planner(form: Schema["rpc_planner_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/planner/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_planner_output"]>>;
}
            export async function consumer_planner(form: Schema["rpc_consumer_planner_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/consumer_planner/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_consumer_planner_output"]>>;
}
            export async function start(form: Schema["rpc_start_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/start/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_start_output"]>>;
}
            export async function onboarding(form: Schema["rpc_onboarding_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/onboarding/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_onboarding_output"]>>;
}
            export async function method(form: Schema["rpc_method_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/method/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_method_output"]>>;
}
            export async function reset_challenge() {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/reset_challenge/", {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_reset_challenge_output"]>>;
}
            export async function shopify_order_created(form: Schema["rpc_shopify_order_created_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/shopify_order_created/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_shopify_order_created_output"]>>;
}
            export async function replace_entry(form: Schema["rpc_replace_entry_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/replace_entry/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_replace_entry_output"]>>;
}
            export async function verify_purchase_entitlement({form}: {form: string}) {
    const {rpc} = await import("@reactivated");
    return rpc.requester(`/rpc/verify_purchase_entitlement/${form}/`, {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_verify_purchase_entitlement_output"]>>;
}
            export async function move_day(form: Schema["rpc_move_day_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/move_day/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_move_day_output"]>>;
}
            export async function copy_day(form: Schema["rpc_copy_day_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/copy_day/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_copy_day_output"]>>;
}
            export async function accept_meal_plan(form: Schema["rpc_accept_meal_plan_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/accept_meal_plan/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_accept_meal_plan_output"]>>;
}
            export async function reject_meal_plan(form: Schema["rpc_reject_meal_plan_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/reject_meal_plan/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_reject_meal_plan_output"]>>;
}
            export async function check_in(form: Schema["rpc_check_in_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/check_in/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_check_in_output"]>>;
}
            export async function target_planner(form: Schema["rpc_target_planner_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/target_planner/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_target_planner_output"]>>;
}
            export namespace Assignment {
                export type input = Schema["models"]["journal.day.Assignment"]["input"];
                export type output = Schema["models"]["journal.day.Assignment"]["output"];
            }
            export namespace CheckIn {
                export type input = Schema["models"]["journal.day.CheckIn"]["input"];
                export type output = Schema["models"]["journal.day.CheckIn"]["output"];
            }
            export namespace CheckInResponse {
                export type input = Schema["models"]["journal.day.CheckInResponse"]["input"];
                export type output = Schema["models"]["journal.day.CheckInResponse"]["output"];
            }
            export namespace ConsumerPlanner {
                export type input = Schema["models"]["journal.day.ConsumerPlanner"]["input"];
                export type output = Schema["models"]["journal.day.ConsumerPlanner"]["output"];
            }
            export namespace ConsumerProfile {
                export type input = Schema["models"]["journal.day.ConsumerProfile"]["input"];
                export type output = Schema["models"]["journal.day.ConsumerProfile"]["output"];
            }
            export namespace ConsumerTarget {
                export type input = Schema["models"]["journal.day.ConsumerTarget"]["input"];
                export type output = Schema["models"]["journal.day.ConsumerTarget"]["output"];
            }
            export namespace DayUpdate {
                export type input = Schema["models"]["journal.day.DayUpdate"]["input"];
                export type output = Schema["models"]["journal.day.DayUpdate"]["output"];
            }
            export namespace ExistingCheckIn {
                export type input = Schema["models"]["journal.day.ExistingCheckIn"]["input"];
                export type output = Schema["models"]["journal.day.ExistingCheckIn"]["output"];
            }
            export namespace FastInit {
                export type input = Schema["models"]["journal.day.FastInit.input"];
            }
            export namespace Journal {
                export type input = Schema["models"]["journal.day.Journal"]["input"];
                export type output = Schema["models"]["journal.day.Journal"]["output"];
            }
            export namespace LegacyDayUpdate {
                export type input = Schema["models"]["journal.day.LegacyDayUpdate"]["input"];
                export type output = Schema["models"]["journal.day.LegacyDayUpdate"]["output"];
            }
            export namespace LegacyUpdateDay {
                export type input = Schema["models"]["journal.day.LegacyUpdateDay"]["input"];
                export type output = Schema["models"]["journal.day.LegacyUpdateDay"]["output"];
            }
            export namespace Measurement {
                export type input = Schema["models"]["journal.day.Measurement"]["input"];
                export type output = Schema["models"]["journal.day.Measurement"]["output"];
            }
            export namespace Metric {
                export type input = Schema["models"]["journal.day.Metric"]["input"];
                export type output = Schema["models"]["journal.day.Metric"]["output"];
            }
            export namespace MetricAggregate {
                export type input = Schema["models"]["journal.day.MetricAggregate"]["input"];
                export type output = Schema["models"]["journal.day.MetricAggregate"]["output"];
            }
            export namespace Planner {
                export type input = Schema["models"]["journal.day.Planner"]["input"];
                export type output = Schema["models"]["journal.day.Planner"]["output"];
            }
            export namespace PurchaseVerification {
                export type input = Schema["models"]["journal.day.PurchaseVerification"]["input"];
                export type output = Schema["models"]["journal.day.PurchaseVerification"]["output"];
            }
            export namespace WorkoutAggregate {
                export type input = Schema["models"]["journal.day.WorkoutAggregate"]["input"];
                export type output = Schema["models"]["journal.day.WorkoutAggregate"]["output"];
            }
            export namespace accept_meal_plan {
                export type output = Schema["rpc_accept_meal_plan_output"];
                export type input = Schema["rpc_accept_meal_plan_input"];
            }
            export namespace check_in {
                export type output = Schema["rpc_check_in_output"];
                export type input = Schema["rpc_check_in_input"];
            }
            export namespace consumer_planner {
                export type output = Schema["rpc_consumer_planner_output"];
                export type input = Schema["rpc_consumer_planner_input"];
            }
            export namespace copy_day {
                export type output = Schema["rpc_copy_day_output"];
                export type input = Schema["rpc_copy_day_input"];
            }
            export namespace delete_journal_workout {
                export type output = Schema["rpc_delete_journal_workout_output"];
                export type input = Schema["rpc_delete_journal_workout_input"];
            }
            export namespace fast_init {
                export type output = Schema["rpc_fast_init_output"];
                export type input = Schema["rpc_fast_init_input"];
            }
            export namespace journal {
                export type output = Schema["rpc_journal_output"];
                export type input = Schema["rpc_journal_input"];
            }
            export namespace legacy_update_day {
                export type output = Schema["rpc_legacy_update_day_output"];
                export type input = Schema["rpc_legacy_update_day_input"];
            }
            export namespace method {
                export type output = Schema["rpc_method_output"];
                export type input = Schema["rpc_method_input"];
            }
            export namespace move_day {
                export type output = Schema["rpc_move_day_output"];
                export type input = Schema["rpc_move_day_input"];
            }
            export namespace onboarding {
                export type output = Schema["rpc_onboarding_output"];
                export type input = Schema["rpc_onboarding_input"];
            }
            export namespace planner {
                export type output = Schema["rpc_planner_output"];
                export type input = Schema["rpc_planner_input"];
            }
            export namespace reject_meal_plan {
                export type output = Schema["rpc_reject_meal_plan_output"];
                export type input = Schema["rpc_reject_meal_plan_input"];
            }
            export namespace replace_entry {
                export type output = Schema["rpc_replace_entry_output"];
                export type input = Schema["rpc_replace_entry_input"];
            }
            export namespace reset_challenge {
                export type output = Schema["rpc_reset_challenge_output"];
            }
            export namespace save {
                export type output = Schema["rpc_save_output"];
                export type input = Schema["rpc_save_input"];
            }
            export namespace shopify_order_created {
                export type output = Schema["rpc_shopify_order_created_output"];
                export type input = Schema["rpc_shopify_order_created_input"];
            }
            export namespace start {
                export type output = Schema["rpc_start_output"];
                export type input = Schema["rpc_start_input"];
            }
            export namespace target_planner {
                export type output = Schema["rpc_target_planner_output"];
                export type input = Schema["rpc_target_planner_input"];
            }
            export namespace update_day {
                export type output = Schema["rpc_update_day_output"];
                export type input = Schema["rpc_update_day_input"];
            }
            export namespace update_measurements {
                export type output = Schema["rpc_update_measurements_output"];
                export type input = Schema["rpc_update_measurements_input"];
            }
            export namespace update_metric_aggregates {
                export type output = Schema["rpc_update_metric_aggregates_output"];
                export type input = Schema["rpc_update_metric_aggregates_input"];
            }
            export namespace update_metrics {
                export type output = Schema["rpc_update_metrics_output"];
                export type input = Schema["rpc_update_metrics_input"];
            }
            export namespace verify_purchase_entitlement {
                export type output = Schema["rpc_verify_purchase_entitlement_output"];
            }
        }
        export namespace learning_week {
            export type LearningWeekData = Schema["models"]["journal.learning_week.LearningWeekData"];
            export namespace LearningWeekDayStatus {
                export type input = Schema["models"]["journal.learning_week.LearningWeekDayStatus"]["input"];
                export type output = Schema["models"]["journal.learning_week.LearningWeekDayStatus"]["output"];
            }
            export namespace LearningWeekMemberStatus {
                export type input = Schema["models"]["journal.learning_week.LearningWeekMemberStatus"]["input"];
                export type output = Schema["models"]["journal.learning_week.LearningWeekMemberStatus"]["output"];
            }
        }
        export namespace mfp {
            export const MFPAccountForm = {
    "fields": {
        "email": {
            "type": "text",
            "readOnly": false,
            "label": "MyFitnessPal email",
            "required": true
        },
        "password": {
            "type": "password",
            "widget": "password",
            "readOnly": false,
            "label": "Password",
            "required": true
        }
    },
    "defaults": {
        "email": "",
        "password": ""
    },
    "iterator": [
        "email",
        "password"
    ]
} as const;
            export type MFPAccountForm = typeof MFPAccountForm;
            export async function mfp_migration_detail() {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/mfp_migration_detail/", {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_mfp_migration_detail_output"]>>;
}
            export async function create_mfp_account(form: Schema["rpc_create_mfp_account_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/create_mfp_account/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_create_mfp_account_output"]>>;
}
            export namespace MFPMigration {
                export type input = Schema["models"]["journal.mfp.MFPMigration"]["input"];
                export type output = Schema["models"]["journal.mfp.MFPMigration"]["output"];
            }
            export namespace create_mfp_account {
                export type output = Schema["rpc_create_mfp_account_output"];
                export type input = Schema["rpc_create_mfp_account_input"];
            }
            export namespace mfp_migration_detail {
                export type output = Schema["rpc_mfp_migration_detail_output"];
            }
        }
        export namespace nutrition {
            export type UpdateCupboard = Schema["models"]["journal.nutrition.UpdateCupboard"];
            export type UpdateRecipe = Schema["models"]["journal.nutrition.UpdateRecipe"];
            export type PublishNutritionalVisionPrompt = Schema["models"]["journal.nutrition.PublishNutritionalVisionPrompt"];
            export type PublishDay = Schema["models"]["journal.nutrition.PublishDay"];
            export type ShareForm = Schema["models"]["journal.nutrition.ShareForm"];
            export type ShareRecipe = Schema["models"]["journal.nutrition.ShareRecipe"];
            export type ListFoods = Schema["models"]["journal.nutrition.ListFoods"];
            export type CreateFoodResponse = Schema["models"]["journal.nutrition.CreateFoodResponse"];
            export type UpdateFood = Schema["models"]["journal.nutrition.UpdateFood"];
            export type DeleteFood = Schema["models"]["journal.nutrition.DeleteFood"];
            export type ListRecipes = Schema["models"]["journal.nutrition.ListRecipes"];
            export type UpdateRecipeMetadata = Schema["models"]["journal.nutrition.UpdateRecipeMetadata"];
            export type DeleteRecipe = Schema["models"]["journal.nutrition.DeleteRecipe"];
            export type CopyRecipe = Schema["models"]["journal.nutrition.CopyRecipe"];
            export type PublishMeal = Schema["models"]["journal.nutrition.PublishMeal"];
            export type DeleteMeal = Schema["models"]["journal.nutrition.DeleteMeal"];
            export type MoveMeal = Schema["models"]["journal.nutrition.MoveMeal"];
            export type CopyMeal = Schema["models"]["journal.nutrition.CopyMeal"];
            export type PublishEntry = Schema["models"]["journal.nutrition.PublishEntry"];
            export type ExpandEntry = Schema["models"]["journal.nutrition.ExpandEntry"];
            export type SearchResult = Schema["models"]["journal.nutrition.SearchResult"];
            export type Backend = Schema["models"]["journal.nutrition.Backend"];
            export type PredictionsData = Schema["models"]["journal.nutrition.PredictionsData"];
            export type Search = Schema["models"]["journal.nutrition.Search"];
            export type RecipeShare = Schema["models"]["journal.nutrition.RecipeShare"];
            export const CalculatorProfileForm = {
    "fields": {
        "name": {
            "type": "text",
            "readOnly": false,
            "label": "Name"
        },
        "diet": {
            "type": "select",
            "widget": "select",
            "readOnly": false,
            "label": "Diet",
            "options": [
                [
                    "GENERAL",
                    "General"
                ],
                [
                    "LEANGAINS",
                    "Leangains"
                ],
                [
                    "KETO",
                    "Keto"
                ]
            ],
            "required": true
        },
        "is_imperial": {
            "type": "select",
            "widget": "select",
            "readOnly": false,
            "label": "Is imperial",
            "options": [
                [
                    true,
                    "Imperial"
                ],
                [
                    false,
                    "Metric"
                ]
            ],
            "required": true
        },
        "date_of_birth": {
            "type": "date",
            "readOnly": false,
            "label": "Date of birth"
        },
        "weight": {
            "type": "weight",
            "widget": "weight",
            "readOnly": false,
            "label": "Weight"
        },
        "height": {
            "type": "length",
            "widget": "length",
            "readOnly": false,
            "label": "Height"
        },
        "gender": {
            "type": "select",
            "widget": "select",
            "readOnly": false,
            "label": "Gender",
            "options": [
                [
                    "",
                    "-----"
                ],
                [
                    "m",
                    "Male"
                ],
                [
                    "f",
                    "Female"
                ],
                [
                    "o",
                    "Other"
                ],
                [
                    "r",
                    "Rather not say"
                ]
            ],
            "required": true
        },
        "activity": {
            "type": "select",
            "widget": "select",
            "readOnly": false,
            "label": "How active are you?",
            "options": [
                [
                    "",
                    "-----"
                ],
                [
                    "1.2",
                    "Sedentary"
                ],
                [
                    "1.375",
                    "Lightly active"
                ],
                [
                    "1.55",
                    "Moderately active"
                ],
                [
                    "1.725",
                    "Very active"
                ],
                [
                    "1.9",
                    "Extremely active"
                ]
            ],
            "required": true
        },
        "body_fat": {
            "type": "percent",
            "widget": "percent",
            "readOnly": false,
            "label": "Body fat"
        }
    },
    "defaults": {
        "name": "",
        "diet": "GENERAL",
        "is_imperial": true,
        "date_of_birth": null,
        "weight": null,
        "height": null,
        "gender": "",
        "activity": "",
        "body_fat": null
    },
    "iterator": [
        "name",
        "diet",
        "is_imperial",
        "date_of_birth",
        "weight",
        "height",
        "gender",
        "activity",
        "body_fat"
    ]
} as const;
            export type CalculatorProfileForm = typeof CalculatorProfileForm;
            export const GeneralCalculatorForm = {
    "fields": {
        "variance": {
            "type": "decimal",
            "readOnly": false,
            "label": "Calorie surplus or deficit",
            "required": true
        },
        "protein_multiplier": {
            "type": "multiplier",
            "widget": "multiplier",
            "readOnly": false,
            "label": "Protein multiplier",
            "required": true
        },
        "fat_carbs": {
            "type": "range",
            "widget": "range",
            "readOnly": false,
            "label": "Dietary fat target",
            "required": true
        }
    },
    "defaults": {
        "variance": null,
        "protein_multiplier": null,
        "fat_carbs": null
    },
    "iterator": [
        "variance",
        "protein_multiplier",
        "fat_carbs"
    ]
} as const;
            export type GeneralCalculatorForm = typeof GeneralCalculatorForm;
            export const KetoCalculatorForm = {
    "fields": {
        "variance": {
            "type": "decimal",
            "readOnly": false,
            "label": "Calorie surplus or deficit",
            "required": true
        },
        "carb_limit": {
            "type": "decimal",
            "readOnly": false,
            "label": "Carb limit",
            "required": true
        }
    },
    "defaults": {
        "variance": null,
        "carb_limit": null
    },
    "iterator": [
        "variance",
        "carb_limit"
    ]
} as const;
            export type KetoCalculatorForm = typeof KetoCalculatorForm;
            export const LeangainsCalculatorForm = {
    "fields": {
        "workout_day_variance": {
            "type": "decimal",
            "readOnly": false,
            "label": "Workout day surplus or deficit",
            "required": true
        },
        "rest_day_variance": {
            "type": "decimal",
            "readOnly": false,
            "label": "Rest day surplus or deficit",
            "required": true
        },
        "protein_multiplier": {
            "type": "multiplier",
            "widget": "multiplier",
            "readOnly": false,
            "label": "Protein multiplier",
            "required": true
        },
        "workout_day_fat": {
            "type": "range",
            "widget": "range",
            "readOnly": false,
            "label": "Workout day fat",
            "required": true
        },
        "rest_day_fat": {
            "type": "range",
            "widget": "range",
            "readOnly": false,
            "label": "Rest day fat",
            "required": true
        }
    },
    "defaults": {
        "workout_day_variance": null,
        "rest_day_variance": null,
        "protein_multiplier": null,
        "workout_day_fat": null,
        "rest_day_fat": null
    },
    "iterator": [
        "workout_day_variance",
        "rest_day_variance",
        "protein_multiplier",
        "workout_day_fat",
        "rest_day_fat"
    ]
} as const;
            export type LeangainsCalculatorForm = typeof LeangainsCalculatorForm;
            export const CreateFood = {
    "fields": {
        "name": {
            "type": "text",
            "readOnly": false,
            "label": "Name",
            "required": true
        },
        "upc": {
            "type": "text",
            "readOnly": false,
            "label": "UPC code"
        },
        "from_missing_upc": {
            "type": "boolean",
            "readOnly": false,
            "label": "From missing UPC",
            "required": true
        },
        "calories_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Calories per serving"
        },
        "protein_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Protein per serving"
        },
        "fat_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Fat per serving"
        },
        "carbs_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Carbs per serving"
        },
        "net_carbs_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Net carbs per serving"
        },
        "fiber_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Fiber per serving"
        },
        "sodium_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Sodium per serving"
        },
        "saturated_fat_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Saturated fat per serving"
        },
        "monounsaturated_fat_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Monounsaturated fat per serving"
        },
        "polyunsaturated_fat_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Polyunsaturated fat per serving"
        },
        "trans_fat_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Trans fat per serving"
        },
        "cholesterol_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Cholesterol per serving"
        },
        "sugars_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Sugars per serving"
        },
        "added_sugars_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Added sugars per serving"
        },
        "potassium_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Potassium per serving"
        },
        "magnesium_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Magnesium per serving"
        },
        "vitamin_a_dv_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Vitamin A DV"
        },
        "vitamin_c_dv_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Vitamin C DV"
        },
        "calcium_dv_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Calcium DV"
        },
        "iron_dv_pg": {
            "type": "decimal",
            "readOnly": false,
            "label": "Iron DV"
        },
        "base_unit": {
            "type": "select",
            "widget": "select",
            "readOnly": false,
            "label": "Base unit",
            "options": [
                [
                    "",
                    "Choose unit"
                ],
                [
                    "g",
                    "g"
                ],
                [
                    "oz",
                    "oz"
                ],
                [
                    "ml",
                    "ml"
                ],
                [
                    "fl oz",
                    "fl oz"
                ],
                [
                    "mg",
                    "mg"
                ],
                [
                    "mcg",
                    "mcg"
                ],
                [
                    "iu",
                    "IU"
                ]
            ],
            "required": true
        },
        "base_quantity": {
            "type": "decimal",
            "readOnly": false,
            "label": "Base quantity"
        },
        "serving_size_unit": {
            "type": "text",
            "readOnly": false,
            "label": "Serving size unit"
        },
        "serving_size_numerator": {
            "type": "decimal",
            "readOnly": false,
            "label": "Serving size numerator"
        },
        "container_servings": {
            "type": "decimal",
            "readOnly": false,
            "label": "Container servings"
        }
    },
    "defaults": {
        "name": "",
        "upc": "",
        "from_missing_upc": false,
        "calories_pg": null,
        "protein_pg": null,
        "fat_pg": null,
        "carbs_pg": null,
        "net_carbs_pg": null,
        "fiber_pg": null,
        "sodium_pg": null,
        "saturated_fat_pg": null,
        "monounsaturated_fat_pg": null,
        "polyunsaturated_fat_pg": null,
        "trans_fat_pg": null,
        "cholesterol_pg": null,
        "sugars_pg": null,
        "added_sugars_pg": null,
        "potassium_pg": null,
        "magnesium_pg": null,
        "vitamin_a_dv_pg": null,
        "vitamin_c_dv_pg": null,
        "calcium_dv_pg": null,
        "iron_dv_pg": null,
        "base_unit": "",
        "base_quantity": null,
        "serving_size_unit": "",
        "serving_size_numerator": null,
        "container_servings": null
    },
    "iterator": [
        "name",
        "upc",
        "from_missing_upc",
        "calories_pg",
        "protein_pg",
        "fat_pg",
        "carbs_pg",
        "net_carbs_pg",
        "fiber_pg",
        "sodium_pg",
        "saturated_fat_pg",
        "monounsaturated_fat_pg",
        "polyunsaturated_fat_pg",
        "trans_fat_pg",
        "cholesterol_pg",
        "sugars_pg",
        "added_sugars_pg",
        "potassium_pg",
        "magnesium_pg",
        "vitamin_a_dv_pg",
        "vitamin_c_dv_pg",
        "calcium_dv_pg",
        "iron_dv_pg",
        "base_unit",
        "base_quantity",
        "serving_size_unit",
        "serving_size_numerator",
        "container_servings"
    ]
} as const;
            export type CreateFood = typeof CreateFood;
            export const CreateRecipe = {
    "fields": {
        "name": {
            "type": "text",
            "readOnly": false,
            "label": "Name your recipe",
            "required": true
        },
        "container_servings": {
            "type": "decimal",
            "readOnly": false,
            "label": "How many servings?",
            "placeholder": "Amount, ex: 0"
        },
        "serving_size_unit": {
            "type": "text",
            "readOnly": false,
            "label": "What do you call a serving? Ex: slices, muffins",
            "placeholder": "Ex: slices, muffins"
        },
        "container_quantity": {
            "type": "decimal",
            "readOnly": false,
            "label": "Total weight",
            "placeholder": "Amount"
        },
        "container_unit": {
            "type": "select",
            "widget": "select",
            "readOnly": false,
            "label": "Weight unit",
            "options": [
                [
                    "",
                    "Choose unit"
                ],
                [
                    "g",
                    "g"
                ],
                [
                    "oz",
                    "oz"
                ]
            ],
            "required": true
        },
        "notes": {
            "type": "markdown",
            "widget": "markdown",
            "readOnly": false,
            "label": "Notes"
        }
    },
    "defaults": {
        "name": "",
        "container_servings": null,
        "serving_size_unit": "",
        "container_quantity": null,
        "container_unit": "",
        "notes": ""
    },
    "iterator": [
        "name",
        "container_servings",
        "serving_size_unit",
        "container_quantity",
        "container_unit",
        "notes"
    ]
} as const;
            export type CreateRecipe = typeof CreateRecipe;
            export const CreateRecipeFromMeal = {
    "fields": {
        "name": {
            "type": "text",
            "readOnly": false,
            "label": "Name your recipe",
            "required": true
        },
        "container_servings": {
            "type": "decimal",
            "readOnly": false,
            "label": "How many servings?",
            "placeholder": "Amount, ex: 0"
        },
        "serving_size_unit": {
            "type": "text",
            "readOnly": false,
            "label": "What do you call a serving? Ex: slices, muffins",
            "placeholder": "Ex: slices, muffins"
        },
        "container_quantity": {
            "type": "decimal",
            "readOnly": false,
            "label": "Total weight",
            "placeholder": "Amount"
        },
        "container_unit": {
            "type": "select",
            "widget": "select",
            "readOnly": false,
            "label": "Weight unit",
            "options": [
                [
                    "",
                    "Choose unit"
                ],
                [
                    "g",
                    "g"
                ],
                [
                    "oz",
                    "oz"
                ]
            ],
            "required": true
        },
        "notes": {
            "type": "markdown",
            "widget": "markdown",
            "readOnly": false,
            "label": "Notes"
        },
        "meal_id": {
            "type": "text",
            "readOnly": false,
            "label": "Meal id",
            "required": true
        }
    },
    "defaults": {
        "name": "",
        "container_servings": null,
        "serving_size_unit": "",
        "container_quantity": null,
        "container_unit": "",
        "notes": "",
        "meal_id": ""
    },
    "iterator": [
        "name",
        "container_servings",
        "serving_size_unit",
        "container_quantity",
        "container_unit",
        "notes",
        "meal_id"
    ]
} as const;
            export type CreateRecipeFromMeal = typeof CreateRecipeFromMeal;
            export async function delete_entry({form}: {form: UUID}) {
    const {rpc} = await import("@reactivated");
    return rpc.requester(`/rpc/delete_entry/${form}/`, {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_delete_entry_output"]>>;
}
            export async function update_cupboard(form: Schema["rpc_update_cupboard_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/update_cupboard/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_update_cupboard_output"]>>;
}
            export async function update_recipe(form: Schema["rpc_update_recipe_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/update_recipe/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_update_recipe_output"]>>;
}
            export async function predictions_data() {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/predictions_data/", {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_predictions_data_output"]>>;
}
            export async function load_search() {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/load_search/", {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_load_search_output"]>>;
}
            export async function search(form: Schema["rpc_search_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/search/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_search_output"]>>;
}
            export async function publish_nutritional_vision_prompt(form: Schema["rpc_publish_nutritional_vision_prompt_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/publish_nutritional_vision_prompt/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_publish_nutritional_vision_prompt_output"]>>;
}
            export async function publish_day(form: Schema["rpc_publish_day_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/publish_day/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_publish_day_output"]>>;
}
            export async function share_detail(form: Schema["rpc_share_detail_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/share_detail/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_share_detail_output"]>>;
}
            export async function share_recipe(form: Schema["rpc_share_recipe_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/share_recipe/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_share_recipe_output"]>>;
}
            export async function toggle_recipe_favorite({form}: {form: UUID}) {
    const {rpc} = await import("@reactivated");
    return rpc.requester(`/rpc/toggle_recipe_favorite/${form}/`, {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_toggle_recipe_favorite_output"]>>;
}
            export async function food_list(form: Schema["rpc_food_list_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/food_list/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_food_list_output"]>>;
}
            export async function create_food(form: Schema["rpc_create_food_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/create_food/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_create_food_output"]>>;
}
            export async function update_food(form: Schema["rpc_update_food_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/update_food/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_update_food_output"]>>;
}
            export async function delete_food(form: Schema["rpc_delete_food_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/delete_food/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_delete_food_output"]>>;
}
            export async function recipe_list(form: Schema["rpc_recipe_list_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/recipe_list/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_recipe_list_output"]>>;
}
            export async function create_recipe(form: Schema["rpc_create_recipe_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/create_recipe/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_create_recipe_output"]>>;
}
            export async function update_recipe_metadata(form: Schema["rpc_update_recipe_metadata_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/update_recipe_metadata/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_update_recipe_metadata_output"]>>;
}
            export async function delete_recipe(form: Schema["rpc_delete_recipe_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/delete_recipe/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_delete_recipe_output"]>>;
}
            export async function copy_recipe(form: Schema["rpc_copy_recipe_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/copy_recipe/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_copy_recipe_output"]>>;
}
            export async function create_recipe_from_meal(form: Schema["rpc_create_recipe_from_meal_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/create_recipe_from_meal/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_create_recipe_from_meal_output"]>>;
}
            export async function publish_meal(form: Schema["rpc_publish_meal_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/publish_meal/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_publish_meal_output"]>>;
}
            export async function delete_meal(form: Schema["rpc_delete_meal_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/delete_meal/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_delete_meal_output"]>>;
}
            export async function move_meal(form: Schema["rpc_move_meal_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/move_meal/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_move_meal_output"]>>;
}
            export async function copy_meal(form: Schema["rpc_copy_meal_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/copy_meal/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_copy_meal_output"]>>;
}
            export async function publish_entry(form: Schema["rpc_publish_entry_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/publish_entry/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_publish_entry_output"]>>;
}
            export async function expand_entry(form: Schema["rpc_expand_entry_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/expand_entry/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_expand_entry_output"]>>;
}
            export namespace CalculatorProfile {
                export type input = Schema["models"]["journal.nutrition.CalculatorProfile"]["input"];
                export type output = Schema["models"]["journal.nutrition.CalculatorProfile"]["output"];
            }
            export namespace Day {
                export type input = Schema["models"]["journal.nutrition.Day"]["input"];
                export type output = Schema["models"]["journal.nutrition.Day"]["output"];
            }
            export namespace Entry {
                export type input = Schema["models"]["journal.nutrition.Entry"]["input"];
                export type output = Schema["models"]["journal.nutrition.Entry"]["output"];
            }
            export namespace ExpandedEntry {
                export type input = Schema["models"]["journal.nutrition.ExpandedEntry"]["input"];
                export type output = Schema["models"]["journal.nutrition.ExpandedEntry"]["output"];
            }
            export namespace Food {
                export type input = Schema["models"]["journal.nutrition.Food"]["input"];
                export type output = Schema["models"]["journal.nutrition.Food"]["output"];
            }
            export namespace FoodUser {
                export type input = Schema["models"]["journal.nutrition.FoodUser"]["input"];
                export type output = Schema["models"]["journal.nutrition.FoodUser"]["output"];
            }
            export namespace InlineEntry {
                export type input = Schema["models"]["journal.nutrition.InlineEntry"]["input"];
                export type output = Schema["models"]["journal.nutrition.InlineEntry"]["output"];
            }
            export namespace Meal {
                export type input = Schema["models"]["journal.nutrition.Meal"]["input"];
                export type output = Schema["models"]["journal.nutrition.Meal"]["output"];
            }
            export namespace NutritionalVisionPrompt {
                export type input = Schema["models"]["journal.nutrition.NutritionalVisionPrompt"]["input"];
                export type output = Schema["models"]["journal.nutrition.NutritionalVisionPrompt"]["output"];
            }
            export namespace Recipe {
                export type input = Schema["models"]["journal.nutrition.Recipe"]["input"];
                export type output = Schema["models"]["journal.nutrition.Recipe"]["output"];
            }
            export namespace SharedProfile {
                export type input = Schema["models"]["journal.nutrition.SharedProfile"]["input"];
                export type output = Schema["models"]["journal.nutrition.SharedProfile"]["output"];
            }
            export namespace StagedMeal {
                export type input = Schema["models"]["journal.nutrition.StagedMeal"]["input"];
                export type output = Schema["models"]["journal.nutrition.StagedMeal"]["output"];
            }
            export namespace Target {
                export type input = Schema["models"]["journal.nutrition.Target"]["input"];
                export type output = Schema["models"]["journal.nutrition.Target"]["output"];
            }
            export namespace copy_meal {
                export type output = Schema["rpc_copy_meal_output"];
                export type input = Schema["rpc_copy_meal_input"];
            }
            export namespace copy_recipe {
                export type output = Schema["rpc_copy_recipe_output"];
                export type input = Schema["rpc_copy_recipe_input"];
            }
            export namespace create_food {
                export type output = Schema["rpc_create_food_output"];
                export type input = Schema["rpc_create_food_input"];
            }
            export namespace create_recipe {
                export type output = Schema["rpc_create_recipe_output"];
                export type input = Schema["rpc_create_recipe_input"];
            }
            export namespace create_recipe_from_meal {
                export type output = Schema["rpc_create_recipe_from_meal_output"];
                export type input = Schema["rpc_create_recipe_from_meal_input"];
            }
            export namespace delete_entry {
                export type output = Schema["rpc_delete_entry_output"];
            }
            export namespace delete_food {
                export type output = Schema["rpc_delete_food_output"];
                export type input = Schema["rpc_delete_food_input"];
            }
            export namespace delete_meal {
                export type output = Schema["rpc_delete_meal_output"];
                export type input = Schema["rpc_delete_meal_input"];
            }
            export namespace delete_recipe {
                export type output = Schema["rpc_delete_recipe_output"];
                export type input = Schema["rpc_delete_recipe_input"];
            }
            export namespace expand_entry {
                export type output = Schema["rpc_expand_entry_output"];
                export type input = Schema["rpc_expand_entry_input"];
            }
            export namespace food_list {
                export type output = Schema["rpc_food_list_output"];
                export type input = Schema["rpc_food_list_input"];
            }
            export namespace load_search {
                export type output = Schema["rpc_load_search_output"];
            }
            export namespace move_meal {
                export type output = Schema["rpc_move_meal_output"];
                export type input = Schema["rpc_move_meal_input"];
            }
            export namespace predictions_data {
                export type output = Schema["rpc_predictions_data_output"];
            }
            export namespace publish_day {
                export type output = Schema["rpc_publish_day_output"];
                export type input = Schema["rpc_publish_day_input"];
            }
            export namespace publish_entry {
                export type output = Schema["rpc_publish_entry_output"];
                export type input = Schema["rpc_publish_entry_input"];
            }
            export namespace publish_meal {
                export type output = Schema["rpc_publish_meal_output"];
                export type input = Schema["rpc_publish_meal_input"];
            }
            export namespace publish_nutritional_vision_prompt {
                export type output = Schema["rpc_publish_nutritional_vision_prompt_output"];
                export type input = Schema["rpc_publish_nutritional_vision_prompt_input"];
            }
            export namespace recipe_list {
                export type output = Schema["rpc_recipe_list_output"];
                export type input = Schema["rpc_recipe_list_input"];
            }
            export namespace search {
                export type output = Schema["rpc_search_output"];
                export type input = Schema["rpc_search_input"];
            }
            export namespace share_detail {
                export type output = Schema["rpc_share_detail_output"];
                export type input = Schema["rpc_share_detail_input"];
            }
            export namespace share_recipe {
                export type output = Schema["rpc_share_recipe_output"];
                export type input = Schema["rpc_share_recipe_input"];
            }
            export namespace toggle_recipe_favorite {
                export type output = Schema["rpc_toggle_recipe_favorite_output"];
            }
            export namespace update_cupboard {
                export type output = Schema["rpc_update_cupboard_output"];
                export type input = Schema["rpc_update_cupboard_input"];
            }
            export namespace update_food {
                export type output = Schema["rpc_update_food_output"];
                export type input = Schema["rpc_update_food_input"];
            }
            export namespace update_recipe {
                export type output = Schema["rpc_update_recipe_output"];
                export type input = Schema["rpc_update_recipe_input"];
            }
            export namespace update_recipe_metadata {
                export type output = Schema["rpc_update_recipe_metadata_output"];
                export type input = Schema["rpc_update_recipe_metadata_input"];
            }
        }
        export namespace nutritional_ai {
            export type QueueBarcode = Schema["models"]["journal.nutritional_ai.QueueBarcode"];
            export type ImportRecipe = Schema["models"]["journal.nutritional_ai.ImportRecipe"];
            export async function queue_meal_image(form: Schema["rpc_queue_meal_image_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/queue_meal_image/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_queue_meal_image_output"]>>;
}
            export async function identify_meal_name({form}: {form: UUID}) {
    const {rpc} = await import("@reactivated");
    return rpc.requester(`/rpc/identify_meal_name/${form}/`, {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_identify_meal_name_output"]>>;
}
            export async function queue_barcode(form: Schema["rpc_queue_barcode_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/queue_barcode/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_queue_barcode_output"]>>;
}
            export async function process_queued_barcode({form}: {form: UUID}) {
    const {rpc} = await import("@reactivated");
    return rpc.requester(`/rpc/process_queued_barcode/${form}/`, {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_process_queued_barcode_output"]>>;
}
            export async function process_queued_image({form}: {form: UUID}) {
    const {rpc} = await import("@reactivated");
    return rpc.requester(`/rpc/process_queued_image/${form}/`, {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_process_queued_image_output"]>>;
}
            export async function reprocess_queued_image(form: Schema["rpc_reprocess_queued_image_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/reprocess_queued_image/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_reprocess_queued_image_output"]>>;
}
            export async function queue_audio_transcription({form}: {form: string}) {
    const {rpc} = await import("@reactivated");
    return rpc.requester(`/rpc/queue_audio_transcription/${form}/`, {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_queue_audio_transcription_output"]>>;
}
            export async function process_queued_audio({form}: {form: UUID}) {
    const {rpc} = await import("@reactivated");
    return rpc.requester(`/rpc/process_queued_audio/${form}/`, {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_process_queued_audio_output"]>>;
}
            export async function import_recipe(form: Schema["rpc_import_recipe_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/import_recipe/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_import_recipe_output"]>>;
}
            export namespace ProcessMealImage {
                export type input = Schema["models"]["journal.nutritional_ai.ProcessMealImage.input"];
            }
            export namespace identify_meal_name {
                export type output = Schema["rpc_identify_meal_name_output"];
            }
            export namespace import_recipe {
                export type output = Schema["rpc_import_recipe_output"];
                export type input = Schema["rpc_import_recipe_input"];
            }
            export namespace process_queued_audio {
                export type output = Schema["rpc_process_queued_audio_output"];
            }
            export namespace process_queued_barcode {
                export type output = Schema["rpc_process_queued_barcode_output"];
            }
            export namespace process_queued_image {
                export type output = Schema["rpc_process_queued_image_output"];
            }
            export namespace queue_audio_transcription {
                export type output = Schema["rpc_queue_audio_transcription_output"];
            }
            export namespace queue_barcode {
                export type output = Schema["rpc_queue_barcode_output"];
                export type input = Schema["rpc_queue_barcode_input"];
            }
            export namespace queue_meal_image {
                export type output = Schema["rpc_queue_meal_image_output"];
                export type input = Schema["rpc_queue_meal_image_input"];
            }
            export namespace reprocess_queued_image {
                export type output = Schema["rpc_reprocess_queued_image_output"];
                export type input = Schema["rpc_reprocess_queued_image_input"];
            }
        }
        export namespace peptides {
            export type CreateVialInput = Schema["models"]["journal.peptides.CreateVialInput"];
            export type DeleteVialInput = Schema["models"]["journal.peptides.DeleteVialInput"];
            export type CreateDoseInput = Schema["models"]["journal.peptides.CreateDoseInput"];
            export async function peptides() {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/peptides/", {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_peptides_output"]>>;
}
            export async function create_peptide_vial(form: Schema["rpc_create_peptide_vial_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/create_peptide_vial/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_create_peptide_vial_output"]>>;
}
            export async function delete_peptide_vial(form: Schema["rpc_delete_peptide_vial_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/delete_peptide_vial/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_delete_peptide_vial_output"]>>;
}
            export async function create_peptide_dose(form: Schema["rpc_create_peptide_dose_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/create_peptide_dose/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_create_peptide_dose_output"]>>;
}
            export namespace create_peptide_dose {
                export type output = Schema["rpc_create_peptide_dose_output"];
                export type input = Schema["rpc_create_peptide_dose_input"];
            }
            export namespace create_peptide_vial {
                export type output = Schema["rpc_create_peptide_vial_output"];
                export type input = Schema["rpc_create_peptide_vial_input"];
            }
            export namespace delete_peptide_vial {
                export type output = Schema["rpc_delete_peptide_vial_output"];
                export type input = Schema["rpc_delete_peptide_vial_input"];
            }
            export namespace peptides {
                export type output = Schema["rpc_peptides_output"];
            }
        }
        export namespace predictions {
            export type EntryItem = Schema["models"]["journal.predictions.EntryItem"];
            export type MealItem = Schema["models"]["journal.predictions.MealItem"];
            export type MealDigest = Schema["models"]["journal.predictions.MealDigest"];
            export type EntryInfo = Schema["models"]["journal.predictions.EntryInfo"];
            export type MealPattern = Schema["models"]["journal.predictions.MealPattern"];
            export type RootPatterns = Schema["models"]["journal.predictions.RootPatterns"];
            export type MealPredictions = Schema["models"]["journal.predictions.MealPredictions"];
        }
        export namespace reports {
            export type WeeklyMacros = Schema["models"]["journal.reports.WeeklyMacros"];
            export type WeeklyMacrosEntry = Schema["models"]["journal.reports.WeeklyMacrosEntry"];
            export async function reports(form: Schema["rpc_reports_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/reports/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_reports_output"]>>;
}
            export async function weekly_macros(form: Schema["rpc_weekly_macros_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/weekly_macros/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_weekly_macros_output"]>>;
}
            export namespace Reports {
                export type input = Schema["models"]["journal.reports.Reports.input"];
                export type output = Schema["models"]["journal.reports.Reports.output"];
            }
            export namespace WeeklyMacros {
                export type input = Schema["models"]["journal.reports.WeeklyMacros.input"];
            }
            export namespace reports {
                export type output = Schema["rpc_reports_output"];
                export type input = Schema["rpc_reports_input"];
            }
            export namespace weekly_macros {
                export type output = Schema["rpc_weekly_macros_output"];
                export type input = Schema["rpc_weekly_macros_input"];
            }
        }
        export namespace tasks {
            export type NotifcationModel = Schema["models"]["journal.tasks.NotifcationModel"];
        }
        export namespace templates {
            export const RecipeExperimentName = {
    "CONTENT_MIDDLE_REGISTRATION_V2": 1,
    "CONTENT_START_REGISTRATION_V2": 2,
    "CTA_INLINE_REGISTRATION_V2": 3
} as const;
            export type RecipeExperimentName = (typeof RecipeExperimentName)[keyof typeof RecipeExperimentName];
            export const RecipeButtonExperimentName = {
    "FREE_TRIAL": 1,
    "OTHER": 2
} as const;
            export type RecipeButtonExperimentName = (typeof RecipeButtonExperimentName)[keyof typeof RecipeButtonExperimentName];
            export const RecipePriceExperimentName = {
    "FULL_TERMS": 1,
    "SHORT": 2,
    "HIDDEN": 3
} as const;
            export type RecipePriceExperimentName = (typeof RecipePriceExperimentName)[keyof typeof RecipePriceExperimentName];
            export const InstacartExperimentName = {
    "INSTACART_CTA_TOP": 1,
    "INSTACART_CTA_BOTTOM": 2
} as const;
            export type InstacartExperimentName = (typeof InstacartExperimentName)[keyof typeof InstacartExperimentName];
            export type App = Schema["template_App"];
            export type Share = Schema["template_Share"];
            export type Leangains = Schema["template_Leangains"];
            export type Start = Schema["template_Start"];
            export namespace PromptShare {
                export type input = Schema["models"]["journal.templates.PromptShare"]["input"];
                export type output = Schema["models"]["journal.templates.PromptShare"]["output"];
            }
        }
        export namespace views {
            export type PullUp = Schema["template_PullUp"];
            export type SuperSmoothies = Schema["template_SuperSmoothies"];
            export type Meet = Schema["template_Meet"];
            export type JoinMeet = Schema["template_JoinMeet"];
            export async function update_meet(form: Schema["rpc_update_meet_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/update_meet/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_update_meet_output"]>>;
}
            export namespace MeetData {
                export type input = Schema["models"]["journal.views.MeetData"]["input"];
                export type output = Schema["models"]["journal.views.MeetData"]["output"];
            }
            export namespace update_meet {
                export type output = Schema["rpc_update_meet_output"];
                export type input = Schema["rpc_update_meet_input"];
            }
        }
        export namespace workouts {
            export type CreateTemplateFromWorkout = Schema["models"]["journal.workouts.CreateTemplateFromWorkout"];
            export type DeleteWorkout = Schema["models"]["journal.workouts.DeleteWorkout"];
            export type DeleteGroup = Schema["models"]["journal.workouts.DeleteGroup"];
            export type CopyProgram = Schema["models"]["journal.workouts.CopyProgram"];
            export type DeleteProgram = Schema["models"]["journal.workouts.DeleteProgram"];
            export type DeleteExerciseGroup = Schema["models"]["journal.workouts.DeleteExerciseGroup"];
            export type SelectProgramWorkout = Schema["models"]["journal.workouts.SelectProgramWorkout"];
            export type ArchiveProgram = Schema["models"]["journal.workouts.ArchiveProgram"];
            export type DisableSync = Schema["models"]["journal.workouts.DisableSync"];
            export type RecentSections = Schema["models"]["journal.workouts.RecentSections"];
            export type ExerciseMediaLookup = Schema["models"]["journal.workouts.ExerciseMediaLookup"];
            export type ExerciseMediaList = Schema["models"]["journal.workouts.ExerciseMediaList"];
            export type DeleteExerciseSet = Schema["models"]["journal.workouts.DeleteExerciseSet"];
            export type DeleteExercise = Schema["models"]["journal.workouts.DeleteExercise"];
            export type ClearExerciseSets = Schema["models"]["journal.workouts.ClearExerciseSets"];
            export type ExerciseDetailForm = Schema["models"]["journal.workouts.ExerciseDetailForm"];
            export type CopyWorkoutForm = Schema["models"]["journal.workouts.CopyWorkoutForm"];
            export type CompleteWorkoutForm = Schema["models"]["journal.workouts.CompleteWorkoutForm"];
            export type IncompleteWorkoutForm = Schema["models"]["journal.workouts.IncompleteWorkoutForm"];
            export type NextWorkoutWrapper = Schema["models"]["journal.workouts.NextWorkoutWrapper"];
            export type Workouts = Schema["models"]["journal.workouts.Workouts"];
            export type ExerciseMaxes = Schema["models"]["journal.workouts.ExerciseMaxes"];
            export const WorkoutTemplateForm = {
    "fields": {
        "name": {
            "type": "text",
            "readOnly": false,
            "label": "Name",
            "required": true
        },
        "instructions": {
            "type": "textarea",
            "widget": "textarea",
            "readOnly": false,
            "label": "Instructions"
        },
        "visibility": {
            "type": "select",
            "readOnly": false,
            "label": "Visibility",
            "options": [
                [
                    "PRIVATE",
                    "Private"
                ],
                [
                    "PUBLIC",
                    "Public"
                ],
                [
                    "CLIENTS",
                    "Share with my clients"
                ]
            ],
            "required": true
        }
    },
    "defaults": {
        "name": "",
        "instructions": "",
        "visibility": "PRIVATE"
    },
    "iterator": [
        "name",
        "instructions",
        "visibility"
    ]
} as const;
            export type WorkoutTemplateForm = typeof WorkoutTemplateForm;
            export const WorkoutGroupForm = {
    "fields": {
        "name": {
            "type": "text",
            "readOnly": false,
            "label": "Name",
            "required": true
        },
        "description": {
            "type": "textarea",
            "widget": "textarea",
            "readOnly": false,
            "label": "Description"
        }
    },
    "defaults": {
        "name": "",
        "description": ""
    },
    "iterator": [
        "name",
        "description"
    ]
} as const;
            export type WorkoutGroupForm = typeof WorkoutGroupForm;
            export const ExerciseTypeForm = {
    "fields": {
        "name": {
            "type": "text",
            "readOnly": false,
            "label": "Name",
            "required": true
        },
        "category": {
            "type": "select",
            "widget": "select",
            "readOnly": false,
            "label": "Category",
            "options": [
                [
                    "WEIGHT",
                    "Weight Training"
                ],
                [
                    "BODYWEIGHT",
                    "Bodyweight"
                ],
                [
                    "CARDIO",
                    "Cardio"
                ],
                [
                    "DURATION",
                    "Duration"
                ],
                [
                    "DURATION_DISTANCE",
                    "Duration & Distance"
                ],
                [
                    "REPS_DISTANCE",
                    "Reps & Distance"
                ],
                [
                    "MEDLEY",
                    "Medley"
                ],
                [
                    "WEIGHT_DISTANCE",
                    "Weight & Distance"
                ],
                [
                    "WEIGHT_DURATION_DISTANCE",
                    "Weight, Duration & Distance"
                ]
            ],
            "required": true
        },
        "video_url": {
            "type": "text",
            "readOnly": false,
            "label": "Video URL"
        },
        "video_uid": {
            "type": "text",
            "readOnly": false,
            "label": "Video UID"
        },
        "description": {
            "type": "textarea",
            "widget": "textarea",
            "readOnly": false,
            "label": "General description and instructions"
        }
    },
    "defaults": {
        "name": "",
        "category": "WEIGHT",
        "video_url": "",
        "video_uid": "",
        "description": ""
    },
    "iterator": [
        "name",
        "category",
        "video_url",
        "video_uid",
        "description"
    ]
} as const;
            export type ExerciseTypeForm = typeof ExerciseTypeForm;
            export const CreateWorkoutTemplateForm = {
    "fields": {
        "name": {
            "type": "text",
            "readOnly": false,
            "label": "Name",
            "required": true
        },
        "instructions": {
            "type": "textarea",
            "widget": "textarea",
            "readOnly": false,
            "label": "Instructions"
        },
        "visibility": {
            "type": "select",
            "widget": "select",
            "readOnly": false,
            "label": "Visibility",
            "options": [
                [
                    "PRIVATE",
                    "Private"
                ],
                [
                    "PUBLIC",
                    "Public"
                ],
                [
                    "CLIENTS",
                    "Share with my clients"
                ]
            ],
            "required": true
        },
        "maxes": {
            "type": "select",
            "widget": "select",
            "readOnly": false,
            "label": "Maxes",
            "options": [
                [
                    "EXISTING_MAXES",
                    "Use existing maxes"
                ],
                [
                    "UPDATE_MAXES",
                    "Request update maxes"
                ],
                [
                    "AUTOMATIC",
                    "Automatic"
                ]
            ],
            "required": true
        }
    },
    "defaults": {
        "name": "",
        "instructions": "",
        "visibility": "PRIVATE",
        "maxes": "EXISTING_MAXES"
    },
    "iterator": [
        "name",
        "instructions",
        "visibility",
        "maxes"
    ]
} as const;
            export type CreateWorkoutTemplateForm = typeof CreateWorkoutTemplateForm;
            export const FiveThreeOneSettingsForm = {
    "fields": {
        "template": {
            "type": "select",
            "widget": "select",
            "readOnly": false,
            "label": "Template",
            "options": [
                [
                    "BORING_BUT_BIG",
                    "Boring But Big"
                ],
                [
                    "BORING_BUT_STRONG",
                    "Boring But Strong"
                ],
                [
                    "FIRST_SET_LAST",
                    "First Set Last"
                ],
                [
                    "SECOND_SET_LAST",
                    "Second Set Last"
                ]
            ],
            "required": true
        },
        "cycle_type": {
            "type": "select",
            "widget": "select",
            "readOnly": false,
            "label": "Cycle type",
            "options": [
                [
                    "ANCHOR",
                    "Anchor"
                ],
                [
                    "LEADER",
                    "Leader"
                ]
            ],
            "required": true
        },
        "swap_exercises": {
            "type": "boolean",
            "readOnly": false,
            "label": "Swap exercises",
            "required": true
        },
        "assistance_exercises": {
            "type": "boolean",
            "readOnly": false,
            "label": "Assistance exercises",
            "required": true
        },
        "deload_week": {
            "type": "boolean",
            "readOnly": false,
            "label": "Deload week",
            "required": true
        },
        "heavy_single": {
            "type": "boolean",
            "readOnly": false,
            "label": "Heavy single",
            "required": true
        }
    },
    "defaults": {
        "template": "BORING_BUT_BIG",
        "cycle_type": "ANCHOR",
        "swap_exercises": false,
        "assistance_exercises": true,
        "deload_week": true,
        "heavy_single": true
    },
    "iterator": [
        "template",
        "cycle_type",
        "swap_exercises",
        "assistance_exercises",
        "deload_week",
        "heavy_single"
    ]
} as const;
            export type FiveThreeOneSettingsForm = typeof FiveThreeOneSettingsForm;
            export const LinearLiftConfigForm = {
    "fields": {
        "progression_per_week": {
            "type": "decimal",
            "readOnly": false,
            "label": "Progression per week",
            "required": true
        },
        "smallest_plate": {
            "type": "decimal",
            "readOnly": false,
            "label": "Smallest plate",
            "required": true
        }
    },
    "defaults": {
        "progression_per_week": null,
        "smallest_plate": null
    },
    "iterator": [
        "progression_per_week",
        "smallest_plate"
    ]
} as const;
            export type LinearLiftConfigForm = typeof LinearLiftConfigForm;
            export const LinearProgramSettingsForm = {
    "fields": {
        "weeks": {
            "type": "number",
            "readOnly": false,
            "label": "Weeks",
            "required": true
        }
    },
    "defaults": {
        "weeks": 3
    },
    "iterator": [
        "weeks"
    ]
} as const;
            export type LinearProgramSettingsForm = typeof LinearProgramSettingsForm;
            export const ExerciseMaxForm = {
    "fields": {
        "reps": {
            "type": "number",
            "readOnly": false,
            "label": "Reps",
            "required": true
        },
        "weight": {
            "type": "weight",
            "widget": "weight",
            "readOnly": false,
            "label": "Weight"
        },
        "smallest_plate": {
            "type": "decimal",
            "readOnly": false,
            "label": "Smallest plate"
        }
    },
    "defaults": {
        "reps": 3,
        "weight": null,
        "smallest_plate": null
    },
    "iterator": [
        "reps",
        "weight",
        "smallest_plate"
    ]
} as const;
            export type ExerciseMaxForm = typeof ExerciseMaxForm;
            export const WorkoutProgramConfigForm = {
    "fields": {
        "name": {
            "type": "text",
            "readOnly": false,
            "label": "Name",
            "required": true
        },
        "description": {
            "type": "textarea",
            "widget": "textarea",
            "readOnly": false,
            "label": "Description"
        },
        "auto_assign": {
            "type": "boolean",
            "readOnly": false,
            "label": "Auto assign",
            "required": true
        }
    },
    "defaults": {
        "name": "",
        "description": "",
        "auto_assign": false
    },
    "iterator": [
        "name",
        "description",
        "auto_assign"
    ]
} as const;
            export type WorkoutProgramConfigForm = typeof WorkoutProgramConfigForm;
            export const QuestionTypeInput = {
    "fields": {
        "name": {
            "type": "text",
            "readOnly": false,
            "label": "Name",
            "required": true
        }
    },
    "defaults": {
        "name": ""
    },
    "iterator": [
        "name"
    ]
} as const;
            export type QuestionTypeInput = typeof QuestionTypeInput;
            export async function program_detail({form}: {form: UUID}) {
    const {rpc} = await import("@reactivated");
    return rpc.requester(`/rpc/program_detail/${form}/`, {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_program_detail_output"]>>;
}
            export async function workouts() {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/workouts/", {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_workouts_output"]>>;
}
            export async function create_template_from_workout(form: Schema["rpc_create_template_from_workout_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/create_template_from_workout/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_create_template_from_workout_output"]>>;
}
            export async function delete_workout_template(form: Schema["rpc_delete_workout_template_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/delete_workout_template/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_delete_workout_template_output"]>>;
}
            export async function delete_workout(form: Schema["rpc_delete_workout_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/delete_workout/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_delete_workout_output"]>>;
}
            export async function delete_group(form: Schema["rpc_delete_group_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/delete_group/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_delete_group_output"]>>;
}
            export async function update_workout(form: Schema["rpc_update_workout_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/update_workout/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_update_workout_output"]>>;
}
            export async function update_program(form: Schema["rpc_update_program_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/update_program/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_update_program_output"]>>;
}
            export async function create_program(form: Schema["rpc_create_program_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/create_program/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_create_program_output"]>>;
}
            export async function copy_program(form: Schema["rpc_copy_program_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/copy_program/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_copy_program_output"]>>;
}
            export async function delete_program(form: Schema["rpc_delete_program_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/delete_program/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_delete_program_output"]>>;
}
            export async function select_program_template(form: Schema["rpc_select_program_template_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/select_program_template/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_select_program_template_output"]>>;
}
            export async function preview_program({form}: {form: UUID}) {
    const {rpc} = await import("@reactivated");
    return rpc.requester(`/rpc/preview_program/${form}/`, {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_preview_program_output"]>>;
}
            export async function create_exercise_types(form: Schema["rpc_create_exercise_types_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/create_exercise_types/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_create_exercise_types_output"]>>;
}
            export async function set_exercise_maxes(form: Schema["rpc_set_exercise_maxes_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/set_exercise_maxes/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_set_exercise_maxes_output"]>>;
}
            export async function delete_exercise_type({source_exercise_type}: {source_exercise_type: UUID}) {
    const {rpc} = await import("@reactivated");
    return rpc.requester(`/rpc/delete_exercise_type/${source_exercise_type}/`, {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_delete_exercise_type_output"]>>;
}
            export async function delete_exercise_group(form: Schema["rpc_delete_exercise_group_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/delete_exercise_group/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_delete_exercise_group_output"]>>;
}
            export async function select_program_workout(form: Schema["rpc_select_program_workout_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/select_program_workout/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_select_program_workout_output"]>>;
}
            export async function archive_program(form: Schema["rpc_archive_program_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/archive_program/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_archive_program_output"]>>;
}
            export async function disable_sync(form: Schema["rpc_disable_sync_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/disable_sync/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_disable_sync_output"]>>;
}
            export async function recent_sections(form: Schema["rpc_recent_sections_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/recent_sections/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_recent_sections_output"]>>;
}
            export async function exercise_media_lookup(form: Schema["rpc_exercise_media_lookup_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/exercise_media_lookup/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_exercise_media_lookup_output"]>>;
}
            export async function update_exercise_media(form: Schema["rpc_update_exercise_media_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/update_exercise_media/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_update_exercise_media_output"]>>;
}
            export async function create_exercise_type(form: Schema["rpc_create_exercise_type_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/create_exercise_type/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_create_exercise_type_output"]>>;
}
            export async function update_exercise_type(form: Schema["rpc_update_exercise_type_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/update_exercise_type/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_update_exercise_type_output"]>>;
}
            export async function delete_exercise_set(form: Schema["rpc_delete_exercise_set_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/delete_exercise_set/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_delete_exercise_set_output"]>>;
}
            export async function delete_exercise(form: Schema["rpc_delete_exercise_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/delete_exercise/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_delete_exercise_output"]>>;
}
            export async function clear_exercise_sets(form: Schema["rpc_clear_exercise_sets_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/clear_exercise_sets/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_clear_exercise_sets_output"]>>;
}
            export async function exercise_detail(form: Schema["rpc_exercise_detail_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/exercise_detail/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_exercise_detail_output"]>>;
}
            export async function copy_workout(form: Schema["rpc_copy_workout_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/copy_workout/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_copy_workout_output"]>>;
}
            export async function complete_workout(form: Schema["rpc_complete_workout_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/complete_workout/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_complete_workout_output"]>>;
}
            export async function incomplete_workout(form: Schema["rpc_incomplete_workout_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/incomplete_workout/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_incomplete_workout_output"]>>;
}
            export async function create_workout_template(form: Schema["rpc_create_workout_template_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/create_workout_template/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_create_workout_template_output"]>>;
}
            export async function create_question_type(form: Schema["rpc_create_question_type_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/create_question_type/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_create_question_type_output"]>>;
}
            export namespace ActiveProgram {
                export type input = Schema["models"]["journal.workouts.ActiveProgram"]["input"];
                export type output = Schema["models"]["journal.workouts.ActiveProgram"]["output"];
            }
            export namespace Exercise {
                export type input = Schema["models"]["journal.workouts.Exercise"]["input"];
                export type output = Schema["models"]["journal.workouts.Exercise"]["output"];
            }
            export namespace ExerciseExerciseProgression {
                export type input = Schema["models"]["journal.workouts.ExerciseExerciseProgression"]["input"];
                export type output = Schema["models"]["journal.workouts.ExerciseExerciseProgression"]["output"];
            }
            export namespace ExerciseGroup {
                export type input = Schema["models"]["journal.workouts.ExerciseGroup"]["input"];
                export type output = Schema["models"]["journal.workouts.ExerciseGroup"]["output"];
            }
            export namespace ExerciseHistory {
                export type input = Schema["models"]["journal.workouts.ExerciseHistory"]["input"];
                export type output = Schema["models"]["journal.workouts.ExerciseHistory"]["output"];
            }
            export namespace ExerciseMax {
                export type input = Schema["models"]["journal.workouts.ExerciseMax"]["input"];
                export type output = Schema["models"]["journal.workouts.ExerciseMax"]["output"];
            }
            export namespace ExerciseMedia {
                export type input = Schema["models"]["journal.workouts.ExerciseMedia"]["input"];
                export type output = Schema["models"]["journal.workouts.ExerciseMedia"]["output"];
            }
            export namespace ExerciseProgression {
                export type input = Schema["models"]["journal.workouts.ExerciseProgression"]["input"];
                export type output = Schema["models"]["journal.workouts.ExerciseProgression"]["output"];
            }
            export namespace ExerciseSet {
                export type input = Schema["models"]["journal.workouts.ExerciseSet"]["input"];
                export type output = Schema["models"]["journal.workouts.ExerciseSet"]["output"];
            }
            export namespace ExerciseType {
                export type input = Schema["models"]["journal.workouts.ExerciseType"]["input"];
                export type output = Schema["models"]["journal.workouts.ExerciseType"]["output"];
            }
            export namespace ExerciseTypeUser {
                export type input = Schema["models"]["journal.workouts.ExerciseTypeUser"]["input"];
                export type output = Schema["models"]["journal.workouts.ExerciseTypeUser"]["output"];
            }
            export namespace IncompleteWorkout {
                export type input = Schema["models"]["journal.workouts.IncompleteWorkout"]["input"];
                export type output = Schema["models"]["journal.workouts.IncompleteWorkout"]["output"];
            }
            export namespace LatestExerciseInstance {
                export type input = Schema["models"]["journal.workouts.LatestExerciseInstance"]["input"];
                export type output = Schema["models"]["journal.workouts.LatestExerciseInstance"]["output"];
            }
            export namespace ListProgram {
                export type input = Schema["models"]["journal.workouts.ListProgram"]["input"];
                export type output = Schema["models"]["journal.workouts.ListProgram"]["output"];
            }
            export namespace PastProgram {
                export type input = Schema["models"]["journal.workouts.PastProgram"]["input"];
                export type output = Schema["models"]["journal.workouts.PastProgram"]["output"];
            }
            export namespace Program {
                export type input = Schema["models"]["journal.workouts.Program"]["input"];
                export type output = Schema["models"]["journal.workouts.Program"]["output"];
            }
            export namespace ProgramUser {
                export type input = Schema["models"]["journal.workouts.ProgramUser"]["input"];
                export type output = Schema["models"]["journal.workouts.ProgramUser"]["output"];
            }
            export namespace Question {
                export type input = Schema["models"]["journal.workouts.Question"]["input"];
                export type output = Schema["models"]["journal.workouts.Question"]["output"];
            }
            export namespace QuestionType {
                export type input = Schema["models"]["journal.workouts.QuestionType"]["input"];
                export type output = Schema["models"]["journal.workouts.QuestionType"]["output"];
            }
            export namespace SelectProgramTemplate {
                export type input = Schema["models"]["journal.workouts.SelectProgramTemplate"]["input"];
                export type output = Schema["models"]["journal.workouts.SelectProgramTemplate"]["output"];
            }
            export namespace Workout {
                export type input = Schema["models"]["journal.workouts.Workout"]["input"];
                export type output = Schema["models"]["journal.workouts.Workout"]["output"];
            }
            export namespace WorkoutGroup {
                export type input = Schema["models"]["journal.workouts.WorkoutGroup"]["input"];
                export type output = Schema["models"]["journal.workouts.WorkoutGroup"]["output"];
            }
            export namespace WorkoutGroupWorkout {
                export type input = Schema["models"]["journal.workouts.WorkoutGroupWorkout"]["input"];
                export type output = Schema["models"]["journal.workouts.WorkoutGroupWorkout"]["output"];
            }
            export namespace WorkoutSection {
                export type input = Schema["models"]["journal.workouts.WorkoutSection"]["input"];
                export type output = Schema["models"]["journal.workouts.WorkoutSection"]["output"];
            }
            export namespace WorkoutSectionHistory {
                export type input = Schema["models"]["journal.workouts.WorkoutSectionHistory"]["input"];
                export type output = Schema["models"]["journal.workouts.WorkoutSectionHistory"]["output"];
            }
            export namespace WorkoutTemplate {
                export type input = Schema["models"]["journal.workouts.WorkoutTemplate"]["input"];
                export type output = Schema["models"]["journal.workouts.WorkoutTemplate"]["output"];
            }
            export namespace archive_program {
                export type output = Schema["rpc_archive_program_output"];
                export type input = Schema["rpc_archive_program_input"];
            }
            export namespace clear_exercise_sets {
                export type output = Schema["rpc_clear_exercise_sets_output"];
                export type input = Schema["rpc_clear_exercise_sets_input"];
            }
            export namespace complete_workout {
                export type output = Schema["rpc_complete_workout_output"];
                export type input = Schema["rpc_complete_workout_input"];
            }
            export namespace copy_program {
                export type output = Schema["rpc_copy_program_output"];
                export type input = Schema["rpc_copy_program_input"];
            }
            export namespace copy_workout {
                export type output = Schema["rpc_copy_workout_output"];
                export type input = Schema["rpc_copy_workout_input"];
            }
            export namespace create_exercise_type {
                export type output = Schema["rpc_create_exercise_type_output"];
                export type input = Schema["rpc_create_exercise_type_input"];
            }
            export namespace create_exercise_types {
                export type output = Schema["rpc_create_exercise_types_output"];
                export type input = Schema["rpc_create_exercise_types_input"];
            }
            export namespace create_program {
                export type output = Schema["rpc_create_program_output"];
                export type input = Schema["rpc_create_program_input"];
            }
            export namespace create_question_type {
                export type output = Schema["rpc_create_question_type_output"];
                export type input = Schema["rpc_create_question_type_input"];
            }
            export namespace create_template_from_workout {
                export type output = Schema["rpc_create_template_from_workout_output"];
                export type input = Schema["rpc_create_template_from_workout_input"];
            }
            export namespace create_workout_template {
                export type output = Schema["rpc_create_workout_template_output"];
                export type input = Schema["rpc_create_workout_template_input"];
            }
            export namespace delete_exercise {
                export type output = Schema["rpc_delete_exercise_output"];
                export type input = Schema["rpc_delete_exercise_input"];
            }
            export namespace delete_exercise_group {
                export type output = Schema["rpc_delete_exercise_group_output"];
                export type input = Schema["rpc_delete_exercise_group_input"];
            }
            export namespace delete_exercise_set {
                export type output = Schema["rpc_delete_exercise_set_output"];
                export type input = Schema["rpc_delete_exercise_set_input"];
            }
            export namespace delete_exercise_type {
                export type output = Schema["rpc_delete_exercise_type_output"];
            }
            export namespace delete_group {
                export type output = Schema["rpc_delete_group_output"];
                export type input = Schema["rpc_delete_group_input"];
            }
            export namespace delete_program {
                export type output = Schema["rpc_delete_program_output"];
                export type input = Schema["rpc_delete_program_input"];
            }
            export namespace delete_workout {
                export type output = Schema["rpc_delete_workout_output"];
                export type input = Schema["rpc_delete_workout_input"];
            }
            export namespace delete_workout_template {
                export type output = Schema["rpc_delete_workout_template_output"];
                export type input = Schema["rpc_delete_workout_template_input"];
            }
            export namespace disable_sync {
                export type output = Schema["rpc_disable_sync_output"];
                export type input = Schema["rpc_disable_sync_input"];
            }
            export namespace exercise_detail {
                export type output = Schema["rpc_exercise_detail_output"];
                export type input = Schema["rpc_exercise_detail_input"];
            }
            export namespace exercise_media_lookup {
                export type output = Schema["rpc_exercise_media_lookup_output"];
                export type input = Schema["rpc_exercise_media_lookup_input"];
            }
            export namespace incomplete_workout {
                export type output = Schema["rpc_incomplete_workout_output"];
                export type input = Schema["rpc_incomplete_workout_input"];
            }
            export namespace preview_program {
                export type output = Schema["rpc_preview_program_output"];
            }
            export namespace program_detail {
                export type output = Schema["rpc_program_detail_output"];
            }
            export namespace recent_sections {
                export type output = Schema["rpc_recent_sections_output"];
                export type input = Schema["rpc_recent_sections_input"];
            }
            export namespace select_program_template {
                export type output = Schema["rpc_select_program_template_output"];
                export type input = Schema["rpc_select_program_template_input"];
            }
            export namespace select_program_workout {
                export type output = Schema["rpc_select_program_workout_output"];
                export type input = Schema["rpc_select_program_workout_input"];
            }
            export namespace set_exercise_maxes {
                export type output = Schema["rpc_set_exercise_maxes_output"];
                export type input = Schema["rpc_set_exercise_maxes_input"];
            }
            export namespace update_exercise_media {
                export type output = Schema["rpc_update_exercise_media_output"];
                export type input = Schema["rpc_update_exercise_media_input"];
            }
            export namespace update_exercise_type {
                export type output = Schema["rpc_update_exercise_type_output"];
                export type input = Schema["rpc_update_exercise_type_input"];
            }
            export namespace update_program {
                export type output = Schema["rpc_update_program_output"];
                export type input = Schema["rpc_update_program_input"];
            }
            export namespace update_workout {
                export type output = Schema["rpc_update_workout_output"];
                export type input = Schema["rpc_update_workout_input"];
            }
            export namespace workouts {
                export type output = Schema["rpc_workouts_output"];
            }
        }
    }
    export namespace manager {
        export namespace reports {
            export type ClientManagerSupplements = Schema["template_ClientManagerSupplements"];
        }
        export namespace templates {
            export type ClientDashboard = Schema["template_ClientDashboard"];
            export type WeeklySummaryEmail = Schema["template_WeeklySummaryEmail"];
            export type ClientManagerDetail = Schema["template_ClientManagerDetail"];
            export type ClientCheckInList = Schema["template_ClientCheckInList"];
            export type ClientManagerSurvey = Schema["template_ClientManagerSurvey"];
            export type ClientDayDetail = Schema["template_ClientDayDetail"];
            export type ConfirmManager = Schema["template_ConfirmManager"];
            export type ClientManagerPlanner = Schema["template_ClientManagerPlanner"];
            export type CreateClient = Schema["template_CreateClient"];
            export type DeleteClient = Schema["template_DeleteClient"];
            export type ClientManagerReports = Schema["template_ClientManagerReports"];
            export type ManagerRegistration = Schema["template_ManagerRegistration"];
            export type ClientRegistration = Schema["template_ClientRegistration"];
            export type HireRegistration = Schema["template_HireRegistration"];
            export type ManagerSettings = Schema["template_ManagerSettings"];
            export type MealPlanList = Schema["template_MealPlanList"];
            export type MealPlanDetail = Schema["template_MealPlanDetail"];
            export type DeleteMealPlan = Schema["template_DeleteMealPlan"];
            export type CreateMealPlan = Schema["template_CreateMealPlan"];
            export type CreateTarget = Schema["template_CreateTarget"];
            export type UpdateTarget = Schema["template_UpdateTarget"];
            export type ProgramList = Schema["template_ProgramList"];
            export type UpdateProgram = Schema["template_UpdateProgram"];
            export type MergeExercises = Schema["template_MergeExercises"];
            export type ExerciseMedia = Schema["template_ExerciseMedia"];
            export namespace ClientCheckIn_6af5d6e9cc {
                export type input = Schema["models"]["manager.templates.ClientCheckIn_6af5d6e9cc"]["input"];
                export type output = Schema["models"]["manager.templates.ClientCheckIn_6af5d6e9cc"]["output"];
            }
            export namespace ClientManagerPick {
                export type input = Schema["models"]["manager.templates.ClientManagerPick"]["input"];
                export type output = Schema["models"]["manager.templates.ClientManagerPick"]["output"];
            }
            export namespace ClientManager_9963dfc2dd {
                export type input = Schema["models"]["manager.templates.ClientManager_9963dfc2dd"]["input"];
                export type output = Schema["models"]["manager.templates.ClientManager_9963dfc2dd"]["output"];
            }
            export namespace ExerciseType_c80bde974a {
                export type input = Schema["models"]["manager.templates.ExerciseType_c80bde974a"]["input"];
                export type output = Schema["models"]["manager.templates.ExerciseType_c80bde974a"]["output"];
            }
            export namespace ListWorkoutProgram {
                export type input = Schema["models"]["manager.templates.ListWorkoutProgram"]["input"];
                export type output = Schema["models"]["manager.templates.ListWorkoutProgram"]["output"];
            }
            export namespace Manager_e413b4138e {
                export type input = Schema["models"]["manager.templates.Manager_e413b4138e"]["input"];
                export type output = Schema["models"]["manager.templates.Manager_e413b4138e"]["output"];
            }
            export namespace MealPlanPick {
                export type input = Schema["models"]["manager.templates.MealPlanPick"]["input"];
                export type output = Schema["models"]["manager.templates.MealPlanPick"]["output"];
            }
            export namespace ProgramTemplate {
                export type input = Schema["models"]["manager.templates.ProgramTemplate"]["input"];
                export type output = Schema["models"]["manager.templates.ProgramTemplate"]["output"];
            }
            export namespace TargetAssignment_f25c746fc2 {
                export type input = Schema["models"]["manager.templates.TargetAssignment_f25c746fc2"]["input"];
                export type output = Schema["models"]["manager.templates.TargetAssignment_f25c746fc2"]["output"];
            }
            export namespace User_124424a5e9 {
                export type input = Schema["models"]["manager.templates.User_124424a5e9"]["input"];
                export type output = Schema["models"]["manager.templates.User_124424a5e9"]["output"];
            }
            export namespace Workout_c29aee4e3e {
                export type input = Schema["models"]["manager.templates.Workout_c29aee4e3e"]["input"];
                export type output = Schema["models"]["manager.templates.Workout_c29aee4e3e"]["output"];
            }
        }
    }
    export namespace nutrition {
        export namespace rpc {
            export type ExportDay = Schema["models"]["nutrition.rpc.ExportDay"];
            export async function usda_foods() {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/usda_foods/", {}, "POST") as unknown as Promise<RPCResult<Schema["rpc_usda_foods_output"]>>;
}
            export async function export_journal(form: Schema["rpc_export_journal_input"]) {
    const {rpc} = await import("@reactivated");
    return rpc.requester("/rpc/export_journal/", form, "POST") as unknown as Promise<RPCResult<Schema["rpc_export_journal_output"]>>;
}
            export namespace ExportMeal {
                export type input = Schema["models"]["nutrition.rpc.ExportMeal"]["input"];
                export type output = Schema["models"]["nutrition.rpc.ExportMeal"]["output"];
            }
            export namespace ExportWorkout {
                export type input = Schema["models"]["nutrition.rpc.ExportWorkout"]["input"];
                export type output = Schema["models"]["nutrition.rpc.ExportWorkout"]["output"];
            }
            export namespace USDAFood {
                export type input = Schema["models"]["nutrition.rpc.USDAFood"]["input"];
                export type output = Schema["models"]["nutrition.rpc.USDAFood"]["output"];
            }
            export namespace export_journal {
                export type output = Schema["rpc_export_journal_output"];
                export type input = Schema["rpc_export_journal_input"];
            }
            export namespace usda_foods {
                export type output = Schema["rpc_usda_foods_output"];
            }
        }
    }
}
// Digest: c9b3b0a4a5d769dd9a9199d55287fa1f16a0e8af
